import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  SafeString: any;
  Upload: any;
  contactEmail_String_NotNull_format_email: any;
  contactEmail_String_format_email: any;
  emailFrom_String_NotNull_format_email: any;
  email_String_NotNull_format_email: any;
  email_String_format_email: any;
  from_Float_min_0: any;
  note_String_NotNull_minLength_1: any;
  password_String_NotNull_minLength_6: any;
  password_String_minLength_6: any;
  quantity_Int_NotNull_min_1: any;
  recipientEmail_String_NotNull_format_email: any;
  reviewToken_String_NotNull_format_uuid: any;
  to_Float_min_0: any;
};

export type AddCollectionProductInput = {
  collectionId: Scalars['Int'];
  positionIndexWeight: Scalars['Int'];
  productId: Scalars['Int'];
  productVariantId?: InputMaybe<Scalars['Int']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<City>;
  country?: Maybe<Country>;
  fullAddress: Scalars['String'];
  state?: Maybe<State>;
  title: Scalars['String'];
  zipCode?: Maybe<Scalars['String']>;
};

export type AdjustClientCreditInput = {
  amount: Scalars['Float'];
  clientId: Scalars['Int'];
  isWithClientNotification?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
};

export type Admin = {
  __typename?: 'Admin';
  createdAtUtc: Datetime;
  email: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type AdminBookedSessions = {
  __typename?: 'AdminBookedSessions';
  data: Array<Maybe<Session>>;
  paginationInfo: PaginationInfo;
};

export type AdminBookedSessionsFilter = {
  clientId?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<StringRangeFilterInput>;
  expertSessionType?: InputMaybe<SessionTypeField>;
  statuses?: InputMaybe<Array<InputMaybe<SessionStatus>>>;
};

export type AdminBookedSessionsInput = {
  filter?: InputMaybe<AdminBookedSessionsFilter>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<SessionsSorterInput>;
};

export type AdminCmsPagesByLimitInput = {
  filter?: InputMaybe<CmsPagesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<CmsPagesSorterInput>;
};

export type AdminCmsPagesInput = {
  filter?: InputMaybe<CmsPagesFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<CmsPagesSorterInput>;
};

export type AdminCancelSessionInput = {
  cancellationFee: Scalars['Int'];
  clientNote: Scalars['String'];
  expertNote: Scalars['String'];
  id: Scalars['Int'];
  refundType: RefundType;
};

export type AdminDashboardCollectionsFilterInput = {
  expertId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CollectionStatus>;
  subtype?: InputMaybe<CollectionSubtype>;
  type?: InputMaybe<CollectionType>;
};

export type AdminDashboardCollectionsInput = {
  filter?: InputMaybe<AdminDashboardCollectionsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<AdminDashboardCollectionsSorterInput>;
};

export enum AdminDashboardCollectionsSorterField {
  CreatedAtUtc = 'createdAtUtc',
  Id = 'id',
  Status = 'status',
  Title = 'title',
  UpdatedAtUtc = 'updatedAtUtc'
}

export type AdminDashboardCollectionsSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<AdminDashboardCollectionsSorterField>;
};

export type AdminDashboardExpertUsersFilterInput = {
  capabilitiesExcluded?: InputMaybe<Array<Scalars['String']>>;
  capabilitiesIncluded?: InputMaybe<Array<Scalars['String']>>;
};

export type AdminDashboardExpertUsersInput = {
  filter?: InputMaybe<AdminDashboardExpertUsersFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<AdminDashboardExpertUsersSorterInput>;
};

export enum AdminDashboardExpertUsersSorterField {
  CreatedAtUtc = 'createdAtUtc',
  Email = 'email',
  Id = 'id'
}

export type AdminDashboardExpertUsersSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<AdminDashboardExpertUsersSorterField>;
};

export type AdminDashboardExpertsFilterInput = {
  capabilitiesExcluded?: InputMaybe<Array<Scalars['String']>>;
  capabilitiesIncluded?: InputMaybe<Array<Scalars['String']>>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  mustHaveShowroom?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<ExpertStatus>>;
};

export type AdminDashboardExpertsInput = {
  filter?: InputMaybe<AdminDashboardExpertsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<AdminDashboardExpertsSorterInput>;
};

export enum AdminDashboardExpertsSorterField {
  BusinessName = 'businessName',
  CreatedAtUtc = 'createdAtUtc',
  Email = 'email',
  HasTaxExemption = 'has_tax_exemption',
  Id = 'id',
  MemberCount = 'member_count',
  ProfileName = 'profileName'
}

export type AdminDashboardExpertsSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<AdminDashboardExpertsSorterField>;
};

export type AdminExpertUsers = {
  __typename?: 'AdminExpertUsers';
  data: Array<Maybe<ExpertUser>>;
  paginationInfo: PaginationInfo;
};

export type AdminExpertUsersInput = {
  filter?: InputMaybe<ExpertUsersFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorter?: InputMaybe<ExpertUsersSorterInput>;
};

export type AdminNavigationGroupInput = {
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AdminPutSessionOnHoldInput = {
  id: Scalars['Int'];
};

export type AdminRescheduleSessionInput = {
  id: Scalars['Int'];
  startAtUtc: Scalars['String'];
};

export type AdminTagFilter = {
  expertId?: InputMaybe<Scalars['Int']>;
};

export type AdminTagPagination = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type AdminTagsInput = {
  filter?: InputMaybe<AdminTagFilter>;
  pagination?: InputMaybe<AdminTagPagination>;
  search?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateExpertInput = {
  businessName?: InputMaybe<Scalars['String']>;
  customCancelationPolicy?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isConsultationRecapFormEnabled?: InputMaybe<Scalars['Boolean']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  isFindable?: InputMaybe<Scalars['Boolean']>;
  isPublicVisible?: InputMaybe<Scalars['Boolean']>;
  isStripeAccountActivated?: InputMaybe<Scalars['Boolean']>;
  legalBusinessName?: InputMaybe<Scalars['String']>;
  platformFeePercentage?: InputMaybe<Scalars['Int']>;
  positionIndexWeight?: InputMaybe<Scalars['Int']>;
};

export type AdminsOrdersInput = {
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<OrdersSorterInput>;
};

export type AlphabeticalIndexWidgetData = {
  __typename?: 'AlphabeticalIndexWidgetData';
  title: Scalars['String'];
  url: Scalars['String'];
};

export type ApproveExpertApplicationInput = {
  currencyIsoCode: CurrencyIsoCode;
  id: Scalars['Int'];
  profileName: Scalars['String'];
  slug: Scalars['String'];
  timezone: Scalars['String'];
};

export type Attachment = {
  __typename?: 'Attachment';
  alt?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type AutocompleteInput = {
  countryIsoCode?: InputMaybe<Scalars['String']>;
  search: Scalars['String'];
};

export enum AvailabilityEnum {
  ReadyToShip = 'READY_TO_SHIP'
}

export type BanClientInput = {
  emailMessage: Scalars['String'];
  id: Scalars['Int'];
};

export type BanExpertInput = {
  id: Scalars['Int'];
};

export type Brand = {
  __typename?: 'Brand';
  cmsBrandPage: CmsBrandPage;
  createdAtUtc: Datetime;
  id: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  ariaLabel?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  label: Scalars['String'];
  link: Scalars['String'];
};

export enum BuyerType {
  Client = 'CLIENT',
  ExpertUser = 'EXPERT_USER'
}

export type CmsAlphabeticalIndexWidget = {
  __typename?: 'CMSAlphabeticalIndexWidget';
  createdAtUtc: Datetime;
  data: Array<AlphabeticalIndexWidgetData>;
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  type: CmsAlphabeticalIndexWidgetType;
  updatedAtUtc: Datetime;
};

export type CmsAlphabeticalIndexWidgetInput = {
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type: CmsAlphabeticalIndexWidgetType;
};

export enum CmsAlphabeticalIndexWidgetType {
  Brand = 'BRAND'
}

export type CmsAltExpertsListingWidget = {
  __typename?: 'CMSAltExpertsListingWidget';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsAltExpertsListingWidgetInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsAltValuePropositionWidget = {
  __typename?: 'CMSAltValuePropositionWidget';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsAltValuePropositionWidgetInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsArticleHeadingWidget = {
  __typename?: 'CMSArticleHeadingWidget';
  author: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsArticleHeadingWidgetInput = {
  author: Scalars['String'];
  caption?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CmsArticlePage = {
  __typename?: 'CMSArticlePage';
  author: Scalars['String'];
  cmsPage: CmsPage;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  previewAttachment?: Maybe<Attachment>;
  previewText?: Maybe<Scalars['String']>;
  relatedArticlesWidget?: Maybe<CmsWidget>;
  tag?: Maybe<Scalars['String']>;
  updatedAtUtc: Datetime;
};

export type CmsArticlePageFilterInput = {
  isPublished?: InputMaybe<Scalars['Boolean']>;
};

export type CmsArticlePageInput = {
  id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CmsArticlePages = {
  __typename?: 'CMSArticlePages';
  data?: Maybe<Array<CmsArticlePage>>;
  paginationInfo: PaginationInfo;
};

export type CmsArticlePagesInput = {
  filter?: InputMaybe<CmsArticlePageFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type CmsArticlesWidget = {
  __typename?: 'CMSArticlesWidget';
  cmsArticlesWidgetItems: CmsArticlesWidgetItems;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsArticlesWidgetInput = {
  cmsArticlesWidgetItems?: InputMaybe<Array<CmsArticlesWidgetItemInput>>;
  id?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CmsArticlesWidgetItem = {
  __typename?: 'CMSArticlesWidgetItem';
  article: CmsArticlePage;
  cmsArticlesWidgetId: Scalars['Int'];
  id: Scalars['Int'];
};

export type CmsArticlesWidgetItemInput = {
  cmsArticlePageId: Scalars['Int'];
  cmsArticlesWidgetId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsArticlesWidgetItems = {
  __typename?: 'CMSArticlesWidgetItems';
  data?: Maybe<Array<CmsArticlesWidgetItem>>;
  paginationInfo: PaginationInfo;
  widgetId: Scalars['Int'];
};

export type CmsBannerWidget = {
  __typename?: 'CMSBannerWidget';
  buttonLink: Scalars['String'];
  buttonText: Scalars['String'];
  createdAtUtc: Datetime;
  expert?: Maybe<Expert>;
  href?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsBannerWidgetInput = {
  buttonText: Scalars['String'];
  expertId?: InputMaybe<Scalars['Int']>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CmsBrandPage = {
  __typename?: 'CMSBrandPage';
  brand: Brand;
  cmsPage: CmsPage;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsBrandPageInput = {
  id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CmsCardNavigationWidget = {
  __typename?: 'CMSCardNavigationWidget';
  buttonLink?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  cmsCardNavigationWidgetItems: Array<CmsCardNavigationWidgetItem>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  placement: CardNavigationPlacement;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAtUtc: Datetime;
};

export type CmsCardNavigationWidgetInput = {
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  cmsCardNavigationWidgetItems: Array<CmsCardNavigationWidgetItemInput>;
  id?: InputMaybe<Scalars['Int']>;
  placement?: InputMaybe<CardNavigationPlacement>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CmsCardNavigationWidgetItem = {
  __typename?: 'CMSCardNavigationWidgetItem';
  attachment: Attachment;
  cmsCardNavigationWidgetId: Scalars['Int'];
  cmsPage: CmsPage;
  id: Scalars['Int'];
  positionIndexWeight?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CmsCardNavigationWidgetItemInput = {
  attachmentId: Scalars['Int'];
  cmsCardNavigationWidgetId?: InputMaybe<Scalars['Int']>;
  cmsPageId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  positionIndexWeight?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CmsCategoryCollectionWidget = {
  __typename?: 'CMSCategoryCollectionWidget';
  /** @deprecated Use CMSCardNavigationWidget instead. */
  cmsCategoryCollectionWidgetItems: Array<CmsCategoryCollectionWidgetItem>;
  /** @deprecated Use CMSCardNavigationWidget instead. */
  createdAtUtc: Datetime;
  /** @deprecated Use CMSCardNavigationWidget instead. */
  id: Scalars['Int'];
  /** @deprecated Use CMSCardNavigationWidget instead. */
  placement: CategoryCollectionPlacement;
  /** @deprecated Use CMSCardNavigationWidget instead. */
  subtitle?: Maybe<Scalars['String']>;
  /** @deprecated Use CMSCardNavigationWidget instead. */
  title: Scalars['String'];
  /** @deprecated Use CMSCardNavigationWidget instead. */
  updatedAtUtc: Datetime;
};

export type CmsCategoryCollectionWidgetInput = {
  cmsCategoryCollectionWidgetItems: Array<CmsCategoryCollectionWidgetItemInput>;
  id?: InputMaybe<Scalars['Int']>;
  placement?: InputMaybe<CategoryCollectionPlacement>;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CmsCategoryCollectionWidgetItem = {
  __typename?: 'CMSCategoryCollectionWidgetItem';
  attachment: Attachment;
  cmsCategoryCollectionWidgetId: Scalars['Int'];
  cmsShowroomPage: CmsShowroomPage;
  id: Scalars['Int'];
  positionIndexWeight?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CmsCategoryCollectionWidgetItemInput = {
  attachmentId: Scalars['Int'];
  cmsCategoryCollectionWidgetId?: InputMaybe<Scalars['Int']>;
  cmsShowroomPageId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  positionIndexWeight?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CmsCategoryHeaderWidget = {
  __typename?: 'CMSCategoryHeaderWidget';
  cmsCategoryHeaderWidgetItems: Array<CmsCategoryHeaderWidgetItem>;
  createdAtUtc: Datetime;
  expert?: Maybe<Expert>;
  id: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: CategoryHeaderType;
  updatedAtUtc: Datetime;
};

export type CmsCategoryHeaderWidgetInput = {
  cmsCategoryHeaderWidgetItems: Array<CmsCategoryHeaderWidgetItemInput>;
  expertId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: CategoryHeaderType;
};

export type CmsCategoryHeaderWidgetItem = {
  __typename?: 'CMSCategoryHeaderWidgetItem';
  attachment: Attachment;
  cmsCategoryHeaderWidgetId: Scalars['Int'];
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  positionIndexWeight?: Maybe<Scalars['Int']>;
  updatedAtUtc: Datetime;
};

export type CmsCategoryHeaderWidgetItemInput = {
  attachmentId: Scalars['Int'];
  cmsCategoryHeaderWidgetId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  positionIndexWeight?: InputMaybe<Scalars['Int']>;
};

export type CmsCategoryPage = {
  __typename?: 'CMSCategoryPage';
  cmsPage: CmsPage;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  productCategory: ProductCategory;
  updatedAtUtc: Datetime;
};

export type CmsCategoryPageInput = {
  id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CmsCollectionHeaderWidget = {
  __typename?: 'CMSCollectionHeaderWidget';
  collectionHeaderType: CollectionHeaderType;
  createdAtUtc: Datetime;
  headerImageAttachment: Attachment;
  id: Scalars['Int'];
  mobileImageAttachment?: Maybe<Attachment>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsCollectionHeaderWidgetInput = {
  collectionHeaderType?: InputMaybe<CollectionHeaderType>;
  headerImageAttachmentId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  mobileImageAttachmentId?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CmsCollectionsCarouselWidget = {
  __typename?: 'CMSCollectionsCarouselWidget';
  cmsCollectionsCarouselWidgetItems: Array<CmsCollectionsCarouselWidgetItem>;
  cmsShowroomPage?: Maybe<CmsShowroomPage>;
  createdAtUtc: Datetime;
  hasExploreAllButton: Scalars['Boolean'];
  id: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsCollectionsCarouselWidgetInput = {
  cmsCollectionsCarouselWidgetItems: Array<CmsCollectionsCarouselWidgetItemInput>;
  cmsShowroomPageId?: InputMaybe<Scalars['Int']>;
  hasExploreAllButton?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CmsCollectionsCarouselWidgetItem = {
  __typename?: 'CMSCollectionsCarouselWidgetItem';
  caption?: Maybe<Scalars['String']>;
  cmsCollectionsCarouselWidgetId: Scalars['Int'];
  cmsShowroomPage: CmsShowroomPage;
  id: Scalars['Int'];
  positionIndexWeight?: Maybe<Scalars['Int']>;
  previewImageAttachment: Attachment;
  profileImageAttachment?: Maybe<Attachment>;
};

export type CmsCollectionsCarouselWidgetItemInput = {
  caption?: InputMaybe<Scalars['String']>;
  cmsCollectionsCarouselWidgetId?: InputMaybe<Scalars['Int']>;
  cmsShowroomPageId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  positionIndexWeight?: InputMaybe<Scalars['Int']>;
  previewImageAttachmentId: Scalars['Int'];
  profileImageAttachmentId?: InputMaybe<Scalars['Int']>;
};

export type CmsConciergeWidget = {
  __typename?: 'CMSConciergeWidget';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsConciergeWidgetInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsConsultationListingWidget = {
  __typename?: 'CMSConsultationListingWidget';
  buttonCopy: Scalars['String'];
  createdAtUtc: Datetime;
  duration?: Maybe<Scalars['String']>;
  expert: Expert;
  headline: Scalars['String'];
  id: Scalars['Int'];
  isButtonIconShown: Scalars['Boolean'];
  isConsultationDetailShown: Scalars['Boolean'];
  previewAttachment: Attachment;
  price?: Maybe<Scalars['String']>;
  updatedAtUtc: Datetime;
};

export type CmsConsultationListingWidgetInput = {
  buttonCopy: Scalars['String'];
  duration?: InputMaybe<Scalars['String']>;
  expertId: Scalars['Int'];
  headline: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  isButtonIconShown: Scalars['Boolean'];
  isConsultationDetailShown: Scalars['Boolean'];
  previewAttachmentId: Scalars['Int'];
  price?: InputMaybe<Scalars['String']>;
};

export type CmsConsultationPage = {
  __typename?: 'CMSConsultationPage';
  cmsPage: CmsPage;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsConsultationPageInput = {
  id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CmsContentWidget = CmsAlphabeticalIndexWidget | CmsAltExpertsListingWidget | CmsAltValuePropositionWidget | CmsArticleHeadingWidget | CmsArticlesWidget | CmsBannerWidget | CmsCardNavigationWidget | CmsCategoryCollectionWidget | CmsCategoryHeaderWidget | CmsCollectionHeaderWidget | CmsCollectionsCarouselWidget | CmsConciergeWidget | CmsDoubleImageWidget | CmsExpertCollectionsWidget | CmsExpertsListingWidget | CmsExpertsWidget | CmsFeaturedInWidget | CmsGalleryWidget | CmsGiftCardWidget | CmsHeroCarouselWidget | CmsHeroMainWidget | CmsHeroWidget | CmsInfoCardsWidget | CmsIntroductionWidget | CmsMultiCollectionWidget | CmsProductsWidget | CmsqaWidget | CmsRichTextWidget | CmsSectionWidget | CmsSingleImageWidget | CmsSpotlightWidget | CmsTestimonialsWidget | CmsValuePropositionWidget | CmsVideoSectionWidget | CmsVideoWidget;

export type CmsDoubleImageWidget = {
  __typename?: 'CMSDoubleImageWidget';
  createdAtUtc: Datetime;
  firstAttachment: Attachment;
  firstCaption?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  secondAttachment: Attachment;
  secondCaption?: Maybe<Scalars['String']>;
  updatedAtUtc: Datetime;
};

export type CmsDoubleImageWidgetInput = {
  firstAttachmentId: Scalars['Int'];
  firstCaption?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  secondAttachmentId: Scalars['Int'];
  secondCaption?: InputMaybe<Scalars['String']>;
};

export type CmsExpertCollectionsWidget = {
  __typename?: 'CMSExpertCollectionsWidget';
  cmsExpertCollectionsWidgetItems: Array<CmsExpertCollectionsWidgetItem>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsExpertCollectionsWidgetInput = {
  cmsExpertCollectionsWidgetItems: Array<CmsExpertCollectionsWidgetItemInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsExpertCollectionsWidgetItem = {
  __typename?: 'CMSExpertCollectionsWidgetItem';
  caption?: Maybe<Scalars['String']>;
  cmsExpertCollectionsWidgetId: Scalars['Int'];
  cmsShowroomPage?: Maybe<CmsShowroomPage>;
  expert?: Maybe<Expert>;
  id: Scalars['Int'];
  positionIndexWeight?: Maybe<Scalars['Int']>;
  previewImageAttachment: Attachment;
  profileImageAttachment?: Maybe<Attachment>;
};

export type CmsExpertCollectionsWidgetItemInput = {
  caption?: InputMaybe<Scalars['String']>;
  cmsExpertCollectionsWidgetId?: InputMaybe<Scalars['Int']>;
  cmsShowroomPageId?: InputMaybe<Scalars['Int']>;
  expertId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  positionIndexWeight?: InputMaybe<Scalars['Int']>;
  previewImageAttachmentId: Scalars['Int'];
  profileImageAttachmentId?: InputMaybe<Scalars['Int']>;
};

export type CmsExpertPage = {
  __typename?: 'CMSExpertPage';
  cmsPage: CmsPage;
  createdAtUtc: Datetime;
  expert: Expert;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsExpertPageInput = {
  id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CmsExpertsListingWidget = {
  __typename?: 'CMSExpertsListingWidget';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  isFilterEnabled: Scalars['Boolean'];
  items: PublicExperts;
  updatedAtUtc: Datetime;
};


export type CmsExpertsListingWidgetItemsArgs = {
  input?: InputMaybe<ExpertsInput>;
};

export type CmsExpertsListingWidgetInput = {
  id?: InputMaybe<Scalars['Int']>;
  isFilterEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type CmsExpertsWidget = {
  __typename?: 'CMSExpertsWidget';
  cmsExpertsWidgetItems: CmsExpertsWidgetItems;
  createdAtUtc: Datetime;
  desktopPageSize: Scalars['Int'];
  id: Scalars['Int'];
  isButtonHidden: Scalars['Boolean'];
  mobilePageSize: Scalars['Int'];
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsExpertsWidgetInput = {
  cmsExpertsWidgetItems?: InputMaybe<Array<CmsExpertsWidgetItemInput>>;
  desktopPageSize?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isButtonHidden?: InputMaybe<Scalars['Boolean']>;
  mobilePageSize?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CmsExpertsWidgetItem = {
  __typename?: 'CMSExpertsWidgetItem';
  cmsExpertsWidgetId: Scalars['Int'];
  expert: Expert;
  id: Scalars['Int'];
};

export type CmsExpertsWidgetItemInput = {
  cmsExpertsWidgetId?: InputMaybe<Scalars['Int']>;
  expertId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsExpertsWidgetItems = {
  __typename?: 'CMSExpertsWidgetItems';
  data?: Maybe<Array<CmsExpertsWidgetItem>>;
  paginationInfo: PaginationInfo;
  widgetId: Scalars['Int'];
};

export type CmsFeaturedInWidget = {
  __typename?: 'CMSFeaturedInWidget';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsFeaturedInWidgetInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsGalleryWidget = {
  __typename?: 'CMSGalleryWidget';
  cmsGalleryWidgetItems?: Maybe<Array<CmsGalleryWidgetItem>>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsGalleryWidgetInput = {
  cmsGalleryWidgetItems?: InputMaybe<Array<CmsGalleryWidgetItemInput>>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CmsGalleryWidgetItem = {
  __typename?: 'CMSGalleryWidgetItem';
  attachment: Attachment;
  caption?: Maybe<Scalars['String']>;
  cmsGalleryWidgetId: Scalars['Int'];
  expert?: Maybe<Expert>;
  id: Scalars['Int'];
};

export type CmsGalleryWidgetItemInput = {
  attachmentId: Scalars['Int'];
  caption?: InputMaybe<Scalars['String']>;
  cmsGalleryWidgetId?: InputMaybe<Scalars['Int']>;
  expertId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsGiftCardWidget = {
  __typename?: 'CMSGiftCardWidget';
  createdAtUtc: Datetime;
  description: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsGiftCardWidgetInput = {
  description: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CmsHelpListingWidget = {
  __typename?: 'CMSHelpListingWidget';
  body: Scalars['String'];
  createdAtUtc: Datetime;
  headline: Scalars['String'];
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsHelpListingWidgetInput = {
  body: Scalars['String'];
  headline: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsHeroCarouselWidget = {
  __typename?: 'CMSHeroCarouselWidget';
  cmsHeroCarouselWidgetItems: Array<CmsHeroCarouselWidgetItem>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  isAutoRotationEnabled: Scalars['Boolean'];
  updatedAtUtc: Datetime;
};

export type CmsHeroCarouselWidgetInput = {
  cmsHeroCarouselWidgetItems: Array<CmsHeroCarouselWidgetItemInput>;
  id?: InputMaybe<Scalars['Int']>;
  isAutoRotationEnabled: Scalars['Boolean'];
};

export type CmsHeroCarouselWidgetItem = {
  __typename?: 'CMSHeroCarouselWidgetItem';
  attachment: Attachment;
  buttonLink?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  cmsHeroCarouselWidgetId: Scalars['Int'];
  createdAtUtc: Datetime;
  hasButton: Scalars['Boolean'];
  headline?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  positionIndexWeight: Scalars['Int'];
  preTitle?: Maybe<Scalars['String']>;
  subheadline?: Maybe<Scalars['String']>;
  updatedAtUtc: Datetime;
};

export type CmsHeroCarouselWidgetItemInput = {
  attachmentId: Scalars['Int'];
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  cmsHeroCarouselWidgetId?: InputMaybe<Scalars['Int']>;
  hasButton: Scalars['Boolean'];
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  positionIndexWeight: Scalars['Int'];
  preTitle?: InputMaybe<Scalars['String']>;
  subheadline?: InputMaybe<Scalars['String']>;
};

export type CmsHeroMainWidget = {
  __typename?: 'CMSHeroMainWidget';
  attachment: Attachment;
  createdAtUtc: Datetime;
  hasSecondaryButton: Scalars['Boolean'];
  headline: Scalars['String'];
  id: Scalars['Int'];
  mainButtonLink: Scalars['String'];
  mainButtonText: Scalars['String'];
  secondaryButtonLink?: Maybe<Scalars['String']>;
  secondaryButtonText?: Maybe<Scalars['String']>;
  subheadline?: Maybe<Scalars['String']>;
  updatedAtUtc: Datetime;
};

export type CmsHeroMainWidgetInput = {
  attachmentId: Scalars['Int'];
  hasSecondaryButton: Scalars['Boolean'];
  headline: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  mainButtonLink: Scalars['String'];
  mainButtonText: Scalars['String'];
  secondaryButtonLink?: InputMaybe<Scalars['String']>;
  secondaryButtonText?: InputMaybe<Scalars['String']>;
  subheadline?: InputMaybe<Scalars['String']>;
};

export type CmsHeroWidget = {
  __typename?: 'CMSHeroWidget';
  attachment: Attachment;
  createdAtUtc: Datetime;
  hasLandingPageButtons: Scalars['Boolean'];
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsHeroWidgetInput = {
  attachmentId: Scalars['Int'];
  hasLandingPageButtons?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CmsInfoCardsWidget = {
  __typename?: 'CMSInfoCardsWidget';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsInfoCardsWidgetInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsInfoListingWidget = {
  __typename?: 'CMSInfoListingWidget';
  body: Scalars['String'];
  buttonText?: Maybe<Scalars['String']>;
  createdAtUtc: Datetime;
  customButtonUrl?: Maybe<Scalars['String']>;
  hasButton: Scalars['Boolean'];
  hasCustomLink: Scalars['Boolean'];
  headline: Scalars['String'];
  id: Scalars['Int'];
  previewAttachment: Attachment;
  updatedAtUtc: Datetime;
};

export type CmsInfoListingWidgetInput = {
  body: Scalars['String'];
  buttonText?: InputMaybe<Scalars['String']>;
  customButtonUrl?: InputMaybe<Scalars['String']>;
  hasButton: Scalars['Boolean'];
  hasCustomLink: Scalars['Boolean'];
  headline: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  previewAttachmentId: Scalars['Int'];
};

export type CmsIntroductionWidget = {
  __typename?: 'CMSIntroductionWidget';
  attachment: Attachment;
  buttonLink: Scalars['String'];
  buttonText: Scalars['String'];
  createdAtUtc: Datetime;
  description: Scalars['String'];
  id: Scalars['Int'];
  posttitle?: Maybe<Scalars['String']>;
  pretitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsIntroductionWidgetInput = {
  attachmentId: Scalars['Int'];
  buttonLink: Scalars['String'];
  buttonText: Scalars['String'];
  description: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  posttitle?: InputMaybe<Scalars['String']>;
  pretitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CmsListingWidget = {
  __typename?: 'CMSListingWidget';
  content?: Maybe<CmsListingWidgetContent>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  name: Scalars['String'];
  type: CmsListingWidgetType;
  updatedAtUtc: Datetime;
};

export type CmsListingWidgetContent = CmsConsultationListingWidget | CmsHelpListingWidget | CmsInfoListingWidget | CmsQuotationListingWidget;

export type CmsListingWidgetInput = {
  cmsConsultationListingWidget?: InputMaybe<CmsConsultationListingWidgetInput>;
  cmsHelpListingWidget?: InputMaybe<CmsHelpListingWidgetInput>;
  cmsInfoListingWidget?: InputMaybe<CmsInfoListingWidgetInput>;
  cmsQuotationListingWidget?: InputMaybe<CmsQuotationListingWidgetInput>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export enum CmsListingWidgetType {
  Consultation = 'CONSULTATION',
  Help = 'HELP',
  Info = 'INFO',
  Quotation = 'QUOTATION'
}

export type CmsListingWidgets = {
  __typename?: 'CMSListingWidgets';
  data: Array<CmsListingWidget>;
  paginationInfo: PaginationInfo;
};

export type CmsListingWidgetsFilterInput = {
  search?: InputMaybe<Scalars['String']>;
};

export type CmsListingWidgetsInput = {
  filter?: InputMaybe<CmsListingWidgetsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type CmsMultiCollectionWidget = {
  __typename?: 'CMSMultiCollectionWidget';
  brands: Array<Brand>;
  categoriesOne: Array<ProductCategory>;
  categoriesThree: Array<ProductCategory>;
  categoriesTwo: Array<ProductCategory>;
  cmsListingWidgets: Array<CmsListingWidget>;
  cmsMultiCollectionWidgetItems: Array<CmsMultiCollectionWidgetItem>;
  cmsShowroomPage?: Maybe<CmsShowroomPage>;
  createdAtUtc: Datetime;
  defaultSortDirection?: Maybe<SortDirection>;
  defaultSortField?: Maybe<ProductSorterField>;
  expert?: Maybe<Expert>;
  firstPublishedAtFilter?: Maybe<Scalars['Int']>;
  headline: Scalars['String'];
  id: Scalars['Int'];
  isShopAllProductsButtonEnabled: Scalars['Boolean'];
  isSortEnabled: Scalars['Boolean'];
  items: CollectionItems;
  maxPrice?: Maybe<Price>;
  type: MultiCollectionType;
  updatedAtUtc: Datetime;
  useBreakoutVariants: Scalars['Boolean'];
};


export type CmsMultiCollectionWidgetItemsArgs = {
  input?: InputMaybe<ProductsInput>;
};

export type CmsMultiCollectionWidgetInput = {
  cmsListingWidgets: Array<Scalars['Int']>;
  cmsMultiCollectionWidgetItems: Array<CmsMultiCollectionWidgetItemInput>;
  cmsShowroomPageId?: InputMaybe<Scalars['Int']>;
  defaultSortDirection?: InputMaybe<SortDirection>;
  defaultSortField?: InputMaybe<ProductSorterField>;
  expertId?: InputMaybe<Scalars['Int']>;
  firstPublishedAtFilter?: InputMaybe<Scalars['Int']>;
  headline: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  isShopAllProductsButtonEnabled?: Scalars['Boolean'];
  isSortEnabled?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<MultiCollectionType>;
  useBreakoutVariants?: InputMaybe<Scalars['Boolean']>;
};

export type CmsMultiCollectionWidgetItem = {
  __typename?: 'CMSMultiCollectionWidgetItem';
  caption?: Maybe<Scalars['String']>;
  cmsMultiCollectionWidgetId: Scalars['Int'];
  collection: Collection;
  id: Scalars['Int'];
  positionIndexWeight?: Maybe<Scalars['Int']>;
};

export type CmsMultiCollectionWidgetItemInput = {
  caption?: InputMaybe<Scalars['String']>;
  cmsMultiCollectionWidgetId?: InputMaybe<Scalars['Int']>;
  collectionId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  positionIndexWeight?: InputMaybe<Scalars['Int']>;
};

export type CmsPage = {
  __typename?: 'CMSPage';
  content?: Maybe<CmsPageType>;
  createdAtUtc: Datetime;
  href: Scalars['String'];
  id: Scalars['Int'];
  isPublished: Scalars['Boolean'];
  isStatic: Scalars['Boolean'];
  keywords?: Maybe<Array<Scalars['String']>>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAtUtc: Datetime;
  widgets?: Maybe<Array<CmsWidget>>;
};


export type CmsPageWidgetsArgs = {
  widgetsDefaultInputs?: InputMaybe<WidgetsDefaultInputs>;
};

export type CmsPageEdge = {
  __typename?: 'CMSPageEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CmsPage>;
};

export enum CmsPageSorterField {
  CreatedAtUtc = 'createdAtUtc',
  Id = 'id',
  IsPublished = 'isPublished',
  Slug = 'slug',
  Title = 'title'
}

export type CmsPageType = CmsArticlePage | CmsBrandPage | CmsCategoryPage | CmsConsultationPage | CmsShowroomPage;

export enum CmsPageTypeName {
  CmsArticlePage = 'CMSArticlePage',
  CmsBrandPage = 'CMSBrandPage',
  CmsCategoryPage = 'CMSCategoryPage',
  CmsConsultationPage = 'CMSConsultationPage',
  CmsShowroomPage = 'CMSShowroomPage'
}

export type CmsPages = {
  __typename?: 'CMSPages';
  edges: Array<CmsPageEdge>;
  pageInfo: CursorPaginationInfo;
};

export type CmsPagesByLimit = {
  __typename?: 'CMSPagesByLimit';
  data: Array<CmsPage>;
  paginationInfo: PaginationInfo;
};

export type CmsPagesFilterInput = {
  isPublished?: InputMaybe<Scalars['Boolean']>;
  pageType?: InputMaybe<CmsPageTypeName>;
};

export type CmsPagesSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<CmsPageSorterField>;
};

export type CmsProductsWidget = {
  __typename?: 'CMSProductsWidget';
  cmsProductsWidgetItems?: Maybe<Array<CmsProductsWidgetItem>>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsProductsWidgetInput = {
  cmsProductsWidgetItems?: InputMaybe<Array<CmsProductsWidgetItemInput>>;
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsProductsWidgetItem = {
  __typename?: 'CMSProductsWidgetItem';
  attachment: Attachment;
  cmsProductsWidgetId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  posttitle?: Maybe<Scalars['String']>;
  pretitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CmsProductsWidgetItemInput = {
  attachmentId: Scalars['Int'];
  cmsProductsWidgetId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  posttitle?: InputMaybe<Scalars['String']>;
  pretitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CmsqaWidget = {
  __typename?: 'CMSQAWidget';
  cmsQAWidgetItems?: Maybe<Array<CmsqaWidgetItem>>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsqaWidgetInput = {
  cmsQAWidgetItems?: InputMaybe<Array<CmsqaWidgetItemInput>>;
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsqaWidgetItem = {
  __typename?: 'CMSQAWidgetItem';
  answer: Scalars['String'];
  cmsQAWidgetId: Scalars['Int'];
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  question: Scalars['String'];
  slug: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsqaWidgetItemInput = {
  answer: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  question: Scalars['String'];
};

export type CmsQuotationListingWidget = {
  __typename?: 'CMSQuotationListingWidget';
  author: Scalars['String'];
  body: Scalars['String'];
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsQuotationListingWidgetInput = {
  author: Scalars['String'];
  body: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsRichTextWidget = {
  __typename?: 'CMSRichTextWidget';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  richText: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsRichTextWidgetInput = {
  id?: InputMaybe<Scalars['Int']>;
  richText: Scalars['String'];
};

export type CmsSectionWidget = {
  __typename?: 'CMSSectionWidget';
  id: Scalars['Int'];
  widgetItems: Array<CmsWidgetItem>;
};

export type CmsSectionWidgetInput = {
  id?: InputMaybe<Scalars['Int']>;
  widgetItems: Array<CmsWidgetItemInput>;
};

export type CmsShowroomPage = {
  __typename?: 'CMSShowroomPage';
  cmsPage: CmsPage;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsShowroomPageFilterInput = {
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isStatic?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type CmsShowroomPageInput = {
  id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CmsShowroomPages = {
  __typename?: 'CMSShowroomPages';
  data?: Maybe<Array<CmsShowroomPage>>;
  paginationInfo: PaginationInfo;
};

export type CmsShowroomPagesInput = {
  filter?: InputMaybe<CmsShowroomPageFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type CmsSingleImageWidget = {
  __typename?: 'CMSSingleImageWidget';
  attachment: Attachment;
  caption?: Maybe<Scalars['String']>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsSingleImageWidgetInput = {
  attachmentId: Scalars['Int'];
  caption?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsSpotlightWidget = {
  __typename?: 'CMSSpotlightWidget';
  attachment: Attachment;
  buttonLink: Scalars['String'];
  buttonText: Scalars['String'];
  createdAtUtc: Datetime;
  description: Scalars['String'];
  expert?: Maybe<Expert>;
  href?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  subTitle: Scalars['String'];
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsSpotlightWidgetInput = {
  attachmentId: Scalars['Int'];
  buttonText: Scalars['String'];
  description: Scalars['String'];
  expertId?: InputMaybe<Scalars['Int']>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  subTitle: Scalars['String'];
  title: Scalars['String'];
};

export type CmsTestimonialsWidget = {
  __typename?: 'CMSTestimonialsWidget';
  cmsTestimonialsWidgetItems?: Maybe<Array<CmsTestimonialsWidgetItem>>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type CmsTestimonialsWidgetInput = {
  cmsTestimonialsWidgetItems?: InputMaybe<Array<CmsTestimonialsWidgetItemInput>>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CmsTestimonialsWidgetItem = {
  __typename?: 'CMSTestimonialsWidgetItem';
  clientInfo: Scalars['String'];
  cmsTestimonialsWidgetId: Scalars['Int'];
  feedback: Scalars['String'];
  id: Scalars['Int'];
};

export type CmsTestimonialsWidgetItemInput = {
  clientInfo: Scalars['String'];
  cmsTestimonialsWidgetId?: InputMaybe<Scalars['Int']>;
  feedback: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsValuePropositionWidget = {
  __typename?: 'CMSValuePropositionWidget';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type CmsValuePropositionWidgetInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsVideoSectionWidget = {
  __typename?: 'CMSVideoSectionWidget';
  createdAtUtc: Datetime;
  ctaCopy?: Maybe<Scalars['String']>;
  ctaCopyUrl?: Maybe<Scalars['String']>;
  hasCtaButton?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  thumbnailAttachment: Attachment;
  title: Scalars['String'];
  updatedAtUtc: Datetime;
  videoAttachment: Attachment;
};

export type CmsVideoSectionWidgetInput = {
  ctaCopy?: InputMaybe<Scalars['String']>;
  ctaCopyUrl?: InputMaybe<Scalars['String']>;
  hasCtaButton?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  thumbnailAttachmentId: Scalars['Int'];
  title: Scalars['String'];
  videoAttachmentId: Scalars['Int'];
};

export type CmsVideoWidget = {
  __typename?: 'CMSVideoWidget';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  thumbnailAttachment?: Maybe<Attachment>;
  title: Scalars['String'];
  updatedAtUtc: Datetime;
  videoAttachment?: Maybe<Attachment>;
};

export type CmsVideoWidgetInput = {
  id?: InputMaybe<Scalars['Int']>;
  thumbnailAttachmentId: Scalars['Int'];
  title: Scalars['String'];
  videoAttachmentId: Scalars['Int'];
};

export type CmsWidget = {
  __typename?: 'CMSWidget';
  content?: Maybe<CmsContentWidget>;
  id: Scalars['Int'];
  positionIndexWeight?: Maybe<Scalars['Int']>;
};

export type CmsWidgetInput = {
  cmsAlphabeticalIndexWidget?: InputMaybe<CmsAlphabeticalIndexWidgetInput>;
  cmsAltExpertsListingWidget?: InputMaybe<CmsAltExpertsListingWidgetInput>;
  cmsAltValuePropositionWidget?: InputMaybe<CmsAltValuePropositionWidgetInput>;
  cmsArticleHeadingWidget?: InputMaybe<CmsArticleHeadingWidgetInput>;
  cmsArticlesWidget?: InputMaybe<CmsArticlesWidgetInput>;
  cmsBannerWidget?: InputMaybe<CmsBannerWidgetInput>;
  cmsCardNavigationWidget?: InputMaybe<CmsCardNavigationWidgetInput>;
  cmsCategoryCollectionWidget?: InputMaybe<CmsCategoryCollectionWidgetInput>;
  cmsCategoryHeaderWidget?: InputMaybe<CmsCategoryHeaderWidgetInput>;
  cmsCollectionHeaderWidget?: InputMaybe<CmsCollectionHeaderWidgetInput>;
  cmsCollectionsCarouselWidget?: InputMaybe<CmsCollectionsCarouselWidgetInput>;
  cmsConciergeWidget?: InputMaybe<CmsConciergeWidgetInput>;
  cmsDoubleImageWidget?: InputMaybe<CmsDoubleImageWidgetInput>;
  cmsExpertCollectionsWidget?: InputMaybe<CmsExpertCollectionsWidgetInput>;
  cmsExpertsListingWidget?: InputMaybe<CmsExpertsListingWidgetInput>;
  cmsExpertsWidget?: InputMaybe<CmsExpertsWidgetInput>;
  cmsFeaturedInWidget?: InputMaybe<CmsFeaturedInWidgetInput>;
  cmsGalleryWidget?: InputMaybe<CmsGalleryWidgetInput>;
  cmsGiftCardWidget?: InputMaybe<CmsGiftCardWidgetInput>;
  cmsHeroCarouselWidget?: InputMaybe<CmsHeroCarouselWidgetInput>;
  cmsHeroMainWidget?: InputMaybe<CmsHeroMainWidgetInput>;
  cmsHeroWidget?: InputMaybe<CmsHeroWidgetInput>;
  cmsInfoCardsWidget?: InputMaybe<CmsInfoCardsWidgetInput>;
  cmsIntroductionWidget?: InputMaybe<CmsIntroductionWidgetInput>;
  cmsMultiCollectionWidget?: InputMaybe<CmsMultiCollectionWidgetInput>;
  cmsProductsWidget?: InputMaybe<CmsProductsWidgetInput>;
  cmsQAWidget?: InputMaybe<CmsqaWidgetInput>;
  cmsRichTextWidget?: InputMaybe<CmsRichTextWidgetInput>;
  cmsSectionWidget?: InputMaybe<CmsSectionWidgetInput>;
  cmsSingleImageWidget?: InputMaybe<CmsSingleImageWidgetInput>;
  cmsSpotlightWidget?: InputMaybe<CmsSpotlightWidgetInput>;
  cmsTestimonialsWidget?: InputMaybe<CmsTestimonialsWidgetInput>;
  cmsValuePropositionWidget?: InputMaybe<CmsValuePropositionWidgetInput>;
  cmsVideoSectionWidget?: InputMaybe<CmsVideoSectionWidgetInput>;
  cmsVideoWidget?: InputMaybe<CmsVideoWidgetInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsWidgetItem = {
  __typename?: 'CMSWidgetItem';
  content: WidgetItem;
  id: Scalars['Int'];
  positionIndexWeight: Scalars['Int'];
};

export type CmsWidgetItemButton = {
  __typename?: 'CMSWidgetItemButton';
  cmsWidgetItemId: Scalars['Int'];
  id: Scalars['Int'];
  link: Scalars['String'];
  text: Scalars['String'];
};

export type CmsWidgetItemButtonInput = {
  id?: InputMaybe<Scalars['Int']>;
  link: Scalars['String'];
  text: Scalars['String'];
};

export type CmsWidgetItemHeadline = {
  __typename?: 'CMSWidgetItemHeadline';
  cmsWidgetItemId: Scalars['Int'];
  headline: Scalars['String'];
  id: Scalars['Int'];
  subheadline?: Maybe<Scalars['String']>;
};

export type CmsWidgetItemHeadlineInput = {
  headline: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  subheadline?: InputMaybe<Scalars['String']>;
};

export type CmsWidgetItemInput = {
  cmsWidgetItemButton?: InputMaybe<CmsWidgetItemButtonInput>;
  cmsWidgetItemHeadline?: InputMaybe<CmsWidgetItemHeadlineInput>;
  cmsWidgetItemThreeColumnCard?: InputMaybe<CmsWidgetItemThreeColumnCardInput>;
  cmsWidgetItemTwoColumnCard?: InputMaybe<CmsWidgetItemTwoColumnCardInput>;
  id?: InputMaybe<Scalars['Int']>;
  positionIndexWeight: Scalars['Int'];
};

export type CmsWidgetItemThreeColumnCard = {
  __typename?: 'CMSWidgetItemThreeColumnCard';
  cmsWidgetItemId: Scalars['Int'];
  firstAttachment: Attachment;
  firstLink?: Maybe<Scalars['String']>;
  firstTitle: Scalars['String'];
  id: Scalars['Int'];
  secondAttachment: Attachment;
  secondLink?: Maybe<Scalars['String']>;
  secondTitle: Scalars['String'];
  thirdAttachment: Attachment;
  thirdLink?: Maybe<Scalars['String']>;
  thirdTitle: Scalars['String'];
};

export type CmsWidgetItemThreeColumnCardInput = {
  firstAttachmentId: Scalars['Int'];
  firstLink?: InputMaybe<Scalars['String']>;
  firstTitle: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  secondAttachmentId: Scalars['Int'];
  secondLink?: InputMaybe<Scalars['String']>;
  secondTitle: Scalars['String'];
  thirdAttachmentId: Scalars['Int'];
  thirdLink?: InputMaybe<Scalars['String']>;
  thirdTitle: Scalars['String'];
};

export type CmsWidgetItemTwoColumnCard = {
  __typename?: 'CMSWidgetItemTwoColumnCard';
  cmsWidgetItemId: Scalars['Int'];
  firstAttachment: Attachment;
  firstLink?: Maybe<Scalars['String']>;
  firstTitle: Scalars['String'];
  id: Scalars['Int'];
  secondAttachment: Attachment;
  secondLink?: Maybe<Scalars['String']>;
  secondTitle: Scalars['String'];
};

export type CmsWidgetItemTwoColumnCardInput = {
  firstAttachmentId: Scalars['Int'];
  firstLink?: InputMaybe<Scalars['String']>;
  firstTitle: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  secondAttachmentId: Scalars['Int'];
  secondLink?: InputMaybe<Scalars['String']>;
  secondTitle: Scalars['String'];
};

export type CalculateRefundInput = {
  cancellationFee: Scalars['Int'];
  checkoutId: Scalars['Int'];
  type: RefundType;
};

export type CalculatedDiscount = {
  __typename?: 'CalculatedDiscount';
  currencyIsoCode: CurrencyIsoCode;
  total: Scalars['Float'];
};

export type CalculatedPrice = {
  __typename?: 'CalculatedPrice';
  currencyIsoCode: CurrencyIsoCode;
  total: Scalars['Float'];
};

export type Calendar = {
  __typename?: 'Calendar';
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type CancelCollectionReviewInput = {
  id: Scalars['Int'];
};

export type CancelInfo = {
  __typename?: 'CancelInfo';
  cancelReason?: Maybe<Scalars['String']>;
  cancelledAtUtc?: Maybe<Datetime>;
  cancelledBy: CancelledBy;
  clientNote?: Maybe<Scalars['String']>;
  expertNote?: Maybe<Scalars['String']>;
};

export enum CancelledBy {
  Admin = 'ADMIN',
  Client = 'CLIENT',
  Cron = 'CRON',
  Expert = 'EXPERT'
}

export enum CardNavigationPlacement {
  Hero = 'HERO',
  Section = 'SECTION'
}

export type Cart = {
  __typename?: 'Cart';
  cartShipments: Array<CartShipment>;
  couponCode?: Maybe<Coupon>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  items: Array<CartItem>;
  promoCode?: Maybe<PromoCode>;
  summary: Summary;
  tax?: Maybe<Scalars['Float']>;
};

export type CartItem = CartItemProductVariant;

export type CartItemInput = {
  cartAvailable: Scalars['Boolean'];
  cartShipmentIds: Array<Scalars['Int']>;
};

export type CartItemProductVariant = {
  __typename?: 'CartItemProductVariant';
  cartId: Scalars['Int'];
  cartShipments: Array<CartShipment>;
  id: Scalars['Int'];
  metadata?: Maybe<ItemMetadata>;
  productVariant: ProductVariant;
  quantity: Scalars['Int'];
};

export type CartShipment = CartShipmentArtaQuote | CartShipmentFreightClubQuote | CartShipmentVendorShipping;

export type CartShipmentArtaQuote = {
  __typename?: 'CartShipmentArtaQuote';
  additionalServices: Array<Scalars['String']>;
  artaId: Scalars['Int'];
  cartId: Scalars['Int'];
  id: Scalars['Int'];
  leadTime: Scalars['Int'];
  name: Scalars['String'];
  price: Price;
  services: Array<CartShipmentArtaQuoteService>;
  sourceAddressHash?: Maybe<Scalars['String']>;
  sourceId: Scalars['Int'];
  type: Scalars['String'];
};

export type CartShipmentArtaQuoteService = {
  __typename?: 'CartShipmentArtaQuoteService';
  cartShipmentArtaId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  price: Price;
  subSubtype: Scalars['String'];
  subtype: Scalars['String'];
  type: Scalars['String'];
};

export type CartShipmentFreightClubQuote = {
  __typename?: 'CartShipmentFreightClubQuote';
  cartId: Scalars['Int'];
  freightClubId: Scalars['Int'];
  id: Scalars['Int'];
  leadTime: Scalars['Int'];
  name: Scalars['String'];
  price: Price;
  rawData?: Maybe<Scalars['JSON']>;
  sourceAddressHash?: Maybe<Scalars['String']>;
  sourceId: Scalars['Int'];
  type: Scalars['String'];
};

export type CartShipmentVendorShipping = {
  __typename?: 'CartShipmentVendorShipping';
  name: Scalars['String'];
  price: Price;
  productVariantId: Scalars['Int'];
  type: Scalars['String'];
};

export type Category = {
  __typename?: 'Category';
  color: Scalars['String'];
  id: Scalars['Int'];
  isHidden: Scalars['Boolean'];
  isHighlighted: Scalars['Boolean'];
  parentId?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export enum CategoryCollectionPlacement {
  Hero = 'HERO',
  Section = 'SECTION'
}

export type CategoryExperts = {
  __typename?: 'CategoryExperts';
  data: Array<Maybe<ExpertCategory>>;
  paginationInfo: PaginationInfo;
};

export type CategoryExpertsFilterInput = {
  categoryId: Scalars['Int'];
  isOrdered?: InputMaybe<Scalars['Boolean']>;
};

export type CategoryExpertsInput = {
  filter: CategoryExpertsFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sorter?: InputMaybe<CategoryExpertsSorterInput>;
};

export enum CategoryExpertsSorterField {
  CreatedAtUtc = 'createdAtUtc',
  PositionIndexWeight = 'positionIndexWeight'
}

export type CategoryExpertsSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<CategoryExpertsSorterField>;
};

export enum CategoryHeaderType {
  Carousel = 'CAROUSEL',
  SingleImage = 'SINGLE_IMAGE'
}

export type ChangeCouponsSettingsInput = {
  isDiscountEnabled: Scalars['Boolean'];
};

export type ChangeVideoThumbnailInput = {
  thumbnailAttachmentId: Scalars['Int'];
  videoId: Scalars['Int'];
};

export type Checkout = {
  __typename?: 'Checkout';
  checkoutItems?: Maybe<CheckoutItems>;
  client?: Maybe<Client>;
  coupon?: Maybe<Coupon>;
  createdAtUtc?: Maybe<Datetime>;
  currencyIsoCode?: Maybe<Scalars['String']>;
  discountsSum: Array<DiscountsSum>;
  displayCurrencyIsoCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  guestUser?: Maybe<GuestUser>;
  id: Scalars['Int'];
  promoCode?: Maybe<PromoCode>;
  stripeClientSecret?: Maybe<Scalars['String']>;
  stripePaymentId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  totalAppliedCoupon?: Maybe<Price>;
  totalAppliedCredit?: Maybe<Price>;
  totalPrice?: Maybe<Price>;
  tradeLicense?: Maybe<TradeLicense>;
  updatedAtUtc?: Maybe<Datetime>;
};


export type CheckoutCheckoutItemsArgs = {
  input?: InputMaybe<CheckoutItemsPaginationInput>;
};

export type CheckoutAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<ClientAddressType>;
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryIsoCode: Scalars['String'];
  countryState?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type CheckoutEdge = {
  __typename?: 'CheckoutEdge';
  cursor: Scalars['String'];
  node: Checkout;
};

export type CheckoutInput = {
  addresses?: InputMaybe<Array<InputMaybe<CheckoutAddressInput>>>;
  checkoutItems: Array<InputMaybe<CheckoutItemsInput>>;
  couponCode?: InputMaybe<Scalars['String']>;
  currencyIsoCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['email_String_format_email']>;
  promoCode?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
  useTaxExemption?: InputMaybe<Scalars['Boolean']>;
};

export type CheckoutItem = {
  __typename?: 'CheckoutItem';
  checkout: Checkout;
  coupon?: Maybe<Coupon>;
  createdAtUtc: Datetime;
  discountedPrice: Price;
  discounts?: Maybe<Array<Discount>>;
  id: Scalars['Int'];
  orderItem?: Maybe<OrderItem>;
  orderShipment?: Maybe<OrderShipment>;
  price: Price;
  purchase?: Maybe<Purchase>;
  quantity: Scalars['quantity_Int_NotNull_min_1'];
  refund?: Maybe<Refund>;
  sessionBooking?: Maybe<SessionClient>;
  updatedAtUtc: Datetime;
};

export type CheckoutItemEdge = {
  __typename?: 'CheckoutItemEdge';
  cursor: Scalars['String'];
  node: CheckoutItem;
};

export type CheckoutItems = {
  __typename?: 'CheckoutItems';
  edges: Array<CheckoutItemEdge>;
  pageInfo: CursorPaginationInfo;
};

export type CheckoutItemsInput = {
  cart?: InputMaybe<CartItemInput>;
  coupon?: InputMaybe<PurchaseCouponInput>;
  purchase?: InputMaybe<PurchaseItemInput>;
  quantity: Scalars['Int'];
  sessionBooking?: InputMaybe<PurchaseSessionBooking>;
};

export type CheckoutItemsPaginationInput = {
  pagination?: InputMaybe<PaginationInput>;
};

export type CheckoutPriceCalculation = {
  __typename?: 'CheckoutPriceCalculation';
  couponDiscountSum?: Maybe<Price>;
  discountItems: Array<DiscountItem>;
  discountPercentage?: Maybe<Scalars['Int']>;
  isTaxExemptionApplied?: Maybe<Scalars['Boolean']>;
  leftovers?: Maybe<LeftoverItem>;
  nonPaymentMethodDiscountSum?: Maybe<Price>;
  priceToPay?: Maybe<Price>;
  priceToPayWithoutShipping?: Maybe<Price>;
  retailSubtotalPrice?: Maybe<Price>;
  shippingPrice?: Maybe<Price>;
  totalDiscount?: Maybe<Price>;
  totalPrice?: Maybe<Price>;
  tradeSubtotalPrice?: Maybe<Price>;
  vatToPayWithoutPaymentMethodDiscounts?: Maybe<Scalars['Float']>;
};

export type Checkouts = {
  __typename?: 'Checkouts';
  edges: Array<CheckoutEdge>;
  pageInfo: CursorPaginationInfo;
};

export type CheckoutsCursorPaginationInput = {
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type City = {
  __typename?: 'City';
  title: Scalars['String'];
};

export type Client = {
  __typename?: 'Client';
  addresses: Array<ClientAddress>;
  businessName?: Maybe<Scalars['String']>;
  cards: Array<ClientCreditCard>;
  clientActivities: ClientActivities;
  contactEmail: Scalars['String'];
  createdAtUtc: Datetime;
  credits: Price;
  favoriteExperts: FavoriteExperts;
  favoriteExpertsSlugs?: Maybe<Array<Scalars['String']>>;
  featureFlags?: Maybe<Array<FeatureFlag>>;
  firebaseProviderIds: Array<Scalars['String']>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['Int'];
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loginEmail: Scalars['String'];
  orders: Orders;
  phoneNumber?: Maybe<Scalars['String']>;
  purchases: ClientPurchases;
  resetPasswordToken?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<ClientAddress>;
  status: ClientStatus;
  timezone: Scalars['String'];
  updatedAtUtc: Datetime;
};


export type ClientFavoriteExpertsArgs = {
  input?: InputMaybe<FavoriteExpertsInput>;
};


export type ClientOrdersArgs = {
  input: CursorPaginationInput;
};


export type ClientPurchasesArgs = {
  input: CursorPaginationInput;
};

export type ClientActivities = {
  __typename?: 'ClientActivities';
  isClientSessionActive?: Maybe<Scalars['Boolean']>;
  isClientShowroomActive?: Maybe<Scalars['Boolean']>;
};

export type ClientAddress = {
  __typename?: 'ClientAddress';
  additionalAddress?: Maybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  addressType: ClientAddressType;
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryIsoCode: Scalars['String'];
  countryState?: Maybe<Scalars['String']>;
  createdAtUtc: Scalars['String'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['Int'];
  isPrimary: Scalars['Boolean'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  updatedAtUtc?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export enum ClientAddressType {
  Billing = 'BILLING',
  Shipping = 'SHIPPING'
}

export type ClientBookedSessions = {
  __typename?: 'ClientBookedSessions';
  data: Array<Maybe<PublicSession>>;
  paginationInfo: PaginationInfo;
};

export type ClientBookedSessionsFilter = {
  clientStatuses?: InputMaybe<Array<InputMaybe<SessionClientStatus>>>;
  date?: InputMaybe<StringRangeFilterInput>;
  statuses?: InputMaybe<Array<InputMaybe<SessionStatus>>>;
};

export type ClientBookedSessionsInput = {
  filter?: InputMaybe<ClientBookedSessionsFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sorter?: InputMaybe<SessionsSorterInput>;
};

export type ClientCreditCard = {
  __typename?: 'ClientCreditCard';
  brand: Scalars['String'];
  expiryMonth: Scalars['String'];
  expiryYear: Scalars['String'];
  last4: Scalars['String'];
  stripeId: Scalars['String'];
};

export type ClientExpertAvailabilitySubscriptionInput = {
  email?: InputMaybe<Scalars['email_String_format_email']>;
  expertId: Scalars['Int'];
  expertSessionId?: InputMaybe<Scalars['Int']>;
  metadata: SubscriptionMetadata;
};

export type ClientPurchases = {
  __typename?: 'ClientPurchases';
  edges: Array<PurchaseEdge>;
  pageInfo: CursorPaginationInfo;
};

export type ClientSignUpInput = {
  contactEmail: Scalars['contactEmail_String_NotNull_format_email'];
  firstName: Scalars['SafeString'];
  idToken: Scalars['String'];
  lastName: Scalars['SafeString'];
  returnUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type ClientSignUpResponse = {
  __typename?: 'ClientSignUpResponse';
  authToken: Scalars['String'];
  contactEmail: Scalars['String'];
  createdAtUtc: Datetime;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  loginEmail: Scalars['String'];
  status: ClientStatus;
  updatedAtUtc: Datetime;
};

export enum ClientSorterField {
  CreatedAtUtc = 'createdAtUtc'
}

export enum ClientStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Suspended = 'SUSPENDED'
}

export type Clients = {
  __typename?: 'Clients';
  data: Array<Maybe<Client>>;
  paginationInfo: PaginationInfo;
};

export type ClientsFilterInput = {
  statuses?: InputMaybe<Array<ClientStatus>>;
};

export type ClientsInput = {
  filter?: InputMaybe<ClientsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<ClientsSorterInput>;
};

export type ClientsSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ClientSorterField>;
};

export type CmsArticlesWidgetSpecificInput = {
  input?: InputMaybe<PaginationInput>;
};

export type CmsExpertsListingWidgetSpecificInput = {
  input?: InputMaybe<ExpertsInput>;
};

export type CmsExpertsWidgetSpecificInput = {
  input?: InputMaybe<PaginationInput>;
};

export type CmsMultiCollectionWidgetProductsCollectionsInput = {
  input?: InputMaybe<CollectionsInput>;
};

export type CmsMultiCollectionWidgetProductsInput = {
  input?: InputMaybe<ProductsInput>;
};

export type Collection = {
  __typename?: 'Collection';
  brands?: Maybe<Array<Brand>>;
  categoriesOne: Array<ProductCategory>;
  categoriesThree: Array<ProductCategory>;
  categoriesTwo: Array<ProductCategory>;
  createdAtUtc: Datetime;
  expert?: Maybe<Expert>;
  id: Scalars['Int'];
  isGenerated: Scalars['Boolean'];
  items: CollectionItems;
  itemsCursorPagination: CollectionItemsCursorPagination;
  maxPrice: Price;
  status: CollectionStatus;
  subtype: CollectionSubtype;
  title: Scalars['String'];
  type: CollectionType;
  updatedAtUtc: Datetime;
};


export type CollectionItemsArgs = {
  input?: InputMaybe<ProductsInput>;
};


export type CollectionItemsCursorPaginationArgs = {
  input?: InputMaybe<ItemsCursorPaginationInput>;
};

export type CollectionEdge = {
  __typename?: 'CollectionEdge';
  cursor: Scalars['String'];
  node: Collection;
};

export type CollectionFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  productsIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

export enum CollectionHeaderType {
  Default = 'DEFAULT',
  WhiteTextOnDark = 'WHITE_TEXT_ON_DARK'
}

export type CollectionItem = {
  __typename?: 'CollectionItem';
  breakoutVariant?: Maybe<ProductBreakoutVariant>;
  id: Scalars['String'];
  maxPublishedPrice?: Maybe<Scalars['Float']>;
  minPublishedPrice?: Maybe<Scalars['Float']>;
  positionIndexWeight?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  productVariant?: Maybe<ProductVariant>;
};

export type CollectionItemEdge = {
  __typename?: 'CollectionItemEdge';
  cursor: Scalars['String'];
  node: CollectionItem;
};

export enum CollectionItemSorterField {
  FirstPublishedAtUtc = 'firstPublishedAtUtc',
  Manufacturer = 'manufacturer',
  MinPublishedPrice = 'minPublishedPrice',
  PositionIndexWeight = 'positionIndexWeight',
  ProductId = 'productId',
  ProductSku = 'productSku',
  ProductTitle = 'productTitle',
  Status = 'status',
  UpdatedAtUtc = 'updatedAtUtc'
}

export type CollectionItems = {
  __typename?: 'CollectionItems';
  data: Array<CollectionItem>;
  paginationInfo: PaginationInfo;
};

export type CollectionItemsCursorPagination = {
  __typename?: 'CollectionItemsCursorPagination';
  edges: Array<CollectionItemEdge>;
  pageInfo: CursorPaginationInfo;
};

export enum CollectionSorterField {
  CreatedAtUtc = 'createdAtUtc'
}

export type CollectionSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<CollectionSorterField>;
};

export enum CollectionStatus {
  InReview = 'IN_REVIEW',
  NotPublished = 'NOT_PUBLISHED',
  Published = 'PUBLISHED'
}

export enum CollectionSubtype {
  Default = 'DEFAULT',
  ExpertShowroom = 'EXPERT_SHOWROOM'
}

export enum CollectionType {
  Automatic = 'AUTOMATIC',
  AutomaticRuleset = 'AUTOMATIC_RULESET',
  Manual = 'MANUAL',
  Ruleset = 'RULESET'
}

export type Collections = {
  __typename?: 'Collections';
  data: Array<Maybe<Collection>>;
  paginationInfo: PaginationInfo;
};

export type CollectionsCursorPagination = {
  __typename?: 'CollectionsCursorPagination';
  edges: Array<CollectionEdge>;
  pageInfo: CursorPaginationInfo;
};

export type CollectionsInput = {
  filter?: InputMaybe<CollectionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorter?: InputMaybe<CollectionSorterInput>;
};

export enum CommissionStatus {
  PaidOut = 'PAID_OUT',
  Unpaid = 'UNPAID'
}

export type Country = {
  __typename?: 'Country';
  isoCode: Scalars['String'];
  title: Scalars['String'];
};

export type Coupon = {
  __typename?: 'Coupon';
  /** @deprecated Use totalAmount and currentAmount instead */
  amount: Scalars['Int'];
  checkoutItem?: Maybe<CheckoutItem>;
  client?: Maybe<Client>;
  code: Scalars['String'];
  createdAtUtc: Datetime;
  currentAmount: Scalars['Float'];
  differentRecipient?: Maybe<DifferentCouponRecipient>;
  guestUserEmail?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isUsed: Scalars['Boolean'];
  isValid: Scalars['Boolean'];
  totalAmount: Scalars['Float'];
  updatedAtUtc: Datetime;
};

export type CouponEdge = {
  __typename?: 'CouponEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Coupon>;
};

export type CouponPrice = {
  __typename?: 'CouponPrice';
  discount?: Maybe<Price>;
  discountPercentage?: Maybe<Scalars['Int']>;
  originalPrice: Price;
  price: Price;
};

export type Coupons = {
  __typename?: 'Coupons';
  edges: Array<CouponEdge>;
  pageInfo: CursorPaginationInfo;
};

export type CouponsInput = {
  filter?: InputMaybe<CouponsInputFilter>;
  pagination: CursorPaginationInput;
  search?: InputMaybe<Scalars['String']>;
};

export type CouponsInputFilter = {
  date?: InputMaybe<StringRangeFilterInput>;
};

export type CouponsSettings = {
  __typename?: 'CouponsSettings';
  isDiscountEnabled: Scalars['Boolean'];
};

export type CreateAccountLinkInput = {
  accountId: Scalars['String'];
  refreshUrl: Scalars['String'];
  returnUrl: Scalars['String'];
};

export type CreateAdminInput = {
  email: Scalars['email_String_NotNull_format_email'];
  name: Scalars['String'];
  password: Scalars['password_String_NotNull_minLength_6'];
};

export type CreateAttachmentInput = {
  crop?: InputMaybe<CropInput>;
  file: Scalars['Upload'];
};

export type CreateCmsArticlePageInput = {
  author: Scalars['String'];
  cmsPageInput: CreateCmsPageInput;
  previewAttachmentId?: InputMaybe<Scalars['Int']>;
  previewText?: InputMaybe<Scalars['String']>;
  relatedArticlesWidget?: InputMaybe<RelatedArticlesWidgetInput>;
  tag?: InputMaybe<Scalars['String']>;
};

export type CreateCmsConsultationPageInput = {
  cmsPageInput: CreateCmsPageInput;
};

export type CreateCmsPageInput = {
  keywords?: InputMaybe<Array<Scalars['String']>>;
  metaDescription?: InputMaybe<Scalars['String']>;
  metaTitle?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  widgets?: InputMaybe<Array<CmsWidgetInput>>;
};

export type CreateCmsShowroomPageInput = {
  cmsPageInput: CreateCmsPageInput;
};

export type CreateCategoryInput = {
  colorHexCode: Scalars['String'];
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isHighlighted?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CreateClientAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<ClientAddressType>;
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryIsoCode: Scalars['String'];
  countryState?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type CreateCollectionInput = {
  expertId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CollectionStatus>;
  title: Scalars['String'];
};

export type CreateCouponInput = {
  amount: Scalars['Int'];
  codeOverride?: InputMaybe<Scalars['String']>;
};

export type CreateExpertApplicationInput = {
  birthDate?: InputMaybe<Scalars['String']>;
  categoryIds: Array<Scalars['Int']>;
  city: Scalars['String'];
  countryIsoCode: Scalars['String'];
  countryState?: InputMaybe<Scalars['String']>;
  email: Scalars['email_String_NotNull_format_email'];
  expertiseDescription: Scalars['String'];
  facebookAccountUrl?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  instagramAccountUrl?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  linkedInAccountUrl?: InputMaybe<Scalars['String']>;
  otherCategory?: InputMaybe<Scalars['String']>;
  subcategoryIds: Array<Scalars['Int']>;
  twitterAccountUrl?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  youtubeAccountUrl?: InputMaybe<Scalars['String']>;
};

export type CreateExpertAttachmentInput = {
  crop?: InputMaybe<CropInput>;
  file: Scalars['Upload'];
  isGalleryImage?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateExpertFromAdminDashboardInput = {
  businessName: Scalars['String'];
  capabilities?: InputMaybe<Array<Scalars['String']>>;
  city?: InputMaybe<Scalars['String']>;
  countryIsoCode?: InputMaybe<Scalars['String']>;
  countryState?: InputMaybe<Scalars['String']>;
  currencyIsoCode?: InputMaybe<CurrencyIsoCode>;
  email: Scalars['email_String_NotNull_format_email'];
  firstName: Scalars['String'];
  isCreatedFromTradeApplication?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  profileName?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type CreateExpertFromApplicationInput = {
  currencyIsoCode?: InputMaybe<CurrencyIsoCode>;
  onboardingToken: Scalars['String'];
  password: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
};

export type CreateExpertRegionInput = {
  expertId: Scalars['Int'];
  expertPositionIndexWeight: Scalars['Int'];
  regionId: Scalars['Int'];
};

export type CreateExpertTagInput = {
  expertId?: InputMaybe<Scalars['Int']>;
  tagTitle?: InputMaybe<Scalars['String']>;
};

export type CreateFilesAndNotesAttachmentInput = {
  file: Scalars['Upload'];
};

export type CreateGroupExpertAvailabilityInput = {
  endAtUtc: Scalars['String'];
  isOnRepeat: Scalars['Boolean'];
  sessionId: Scalars['Int'];
  startAtUtc: Scalars['String'];
};

export type CreateGroupExpertSessionInput = {
  description: Scalars['String'];
  emailNote: Scalars['String'];
  expertUserId?: InputMaybe<Scalars['Int']>;
  lengthInMinutes: Scalars['Int'];
  minimumSessionSize: Scalars['Int'];
  price: Scalars['Float'];
  sessionCapacity: Scalars['Int'];
  title: Scalars['String'];
};

export type CreateNavigationInput = {
  childTitle: Scalars['String'];
  cmsPageId: Scalars['Int'];
  navigationGroupId: Scalars['Int'];
  title: Scalars['String'];
};

export type CreateNavigationItemInput = {
  attachmentId?: InputMaybe<Scalars['Int']>;
  cmsPageId?: InputMaybe<Scalars['Int']>;
  navigationId: Scalars['Int'];
  parentId: Scalars['Int'];
  positionIndexWeight?: InputMaybe<Scalars['String']>;
  subItemsWithImages: Scalars['Boolean'];
  title: Scalars['String'];
};

export type CreateOrderNoteInput = {
  message: Scalars['String'];
  orderId: Scalars['Int'];
};

export type CreatePrivateExpertAvailabilityInput = {
  endAtUtc: Scalars['String'];
  isOnRepeat: Scalars['Boolean'];
  startAtUtc: Scalars['String'];
};

export type CreatePrivateExpertSessionInput = {
  description: Scalars['String'];
  emailNote: Scalars['String'];
  expertUserId?: InputMaybe<Scalars['Int']>;
  isUpToThreeGuestsAllowed: Scalars['Boolean'];
  lengthInMinutes: Scalars['Int'];
  price: Scalars['Float'];
  title: Scalars['String'];
};

export type CreatePurchaseInput = {
  attachmentId?: InputMaybe<Scalars['Int']>;
  billingAddressLine1?: InputMaybe<Scalars['String']>;
  billingAddressLine2?: InputMaybe<Scalars['String']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingCompany?: InputMaybe<Scalars['String']>;
  billingCountryIsoCode?: InputMaybe<Scalars['String']>;
  billingCountryState?: InputMaybe<Scalars['String']>;
  billingFullName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingZipCode?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  expertId?: InputMaybe<Scalars['Int']>;
  expertUserId?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<Scalars['String']>;
  retailPrice: Scalars['Float'];
  shippingAddressLine1?: InputMaybe<Scalars['String']>;
  shippingAddressLine2?: InputMaybe<Scalars['String']>;
  shippingCity?: InputMaybe<Scalars['String']>;
  shippingCompany?: InputMaybe<Scalars['String']>;
  shippingCountryIsoCode?: InputMaybe<Scalars['String']>;
  shippingCountryState?: InputMaybe<Scalars['String']>;
  shippingFullName?: InputMaybe<Scalars['String']>;
  shippingPhone?: InputMaybe<Scalars['String']>;
  shippingPrice: Scalars['Float'];
  shippingZipCode?: InputMaybe<Scalars['String']>;
  tax: Scalars['Float'];
  tradeLicenseId?: InputMaybe<Scalars['Int']>;
  vendorExpertCommission: Scalars['Float'];
  vendorId?: InputMaybe<Scalars['Int']>;
  vendorPrice: Scalars['Float'];
};

export type CreateRegionInput = {
  parentId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CreateSessionClientAttachmentInput = {
  file: Scalars['Upload'];
  name?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['Int'];
};

export type CreateTagInput = {
  title: Scalars['String'];
};

export type CreateTradeLicenseInput = {
  attachmentIds: Array<Scalars['Int']>;
  countryStates: Array<Scalars['String']>;
  expertId: Scalars['Int'];
  expiresAtUtc?: InputMaybe<Scalars['String']>;
  isSingleUse?: InputMaybe<Scalars['Boolean']>;
  legalBusinessName?: InputMaybe<Scalars['String']>;
  licenseNumber: Scalars['String'];
  name: Scalars['String'];
};

export type CreateTrustedSourceInput = {
  childSrc?: InputMaybe<Scalars['Boolean']>;
  connectSrc?: InputMaybe<Scalars['Boolean']>;
  domain: Scalars['String'];
  fontSrc?: InputMaybe<Scalars['Boolean']>;
  frameSrc?: InputMaybe<Scalars['Boolean']>;
  imgSrc?: InputMaybe<Scalars['Boolean']>;
  manifestSrc?: InputMaybe<Scalars['Boolean']>;
  mediaSrc?: InputMaybe<Scalars['Boolean']>;
  objectSrc?: InputMaybe<Scalars['Boolean']>;
  prefetchSrc?: InputMaybe<Scalars['Boolean']>;
  scriptSrc?: InputMaybe<Scalars['Boolean']>;
  scriptSrcAttr?: InputMaybe<Scalars['Boolean']>;
  scriptSrcElem?: InputMaybe<Scalars['Boolean']>;
  styleSrc?: InputMaybe<Scalars['Boolean']>;
  styleSrcAttr?: InputMaybe<Scalars['Boolean']>;
  styleSrcElem?: InputMaybe<Scalars['Boolean']>;
  workerSrc?: InputMaybe<Scalars['Boolean']>;
};

export type CreateVendorInput = {
  attachmentId: Scalars['Int'];
  brands: Array<Scalars['String']>;
  expertCommission: Scalars['Int'];
  name: Scalars['String'];
  policy?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type CreditTransaction = {
  __typename?: 'CreditTransaction';
  amount?: Maybe<Scalars['Float']>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  type: CreditTransactionType;
};

export enum CreditTransactionType {
  AdminModified = 'ADMIN_MODIFIED',
  Refund = 'REFUND'
}

export type CropInput = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
  x?: InputMaybe<Scalars['Int']>;
  y?: InputMaybe<Scalars['Int']>;
};

export enum CurrencyIsoCode {
  Cad = 'CAD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type CursorPaginationInfo = {
  __typename?: 'CursorPaginationInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type CursorPaginationInput = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CustomFlowPurchaseInput = {
  addresses?: InputMaybe<Array<InputMaybe<CheckoutAddressInput>>>;
  cartShipmentIds?: InputMaybe<Array<Scalars['Int']>>;
  email?: InputMaybe<Scalars['email_String_format_email']>;
};

export type Datetime = {
  __typename?: 'Datetime';
  isoFormat: Scalars['String'];
  mysqlUtcFormat: Scalars['String'];
};

export type DeleteExpertAttachmentInput = {
  attachmentId: Scalars['Int'];
};

export type DeleteExpertAvailabilitiesInput = {
  ids: Array<Scalars['Int']>;
  isDeleteAllFollowingEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type DeleteExpertRegionInput = {
  expertId: Scalars['Int'];
  regionId: Scalars['Int'];
};

export type DeleteExpertTagInput = {
  expertId: Scalars['Int'];
  tagId: Scalars['Int'];
};

export type DeleteSessionClientAttachmentInput = {
  attachmentId: Scalars['Int'];
  sessionClientId: Scalars['Int'];
};

export type DifferentCouponRecipient = {
  __typename?: 'DifferentCouponRecipient';
  buyerFullName: Scalars['String'];
  recipientEmail: Scalars['String'];
  recipientFirstName: Scalars['String'];
  recipientMessage: Scalars['String'];
};

export type DifferentCouponRecipientInput = {
  buyerFullName: Scalars['SafeString'];
  recipientEmail: Scalars['recipientEmail_String_NotNull_format_email'];
  recipientFirstName: Scalars['SafeString'];
  recipientMessage: Scalars['String'];
};

export type Discount = {
  __typename?: 'Discount';
  id: Scalars['Int'];
  type: DiscountType;
  unitDiscount: Price;
};

export type DiscountItem = {
  __typename?: 'DiscountItem';
  checkoutItemId: Scalars['Int'];
  itemId: Scalars['Int'];
  itemType: DiscountItemType;
  itemUnitDiscount: Price;
};

export enum DiscountItemType {
  Coupon = 'COUPON',
  OrderShipment = 'ORDER_SHIPMENT',
  ProductVariant = 'PRODUCT_VARIANT',
  Purchase = 'PURCHASE',
  Session = 'SESSION'
}

export enum DiscountType {
  CouponAmount = 'COUPON_AMOUNT',
  CouponPercentage = 'COUPON_PERCENTAGE',
  CreditAmount = 'CREDIT_AMOUNT',
  PromoCodeAmount = 'PROMO_CODE_AMOUNT',
  PromoCodePercentage = 'PROMO_CODE_PERCENTAGE',
  SessionPercentage = 'SESSION_PERCENTAGE',
  ShipmentSubsidy = 'SHIPMENT_SUBSIDY'
}

export type DiscountsSum = {
  __typename?: 'DiscountsSum';
  discount?: Maybe<Price>;
  type?: Maybe<DiscountType>;
};

export type EditCategoryInput = {
  colorHexCode?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isHighlighted?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EditCollectionProductInput = {
  collectionId: Scalars['Int'];
  positionIndexWeight: Scalars['Int'];
  productId: Scalars['Int'];
  productVariantId?: InputMaybe<Scalars['Int']>;
};

export type EditTagInput = {
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type EmailEvent = {
  __typename?: 'EmailEvent';
  createdAtUtc: Datetime;
  event: Scalars['String'];
  id: Scalars['Int'];
  sendgridEventId: Scalars['String'];
  sendgridMessageId: Scalars['String'];
  type: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type Expert = {
  __typename?: 'Expert';
  attachments: Array<Maybe<Attachment>>;
  availableExpertDetailTabs: Array<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  businessName: Scalars['String'];
  capabilities: Array<Scalars['String']>;
  categories: Array<ExpertCategory>;
  charts: ExpertChart;
  city?: Maybe<Scalars['String']>;
  countryIsoCode?: Maybe<Scalars['String']>;
  countryState?: Maybe<Scalars['String']>;
  createdAtUtc: Datetime;
  currencyIsoCode: CurrencyIsoCode;
  customCancelationPolicy?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  expertShowroomCollection?: Maybe<Collection>;
  expertises?: Maybe<Array<ExpertExpertise>>;
  facebookAccountUrl?: Maybe<Scalars['String']>;
  hasRequiredServicesActivated: Scalars['Boolean'];
  headshotImageAttachment?: Maybe<Attachment>;
  /** @deprecated Use headshotImageAttachment instead */
  headshotImageUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  images: Array<Maybe<Attachment>>;
  instagramAccountUrl?: Maybe<Scalars['String']>;
  isConsultationRecapFormEnabled?: Maybe<Scalars['Boolean']>;
  isContractAccepted: Scalars['Boolean'];
  isContractManuallyDisabled: Scalars['Boolean'];
  isFeatured: Scalars['Boolean'];
  isFindable: Scalars['Boolean'];
  isFundraiser: Scalars['Boolean'];
  isPublicVisible: Scalars['Boolean'];
  isStripeAccountActivated: Scalars['Boolean'];
  isStripeOnboarded: Scalars['Boolean'];
  jobTitle?: Maybe<Scalars['String']>;
  legalBusinessName?: Maybe<Scalars['String']>;
  linkedInAccountUrl?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  mainUser: ExpertUser;
  nonBookedAvailabilityHours?: Maybe<Scalars['Float']>;
  orders: Orders;
  platformFeePercentage: Scalars['Int'];
  positionIndexWeight?: Maybe<Scalars['Int']>;
  primaryLocation?: Maybe<Scalars['String']>;
  profileImageAttachment?: Maybe<Attachment>;
  /** @deprecated Use profileImageAttachment instead */
  profileImageUrl?: Maybe<Scalars['String']>;
  profileName?: Maybe<Scalars['String']>;
  purchaseCommissions: ExpertPurchases;
  purchases: ExpertPurchases;
  purchasesWithoutCommission: ExpertPurchases;
  regions: Array<Region>;
  reviews?: Maybe<Reviews>;
  reviewsAverageRating?: Maybe<ReviewsAverageRating>;
  secondaryLocation?: Maybe<Scalars['String']>;
  sessions: Array<PublicExpertSession>;
  shortDescription?: Maybe<Scalars['String']>;
  showroomCommissions: ExpertShowroomCommissions;
  slug: Scalars['String'];
  status: ExpertStatus;
  stripeDashboardUrl?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripeOnboardingToken?: Maybe<Scalars['String']>;
  subCategories: Array<ExpertCategory>;
  subscribersCount: Scalars['Int'];
  tags?: Maybe<Array<Tag>>;
  testimonials?: Maybe<Testimonials>;
  tradeLicenses: TradeLicenses;
  twitterAccountUrl?: Maybe<Scalars['String']>;
  updatedAtUtc: Datetime;
  users?: Maybe<Array<ExpertUser>>;
  websiteUrl?: Maybe<Scalars['String']>;
  youtubeAccountUrl?: Maybe<Scalars['String']>;
};


export type ExpertOrdersArgs = {
  input: CursorPaginationInput;
};


export type ExpertPurchaseCommissionsArgs = {
  input: CursorPaginationInput;
};


export type ExpertPurchasesArgs = {
  input: CursorPaginationInput;
};


export type ExpertPurchasesWithoutCommissionArgs = {
  input: CursorPaginationInput;
};


export type ExpertReviewsArgs = {
  input?: InputMaybe<ReviewsInput>;
};


export type ExpertShowroomCommissionsArgs = {
  input: CursorPaginationInput;
};


export type ExpertTestimonialsArgs = {
  input?: InputMaybe<TestimonialsInput>;
};


export type ExpertTradeLicensesArgs = {
  input: ExpertTradeLicensesInput;
};

export type ExpertApplication = {
  __typename?: 'ExpertApplication';
  birthDate?: Maybe<Datetime>;
  categories: Array<Maybe<Category>>;
  city: Scalars['String'];
  countryIsoCode: Scalars['String'];
  countryState?: Maybe<Scalars['String']>;
  createdAtUtc: Datetime;
  email: Scalars['String'];
  expertiseDescription: Scalars['String'];
  facebookAccountUrl?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  instagramAccountUrl?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  linkedInAccountUrl?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  onboardingToken?: Maybe<Scalars['String']>;
  otherCategory?: Maybe<Scalars['String']>;
  status: ExpertApplicationStatus;
  twitterAccountUrl?: Maybe<Scalars['String']>;
  updatedAtUtc: Datetime;
  websiteUrl?: Maybe<Scalars['String']>;
  youtubeAccountUrl?: Maybe<Scalars['String']>;
};

export enum ExpertApplicationStatus {
  Approved = 'APPROVED',
  InWaitlist = 'IN_WAITLIST',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ExpertApplications = {
  __typename?: 'ExpertApplications';
  data: Array<Maybe<ExpertApplication>>;
  paginationInfo: PaginationInfo;
};

export type ExpertApplicationsInput = {
  pagination?: InputMaybe<PaginationInput>;
  sorter?: InputMaybe<ExpertApplicationsSorterInput>;
  statuses?: InputMaybe<Array<ExpertApplicationStatus>>;
};

export type ExpertApplicationsSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ExpertApplicationsorterField>;
};

export enum ExpertApplicationsorterField {
  CreatedAtUtc = 'createdAtUtc',
  Email = 'email',
  FirstName = 'firstName'
}

export type ExpertAttachment = {
  __typename?: 'ExpertAttachment';
  attachment: Attachment;
  id: Scalars['Int'];
};

export type ExpertAttachmentsInput = {
  expertId: Scalars['Int'];
};

export type ExpertAvailabilities = {
  __typename?: 'ExpertAvailabilities';
  data: Array<Maybe<ExpertAvailability>>;
  paginationInfo: PaginationInfo;
};

export type ExpertAvailabilitiesFilter = {
  date?: InputMaybe<StringRangeFilterInput>;
  expertUserIds?: InputMaybe<Array<Scalars['Int']>>;
  sessionType?: InputMaybe<SessionTypeField>;
  unusedOnly: Scalars['Boolean'];
};

export type ExpertAvailabilitiesInput = {
  expertUserId: Scalars['Int'];
  filter?: InputMaybe<ExpertAvailabilitiesFilter>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ExpertAvailability = {
  __typename?: 'ExpertAvailability';
  endAtUtc: Datetime;
  expert: Expert;
  expertUser: ExpertUser;
  id: Scalars['Int'];
  isOnRepeat: Scalars['Boolean'];
  sessionType: SessionTypeField;
  startAtUtc: Datetime;
  templateId?: Maybe<Scalars['Int']>;
};

export type ExpertAvailabilityGroup = {
  __typename?: 'ExpertAvailabilityGroup';
  contains: Array<ExpertAvailability>;
  endAtUtc: Datetime;
  startAtUtc: Datetime;
};

export type ExpertAvailableTimesInput = {
  date: StringRangeFilterInput;
  duration: Scalars['Int'];
  expertUserId: Scalars['Int'];
};

export type ExpertBookedSessions = {
  __typename?: 'ExpertBookedSessions';
  data: Array<Maybe<Session>>;
  paginationInfo: PaginationInfo;
  stats?: Maybe<ExpertBookedSessionsStats>;
};

export type ExpertBookedSessionsFilter = {
  date?: InputMaybe<StringRangeFilterInput>;
  expertSessionId?: InputMaybe<Scalars['Int']>;
  expertSessionType?: InputMaybe<SessionTypeField>;
  expertUserIds?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<SessionStatus>>;
};

export type ExpertBookedSessionsInput = {
  expertUserId: Scalars['Int'];
  filter?: InputMaybe<ExpertBookedSessionsFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sorter?: InputMaybe<SessionsSorterInput>;
};

export type ExpertBookedSessionsStats = {
  __typename?: 'ExpertBookedSessionsStats';
  totalPrice: Array<Price>;
};

export type ExpertCancelSessionInput = {
  cancelReason: Scalars['String'];
  id: Scalars['Int'];
};

export type ExpertCategory = {
  __typename?: 'ExpertCategory';
  category: Category;
  categoryType: ExpertCategoryTypes;
  expert: Expert;
  positionIndexWeight?: Maybe<Scalars['Int']>;
};

export enum ExpertCategoryTypes {
  None = 'NONE',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type ExpertChart = {
  __typename?: 'ExpertChart';
  sessionCount: Array<ExpertChartTimeRecord>;
  sessionRevenue: Array<ExpertChartTimeRecord>;
};


export type ExpertChartSessionCountArgs = {
  input: ExpertChartOptions;
};


export type ExpertChartSessionRevenueArgs = {
  input: ExpertChartOptions;
};

export type ExpertChartData = {
  __typename?: 'ExpertChartData';
  currencyIsoCode: CurrencyIsoCode;
  status: SessionStatus;
  value: Scalars['Float'];
};

export type ExpertChartOptions = {
  date?: InputMaybe<StringRangeFilterInput>;
  groupType?: InputMaybe<RevenueGroupField>;
};

export type ExpertChartTimeRecord = {
  __typename?: 'ExpertChartTimeRecord';
  chartData: Array<ExpertChartData>;
  date: Datetime;
  unix: Scalars['Int'];
};

export type ExpertCreditCard = {
  __typename?: 'ExpertCreditCard';
  brand: Scalars['String'];
  expiryMonth: Scalars['String'];
  expiryYear: Scalars['String'];
  last4: Scalars['String'];
  stripeId: Scalars['String'];
};

export type ExpertEdge = {
  __typename?: 'ExpertEdge';
  cursor: Scalars['String'];
  node: Expert;
};

export type ExpertExpertise = {
  __typename?: 'ExpertExpertise';
  expert: Expert;
  expertise: Scalars['String'];
  id: Scalars['Int'];
  positionIndexWeight: Scalars['Int'];
};

export type ExpertExpertiseInput = {
  expertise: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  positionIndexWeight: Scalars['Int'];
};

export type ExpertFilterInput = {
  availability?: InputMaybe<StringRangeFilterInput>;
  categoryId?: InputMaybe<Scalars['Int']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  isFindable?: InputMaybe<Scalars['Boolean']>;
  isOrdered?: InputMaybe<Scalars['Boolean']>;
  isPublicVisible?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<IntRangeFilterInput>;
  regions?: InputMaybe<Array<Scalars['String']>>;
  regionsExclude?: InputMaybe<Array<Scalars['String']>>;
  sessionLength?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<ExpertStatus>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type ExpertPrivateAvailabilitiesGroupsInput = {
  date: StringRangeFilterInput;
  expertUserId: Scalars['Int'];
};

export type ExpertPurchases = {
  __typename?: 'ExpertPurchases';
  edges: Array<Maybe<PurchaseEdge>>;
  pageInfo: CursorPaginationInfo;
};

export type ExpertSession = {
  __typename?: 'ExpertSession';
  createdAtUtc: Datetime;
  description: Scalars['String'];
  emailNote?: Maybe<Scalars['String']>;
  expert: Expert;
  expertUser: ExpertUser;
  id: Scalars['Int'];
  isUpToThreeGuestsAllowed: Scalars['Boolean'];
  lengthInMinutes: Scalars['Int'];
  minimumSessionSize?: Maybe<Scalars['Int']>;
  price: Price;
  sessionCapacity?: Maybe<Scalars['Int']>;
  sessionType: SessionTypeField;
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type ExpertSessionClientInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['email_String_format_email']>;
  id: Scalars['Int'];
  promoCode?: InputMaybe<Scalars['String']>;
};

export type ExpertSessionInput = {
  expertUserId: Scalars['Int'];
  id: Scalars['Int'];
};

export type ExpertSessions = {
  __typename?: 'ExpertSessions';
  data: Array<Maybe<ExpertSession>>;
  paginationInfo: PaginationInfo;
};

export type ExpertSessionsFilterInput = {
  expertUsersIds?: InputMaybe<Array<Scalars['Int']>>;
  priceRange?: InputMaybe<FloatRangeFilterInput>;
  sessionType?: InputMaybe<SessionTypeField>;
};

export type ExpertSessionsInput = {
  expertUserId: Scalars['Int'];
  filter?: InputMaybe<ExpertSessionsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ExpertShowroomCommission = {
  __typename?: 'ExpertShowroomCommission';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  productData: Scalars['JSON'];
  quantity: Scalars['Int'];
  rate: Scalars['Float'];
  status: CommissionStatus;
};

export type ExpertShowroomCommissionEdge = {
  __typename?: 'ExpertShowroomCommissionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ExpertShowroomCommission>;
};

export type ExpertShowroomCommissions = {
  __typename?: 'ExpertShowroomCommissions';
  edges: Array<Maybe<ExpertShowroomCommissionEdge>>;
  pageInfo: CursorPaginationInfo;
};

export enum ExpertSorterField {
  CreatedAtUtc = 'createdAtUtc',
  NonBookedAvailabilityHours = 'nonBookedAvailabilityHours',
  PositionIndexWeight = 'positionIndexWeight',
  ProfileName = 'profileName'
}

export type ExpertSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ExpertSorterField>;
};

export enum ExpertStatus {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED'
}

export type ExpertTestimonial = {
  __typename?: 'ExpertTestimonial';
  clientName: Scalars['String'];
  consultationName?: Maybe<Scalars['String']>;
  createdAtUtc: Datetime;
  expert: Expert;
  expertUser: ExpertUser;
  feedback: Scalars['String'];
  id: Scalars['Int'];
  positionIndexWeight: Scalars['Int'];
};

export type ExpertTestimonialInput = {
  clientName: Scalars['String'];
  consultationName: Scalars['String'];
  expertUserId: Scalars['Int'];
  feedback: Scalars['String'];
  positionIndexWeight: Scalars['Int'];
  testimonialId?: InputMaybe<Scalars['Int']>;
};

export type ExpertTradeLicensesInput = {
  filter?: InputMaybe<TradeLicensesFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type ExpertUser = {
  __typename?: 'ExpertUser';
  activeSessionsCount: Scalars['Int'];
  bookingsCount: Scalars['Int'];
  calendar?: Maybe<Calendar>;
  capabilities: Array<Scalars['String']>;
  cards: Array<ExpertCreditCard>;
  createdAtUtc: Datetime;
  email: Scalars['String'];
  expert: Expert;
  featureFlags?: Maybe<Array<FeatureFlag>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isMain?: Maybe<Scalars['Boolean']>;
  isZoomAccountActivated?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  nonBookedAvailabilityHours?: Maybe<Scalars['Float']>;
  notificationEmails: Array<NotificationEmail>;
  onboardingToken?: Maybe<Scalars['String']>;
  ordersCount?: Maybe<Scalars['Int']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  status: ExpertUserStatus;
  timezone: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  totalEarned: Price;
  updatedAtUtc: Datetime;
  zoomAccountId?: Maybe<Scalars['String']>;
  zoomAccountType?: Maybe<ExpertUserZoomAccountType>;
  zoomConnectedEmail?: Maybe<Scalars['String']>;
};

export type ExpertUserEdge = {
  __typename?: 'ExpertUserEdge';
  cursor: Scalars['String'];
  node: ExpertUser;
};

export type ExpertUserNotificationEmailInput = {
  email: Scalars['email_String_NotNull_format_email'];
  id?: InputMaybe<Scalars['Int']>;
};

export enum ExpertUserSorterField {
  CreatedAtUtc = 'createdAtUtc'
}

export enum ExpertUserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Suspended = 'SUSPENDED'
}

export enum ExpertUserZoomAccountType {
  Basic = 'BASIC',
  Licenced = 'LICENCED',
  None = 'NONE',
  OnPrem = 'ON_PREM'
}

export type ExpertUsers = {
  __typename?: 'ExpertUsers';
  data: Array<Maybe<ExpertUser>>;
  paginationInfo: PaginationInfo;
};

export type ExpertUsersCursorPagination = {
  __typename?: 'ExpertUsersCursorPagination';
  edges: Array<ExpertUserEdge>;
  pageInfo: CursorPaginationInfo;
};

export type ExpertUsersFilterInput = {
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<ExpertUserStatus>>;
};

export type ExpertUsersInput = {
  expertUserId: Scalars['Int'];
  filter?: InputMaybe<ExpertUsersFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorter?: InputMaybe<ExpertUsersSorterInput>;
};

export type ExpertUsersSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ExpertUserSorterField>;
};

export type Experts = {
  __typename?: 'Experts';
  data: Array<Maybe<Expert>>;
  paginationInfo: PaginationInfo;
};

export type ExpertsCursorPagination = {
  __typename?: 'ExpertsCursorPagination';
  edges: Array<ExpertEdge>;
  pageInfo: CursorPaginationInfo;
};

export type ExpertsInput = {
  currencyIsoCode?: InputMaybe<CurrencyIsoCode>;
  filter?: InputMaybe<ExpertFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<ExpertSorterInput>;
};

export type ExpertsTagsInput = {
  expertId: Scalars['Int'];
};

export type ExternalProductPreview = {
  __typename?: 'ExternalProductPreview';
  attachment?: Maybe<Attachment>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  inputUrl: Scalars['String'];
  originUrl: Scalars['String'];
  publisher: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ExternalProductPreviewInput = {
  id?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

export type FavoriteExperts = {
  __typename?: 'FavoriteExperts';
  data: Array<Maybe<Expert>>;
  paginationInfo: PaginationInfo;
};

export type FavoriteExpertsInput = {
  pagination?: InputMaybe<PaginationInput>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  description: Scalars['String'];
  id: Scalars['Int'];
  label: FeatureFlagLabel;
  status: FeatureFlagStatus;
};

export enum FeatureFlagLabel {
  ExpertCommissions = 'EXPERT_COMMISSIONS',
  Payment = 'PAYMENT',
  UserSelfServiceShowroom = 'USER_SELF_SERVICE_SHOWROOM'
}

export enum FeatureFlagStatus {
  Disabled = 'DISABLED',
  EnabledForAll = 'ENABLED_FOR_ALL',
  EnabledForSpecificUsers = 'ENABLED_FOR_SPECIFIC_USERS'
}

export enum FileType {
  File = 'FILE',
  Image = 'IMAGE'
}

export type FilesAndNotes = {
  __typename?: 'FilesAndNotes';
  edges: Array<FilesAndNotesItemEdge>;
  pageInfo?: Maybe<CursorPaginationInfo>;
};

export type FilesAndNotesFilterInput = {
  fileType: FileType;
};

export type FilesAndNotesInput = {
  filter?: InputMaybe<FilesAndNotesFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type FilesAndNotesItem = {
  __typename?: 'FilesAndNotesItem';
  attachment: Attachment;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  updatedAtUtc: Datetime;
};

export type FilesAndNotesItemEdge = {
  __typename?: 'FilesAndNotesItemEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<FilesAndNotesItem>;
};

export type FilesAndNotesItemInput = {
  attachmentId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  note: Scalars['String'];
};

export type FirstTimePublishInput = {
  id: Scalars['Int'];
};

export type FloatRangeFilterInput = {
  from?: InputMaybe<Scalars['from_Float_min_0']>;
  to?: InputMaybe<Scalars['to_Float_min_0']>;
};

export type GlobalSearchInput = {
  limit?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
};

export type GlobalSearchResults = {
  __typename?: 'GlobalSearchResults';
  brands: Array<Brand>;
  navigationItems: Array<NavigationItem>;
  productVariants: Array<ProductVariant>;
  publicExperts: Array<Expert>;
  searchValue: Scalars['String'];
};

export type GuestUser = {
  __typename?: 'GuestUser';
  createdAtUtc: Datetime;
  email: Scalars['String'];
  id: Scalars['Int'];
  updatedAtUtc: Datetime;
};

export type IntRangeFilterInput = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

export type InviteExpertUserInput = {
  email: Scalars['email_String_NotNull_format_email'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type ItemGa4MetaData = {
  __typename?: 'ItemGA4MetaData';
  listIndex?: Maybe<Scalars['Int']>;
  listName?: Maybe<Scalars['String']>;
};

export type ItemGa4MetaDataInput = {
  listIndex?: InputMaybe<Scalars['Int']>;
  listName?: InputMaybe<Scalars['String']>;
};

export type ItemMetadata = {
  __typename?: 'ItemMetadata';
  acknowledgedAt?: Maybe<Datetime>;
  ga4?: Maybe<ItemGa4MetaData>;
  secondaryAcknowledgedAt?: Maybe<Datetime>;
};

export type ItemMetadataInput = {
  ga4?: InputMaybe<ItemGa4MetaDataInput>;
};

export type ItemsCursorPaginationFilterInput = {
  availability?: InputMaybe<Array<AvailabilityEnum>>;
  brands?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['Int']>>;
  price?: InputMaybe<FloatRangeFilterInput>;
  statuses?: InputMaybe<Array<ProductStatus>>;
  useBreakoutVariants?: InputMaybe<Scalars['Boolean']>;
};

export type ItemsCursorPaginationInput = {
  filter?: InputMaybe<ItemsCursorPaginationFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<ItemsCursorPaginationSorterInput>;
};

export type ItemsCursorPaginationSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<CollectionItemSorterField>;
  orderByAvailabilityFirst?: InputMaybe<Scalars['Boolean']>;
};

export type LeftoverItem = {
  __typename?: 'LeftoverItem';
  coupon: Scalars['Float'];
};

export type ManagedCustomFields = {
  __typename?: 'ManagedCustomFields';
  artaMethod?: Maybe<Scalars['String']>;
  artaPackaging?: Maybe<Scalars['String']>;
  artaServices?: Maybe<Scalars['String']>;
  artaSetQuantity?: Maybe<Scalars['String']>;
  artaSubtype?: Maybe<Scalars['String']>;
  depth?: Maybe<Scalars['Float']>;
  enableCounter: Scalars['Boolean'];
  freightClubCategory?: Maybe<Scalars['String']>;
  freightClubMethod?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  incrementalShipmentPrice1?: Maybe<Scalars['Float']>;
  leadTime?: Maybe<Scalars['String']>;
  minimumQuantity?: Maybe<Scalars['String']>;
  productVariantId: Scalars['Int'];
  prop65Eligible?: Maybe<Scalars['Boolean']>;
  proposition65?: Maybe<Scalars['String']>;
  quantityThreshold?: Maybe<Scalars['String']>;
  quantityUnitPlural?: Maybe<Scalars['String']>;
  quantityUnitSingular?: Maybe<Scalars['String']>;
  returnNotEligible?: Maybe<Scalars['Boolean']>;
  shipmentMaxSubsidy?: Maybe<Scalars['Float']>;
  shipmentPercentRetail?: Maybe<Scalars['Float']>;
  shippingCarrier?: Maybe<Scalars['String']>;
  vendorShipping: Scalars['Boolean'];
  vendorShippingFlatRate?: Maybe<Scalars['Boolean']>;
  vendorShippingMethod?: Maybe<Scalars['String']>;
};

export type MarkOrderITemsAsDeliveredInput = {
  deliveredAtUtc?: InputMaybe<Scalars['String']>;
  orderItemIds: Array<Scalars['Int']>;
  shouldSendEmail: Scalars['Boolean'];
};

export type MessageSessionClientsInput = {
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  isMessageToAllPast?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
};

export type MigrateClientToExpertInput = {
  id: Scalars['Int'];
};

export type MoveCategoryAndReorderChildrenInput = {
  childrenCategoryIds: Array<InputMaybe<Scalars['Int']>>;
  id: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
};

export enum MultiCollectionType {
  Default = 'DEFAULT',
  Featured = 'FEATURED'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptContractAgreement: Scalars['Boolean'];
  activateExpertUser: ExpertUser;
  addCollectionProduct: Collection;
  addExpertTestimonial?: Maybe<ExpertTestimonial>;
  addExpertToFavorites: Scalars['Boolean'];
  addExpertUserFeatureFlag: Expert;
  adjustClientCredit: Client;
  adminCancelSession: Session;
  adminCreateExpertRegion: Expert;
  adminDeleteExpertRegion: Expert;
  adminPutSessionOnHold: Session;
  adminRescheduleSession: Session;
  adminResendActivationEmail?: Maybe<Scalars['Boolean']>;
  adminUpdateExpert: Expert;
  adminUpdateExpertRegion: Expert;
  applyCoupon: Scalars['Boolean'];
  applyPromoCode: Scalars['Boolean'];
  approveExpertApplication: Expert;
  banClient: Client;
  banExpert: Expert;
  cancelCheckout: Checkout;
  cancelCollectionReview: Collection;
  cancelPayment: Scalars['Boolean'];
  changeCouponsSettings: CouponsSettings;
  changeEmail: Scalars['Boolean'];
  changeVideoThumbnail: Scalars['Boolean'];
  clientConfirmEmail: Client;
  clientSignUp: ClientSignUpResponse;
  confirmChangeEmail?: Maybe<Scalars['Boolean']>;
  confirmCheckout: Checkout;
  createAccountLink: Scalars['String'];
  createAdmin: Admin;
  createAttachment: Attachment;
  createCartShipmentsFromCart: Cart;
  createCategory: Category;
  createCheckout: Checkout;
  createClientAddress: ClientAddress;
  createCmsArticlePage: CmsArticlePage;
  createCmsConsultationPage: CmsConsultationPage;
  createCmsListingWidget: CmsListingWidget;
  createCmsShowroomPage: CmsShowroomPage;
  createCollection: Collection;
  createCoupon: Coupon;
  createExpertApplication: ExpertApplication;
  createExpertAttachment: Attachment;
  createExpertFromAdminDashboard: Expert;
  createExpertFromApplication: Expert;
  createExpertFromToken: Expert;
  createExpertTag: Tag;
  createExternalProductPreview: ExternalProductPreview;
  createFilesAndNotesAttachment: Attachment;
  createGroupExpertAvailability: ExpertAvailability;
  createGroupExpertSession: ExpertSession;
  createNavigation: Navigation;
  createNavigationItem: NavigationItem;
  createOrderNote: OrderNote;
  createPrivateExpertAvailability: Array<ExpertAvailability>;
  createPrivateExpertSession: ExpertSession;
  createPurchase: Purchase;
  createRegion: Region;
  createSessionClientAttachment: SessionClientAttachment;
  createSessionReport: SessionReport;
  createTradeLicense: TradeLicense;
  createTrustedSource: TrustedSource;
  createVendor: Vendor;
  createVideoAttachment: Attachment;
  cronofyOnboarding: Scalars['Boolean'];
  deleteAdmin: Scalars['Boolean'];
  deleteCategory: Category;
  deleteClient: Client;
  deleteClientAddress: ClientAddress;
  deleteClientCard?: Maybe<Scalars['Boolean']>;
  deleteCmsArticlePage: CmsArticlePage;
  deleteCmsConsultationPage: CmsConsultationPage;
  deleteCmsListingWidget: CmsListingWidget;
  deleteCmsShowroomPage: CmsShowroomPage;
  deleteCollection: Collection;
  deleteCoupon: Coupon;
  deleteExpert: Expert;
  deleteExpertAvailabilities: Array<ExpertAvailability>;
  deleteExpertSession: ExpertSession;
  deleteExpertTag: Tag;
  deleteExpertTestimonial?: Maybe<ExpertTestimonial>;
  deleteExpertUserCard?: Maybe<Scalars['Boolean']>;
  deleteNavigation: Scalars['Boolean'];
  deleteNavigationItem: Scalars['Boolean'];
  deleteRegion: Region;
  deleteSessionClientAttachment: SessionClientAttachment;
  deleteTrustedSource: Scalars['Boolean'];
  deleteVendor: Vendor;
  disconnectZoomAccount: ExpertUser;
  duplicateNavigation: Navigation;
  editCategory: Category;
  editCollectionProduct: Collection;
  exchangeCustomTokenForAdminToken: Scalars['String'];
  expertCancelSession: Session;
  expertUpdateExpert: Expert;
  firstTimePublishProduct: Product;
  firstTimePublishProductVariant: ProductVariant;
  inviteExpertUser: ExpertUser;
  markOrderItemsAsDelivered: Order;
  messageSessionClients: Scalars['Boolean'];
  migrateClientToExpert: Expert;
  moveCategoryAndReorderChildren: Category;
  onboardExpertUser: ExpertUser;
  onboardStripeExpert: Expert;
  overrideOrderItemShippingId: OrderItem;
  payExpertCommission?: Maybe<Scalars['Boolean']>;
  publishCmsPage: CmsPage;
  purchaseMissingTaxCart: Scalars['Boolean'];
  purchaseNoQuotesCart: Scalars['Boolean'];
  recheckZoomLicence: Scalars['Boolean'];
  rejectExpertApplication: ExpertApplication;
  removeCollectionProduct: Collection;
  removeCoupon: Scalars['Boolean'];
  removeExpertAttachmentFromGallery: Attachment;
  removeExpertFromFavorites: Scalars['Boolean'];
  removeExpertUserFeatureFlag: Expert;
  removeItemFromCart: Cart;
  removePromoCode: Scalars['Boolean'];
  reorderExpertImages: Scalars['Boolean'];
  reorderNavigationItems: NavigationItem;
  reorderRegions: Region;
  requestCollectionReview: Collection;
  resendActivationEmail?: Maybe<Scalars['Boolean']>;
  resendExpertUserInvitation: ExpertUser;
  resendPurchaseCheckoutEmail?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  revalidateFirebaseClaims?: Maybe<Scalars['Boolean']>;
  reviewSession: SessionReview;
  revokeCalendar?: Maybe<Scalars['Boolean']>;
  saveQuestionnaire: PastSessionClient;
  sendContactUsHelloEmail?: Maybe<Scalars['Boolean']>;
  sendContactUsShowroomEmail?: Maybe<Scalars['Boolean']>;
  sendFreeAssistanceEmail?: Maybe<Scalars['Boolean']>;
  sendItemInquireEmail?: Maybe<Scalars['Boolean']>;
  sendOnboardingEmailToExpert: Scalars['Boolean'];
  sendResetPasswordEmail?: Maybe<Scalars['Boolean']>;
  setItemToCart: Cart;
  setupClientPaymentMethod: Scalars['String'];
  setupExpertUserPaymentMethod: Scalars['String'];
  subscribeToExpertAvailability: Scalars['Boolean'];
  subscribeToMailingList: Scalars['Boolean'];
  suspendExpertUser: ExpertUser;
  toggleIsDisabledTradeLicense: TradeLicense;
  unpublishCmsPage: CmsPage;
  updateAdmin: Admin;
  updateCartShipmentAddress: Cart;
  updateCategoryExpert: ExpertCategory;
  updateClient: Client;
  updateClientAddress: ClientAddress;
  updateClientBusinessName: Client;
  updateCmsArticlePage: CmsArticlePage;
  updateCmsBrandPage: CmsBrandPage;
  updateCmsCategoryPage: CmsCategoryPage;
  updateCmsConsultationPage: CmsConsultationPage;
  updateCmsExpertPage: CmsExpertPage;
  updateCmsListingWidget: CmsListingWidget;
  updateCmsShowroomPage: CmsShowroomPage;
  updateCollection: Collection;
  updateCoupon: Coupon;
  updateExpertBusinessName: Expert;
  updateExpertHeadshotImage: Expert;
  updateExpertProfileImage: Expert;
  updateExpertTestimonial?: Maybe<ExpertTestimonial>;
  updateExpertUser: ExpertUser;
  updateGroupExpertSession: ExpertSession;
  updateNavigation: Navigation;
  updateNavigationItem: NavigationItem;
  updatePrivateExpertSession: ExpertSession;
  updateProductCustomContentMutation: Product;
  updateProductVariantCustomContentMutation: Product;
  updatePurchase: Purchase;
  updateRegion: Region;
  updateSessionReport: SessionReport;
  updateSessionReview: SessionReview;
  updateTrustedSource: TrustedSource;
  updateVendor: Vendor;
  verifyInvisibleRecaptchaToken: Recaptcha;
  verifyRecaptchaToken: Recaptcha;
  waitlistExpertApplication: ExpertApplication;
  warnClient: Client;
  warnExpert: Expert;
  zoomOnboarding: Scalars['Boolean'];
};


export type MutationActivateExpertUserArgs = {
  id: Scalars['Int'];
};


export type MutationAddCollectionProductArgs = {
  input: AddCollectionProductInput;
};


export type MutationAddExpertTestimonialArgs = {
  input: ExpertTestimonialInput;
};


export type MutationAddExpertToFavoritesArgs = {
  expertId: Scalars['Int'];
};


export type MutationAddExpertUserFeatureFlagArgs = {
  input: UpdateExpertUserFeatureFlagInput;
};


export type MutationAdjustClientCreditArgs = {
  input: AdjustClientCreditInput;
};


export type MutationAdminCancelSessionArgs = {
  input: AdminCancelSessionInput;
};


export type MutationAdminCreateExpertRegionArgs = {
  input: CreateExpertRegionInput;
};


export type MutationAdminDeleteExpertRegionArgs = {
  input: DeleteExpertRegionInput;
};


export type MutationAdminPutSessionOnHoldArgs = {
  input: AdminPutSessionOnHoldInput;
};


export type MutationAdminRescheduleSessionArgs = {
  input: AdminRescheduleSessionInput;
};


export type MutationAdminResendActivationEmailArgs = {
  clientId: Scalars['Int'];
};


export type MutationAdminUpdateExpertArgs = {
  input?: InputMaybe<AdminUpdateExpertInput>;
};


export type MutationAdminUpdateExpertRegionArgs = {
  input: UpdateExpertRegionInput;
};


export type MutationApplyCouponArgs = {
  couponCode?: InputMaybe<Scalars['String']>;
};


export type MutationApplyPromoCodeArgs = {
  promoCode?: InputMaybe<Scalars['String']>;
};


export type MutationApproveExpertApplicationArgs = {
  input: ApproveExpertApplicationInput;
};


export type MutationBanClientArgs = {
  input: BanClientInput;
};


export type MutationBanExpertArgs = {
  input: BanExpertInput;
};


export type MutationCancelCheckoutArgs = {
  id: Scalars['Int'];
};


export type MutationCancelCollectionReviewArgs = {
  input: CancelCollectionReviewInput;
};


export type MutationCancelPaymentArgs = {
  input: SessionCancellationInput;
};


export type MutationChangeCouponsSettingsArgs = {
  input: ChangeCouponsSettingsInput;
};


export type MutationChangeEmailArgs = {
  email: Scalars['String'];
};


export type MutationChangeVideoThumbnailArgs = {
  input: ChangeVideoThumbnailInput;
};


export type MutationClientConfirmEmailArgs = {
  confirmEmailToken: Scalars['String'];
};


export type MutationClientSignUpArgs = {
  input?: InputMaybe<ClientSignUpInput>;
};


export type MutationConfirmChangeEmailArgs = {
  confirmEmailToken: Scalars['String'];
};


export type MutationConfirmCheckoutArgs = {
  id: Scalars['Int'];
};


export type MutationCreateAccountLinkArgs = {
  input: CreateAccountLinkInput;
};


export type MutationCreateAdminArgs = {
  input: CreateAdminInput;
};


export type MutationCreateAttachmentArgs = {
  input: CreateAttachmentInput;
};


export type MutationCreateCartShipmentsFromCartArgs = {
  input: ShipmentAddress;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateCheckoutArgs = {
  input: CheckoutInput;
};


export type MutationCreateClientAddressArgs = {
  input: CreateClientAddressInput;
};


export type MutationCreateCmsArticlePageArgs = {
  input: CreateCmsArticlePageInput;
};


export type MutationCreateCmsConsultationPageArgs = {
  input: CreateCmsConsultationPageInput;
};


export type MutationCreateCmsListingWidgetArgs = {
  input: CmsListingWidgetInput;
};


export type MutationCreateCmsShowroomPageArgs = {
  input: CreateCmsShowroomPageInput;
};


export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput;
};


export type MutationCreateCouponArgs = {
  input: CreateCouponInput;
};


export type MutationCreateExpertApplicationArgs = {
  input: CreateExpertApplicationInput;
};


export type MutationCreateExpertAttachmentArgs = {
  input: CreateExpertAttachmentInput;
};


export type MutationCreateExpertFromAdminDashboardArgs = {
  input: CreateExpertFromAdminDashboardInput;
};


export type MutationCreateExpertFromApplicationArgs = {
  input: CreateExpertFromApplicationInput;
};


export type MutationCreateExpertFromTokenArgs = {
  input: CreateExpertFromApplicationInput;
};


export type MutationCreateExpertTagArgs = {
  input: CreateExpertTagInput;
};


export type MutationCreateExternalProductPreviewArgs = {
  input: ExternalProductPreviewInput;
};


export type MutationCreateFilesAndNotesAttachmentArgs = {
  input: CreateFilesAndNotesAttachmentInput;
};


export type MutationCreateGroupExpertAvailabilityArgs = {
  input: CreateGroupExpertAvailabilityInput;
};


export type MutationCreateGroupExpertSessionArgs = {
  input: CreateGroupExpertSessionInput;
};


export type MutationCreateNavigationArgs = {
  input: CreateNavigationInput;
};


export type MutationCreateNavigationItemArgs = {
  input: CreateNavigationItemInput;
};


export type MutationCreateOrderNoteArgs = {
  input: CreateOrderNoteInput;
};


export type MutationCreatePrivateExpertAvailabilityArgs = {
  input: CreatePrivateExpertAvailabilityInput;
};


export type MutationCreatePrivateExpertSessionArgs = {
  input: CreatePrivateExpertSessionInput;
};


export type MutationCreatePurchaseArgs = {
  input: CreatePurchaseInput;
};


export type MutationCreateRegionArgs = {
  input: CreateRegionInput;
};


export type MutationCreateSessionClientAttachmentArgs = {
  input: CreateSessionClientAttachmentInput;
};


export type MutationCreateSessionReportArgs = {
  input: SessionReportInput;
};


export type MutationCreateTradeLicenseArgs = {
  input: CreateTradeLicenseInput;
};


export type MutationCreateTrustedSourceArgs = {
  input: CreateTrustedSourceInput;
};


export type MutationCreateVendorArgs = {
  input: CreateVendorInput;
};


export type MutationCreateVideoAttachmentArgs = {
  input: CreateAttachmentInput;
};


export type MutationCronofyOnboardingArgs = {
  userCronofyCode: Scalars['String'];
};


export type MutationDeleteAdminArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteClientAddressArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteClientCardArgs = {
  stripeId: Scalars['String'];
};


export type MutationDeleteCmsArticlePageArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCmsConsultationPageArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCmsListingWidgetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCmsShowroomPageArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCollectionArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCouponArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteExpertArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteExpertAvailabilitiesArgs = {
  input: DeleteExpertAvailabilitiesInput;
};


export type MutationDeleteExpertSessionArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteExpertTagArgs = {
  input: DeleteExpertTagInput;
};


export type MutationDeleteExpertTestimonialArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteExpertUserCardArgs = {
  stripeId: Scalars['String'];
};


export type MutationDeleteNavigationArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteNavigationItemArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRegionArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteSessionClientAttachmentArgs = {
  input: DeleteSessionClientAttachmentInput;
};


export type MutationDeleteTrustedSourceArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteVendorArgs = {
  id: Scalars['Int'];
};


export type MutationDisconnectZoomAccountArgs = {
  id: Scalars['Int'];
};


export type MutationDuplicateNavigationArgs = {
  id: Scalars['Int'];
};


export type MutationEditCategoryArgs = {
  input: EditCategoryInput;
};


export type MutationEditCollectionProductArgs = {
  input: EditCollectionProductInput;
};


export type MutationExpertCancelSessionArgs = {
  input: ExpertCancelSessionInput;
};


export type MutationExpertUpdateExpertArgs = {
  input: UpdateExpertInput;
};


export type MutationFirstTimePublishProductArgs = {
  input: FirstTimePublishInput;
};


export type MutationFirstTimePublishProductVariantArgs = {
  input: FirstTimePublishInput;
};


export type MutationInviteExpertUserArgs = {
  input?: InputMaybe<InviteExpertUserInput>;
};


export type MutationMarkOrderItemsAsDeliveredArgs = {
  input: MarkOrderITemsAsDeliveredInput;
};


export type MutationMessageSessionClientsArgs = {
  input: MessageSessionClientsInput;
};


export type MutationMigrateClientToExpertArgs = {
  input?: InputMaybe<MigrateClientToExpertInput>;
};


export type MutationMoveCategoryAndReorderChildrenArgs = {
  input: MoveCategoryAndReorderChildrenInput;
};


export type MutationOnboardExpertUserArgs = {
  input: OnboardExpertUserInput;
};


export type MutationOverrideOrderItemShippingIdArgs = {
  input: OverrideOrderItemShippingIdMutationInput;
};


export type MutationPayExpertCommissionArgs = {
  id: Scalars['Int'];
};


export type MutationPublishCmsPageArgs = {
  id: Scalars['Int'];
};


export type MutationPurchaseMissingTaxCartArgs = {
  input: CustomFlowPurchaseInput;
};


export type MutationPurchaseNoQuotesCartArgs = {
  input: CustomFlowPurchaseInput;
};


export type MutationRejectExpertApplicationArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveCollectionProductArgs = {
  input: RemoveCollectionProductInput;
};


export type MutationRemoveCouponArgs = {
  couponCode?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveExpertAttachmentFromGalleryArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveExpertFromFavoritesArgs = {
  expertId: Scalars['Int'];
};


export type MutationRemoveExpertUserFeatureFlagArgs = {
  input: UpdateExpertUserFeatureFlagInput;
};


export type MutationRemoveItemFromCartArgs = {
  input: RemoveItemFromCartInput;
};


export type MutationRemovePromoCodeArgs = {
  promoCode?: InputMaybe<Scalars['String']>;
};


export type MutationReorderExpertImagesArgs = {
  input: ReorderExpertImagesInput;
};


export type MutationReorderNavigationItemsArgs = {
  input: ReorderNavigationItemsInput;
};


export type MutationReorderRegionsArgs = {
  input: ReorderRegionsInput;
};


export type MutationRequestCollectionReviewArgs = {
  input: RequestCollectionReviewInput;
};


export type MutationResendExpertUserInvitationArgs = {
  id: Scalars['Int'];
};


export type MutationResendPurchaseCheckoutEmailArgs = {
  id: Scalars['Int'];
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRevalidateFirebaseClaimsArgs = {
  email: Scalars['String'];
};


export type MutationReviewSessionArgs = {
  input: SessionReviewInput;
};


export type MutationSaveQuestionnaireArgs = {
  input: SessionQuestionnaireInput;
};


export type MutationSendContactUsHelloEmailArgs = {
  input: SendContactUsEmailInput;
};


export type MutationSendContactUsShowroomEmailArgs = {
  input: SendContactUsEmailInput;
};


export type MutationSendFreeAssistanceEmailArgs = {
  input: SendFreeAssistanceEmailInput;
};


export type MutationSendItemInquireEmailArgs = {
  input?: InputMaybe<SendItemInquireEmailInput>;
};


export type MutationSendResetPasswordEmailArgs = {
  email: Scalars['String'];
};


export type MutationSetItemToCartArgs = {
  input: SetItemToCartInput;
};


export type MutationSubscribeToExpertAvailabilityArgs = {
  input: ClientExpertAvailabilitySubscriptionInput;
};


export type MutationSubscribeToMailingListArgs = {
  input?: InputMaybe<SubscribeToMailingListInput>;
};


export type MutationSuspendExpertUserArgs = {
  id: Scalars['Int'];
};


export type MutationToggleIsDisabledTradeLicenseArgs = {
  input: ToggleIsDisabledTradeLicenseInput;
};


export type MutationUnpublishCmsPageArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateAdminArgs = {
  input: UpdateAdminInput;
};


export type MutationUpdateCartShipmentAddressArgs = {
  input: ShipmentAddress;
};


export type MutationUpdateCategoryExpertArgs = {
  input: UpdateCategoryExpertInput;
};


export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};


export type MutationUpdateClientAddressArgs = {
  input: UpdateClientAddressInput;
};


export type MutationUpdateClientBusinessNameArgs = {
  input?: InputMaybe<UpdateClientBusinessNameInput>;
};


export type MutationUpdateCmsArticlePageArgs = {
  input: UpdateCmsArticlePageInput;
};


export type MutationUpdateCmsBrandPageArgs = {
  input: UpdateCmsBrandPageInput;
};


export type MutationUpdateCmsCategoryPageArgs = {
  input: UpdateCmsCategoryPageInput;
};


export type MutationUpdateCmsConsultationPageArgs = {
  input: UpdateCmsConsultationPageInput;
};


export type MutationUpdateCmsExpertPageArgs = {
  input: UpdateCmsExpertPageInput;
};


export type MutationUpdateCmsListingWidgetArgs = {
  input: CmsListingWidgetInput;
};


export type MutationUpdateCmsShowroomPageArgs = {
  input: UpdateCmsShowroomPageInput;
};


export type MutationUpdateCollectionArgs = {
  input: UpdateCollectionInput;
};


export type MutationUpdateCouponArgs = {
  input: UpdateCouponInput;
};


export type MutationUpdateExpertBusinessNameArgs = {
  input: UpdateExpertBusinessNameInput;
};


export type MutationUpdateExpertHeadshotImageArgs = {
  input: UpdateExpertHeadshotImageInput;
};


export type MutationUpdateExpertProfileImageArgs = {
  input: UpdateExpertProfileImageInput;
};


export type MutationUpdateExpertTestimonialArgs = {
  input: ExpertTestimonialInput;
};


export type MutationUpdateExpertUserArgs = {
  input: UpdateExpertUserInput;
};


export type MutationUpdateGroupExpertSessionArgs = {
  input: UpdateGroupExpertSessionInput;
};


export type MutationUpdateNavigationArgs = {
  input: UpdateNavigationInput;
};


export type MutationUpdateNavigationItemArgs = {
  input: UpdateNavigationItemInput;
};


export type MutationUpdatePrivateExpertSessionArgs = {
  input: UpdatePrivateExpertSessionInput;
};


export type MutationUpdateProductCustomContentMutationArgs = {
  input: ProductCustomContentInput;
};


export type MutationUpdateProductVariantCustomContentMutationArgs = {
  input: ProductVariantCustomContentInput;
};


export type MutationUpdatePurchaseArgs = {
  input: UpdatePurchaseInput;
};


export type MutationUpdateRegionArgs = {
  input: UpdateRegionInput;
};


export type MutationUpdateSessionReportArgs = {
  input: SessionReportInput;
};


export type MutationUpdateSessionReviewArgs = {
  input: SessionReviewMutationInput;
};


export type MutationUpdateTrustedSourceArgs = {
  input: UpdateTrustedSourceInput;
};


export type MutationUpdateVendorArgs = {
  input: UpdateVendorInput;
};


export type MutationVerifyInvisibleRecaptchaTokenArgs = {
  token: Scalars['String'];
};


export type MutationVerifyRecaptchaTokenArgs = {
  token: Scalars['String'];
};


export type MutationWaitlistExpertApplicationArgs = {
  id: Scalars['Int'];
};


export type MutationWarnClientArgs = {
  input: WarnClientInput;
};


export type MutationWarnExpertArgs = {
  input: WarnExpertInput;
};


export type MutationZoomOnboardingArgs = {
  userZoomCode: Scalars['String'];
};

export type Navigation = {
  __typename?: 'Navigation';
  children: Array<NavigationItem>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  navigationGroupId: Scalars['Int'];
  rootItem: NavigationItem;
  status: NavigationStatus;
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export type NavigationEdge = {
  __typename?: 'NavigationEdge';
  cursor: Scalars['String'];
  node: Navigation;
};

export type NavigationGroup = {
  __typename?: 'NavigationGroup';
  id: Scalars['Int'];
  navigations: Array<Navigation>;
  publishedNavigation?: Maybe<Navigation>;
  title: Scalars['String'];
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  attachment?: Maybe<Attachment>;
  children: Array<NavigationItem>;
  cmsPage: CmsPage;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  navigation: Navigation;
  parent?: Maybe<NavigationItem>;
  parentId?: Maybe<Scalars['Int']>;
  positionIndexWeight: Scalars['Int'];
  subItemsWithImages: Scalars['Boolean'];
  title: Scalars['String'];
  updatedAtUtc: Datetime;
};

export enum NavigationSorterField {
  CreatedAtUtc = 'createdAtUtc',
  Status = 'status',
  UpdatedAtUtc = 'updatedAtUtc'
}

export type NavigationSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<NavigationSorterField>;
};

export enum NavigationStatus {
  NotPublished = 'NOT_PUBLISHED',
  Published = 'PUBLISHED'
}

export type Navigations = {
  __typename?: 'Navigations';
  edges: Array<NavigationEdge>;
  pageInfo: CursorPaginationInfo;
};

export type NavigationsInput = {
  pagination: CursorPaginationInput;
  sorter?: InputMaybe<NavigationSorterInput>;
};

export type NotificationEmail = {
  __typename?: 'NotificationEmail';
  email: Scalars['String'];
  id: Scalars['Int'];
};

export type OnboardExpertUserInput = {
  onboardingToken: Scalars['String'];
  password: Scalars['String'];
};

export type OnboardingValidationResponse = ExpertApplication | ExpertUser;

export type Order = {
  __typename?: 'Order';
  billingAddressLine1?: Maybe<Scalars['String']>;
  billingAddressLine2?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCompany?: Maybe<Scalars['String']>;
  billingCountryIsoCode?: Maybe<Scalars['String']>;
  billingCountryState?: Maybe<Scalars['String']>;
  billingFullName?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingZipCode?: Maybe<Scalars['String']>;
  buyerEmail: Scalars['String'];
  checkout?: Maybe<Checkout>;
  client?: Maybe<Client>;
  createdAtUtc: Datetime;
  emailActivity: Array<EmailEvent>;
  expertUser?: Maybe<ExpertUser>;
  flxId?: Maybe<Scalars['Int']>;
  guestUser?: Maybe<GuestUser>;
  id: Scalars['Int'];
  notes: OrderNotes;
  orderItems: Array<OrderItem>;
  paymentDetails?: Maybe<PaymentDetails>;
  price: OrderPriceType;
  shippingAddressLine1?: Maybe<Scalars['String']>;
  shippingAddressLine2?: Maybe<Scalars['String']>;
  shippingCity?: Maybe<Scalars['String']>;
  shippingCompany?: Maybe<Scalars['String']>;
  shippingCountryIsoCode?: Maybe<Scalars['String']>;
  shippingCountryState?: Maybe<Scalars['String']>;
  shippingFullName?: Maybe<Scalars['String']>;
  shippingPhone?: Maybe<Scalars['String']>;
  shippingPrice?: Maybe<Price>;
  shippingZipCode?: Maybe<Scalars['String']>;
  status: OrderStatus;
  stripeTransactionLink?: Maybe<Scalars['String']>;
  tax: Price;
  totalDiscount: Price;
  totalPrice: Price;
  updatedAtUtc: Datetime;
};


export type OrderEmailActivityArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type OrderNotesArgs = {
  input?: InputMaybe<OrderNotesInput>;
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Order>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  /** @deprecated Use orderShipment's artaShipmentId */
  artaShipmentId?: Maybe<Scalars['String']>;
  bookedQuote?: Maybe<Scalars['String']>;
  checkoutItem?: Maybe<CheckoutItem>;
  createdAtUtc: Datetime;
  deliveredAtUtc?: Maybe<Scalars['String']>;
  flxPointUrl?: Maybe<Scalars['String']>;
  flxPurchaseOrderId?: Maybe<Scalars['Int']>;
  flxPurchaseOrderNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  leadTime?: Maybe<Scalars['String']>;
  metadata?: Maybe<ItemMetadata>;
  orderId: Scalars['Int'];
  orderShipment?: Maybe<OrderShipment>;
  price: Price;
  productData?: Maybe<Scalars['JSON']>;
  productVariant: ProductVariant;
  quantity: Scalars['Int'];
  shippedAtUtc?: Maybe<Scalars['String']>;
  status: OrderItemStatus;
  trackingUrl?: Maybe<Scalars['String']>;
  unitRetailPrice: Price;
};

export enum OrderItemStatus {
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Shipped = 'SHIPPED'
}

export type OrderNote = {
  __typename?: 'OrderNote';
  admin: Admin;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  message: Scalars['String'];
  order: Order;
  updatedAtUtc: Datetime;
};

export type OrderNoteEdge = {
  __typename?: 'OrderNoteEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<OrderNote>;
};

export type OrderNotes = {
  __typename?: 'OrderNotes';
  edges: Array<OrderNoteEdge>;
  pageInfo: CursorPaginationInfo;
};

export type OrderNotesInput = {
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type OrderPayment = {
  __typename?: 'OrderPayment';
  card?: Maybe<Scalars['Float']>;
  coupon?: Maybe<Scalars['Float']>;
  credit?: Maybe<Scalars['Float']>;
  methods?: Maybe<Scalars['String']>;
  paidAtUtc?: Maybe<Scalars['String']>;
};

export type OrderPriceType = {
  __typename?: 'OrderPriceType';
  currencyIsoCode?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  itemsSum?: Maybe<SumPrice>;
  originalPrice?: Maybe<Scalars['Float']>;
  payment?: Maybe<OrderPayment>;
  shipmentsSum?: Maybe<SumPrice>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

export type OrderShipment = {
  __typename?: 'OrderShipment';
  id: Scalars['Int'];
  orderId: Scalars['Int'];
  price: Price;
  shipmentData?: Maybe<ShipmentData>;
  sourceId: Scalars['Int'];
};

export type OrderShipmentArtaQuote = {
  __typename?: 'OrderShipmentArtaQuote';
  additionalServices: Array<Scalars['String']>;
  artaId: Scalars['Int'];
  artaShipmentId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  rawData?: Maybe<OrderShipmentRawData>;
  services: Array<OrderShipmentArtaQuoteService>;
  type: Scalars['String'];
};

export type OrderShipmentArtaQuoteService = {
  __typename?: 'OrderShipmentArtaQuoteService';
  id: Scalars['Int'];
  name: Scalars['String'];
  orderShipmentArtaId: Scalars['Int'];
  price: Price;
  subSubtype: Scalars['String'];
  subtype: Scalars['String'];
  type: Scalars['String'];
};

export type OrderShipmentFreightClubQuote = {
  __typename?: 'OrderShipmentFreightClubQuote';
  freightClubId: Scalars['Int'];
  freightClubShipmentId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  rawData?: Maybe<OrderShipmentRawData>;
  type: Scalars['String'];
};

export type OrderShipmentRawData = {
  __typename?: 'OrderShipmentRawData';
  artaId?: Maybe<Scalars['String']>;
};

export type OrderShipmentVendorShipping = {
  __typename?: 'OrderShipmentVendorShipping';
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export enum OrderSorterField {
  BuyerEmail = 'buyerEmail',
  CreatedAtUtc = 'createdAtUtc',
  FlxId = 'flxId',
  Id = 'id',
  TotalPrice = 'totalPrice'
}

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Unpaid = 'UNPAID'
}

export type Orders = {
  __typename?: 'Orders';
  edges: Array<OrderEdge>;
  pageInfo: CursorPaginationInfo;
};

export type OrdersInput = {
  pagination?: InputMaybe<CursorPaginationInput>;
  sorter?: InputMaybe<OrdersSorterInput>;
};

export type OrdersSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<OrderSorterField>;
};

export type OverrideOrderItemShippingIdMutationInput = {
  orderItemId: Scalars['Int'];
  shipmentId: Scalars['String'];
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int'];
  firstPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  nextPage?: Maybe<Scalars['Int']>;
  previousPage?: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type PastSessionClient = {
  __typename?: 'PastSessionClient';
  attachments?: Maybe<Array<Attachment>>;
  checkoutItem?: Maybe<CheckoutItem>;
  client: Client;
  guests?: Maybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  lifetimeValue: Array<Price>;
  questionnaireData?: Maybe<Scalars['JSON']>;
  report?: Maybe<SessionReport>;
  session: PublicSession;
  sessionData: ExpertSession;
  sessionsCount: Scalars['Int'];
  startAtUtc: Datetime;
};

export type PastSessionsClients = {
  __typename?: 'PastSessionsClients';
  data: Array<Maybe<PastSessionClient>>;
  paginationInfo: PaginationInfo;
};

export type PastSessionsClientsFilterInput = {
  expertSessionType?: InputMaybe<SessionTypeField>;
};

export type PastSessionsClientsInput = {
  expertUserId: Scalars['Int'];
  filter?: InputMaybe<PastSessionsClientsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<PastSessionsClientsSorterInput>;
};

export type PastSessionsClientsSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<SessionSorterField>;
};

export type Payment = {
  __typename?: 'Payment';
  card?: Maybe<Scalars['Float']>;
  coupon?: Maybe<Scalars['Float']>;
  credit?: Maybe<Scalars['Float']>;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  card?: Maybe<ClientCreditCard>;
  isCouponPayment?: Maybe<Scalars['Boolean']>;
  isCreditsPayment?: Maybe<Scalars['Boolean']>;
  paidAtUtc?: Maybe<Datetime>;
};

export type Price = {
  __typename?: 'Price';
  base: Scalars['Float'];
  calculatedPrices: Array<CalculatedPrice>;
  currencyIsoCode: CurrencyIsoCode;
  total: Scalars['Float'];
  vat: Scalars['Float'];
  vatRate: Scalars['Float'];
};

export type Product = {
  __typename?: 'Product';
  attributes: Array<ProductAttribute>;
  availability: ProductAvailability;
  brand?: Maybe<Brand>;
  categoryOne?: Maybe<ProductCategory>;
  categoryThree?: Maybe<ProductCategory>;
  categoryTwo?: Maybe<ProductCategory>;
  collections: Collections;
  createdAtUtc: Datetime;
  customContent?: Maybe<ProductCustomContentFields>;
  customFields: Array<ProductCustomField>;
  description?: Maybe<Scalars['String']>;
  flxId: Scalars['Int'];
  forceRedirectToProduct?: Maybe<Product>;
  id: Scalars['Int'];
  images: Array<Attachment>;
  /** @deprecated No longer supported */
  isVendorShipping: Scalars['Boolean'];
  /** @deprecated No longer supported */
  manufacturer?: Maybe<Scalars['String']>;
  mightAlsoLikeProducts: Array<Product>;
  options: Array<ProductOption>;
  positionIndexWeight?: Maybe<Scalars['Int']>;
  previewImageAlt?: Maybe<Scalars['String']>;
  recommendedProducts: Array<RecommendedProduct>;
  /** @deprecated No longer supported */
  shippingMethod: Scalars['String'];
  sku: Scalars['String'];
  slug: Scalars['String'];
  status: ProductStatus;
  title: Scalars['String'];
  updatedAtUtc: Datetime;
  variants: Array<ProductVariant>;
};


export type ProductCollectionsArgs = {
  input?: InputMaybe<CollectionsInput>;
};


export type ProductRecommendedProductsArgs = {
  input?: InputMaybe<RecommendedProductsFilterInput>;
};


export type ProductVariantsArgs = {
  statuses?: InputMaybe<Array<ProductVariantStatus>>;
};

export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  name: Scalars['String'];
  product: Product;
  updatedAtUtc: Datetime;
  value: Scalars['String'];
};

export enum ProductAvailability {
  Enquire = 'ENQUIRE',
  InStock = 'IN_STOCK',
  MadeToOrder = 'MADE_TO_ORDER',
  SoldOut = 'SOLD_OUT'
}

export type ProductBreakoutVariant = {
  __typename?: 'ProductBreakoutVariant';
  attachment?: Maybe<Attachment>;
  availability: ProductAvailability;
  cost?: Maybe<Price>;
  createdAtUtc: Datetime;
  customFields: Array<ProductVariantCustomField>;
  dimensionUnit?: Maybe<Scalars['String']>;
  estimatedDropshipFee?: Maybe<Price>;
  estimatedShippingCost?: Maybe<Price>;
  flxId: Scalars['Int'];
  height?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  length?: Maybe<Scalars['Float']>;
  managedCustomFields?: Maybe<ManagedCustomFields>;
  maxPrice: Price;
  mergedVariants: Array<ProductVariant>;
  minPrice: Price;
  optionValues: Array<ProductOptionValue>;
  price: Price;
  product: Product;
  quantity: Scalars['Int'];
  sku: Scalars['String'];
  slug: Scalars['String'];
  source: Source;
  status: ProductVariantStatus;
  title: Scalars['String'];
  tradeMaxPrice?: Maybe<Price>;
  tradeMinPrice?: Maybe<Price>;
  tradePrice?: Maybe<Price>;
  updatedAtUtc: Datetime;
  weight?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  children: Array<ProductCategory>;
  cmsPage?: Maybe<CmsPage>;
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  name: Scalars['String'];
  parentCategory?: Maybe<ProductCategory>;
  parentId?: Maybe<Scalars['Int']>;
  updatedAtUtc: Datetime;
};

export type ProductCustomContentFields = {
  __typename?: 'ProductCustomContentFields';
  aboveTheFold?: Maybe<Scalars['String']>;
  accordionCare?: Maybe<Scalars['String']>;
  accordionDetails?: Maybe<Scalars['String']>;
  accordionShipping?: Maybe<Scalars['String']>;
  askExpert?: Maybe<Expert>;
  askExpertCopy?: Maybe<Scalars['String']>;
  customDimensions?: Maybe<Scalars['String']>;
  customProductDescription?: Maybe<Scalars['String']>;
  customProductHeadline?: Maybe<Scalars['String']>;
};

export type ProductCustomContentFieldsInput = {
  aboveTheFold?: InputMaybe<Scalars['String']>;
  accordionCare?: InputMaybe<Scalars['String']>;
  accordionDetails?: InputMaybe<Scalars['String']>;
  accordionShipping?: InputMaybe<Scalars['String']>;
  askExpertCopy?: InputMaybe<Scalars['String']>;
  askExpertId?: InputMaybe<Scalars['Int']>;
  customDimensions?: InputMaybe<Scalars['String']>;
  customProductDescription?: InputMaybe<Scalars['String']>;
  customProductHeadline?: InputMaybe<Scalars['String']>;
};

export type ProductCustomContentInput = {
  customContent?: InputMaybe<ProductCustomContentFieldsInput>;
  forceRedirectToProductId?: InputMaybe<Scalars['Int']>;
  productId: Scalars['Int'];
  recommendedProducts: Array<RecommendedProductInput>;
};

export type ProductCustomField = {
  __typename?: 'ProductCustomField';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  name: Scalars['String'];
  product: Product;
  updatedAtUtc: Datetime;
  value: Scalars['String'];
};

export type ProductFilterInput = {
  availability?: InputMaybe<Array<AvailabilityEnum>>;
  brands?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['Int']>>;
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  distinctOnVariantIds?: InputMaybe<Scalars['Boolean']>;
  firstPublishedAtUtc?: InputMaybe<Scalars['Int']>;
  includeOnlyComputedStatuses?: InputMaybe<Scalars['Boolean']>;
  isOrdered?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<FloatRangeFilterInput>;
  statuses?: InputMaybe<Array<ProductStatus>>;
  variantStatuses?: InputMaybe<Array<ProductVariantStatus>>;
};

export type ProductInput = {
  id: Scalars['Int'];
  status?: InputMaybe<ProductStatus>;
};

export type ProductOption = {
  __typename?: 'ProductOption';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAtUtc: Datetime;
  variantsValues: Array<ProductOptionValue>;
};


export type ProductOptionVariantsValuesArgs = {
  productId: Scalars['Int'];
};

export type ProductOptionValue = {
  __typename?: 'ProductOptionValue';
  productOption: ProductOption;
  productVariant: ProductVariant;
  value: Scalars['String'];
};

export enum ProductSorterField {
  Availability = 'availability',
  ComputedStatus = 'computedStatus',
  CreatedAtUtc = 'createdAtUtc',
  FirstPublishedAtUtc = 'firstPublishedAtUtc',
  Id = 'id',
  Manufacturer = 'manufacturer',
  MinPublishedPrice = 'minPublishedPrice',
  PositionIndexWeight = 'positionIndexWeight',
  Price = 'price',
  Quantity = 'quantity',
  Sku = 'sku',
  Status = 'status',
  Title = 'title',
  UpdatedAtUtc = 'updatedAtUtc'
}

export type ProductSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ProductSorterField>;
  orderByAvailabilityFirst?: InputMaybe<Scalars['Boolean']>;
};

export enum ProductStatus {
  Archived = 'ARCHIVED',
  NotPublished = 'NOT_PUBLISHED',
  PendingApproval = 'PENDING_APPROVAL',
  Published = 'PUBLISHED'
}

export type ProductVariant = {
  __typename?: 'ProductVariant';
  availability: ProductAvailability;
  carouselImage?: Maybe<Attachment>;
  colorImage?: Maybe<Attachment>;
  cost?: Maybe<Price>;
  createdAtUtc: Datetime;
  customContent?: Maybe<ProductVariantCustomContentFields>;
  customFields: Array<ProductVariantCustomField>;
  dimensionUnit?: Maybe<Scalars['String']>;
  estimatedDropshipFee?: Maybe<Price>;
  estimatedShippingCost?: Maybe<Price>;
  fabricDetails?: Maybe<Scalars['String']>;
  fabricHeader?: Maybe<Scalars['String']>;
  fabricImage?: Maybe<Attachment>;
  fabricSubheader?: Maybe<Scalars['String']>;
  finishDetails?: Maybe<Scalars['String']>;
  finishHeader?: Maybe<Scalars['String']>;
  finishImage?: Maybe<Attachment>;
  finishSubheader?: Maybe<Scalars['String']>;
  firstPublishedAtUtc?: Maybe<Datetime>;
  flxId: Scalars['Int'];
  height?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  images: Array<Attachment>;
  isPublishedFirstTime: Scalars['Boolean'];
  leadImage?: Maybe<Attachment>;
  length?: Maybe<Scalars['Float']>;
  managedCustomFields?: Maybe<ManagedCustomFields>;
  optionValues: Array<ProductOptionValue>;
  price: Price;
  product: Product;
  quantity: Scalars['Int'];
  sku: Scalars['String'];
  slug: Scalars['String'];
  source: Source;
  sourceAddress: SourceAddress;
  status: ProductVariantStatus;
  title: Scalars['String'];
  tradeCost?: Maybe<Price>;
  tradePrice?: Maybe<Price>;
  updatedAtUtc: Datetime;
  weight?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type ProductVariantCustomContentFields = {
  __typename?: 'ProductVariantCustomContentFields';
  aboveTheFold?: Maybe<Scalars['String']>;
  accordionCare?: Maybe<Scalars['String']>;
  accordionDetails?: Maybe<Scalars['String']>;
  accordionShipping?: Maybe<Scalars['String']>;
  askExpert?: Maybe<Expert>;
  askExpertCopy?: Maybe<Scalars['String']>;
  customDimensions?: Maybe<Scalars['String']>;
  customProductDescription?: Maybe<Scalars['String']>;
  customProductHeadline?: Maybe<Scalars['String']>;
  enquire?: Maybe<Scalars['Boolean']>;
};

export type ProductVariantCustomContentFieldsInput = {
  aboveTheFold?: InputMaybe<Scalars['String']>;
  accordionCare?: InputMaybe<Scalars['String']>;
  accordionDetails?: InputMaybe<Scalars['String']>;
  accordionShipping?: InputMaybe<Scalars['String']>;
  askExpertCopy?: InputMaybe<Scalars['String']>;
  askExpertId?: InputMaybe<Scalars['Int']>;
  customDimensions?: InputMaybe<Scalars['String']>;
  customProductDescription?: InputMaybe<Scalars['String']>;
  customProductHeadline?: InputMaybe<Scalars['String']>;
  enquire?: InputMaybe<Scalars['Boolean']>;
};

export type ProductVariantCustomContentInput = {
  customContent?: InputMaybe<ProductVariantCustomContentFieldsInput>;
  fabricDetails?: InputMaybe<Scalars['String']>;
  fabricHeader?: InputMaybe<Scalars['String']>;
  fabricSubheader?: InputMaybe<Scalars['String']>;
  finishDetails?: InputMaybe<Scalars['String']>;
  finishHeader?: InputMaybe<Scalars['String']>;
  finishSubheader?: InputMaybe<Scalars['String']>;
  productVariantId: Scalars['Int'];
};

export type ProductVariantCustomField = {
  __typename?: 'ProductVariantCustomField';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAtUtc: Datetime;
  value: Scalars['String'];
};

export type ProductVariantFilterInput = {
  statuses?: InputMaybe<Array<ProductVariantStatus>>;
};

export enum ProductVariantSorterField {
  CreatedAtUtc = 'createdAtUtc',
  Id = 'id',
  Manufacturer = 'manufacturer',
  Quantity = 'quantity',
  Sku = 'sku',
  Status = 'status',
  Title = 'title',
  UpdatedAtUtc = 'updatedAtUtc'
}

export type ProductVariantSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ProductVariantSorterField>;
};

export enum ProductVariantStatus {
  Archived = 'ARCHIVED',
  NotPublished = 'NOT_PUBLISHED',
  PendingApproval = 'PENDING_APPROVAL',
  Published = 'PUBLISHED'
}

export type ProductVariants = {
  __typename?: 'ProductVariants';
  data: Array<ProductVariant>;
  paginationInfo: PaginationInfo;
};

export type ProductVariantsInput = {
  filter?: InputMaybe<ProductVariantFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<ProductVariantSorterInput>;
};

export type Products = {
  __typename?: 'Products';
  data: Array<Maybe<Product>>;
  paginationInfo: PaginationInfo;
};

export type ProductsInput = {
  filter?: InputMaybe<ProductFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<ProductSorterInput>;
};

export type PromoCode = {
  __typename?: 'PromoCode';
  amount: Scalars['Int'];
  code: Scalars['String'];
  end?: Maybe<Datetime>;
  exclusionBrands?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['Int'];
  isValid: Scalars['Boolean'];
  linkToTac?: Maybe<Scalars['String']>;
  maxUsage?: Maybe<Scalars['Int']>;
  start?: Maybe<Datetime>;
  type: PromoCodeType;
};

export enum PromoCodeType {
  Default = 'DEFAULT'
}

export type PublicCategoriesFilterInput = {
  isHighlighted?: InputMaybe<Scalars['Boolean']>;
  isSubcategory?: InputMaybe<Scalars['Boolean']>;
  parentCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type PublicCategoriesInput = {
  filter?: InputMaybe<PublicCategoriesFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
};

export type PublicCategory = {
  __typename?: 'PublicCategory';
  color: Scalars['String'];
  id: Scalars['Int'];
  parentId?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type PublicExpertAvailabilitiesInput = {
  date: StringRangeFilterInput;
  duration: Scalars['Int'];
  expertSessionId?: InputMaybe<Scalars['Int']>;
  expertUserId: Scalars['Int'];
  sessionType: SessionTypeField;
};

export type PublicExpertSession = {
  __typename?: 'PublicExpertSession';
  couponCode?: Maybe<Scalars['String']>;
  couponPrice?: Maybe<Price>;
  creditPrice: Price;
  description: Scalars['String'];
  expert: Expert;
  expertUser: ExpertUser;
  id: Scalars['Int'];
  isAvailable: Scalars['Boolean'];
  isUpToThreeGuestsAllowed: Scalars['Boolean'];
  lengthInMinutes: Scalars['Int'];
  minimumSessionSize?: Maybe<Scalars['Int']>;
  payPrice: Price;
  price: Price;
  promoCode?: Maybe<PromoCode>;
  sessionCapacity?: Maybe<Scalars['Int']>;
  sessionType: SessionTypeField;
  title: Scalars['String'];
};

export type PublicExperts = {
  __typename?: 'PublicExperts';
  data: Array<Maybe<Expert>>;
  paginationInfo: PaginationInfo;
};

export type PublicSession = {
  __typename?: 'PublicSession';
  couponDiscountPrice: Price;
  createdAtUtc: Datetime;
  endAtUtc: Datetime;
  expert: Expert;
  expertUser: ExpertUser;
  id: Scalars['Int'];
  payPrice: Price;
  promoCodeAmount?: Maybe<Scalars['Int']>;
  sessionClient: SessionClient;
  sessionData: PublicExpertSession;
  startAtUtc: Datetime;
  status: SessionStatus;
  updatedAtUtc: Datetime;
  zoomSession?: Maybe<PublicZoomSession>;
  zoomSessionId?: Maybe<Scalars['String']>;
};

export type PublicZoomSession = {
  __typename?: 'PublicZoomSession';
  id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Purchase = {
  __typename?: 'Purchase';
  attachment?: Maybe<Attachment>;
  billingAddressLine1?: Maybe<Scalars['String']>;
  billingAddressLine2?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCompany?: Maybe<Scalars['String']>;
  billingCountryIsoCode?: Maybe<Scalars['String']>;
  billingCountryState?: Maybe<Scalars['String']>;
  billingFullName?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingZipCode?: Maybe<Scalars['String']>;
  buyerType: BuyerType;
  checkoutItem?: Maybe<CheckoutItem>;
  client?: Maybe<Client>;
  couponCode?: Maybe<Scalars['String']>;
  couponPrice?: Maybe<Price>;
  createdAtUtc: Datetime;
  creditPrice: Price;
  description: Scalars['String'];
  expert?: Maybe<Expert>;
  expertUser?: Maybe<ExpertUser>;
  id: Scalars['Int'];
  isExpertCommissionPaid?: Maybe<Scalars['Boolean']>;
  payPrice: Price;
  paymentDetails?: Maybe<PaymentDetails>;
  platformCommissionAmount: Price;
  policy?: Maybe<Scalars['String']>;
  price?: Maybe<PurchasePriceType>;
  retailPrice: Price;
  /** @deprecated Use `shippingAddressLine2` field instead */
  shippingAdditionalAddress?: Maybe<Scalars['String']>;
  /** @deprecated Use `shippingAddressLine1` field instead */
  shippingAddress?: Maybe<Scalars['String']>;
  shippingAddressLine1?: Maybe<Scalars['String']>;
  shippingAddressLine2?: Maybe<Scalars['String']>;
  shippingCity?: Maybe<Scalars['String']>;
  shippingCompany?: Maybe<Scalars['String']>;
  shippingCountryIsoCode?: Maybe<Scalars['String']>;
  shippingCountryState?: Maybe<Scalars['String']>;
  /** @deprecated Use `shippingFullName` field instead */
  shippingFirstName?: Maybe<Scalars['String']>;
  shippingFullName?: Maybe<Scalars['String']>;
  /** @deprecated Use `shippingFullName` field instead */
  shippingLastName?: Maybe<Scalars['String']>;
  shippingPhone?: Maybe<Scalars['String']>;
  shippingPrice: Price;
  shippingZipCode?: Maybe<Scalars['String']>;
  status: PurchaseStatus;
  tax: Price;
  totalPrice: Price;
  trackingUrl?: Maybe<Scalars['String']>;
  tradeLicense?: Maybe<TradeLicense>;
  updatedAtUtc: Datetime;
  vendor?: Maybe<Vendor>;
  vendorExpertCommission: Scalars['Int'];
  vendorExpertCommissionAmount?: Maybe<Price>;
  vendorPrice: Price;
};

export type PurchaseCouponInput = {
  amount: Scalars['Int'];
  differentRecipient?: InputMaybe<DifferentCouponRecipientInput>;
};

export type PurchaseEdge = {
  __typename?: 'PurchaseEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Purchase>;
};

export type PurchaseInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type PurchaseItemInput = {
  billingAddressLine1?: InputMaybe<Scalars['String']>;
  billingAddressLine2?: InputMaybe<Scalars['String']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingCompany?: InputMaybe<Scalars['String']>;
  billingCountryIsoCode?: InputMaybe<Scalars['String']>;
  billingCountryState?: InputMaybe<Scalars['String']>;
  billingFullName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingZipCode?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  shippingAddressLine1?: InputMaybe<Scalars['String']>;
  shippingAddressLine2?: InputMaybe<Scalars['String']>;
  shippingCity?: InputMaybe<Scalars['String']>;
  shippingCompany?: InputMaybe<Scalars['String']>;
  shippingCountryIsoCode?: InputMaybe<Scalars['String']>;
  shippingCountryState?: InputMaybe<Scalars['String']>;
  shippingFullName?: InputMaybe<Scalars['String']>;
  shippingPhone?: InputMaybe<Scalars['String']>;
  shippingZipCode?: InputMaybe<Scalars['String']>;
};

export type PurchasePayment = {
  __typename?: 'PurchasePayment';
  card?: Maybe<Scalars['Float']>;
  coupon?: Maybe<Scalars['Float']>;
  credit?: Maybe<Scalars['Float']>;
};

export type PurchasePriceType = {
  __typename?: 'PurchasePriceType';
  currencyIsoCode?: Maybe<Scalars['String']>;
  payment?: Maybe<PurchasePayment>;
};

export type PurchaseSessionBooking = {
  clientDescription?: InputMaybe<Scalars['String']>;
  clientPhone: Scalars['String'];
  expertSessionId: Scalars['Int'];
  guests?: InputMaybe<Array<Scalars['String']>>;
  startingExpertAvailabilityId: Scalars['Int'];
};

export enum PurchaseSorterField {
  BuyerEmail = 'buyerEmail',
  ContactEmail = 'contactEmail',
  CreatedAtUtc = 'createdAtUtc',
  Email = 'email',
  Id = 'id',
  PlatformCommissionAmount = 'platformCommissionAmount',
  TotalPrice = 'totalPrice'
}

export enum PurchaseStatus {
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  InProduction = 'IN_PRODUCTION',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Shipped = 'SHIPPED',
  Void = 'VOID'
}

export type Purchases = {
  __typename?: 'Purchases';
  data: Array<Purchase>;
  paginationInfo: PaginationInfo;
};

export type PurchasesFilterInput = {
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type PurchasesInput = {
  filter?: InputMaybe<PurchasesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorter?: InputMaybe<PurchasesSorterInput>;
};

export type PurchasesSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<PurchaseSorterField>;
};

export type Query = {
  __typename?: 'Query';
  addresses: Array<Maybe<Address>>;
  adminBookedSessions: AdminBookedSessions;
  adminCategories: Array<Maybe<Category>>;
  adminCategoryExperts: CategoryExperts;
  adminCmsPages: CmsPages;
  adminCmsPagesByLimit: CmsPagesByLimit;
  adminDashboardCollections: CollectionsCursorPagination;
  adminDashboardExpertUsers: ExpertUsersCursorPagination;
  adminDashboardExperts: ExpertsCursorPagination;
  adminExpertApplication: ExpertApplication;
  adminExpertUsers: AdminExpertUsers;
  adminMe: Admin;
  adminNavigationGroup?: Maybe<NavigationGroup>;
  adminNavigations: Navigations;
  adminOrders: Orders;
  adminRegions: Array<Maybe<Region>>;
  adminSignInAsClient: Scalars['String'];
  adminSignInAsExpertUser: Scalars['String'];
  adminTags: Array<Tag>;
  admins: Array<Admin>;
  allPublicExperts: Array<Maybe<Expert>>;
  calculatePriceCheckout: CheckoutPriceCalculation;
  calculateRefund: RefundCalculation;
  cart?: Maybe<Cart>;
  checkout: Checkout;
  cities: Array<Maybe<City>>;
  client: Client;
  clientBookedSessions: ClientBookedSessions;
  clientExpertSession?: Maybe<PublicExpertSession>;
  clientMe: Client;
  clients: Clients;
  cmsArticlePage: CmsArticlePage;
  cmsArticlePageBySlug: CmsArticlePage;
  cmsArticlePagePreview: CmsArticlePage;
  cmsArticlePageSlugs: Array<Scalars['String']>;
  cmsArticlePages: CmsArticlePages;
  cmsBrandPage: CmsBrandPage;
  cmsBrandPageBySlug: CmsBrandPage;
  cmsBrandPageSlugs: Array<Scalars['String']>;
  cmsCategoryPage: CmsCategoryPage;
  cmsCategoryPageBySlug: CmsCategoryPage;
  cmsCategoryPageSlugs: Array<Scalars['String']>;
  cmsConsultationPage: CmsConsultationPage;
  cmsConsultationPageBySlug: CmsConsultationPage;
  cmsConsultationPagePreview: CmsConsultationPage;
  cmsConsultationPageSlugs: Array<Scalars['String']>;
  cmsExpertPage: CmsExpertPage;
  cmsExpertPageBySlug: CmsExpertPage;
  cmsExpertPageSlugs: Array<Scalars['String']>;
  cmsListingWidgetById: CmsListingWidget;
  cmsListingWidgets: CmsListingWidgets;
  cmsShowroomNavigationPageSlugs: Array<Scalars['String']>;
  cmsShowroomPage: CmsShowroomPage;
  cmsShowroomPageBySlug: CmsShowroomPage;
  cmsShowroomPagePreview: CmsShowroomPage;
  cmsShowroomPageSlugs: Array<Scalars['String']>;
  cmsShowroomPages: CmsShowroomPages;
  cmsWidgetById: CmsWidget;
  collection: Collection;
  collections: Collections;
  countries: Array<Maybe<Country>>;
  coupon: Coupon;
  couponPrice: CouponPrice;
  coupons: Coupons;
  couponsSettings: CouponsSettings;
  expert: Expert;
  expertApplication: ExpertApplication;
  expertApplications: ExpertApplications;
  expertAttachments?: Maybe<Array<Attachment>>;
  expertAvailabilities: ExpertAvailabilities;
  expertAvailability: ExpertAvailability;
  expertAvailableTimes: Array<Maybe<Datetime>>;
  expertBookedSessions: ExpertBookedSessions;
  expertBySlug: Expert;
  expertChart: ExpertChart;
  expertMe: Expert;
  expertPrivateAvailabilitiesGroups?: Maybe<Array<Maybe<ExpertAvailabilityGroup>>>;
  expertSession: ExpertSession;
  expertSessionClient: SessionClient;
  expertSessions: ExpertSessions;
  expertShowroomCollectionCollectionItem?: Maybe<CollectionItem>;
  expertUser: ExpertUser;
  expertUsers: ExpertUsers;
  experts: Experts;
  externalProductPreview: ExternalProductPreview;
  firstPublicExpertAvailability?: Maybe<ExpertAvailability>;
  getBreadcrumbsByPath: Array<Breadcrumb>;
  globalSearch: GlobalSearchResults;
  navigation: Navigation;
  order: Order;
  orders: Orders;
  pastSessionsClients: PastSessionsClients;
  product: Product;
  productSlugs: Array<Slugs>;
  productVariants: ProductVariants;
  products: Products;
  publicCategories: Array<Maybe<PublicCategory>>;
  publicExpertAvailabilities: Array<Maybe<ExpertAvailability>>;
  publicExpertSlugs: Array<Scalars['String']>;
  publicExperts: PublicExperts;
  publicRegions: Array<Maybe<Region>>;
  publicTags?: Maybe<Array<Tag>>;
  publishedNavigationGroups: Array<NavigationGroup>;
  purchase: Purchase;
  purchases: Purchases;
  reviewPastSession: PastSessionClient;
  safeString?: Maybe<Scalars['SafeString']>;
  session?: Maybe<Session>;
  sessionClient: PastSessionClient;
  sessionLogs: SessionLogs;
  sessionReport: SessionReport;
  specificUsersFeatureFlags: Array<Maybe<FeatureFlag>>;
  states: Array<Maybe<State>>;
  tradeLicense: TradeLicense;
  tradeLicenses: TradeLicenses;
  trustedSources: TrustedSources;
  userMe: User;
  validateAvailableCmsArticlePageSlug?: Maybe<Scalars['Boolean']>;
  validateAvailableCmsConsultationPageSlug?: Maybe<Scalars['Boolean']>;
  validateAvailableCmsShowroomPageSlug?: Maybe<Scalars['Boolean']>;
  validateAvailableExpertApplicationEmail: Scalars['Boolean'];
  validateAvailableExpertBusinessName: Scalars['Boolean'];
  validateAvailableExpertSlug: Scalars['Boolean'];
  validateExpertUserOnboardingToken: ExpertUser;
  validateOnboardingToken: OnboardingValidationResponse;
  vendors: Array<Vendor>;
};


export type QueryAddressesArgs = {
  input: AutocompleteInput;
};


export type QueryAdminBookedSessionsArgs = {
  input?: InputMaybe<AdminBookedSessionsInput>;
};


export type QueryAdminCategoryExpertsArgs = {
  input: CategoryExpertsInput;
};


export type QueryAdminCmsPagesArgs = {
  input: AdminCmsPagesInput;
};


export type QueryAdminCmsPagesByLimitArgs = {
  input: AdminCmsPagesByLimitInput;
};


export type QueryAdminDashboardCollectionsArgs = {
  input?: InputMaybe<AdminDashboardCollectionsInput>;
};


export type QueryAdminDashboardExpertUsersArgs = {
  input?: InputMaybe<AdminDashboardExpertUsersInput>;
};


export type QueryAdminDashboardExpertsArgs = {
  input?: InputMaybe<AdminDashboardExpertsInput>;
};


export type QueryAdminExpertApplicationArgs = {
  id: Scalars['Int'];
};


export type QueryAdminExpertUsersArgs = {
  input?: InputMaybe<AdminExpertUsersInput>;
};


export type QueryAdminNavigationGroupArgs = {
  input: AdminNavigationGroupInput;
};


export type QueryAdminNavigationsArgs = {
  input?: InputMaybe<NavigationsInput>;
};


export type QueryAdminOrdersArgs = {
  input?: InputMaybe<AdminsOrdersInput>;
};


export type QueryAdminSignInAsClientArgs = {
  clientId: Scalars['Int'];
};


export type QueryAdminSignInAsExpertUserArgs = {
  expertUserId: Scalars['Int'];
};


export type QueryAdminTagsArgs = {
  input?: InputMaybe<AdminTagsInput>;
};


export type QueryCalculatePriceCheckoutArgs = {
  input: CheckoutInput;
};


export type QueryCalculateRefundArgs = {
  input: CalculateRefundInput;
};


export type QueryCheckoutArgs = {
  id: Scalars['Int'];
};


export type QueryCitiesArgs = {
  input: AutocompleteInput;
};


export type QueryClientArgs = {
  id: Scalars['Int'];
};


export type QueryClientBookedSessionsArgs = {
  input?: InputMaybe<ClientBookedSessionsInput>;
};


export type QueryClientExpertSessionArgs = {
  input: ExpertSessionClientInput;
};


export type QueryClientMeArgs = {
  id: Scalars['Int'];
};


export type QueryClientsArgs = {
  input: ClientsInput;
};


export type QueryCmsArticlePageArgs = {
  input: CmsArticlePageInput;
};


export type QueryCmsArticlePageBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCmsArticlePagePreviewArgs = {
  slug: Scalars['String'];
};


export type QueryCmsArticlePagesArgs = {
  input?: InputMaybe<CmsArticlePagesInput>;
};


export type QueryCmsBrandPageArgs = {
  input: CmsBrandPageInput;
};


export type QueryCmsBrandPageBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCmsCategoryPageArgs = {
  input: CmsCategoryPageInput;
};


export type QueryCmsCategoryPageBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCmsConsultationPageArgs = {
  input: CmsConsultationPageInput;
};


export type QueryCmsConsultationPageBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCmsConsultationPagePreviewArgs = {
  slug: Scalars['String'];
};


export type QueryCmsExpertPageArgs = {
  input: CmsExpertPageInput;
};


export type QueryCmsExpertPageBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCmsListingWidgetByIdArgs = {
  id: Scalars['Int'];
};


export type QueryCmsListingWidgetsArgs = {
  input: CmsListingWidgetsInput;
};


export type QueryCmsShowroomPageArgs = {
  input: CmsShowroomPageInput;
};


export type QueryCmsShowroomPageBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCmsShowroomPagePreviewArgs = {
  slug: Scalars['String'];
};


export type QueryCmsShowroomPagesArgs = {
  input: CmsShowroomPagesInput;
};


export type QueryCmsWidgetByIdArgs = {
  input: WidgetsByIdInput;
};


export type QueryCollectionArgs = {
  id: Scalars['Int'];
};


export type QueryCollectionsArgs = {
  input?: InputMaybe<CollectionsInput>;
};


export type QueryCountriesArgs = {
  search: Scalars['String'];
};


export type QueryCouponArgs = {
  id: Scalars['Int'];
};


export type QueryCouponPriceArgs = {
  amount: Scalars['Int'];
};


export type QueryCouponsArgs = {
  input: CouponsInput;
};


export type QueryExpertArgs = {
  id: Scalars['Int'];
};


export type QueryExpertApplicationArgs = {
  onboardingToken: Scalars['String'];
};


export type QueryExpertApplicationsArgs = {
  input?: InputMaybe<ExpertApplicationsInput>;
};


export type QueryExpertAttachmentsArgs = {
  input: ExpertAttachmentsInput;
};


export type QueryExpertAvailabilitiesArgs = {
  input: ExpertAvailabilitiesInput;
};


export type QueryExpertAvailabilityArgs = {
  id: Scalars['Int'];
};


export type QueryExpertAvailableTimesArgs = {
  input?: InputMaybe<ExpertAvailableTimesInput>;
};


export type QueryExpertBookedSessionsArgs = {
  input?: InputMaybe<ExpertBookedSessionsInput>;
};


export type QueryExpertBySlugArgs = {
  reviewsInput?: InputMaybe<ReviewsInput>;
  slug: Scalars['String'];
};


export type QueryExpertChartArgs = {
  expertId: Scalars['Int'];
};


export type QueryExpertMeArgs = {
  id: Scalars['Int'];
};


export type QueryExpertPrivateAvailabilitiesGroupsArgs = {
  input: ExpertPrivateAvailabilitiesGroupsInput;
};


export type QueryExpertSessionArgs = {
  input: ExpertSessionInput;
};


export type QueryExpertSessionClientArgs = {
  id: Scalars['Int'];
};


export type QueryExpertSessionsArgs = {
  input?: InputMaybe<ExpertSessionsInput>;
};


export type QueryExpertShowroomCollectionCollectionItemArgs = {
  productVariantId: Scalars['Int'];
};


export type QueryExpertUserArgs = {
  id: Scalars['Int'];
};


export type QueryExpertUsersArgs = {
  input?: InputMaybe<ExpertUsersInput>;
};


export type QueryExpertsArgs = {
  input?: InputMaybe<ExpertsInput>;
};


export type QueryExternalProductPreviewArgs = {
  input: ExternalProductPreviewInput;
};


export type QueryFirstPublicExpertAvailabilityArgs = {
  expertSessionId: Scalars['Int'];
};


export type QueryGetBreadcrumbsByPathArgs = {
  path: Scalars['String'];
};


export type QueryGlobalSearchArgs = {
  input: GlobalSearchInput;
};


export type QueryNavigationArgs = {
  id: Scalars['Int'];
};


export type QueryOrderArgs = {
  id: Scalars['Int'];
};


export type QueryOrdersArgs = {
  input?: InputMaybe<OrdersInput>;
};


export type QueryPastSessionsClientsArgs = {
  input?: InputMaybe<PastSessionsClientsInput>;
};


export type QueryProductArgs = {
  input: ProductInput;
};


export type QueryProductVariantsArgs = {
  input?: InputMaybe<ProductVariantsInput>;
};


export type QueryProductsArgs = {
  input?: InputMaybe<ProductsInput>;
};


export type QueryPublicCategoriesArgs = {
  input?: InputMaybe<PublicCategoriesInput>;
};


export type QueryPublicExpertAvailabilitiesArgs = {
  input: PublicExpertAvailabilitiesInput;
};


export type QueryPublicExpertsArgs = {
  input?: InputMaybe<ExpertsInput>;
};


export type QueryPurchaseArgs = {
  input: PurchaseInput;
};


export type QueryPurchasesArgs = {
  input?: InputMaybe<PurchasesInput>;
};


export type QueryReviewPastSessionArgs = {
  input: SessionReviewQueryInput;
};


export type QuerySafeStringArgs = {
  input?: InputMaybe<Scalars['SafeString']>;
};


export type QuerySessionArgs = {
  id: Scalars['Int'];
};


export type QuerySessionClientArgs = {
  input: SessionClientInput;
};


export type QuerySessionLogsArgs = {
  input?: InputMaybe<SessionLogsInput>;
};


export type QuerySessionReportArgs = {
  id: Scalars['Int'];
};


export type QueryStatesArgs = {
  input: AutocompleteInput;
};


export type QueryTradeLicenseArgs = {
  input: TradeLicenseInput;
};


export type QueryTradeLicensesArgs = {
  input?: InputMaybe<TradeLicensesInput>;
};


export type QueryTrustedSourcesArgs = {
  input?: InputMaybe<TrustedSourcesInput>;
};


export type QueryValidateAvailableCmsArticlePageSlugArgs = {
  input: ValidateAvailableCmsPageSlugInput;
};


export type QueryValidateAvailableCmsConsultationPageSlugArgs = {
  input: ValidateAvailableCmsPageSlugInput;
};


export type QueryValidateAvailableCmsShowroomPageSlugArgs = {
  input: ValidateAvailableCmsPageSlugInput;
};


export type QueryValidateAvailableExpertApplicationEmailArgs = {
  input: ValidateAvailableExpertApplicationEmailInput;
};


export type QueryValidateAvailableExpertBusinessNameArgs = {
  input: ValidateExpertBusinessNameInput;
};


export type QueryValidateAvailableExpertSlugArgs = {
  input: ValidateExpertSlugInput;
};


export type QueryValidateExpertUserOnboardingTokenArgs = {
  onboardingToken: Scalars['String'];
};


export type QueryValidateOnboardingTokenArgs = {
  onboardingToken: Scalars['String'];
};

export type Recaptcha = {
  __typename?: 'Recaptcha';
  isSuccess: Scalars['Boolean'];
};

export type RecommendedProduct = {
  __typename?: 'RecommendedProduct';
  createdAtUtc: Datetime;
  id: Scalars['Int'];
  pairedProduct: Product;
  positionIndexWeight: Scalars['Int'];
  product: Product;
  updatedAtUtc: Datetime;
};

export type RecommendedProductInput = {
  id?: InputMaybe<Scalars['Int']>;
  positionIndexWeight: Scalars['Int'];
  productId: Scalars['Int'];
};

export type RecommendedProductsFilterInput = {
  listUnavailableProducts?: InputMaybe<Scalars['Boolean']>;
};

export type Refund = {
  __typename?: 'Refund';
  cancellationFee: Scalars['Int'];
  createdAtUtc: Datetime;
  creditTransaction?: Maybe<CreditTransaction>;
  id: Scalars['Int'];
  price: Price;
  stripeRefundId?: Maybe<Scalars['String']>;
};

export type RefundCalculation = {
  __typename?: 'RefundCalculation';
  cash: Price;
  credits: Price;
};

export enum RefundType {
  Cash = 'CASH',
  Credits = 'CREDITS'
}

export type Region = {
  __typename?: 'Region';
  children: Array<Maybe<Region>>;
  expertPositionIndexWeight?: Maybe<Scalars['Int']>;
  experts: Array<Maybe<Expert>>;
  id: Scalars['Int'];
  parent?: Maybe<Region>;
  parentId?: Maybe<Scalars['Int']>;
  positionIndexWeight?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type RelatedArticlesWidgetInput = {
  cmsArticlesWidget?: InputMaybe<CmsArticlesWidgetInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type RemoveCollectionProductInput = {
  collectionId: Scalars['Int'];
  productId: Scalars['Int'];
  productVariantId?: InputMaybe<Scalars['Int']>;
};

export type RemoveItemFromCartInput = {
  cartItemId?: InputMaybe<Scalars['Int']>;
};

export type ReorderExpertImagesInput = {
  expertAttachmentIds: Array<Scalars['Int']>;
};

export type ReorderNavigationItemsInput = {
  childrenIds: Array<InputMaybe<Scalars['Int']>>;
  id: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
};

export type ReorderRegionsInput = {
  childrenRegionIds: Array<InputMaybe<Scalars['Int']>>;
  id: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
};

export type RequestCollectionReviewInput = {
  id: Scalars['Int'];
};

export type ResetPasswordInput = {
  password: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};

export enum RevenueGroupField {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Reviews = {
  __typename?: 'Reviews';
  data?: Maybe<Array<SessionReview>>;
  paginationInfo: PaginationInfo;
};

export type ReviewsAverageRating = {
  __typename?: 'ReviewsAverageRating';
  avg?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};

export type ReviewsInput = {
  isPublicVisible?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
};

export type SendContactUsEmailInput = {
  emailFrom: Scalars['emailFrom_String_NotNull_format_email'];
  message: Scalars['String'];
};

export type SendFreeAssistanceEmailInput = {
  emailMessage: Scalars['String'];
  sessionReportId: Scalars['Int'];
};

export type SendItemInquireEmailInput = {
  emailMessage: Scalars['String'];
  sessionReportId: Scalars['Int'];
  sessionReportItemId: Scalars['Int'];
};

export type Session = {
  __typename?: 'Session';
  availabilities: Array<ExpertAvailability>;
  couponDiscountPrice: Price;
  createdAtUtc: Datetime;
  discountedPrice: Price;
  endAtUtc: Datetime;
  expert: Expert;
  expertJoinedAtUtc?: Maybe<Datetime>;
  expertUser: ExpertUser;
  id: Scalars['Int'];
  isMinimumSizeReached: Scalars['Boolean'];
  isNoShow: Scalars['Boolean'];
  numberOfActiveBookings: Scalars['Int'];
  promoCodeAmount?: Maybe<Scalars['Int']>;
  sessionClients: Array<SessionClient>;
  sessionData: ExpertSession;
  startAtUtc: Datetime;
  status: SessionStatus;
  updatedAtUtc: Datetime;
  zoomLogs?: Maybe<Array<SessionLog>>;
  zoomSession?: Maybe<ZoomSession>;
  zoomSessionId?: Maybe<Scalars['String']>;
};

export type SessionCancellationInput = {
  refundType: RefundType;
  sessionClientId: Scalars['Int'];
};

export type SessionClient = {
  __typename?: 'SessionClient';
  attachments?: Maybe<Array<Attachment>>;
  cancelInfo?: Maybe<CancelInfo>;
  checkoutItem?: Maybe<CheckoutItem>;
  client: Client;
  clientDescription?: Maybe<Scalars['String']>;
  clientPhone?: Maybe<Scalars['String']>;
  createdAtUtc: Datetime;
  guests?: Maybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  /** @deprecated Use checkoutItem */
  paymentStatus: SessionClientPaymentStatus;
  price: Price;
  questionnaireData?: Maybe<Scalars['JSON']>;
  report?: Maybe<SessionReport>;
  reviewToken?: Maybe<Scalars['String']>;
  session: PublicSession;
  status: SessionClientStatus;
  /** @deprecated Use checkoutItem */
  stripePaymentId?: Maybe<Scalars['String']>;
  stripeTransferId?: Maybe<Scalars['String']>;
  updatedAtUtc: Datetime;
};

export type SessionClientAttachment = {
  __typename?: 'SessionClientAttachment';
  attachment: Attachment;
  id: Scalars['Int'];
};

export type SessionClientInput = {
  clientId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
};

export enum SessionClientPaymentStatus {
  Cancelled = 'CANCELLED',
  OnHold = 'ON_HOLD',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export enum SessionClientStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type SessionCount = {
  __typename?: 'SessionCount';
  count: Scalars['Int'];
  dateUtc: Datetime;
};

export type SessionLog = {
  __typename?: 'SessionLog';
  createdAtUtc: Datetime;
  eventType: SessionLogEventTypes;
  expertUser: ExpertUser;
  id: Scalars['Int'];
  occurredAtUtc: Datetime;
  session: Session;
};

export enum SessionLogEventTypes {
  Joined = 'JOINED',
  Left = 'LEFT'
}

export type SessionLogs = {
  __typename?: 'SessionLogs';
  data: Array<SessionLog>;
  paginationInfo: PaginationInfo;
};

export type SessionLogsInput = {
  filter?: InputMaybe<SessionLogsInputFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sorter?: InputMaybe<SessionLogsSorterInput>;
};

export type SessionLogsInputFilter = {
  clientId?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<StringRangeFilterInput>;
  eventType?: InputMaybe<SessionLogEventTypes>;
  expertName?: InputMaybe<Scalars['String']>;
  expertUserId?: InputMaybe<Scalars['Int']>;
  sessionId?: InputMaybe<Scalars['Int']>;
};

export enum SessionLogsSorterField {
  OccurredAtUtc = 'occurredAtUtc'
}

export type SessionLogsSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<SessionLogsSorterField>;
};

export type SessionQuestionnaireInput = {
  questionnaireData?: InputMaybe<Scalars['JSON']>;
  sessionClientId: Scalars['Int'];
};

export type SessionReport = {
  __typename?: 'SessionReport';
  createdAtUtc: Datetime;
  directToConsumerItems?: Maybe<Array<SessionReportItem>>;
  filesAndNotes: FilesAndNotes;
  id: Scalars['Int'];
  note: Scalars['String'];
  state: SessionReportState;
  tradeOnlyItems?: Maybe<Array<SessionReportItem>>;
  updatedAtUtc: Datetime;
};


export type SessionReportFilesAndNotesArgs = {
  input?: InputMaybe<FilesAndNotesInput>;
};

export type SessionReportInput = {
  directToConsumerItems?: InputMaybe<Array<SessionReportItemInput>>;
  filesAndNotes?: InputMaybe<Array<FilesAndNotesItemInput>>;
  id?: InputMaybe<Scalars['Int']>;
  isWithEmailNotification: Scalars['Boolean'];
  note: Scalars['note_String_NotNull_minLength_1'];
  sessionClientId: Scalars['Int'];
  state?: InputMaybe<SessionReportState>;
  tradeOnlyItems?: InputMaybe<Array<SessionReportItemInput>>;
};

export type SessionReportItem = {
  __typename?: 'SessionReportItem';
  attachment?: Maybe<Attachment>;
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  originUrl: Scalars['String'];
  publisher: Scalars['String'];
  title: Scalars['String'];
  type: SessionReportItemType;
  url: Scalars['String'];
};

export type SessionReportItemInput = {
  attachmentId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  publisher: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export enum SessionReportItemType {
  DirectToConsumer = 'DIRECT_TO_CONSUMER',
  TradeOnly = 'TRADE_ONLY'
}

export enum SessionReportState {
  Draft = 'DRAFT',
  Sent = 'SENT'
}

export type SessionRevenue = {
  __typename?: 'SessionRevenue';
  currencyIsoCode: Scalars['String'];
  dateUtc: Datetime;
  revenue: Scalars['Float'];
  status: SessionStatus;
};

export type SessionReview = {
  __typename?: 'SessionReview';
  client?: Maybe<Client>;
  createdAtUtc: Datetime;
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isVisible: Scalars['Boolean'];
  rating: Scalars['Int'];
  session?: Maybe<Session>;
};

export type SessionReviewInput = {
  feedback?: InputMaybe<Scalars['String']>;
  rating: Scalars['Int'];
  reviewToken: Scalars['reviewToken_String_NotNull_format_uuid'];
};

export type SessionReviewMutationInput = {
  isVisible: Scalars['Boolean'];
  sessionReviewId: Scalars['Int'];
};

export type SessionReviewQueryInput = {
  reviewToken: Scalars['reviewToken_String_NotNull_format_uuid'];
};

export enum SessionSorterField {
  CreatedAtUtc = 'createdAtUtc',
  StartAtUtc = 'startAtUtc'
}

export enum SessionStatus {
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  OnHold = 'ON_HOLD',
  Pending = 'PENDING',
  Unpaid = 'UNPAID'
}

export enum SessionTypeField {
  Group = 'GROUP',
  Private = 'PRIVATE'
}

export type SessionsSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<SessionSorterField>;
};

export type SetItemToCartInput = {
  expertSlug?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<ItemMetadataInput>;
  productVariantId?: InputMaybe<Scalars['Int']>;
  quantity: Scalars['Int'];
  requestedAtUtc: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type ShipmentAddress = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  countryIsoCode: Scalars['String'];
  countryState?: InputMaybe<Scalars['String']>;
  email: Scalars['email_String_NotNull_format_email'];
  fullName: Scalars['String'];
  phone: Scalars['String'];
  zipCode: Scalars['String'];
};

export type ShipmentData = OrderShipmentArtaQuote | OrderShipmentFreightClubQuote | OrderShipmentVendorShipping;

export type Slugs = {
  __typename?: 'Slugs';
  product: Scalars['String'];
  variant: Scalars['String'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Source = {
  __typename?: 'Source';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  countryCode: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  flxId: Scalars['Int'];
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
};

export type SourceAddress = {
  __typename?: 'SourceAddress';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  cityCode: Scalars['String'];
  countryCode: Scalars['String'];
  email1: Scalars['String'];
  email2?: Maybe<Scalars['String']>;
  firstName1: Scalars['String'];
  firstName2?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName1: Scalars['String'];
  lastName2?: Maybe<Scalars['String']>;
  phone1: Scalars['String'];
  phone2?: Maybe<Scalars['String']>;
  postal: Scalars['String'];
  stateCode: Scalars['String'];
};

export type State = {
  __typename?: 'State';
  shortCode: Scalars['String'];
  title: Scalars['String'];
};

export type StringRangeFilterInput = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type SubscribeToMailingListInput = {
  email: Scalars['email_String_NotNull_format_email'];
};

export type SubscriptionMetadata = {
  dateRange: Array<SubscriptionPreferredDateRange>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  timeRange: Array<SubscriptionPreferredTimeRange>;
  timezone: Scalars['String'];
};

export enum SubscriptionPreferredDateRange {
  NextMonth = 'NEXT_MONTH',
  NextSixMonths = 'NEXT_SIX_MONTHS',
  NextTwoWeeks = 'NEXT_TWO_WEEKS',
  ThisWeek = 'THIS_WEEK'
}

export enum SubscriptionPreferredTimeRange {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Morning = 'MORNING'
}

export type SumPrice = {
  __typename?: 'SumPrice';
  currencyIsoCode?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
  payment?: Maybe<Payment>;
  retailPrice?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

export type Summary = {
  __typename?: 'Summary';
  itemsCount: Scalars['Int'];
  totalPrice: Price;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type Testimonials = {
  __typename?: 'Testimonials';
  data?: Maybe<Array<ExpertTestimonial>>;
  paginationInfo: PaginationInfo;
};

export type TestimonialsInput = {
  pagination?: InputMaybe<PaginationInput>;
};

export type ToggleIsDisabledTradeLicenseInput = {
  id: Scalars['Int'];
};

export type TradeLicense = {
  __typename?: 'TradeLicense';
  attachments: Array<Attachment>;
  checkouts: Checkouts;
  countryStates: Array<Scalars['String']>;
  createdAtUtc: Datetime;
  expert: Expert;
  expertId: Scalars['Int'];
  expiresAtUtc?: Maybe<Datetime>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isDisabled: Scalars['Boolean'];
  isSingleUse: Scalars['Boolean'];
  licenseNumber: Scalars['String'];
  name: Scalars['String'];
  updatedAtUtc: Datetime;
};


export type TradeLicenseCheckoutsArgs = {
  input?: InputMaybe<CheckoutsCursorPaginationInput>;
};

export type TradeLicenseEdge = {
  __typename?: 'TradeLicenseEdge';
  cursor: Scalars['String'];
  node: TradeLicense;
};

export type TradeLicenseInput = {
  id: Scalars['Int'];
};

export enum TradeLicenseSorterField {
  CreatedAtUtc = 'createdAtUtc',
  Id = 'id',
  IsActive = 'isActive',
  IsDisabled = 'isDisabled',
  IsSingleUse = 'isSingleUse',
  Name = 'name',
  UpdatedAtUtc = 'updatedAtUtc'
}

export type TradeLicenses = {
  __typename?: 'TradeLicenses';
  edges: Array<TradeLicenseEdge>;
  pageInfo: CursorPaginationInfo;
};

export type TradeLicensesFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  states?: InputMaybe<Array<Scalars['String']>>;
};

export type TradeLicensesInput = {
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<TradeLicensesSorterInput>;
};

export type TradeLicensesSorterInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<TradeLicenseSorterField>;
};

export type TrustedSource = {
  __typename?: 'TrustedSource';
  childSrc: Scalars['Boolean'];
  connectSrc: Scalars['Boolean'];
  createdAtUtc: Datetime;
  domain: Scalars['String'];
  fontSrc: Scalars['Boolean'];
  frameSrc: Scalars['Boolean'];
  id: Scalars['Int'];
  imgSrc: Scalars['Boolean'];
  manifestSrc: Scalars['Boolean'];
  mediaSrc: Scalars['Boolean'];
  objectSrc: Scalars['Boolean'];
  prefetchSrc: Scalars['Boolean'];
  scriptSrc: Scalars['Boolean'];
  scriptSrcAttr: Scalars['Boolean'];
  scriptSrcElem: Scalars['Boolean'];
  styleSrc: Scalars['Boolean'];
  styleSrcAttr: Scalars['Boolean'];
  styleSrcElem: Scalars['Boolean'];
  updatedAtUtc: Datetime;
  workerSrc: Scalars['Boolean'];
};

export type TrustedSources = {
  __typename?: 'TrustedSources';
  data: Array<Maybe<TrustedSource>>;
  paginationInfo: PaginationInfo;
};

export type TrustedSourcesInput = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']>;
};

export type UpdateAdminInput = {
  email?: InputMaybe<Scalars['email_String_format_email']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['password_String_minLength_6']>;
};

export type UpdateCmsArticlePageInput = {
  author: Scalars['String'];
  cmsPageInput: UpdateCmsPageInput;
  id: Scalars['Int'];
  previewAttachmentId?: InputMaybe<Scalars['Int']>;
  previewText?: InputMaybe<Scalars['String']>;
  relatedArticlesWidget?: InputMaybe<RelatedArticlesWidgetInput>;
  tag?: InputMaybe<Scalars['String']>;
};

export type UpdateCmsBrandPageInput = {
  cmsPageInput: UpdateCmsPageInput;
  id: Scalars['Int'];
};

export type UpdateCmsCategoryPageInput = {
  cmsPageInput: UpdateCmsPageInput;
  id: Scalars['Int'];
};

export type UpdateCmsConsultationPageInput = {
  cmsPageInput: UpdateCmsPageInput;
  id: Scalars['Int'];
};

export type UpdateCmsExpertPageInput = {
  cmsPageInput: UpdateCmsPageInput;
  id: Scalars['Int'];
};

export type UpdateCmsPageInput = {
  id: Scalars['Int'];
  keywords?: InputMaybe<Array<Scalars['String']>>;
  metaDescription?: InputMaybe<Scalars['String']>;
  metaTitle?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  widgets?: InputMaybe<Array<CmsWidgetInput>>;
};

export type UpdateCmsShowroomPageInput = {
  cmsPageInput: UpdateCmsPageInput;
  id: Scalars['Int'];
};

export type UpdateCategoryExpertInput = {
  categoryId: Scalars['Int'];
  expertId: Scalars['Int'];
  positionIndexWeight?: InputMaybe<Scalars['Int']>;
};

export type UpdateClientAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countryIsoCode?: InputMaybe<Scalars['String']>;
  countryState?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateClientBusinessNameInput = {
  businessName: Scalars['String'];
  id: Scalars['Int'];
};

export type UpdateClientInput = {
  businessName?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['contactEmail_String_format_email']>;
  firstName?: InputMaybe<Scalars['SafeString']>;
  lastName?: InputMaybe<Scalars['SafeString']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpdateCollectionInput = {
  expertId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  status?: InputMaybe<CollectionStatus>;
  title: Scalars['String'];
};

export type UpdateCouponInput = {
  amount?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  isValid?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateExpertBusinessNameInput = {
  businessName: Scalars['String'];
};

export type UpdateExpertHeadshotImageInput = {
  crop?: InputMaybe<CropInput>;
  file?: InputMaybe<Scalars['Upload']>;
};

export type UpdateExpertInput = {
  categories: Array<Scalars['Int']>;
  city: Scalars['String'];
  countryIsoCode: Scalars['String'];
  countryState?: InputMaybe<Scalars['String']>;
  currencyIsoCode?: InputMaybe<CurrencyIsoCode>;
  expertises?: InputMaybe<Array<ExpertExpertiseInput>>;
  facebookAccountUrl?: InputMaybe<Scalars['String']>;
  instagramAccountUrl?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  linkedInAccountUrl?: InputMaybe<Scalars['String']>;
  longDescription?: InputMaybe<Scalars['String']>;
  primaryCategoryId?: InputMaybe<Scalars['Int']>;
  primaryLocation?: InputMaybe<Scalars['String']>;
  primarySubcategoryId?: InputMaybe<Scalars['Int']>;
  profileName?: InputMaybe<Scalars['String']>;
  secondaryLocation?: InputMaybe<Scalars['String']>;
  secondarySubcategoryId?: InputMaybe<Scalars['Int']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  subcategories: Array<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  twitterAccountUrl?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  youtubeAccountUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateExpertProfileImageInput = {
  crop?: InputMaybe<CropInput>;
  file?: InputMaybe<Scalars['Upload']>;
};

export type UpdateExpertRegionInput = {
  expertId: Scalars['Int'];
  expertPositionIndexWeight?: InputMaybe<Scalars['Int']>;
  regionId: Scalars['Int'];
};

export type UpdateExpertUserFeatureFlagInput = {
  expertUserId: Scalars['Int'];
  featureFlagId: Scalars['Int'];
};

export type UpdateExpertUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  notificationEmails?: InputMaybe<Array<ExpertUserNotificationEmailInput>>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateGroupExpertSessionInput = {
  description?: InputMaybe<Scalars['String']>;
  emailNote?: InputMaybe<Scalars['String']>;
  expertUserId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  lengthInMinutes?: InputMaybe<Scalars['Int']>;
  minimumSessionSize?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  sessionCapacity?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateNavigationInput = {
  cmsPageId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  status?: InputMaybe<NavigationStatus>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateNavigationItemInput = {
  attachmentId?: InputMaybe<Scalars['Int']>;
  cmsPageId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  navigationId: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
  subItemsWithImages: Scalars['Boolean'];
  title: Scalars['String'];
};

export type UpdatePrivateExpertSessionInput = {
  description?: InputMaybe<Scalars['String']>;
  emailNote?: InputMaybe<Scalars['String']>;
  expertUserId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  isUpToThreeGuestsAllowed: Scalars['Boolean'];
  lengthInMinutes?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePurchaseInput = {
  attachmentId?: InputMaybe<Scalars['Int']>;
  billingAddressLine1?: InputMaybe<Scalars['String']>;
  billingAddressLine2?: InputMaybe<Scalars['String']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingCompany?: InputMaybe<Scalars['String']>;
  billingCountryIsoCode?: InputMaybe<Scalars['String']>;
  billingCountryState?: InputMaybe<Scalars['String']>;
  billingFullName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingZipCode?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  expertId?: InputMaybe<Scalars['Int']>;
  expertUserId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  policy?: InputMaybe<Scalars['String']>;
  retailPrice: Scalars['Float'];
  shippingAddressLine1?: InputMaybe<Scalars['String']>;
  shippingAddressLine2?: InputMaybe<Scalars['String']>;
  shippingCity?: InputMaybe<Scalars['String']>;
  shippingCompany?: InputMaybe<Scalars['String']>;
  shippingCountryIsoCode?: InputMaybe<Scalars['String']>;
  shippingCountryState?: InputMaybe<Scalars['String']>;
  shippingFullName?: InputMaybe<Scalars['String']>;
  shippingPhone?: InputMaybe<Scalars['String']>;
  shippingPrice: Scalars['Float'];
  shippingZipCode?: InputMaybe<Scalars['String']>;
  status: PurchaseStatus;
  tax: Scalars['Float'];
  trackingUrl?: InputMaybe<Scalars['String']>;
  tradeLicenseId?: InputMaybe<Scalars['Int']>;
  vendorExpertCommission: Scalars['Float'];
  vendorId?: InputMaybe<Scalars['Int']>;
  vendorPrice: Scalars['Float'];
};

export type UpdateRegionInput = {
  id: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateTrustedSourceInput = {
  childSrc?: InputMaybe<Scalars['Boolean']>;
  connectSrc?: InputMaybe<Scalars['Boolean']>;
  domain?: InputMaybe<Scalars['String']>;
  fontSrc?: InputMaybe<Scalars['Boolean']>;
  frameSrc?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  imgSrc?: InputMaybe<Scalars['Boolean']>;
  manifestSrc?: InputMaybe<Scalars['Boolean']>;
  mediaSrc?: InputMaybe<Scalars['Boolean']>;
  objectSrc?: InputMaybe<Scalars['Boolean']>;
  prefetchSrc?: InputMaybe<Scalars['Boolean']>;
  scriptSrc?: InputMaybe<Scalars['Boolean']>;
  scriptSrcAttr?: InputMaybe<Scalars['Boolean']>;
  scriptSrcElem?: InputMaybe<Scalars['Boolean']>;
  styleSrc?: InputMaybe<Scalars['Boolean']>;
  styleSrcAttr?: InputMaybe<Scalars['Boolean']>;
  styleSrcElem?: InputMaybe<Scalars['Boolean']>;
  workerSrc?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateVendorInput = {
  attachmentId: Scalars['Int'];
  brands: Array<Scalars['String']>;
  expertCommission: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  policy?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type User = Admin | Client | ExpertUser;

export type ValidateAvailableCmsPageSlugInput = {
  id?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
};

export type ValidateAvailableExpertApplicationEmailInput = {
  email: Scalars['email_String_NotNull_format_email'];
  omitRejected?: InputMaybe<Scalars['Boolean']>;
};

export type ValidateExpertBusinessNameInput = {
  businessName: Scalars['String'];
};

export type ValidateExpertSlugInput = {
  expertId?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
};

export type Vendor = {
  __typename?: 'Vendor';
  attachment: Attachment;
  brands: Array<Scalars['String']>;
  createdAtUtc: Datetime;
  expertCommission: Scalars['Int'];
  id: Scalars['Int'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  policy?: Maybe<Scalars['String']>;
  updatedAtUtc: Datetime;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type WarnClientInput = {
  emailMessage: Scalars['String'];
  id: Scalars['Int'];
};

export type WarnExpertInput = {
  emailMessage: Scalars['String'];
  id: Scalars['Int'];
};

export type WidgetItem = CmsWidgetItemButton | CmsWidgetItemHeadline | CmsWidgetItemThreeColumnCard | CmsWidgetItemTwoColumnCard;

export type WidgetsByIdInput = {
  cmsArticlesInput?: InputMaybe<CmsArticlesWidgetSpecificInput>;
  cmsExpertsInput?: InputMaybe<CmsExpertsWidgetSpecificInput>;
  cmsExpertsListingWidgetInput?: InputMaybe<CmsExpertsListingWidgetSpecificInput>;
  cmsMultiCollectionProductsInput?: InputMaybe<CmsMultiCollectionWidgetProductsInput>;
  cmsMultiCollectionWidgetProductsCollectionsInput?: InputMaybe<CmsMultiCollectionWidgetProductsCollectionsInput>;
  widgetId: Scalars['Int'];
};

export type WidgetsDefaultInputs = {
  cmsArticlesInput?: InputMaybe<PaginationInput>;
  cmsExpertsInput?: InputMaybe<PaginationInput>;
  cmsExpertsListingWidgetInput?: InputMaybe<ExpertsInput>;
  cmsMultiCollectionProductsCollectionsInput?: InputMaybe<CollectionsInput>;
  cmsMultiCollectionProductsInput?: InputMaybe<ProductsInput>;
};

export type ZoomSession = {
  __typename?: 'ZoomSession';
  id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type GetAddressesQueryVariables = Exact<{
  input: AutocompleteInput;
}>;


export type GetAddressesQuery = { __typename?: 'Query', addresses: Array<{ __typename?: 'Address', fullAddress: string, title: string, zipCode?: string | null, city?: { __typename?: 'City', title: string } | null, state?: { __typename?: 'State', title: string, shortCode: string } | null, country?: { __typename?: 'Country', title: string, isoCode: string } | null } | null> };

export type AdminCmsBrandPageFieldsFragment = { __typename?: 'CMSBrandPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } };

export type CmsBrandPageQueryVariables = Exact<{
  input: CmsBrandPageInput;
}>;


export type CmsBrandPageQuery = { __typename?: 'Query', cmsBrandPage: { __typename?: 'CMSBrandPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } } };

export type UpdateCmsBrandPageMutationVariables = Exact<{
  input: UpdateCmsBrandPageInput;
}>;


export type UpdateCmsBrandPageMutation = { __typename?: 'Mutation', updateCmsBrandPage: { __typename?: 'CMSBrandPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } } };

export type AdminCmsConsultationPageFieldsFragment = { __typename?: 'CMSConsultationPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } };

export type CmsConsultationPageQueryVariables = Exact<{
  input: CmsConsultationPageInput;
}>;


export type CmsConsultationPageQuery = { __typename?: 'Query', cmsConsultationPage: { __typename?: 'CMSConsultationPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } } };

export type UpdateCmsConsultationPageMutationVariables = Exact<{
  input: UpdateCmsConsultationPageInput;
}>;


export type UpdateCmsConsultationPageMutation = { __typename?: 'Mutation', updateCmsConsultationPage: { __typename?: 'CMSConsultationPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } } };

export type CreateCmsConsultationPageMutationVariables = Exact<{
  input: CreateCmsConsultationPageInput;
}>;


export type CreateCmsConsultationPageMutation = { __typename?: 'Mutation', createCmsConsultationPage: { __typename?: 'CMSConsultationPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } } };

export type DeleteCmsConsultationPageMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCmsConsultationPageMutation = { __typename?: 'Mutation', deleteCmsConsultationPage: { __typename?: 'CMSConsultationPage', id: number } };

export type ValidateAvailableCmsConsultationPageSlugQueryVariables = Exact<{
  input: ValidateAvailableCmsPageSlugInput;
}>;


export type ValidateAvailableCmsConsultationPageSlugQuery = { __typename?: 'Query', validateAvailableCmsConsultationPageSlug?: boolean | null };

export type AdminCmsArticlesWidgetFieldsFragment = { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } };

export type CmsHeroCarouselWidgetFieldsFragment = { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> };

export type CmsCardNavigationWidgetFieldsFragment = { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> };

export type AdminCmsPageFieldsFragment = { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null };

export type AdminDashboardCollectionsQueryVariables = Exact<{
  input?: InputMaybe<AdminDashboardCollectionsInput>;
}>;


export type AdminDashboardCollectionsQuery = { __typename?: 'Query', adminDashboardCollections: { __typename?: 'CollectionsCursorPagination', edges: Array<{ __typename?: 'CollectionEdge', node: { __typename?: 'Collection', id: number, title: string, status: CollectionStatus, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string } } }>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type AutocompleteAdminExpertsQueryVariables = Exact<{
  input?: InputMaybe<ExpertsInput>;
}>;


export type AutocompleteAdminExpertsQuery = { __typename?: 'Query', experts: { __typename?: 'Experts', data: Array<{ __typename?: 'Expert', id: number, profileName?: string | null, email: string } | null> } };

export type AdminExpertRegionsQueryVariables = Exact<{
  input?: InputMaybe<ExpertsInput>;
}>;


export type AdminExpertRegionsQuery = { __typename?: 'Query', experts: { __typename?: 'Experts', paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, firstPage: number, lastPage: number, currentPage: number, nextPage?: number | null, previousPage?: number | null }, data: Array<{ __typename?: 'Expert', id: number, profileName?: string | null, email: string, status: ExpertStatus, regions: Array<{ __typename?: 'Region', title: string, expertPositionIndexWeight?: number | null }> } | null> } };

export type AdminDashboardExpertsQueryVariables = Exact<{
  input?: InputMaybe<AdminDashboardExpertsInput>;
}>;


export type AdminDashboardExpertsQuery = { __typename?: 'Query', adminDashboardExperts: { __typename?: 'ExpertsCursorPagination', edges: Array<{ __typename?: 'ExpertEdge', node: { __typename?: 'Expert', id: number, email: string, businessName: string, profileName?: string | null, status: ExpertStatus, subscribersCount: number, nonBookedAvailabilityHours?: number | null, isFindable: boolean, isPublicVisible: boolean, capabilities: Array<string>, users?: Array<{ __typename?: 'ExpertUser', id: number, onboardingToken?: string | null, expert: { __typename?: 'Expert', id: number } }> | null, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, mainUser: { __typename?: 'ExpertUser', id: number }, tradeLicenses: { __typename?: 'TradeLicenses', edges: Array<{ __typename?: 'TradeLicenseEdge', node: { __typename?: 'TradeLicense', isActive: boolean } }> } } }>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type AdminDashboardExpertUsersQueryVariables = Exact<{
  input?: InputMaybe<AdminDashboardExpertUsersInput>;
}>;


export type AdminDashboardExpertUsersQuery = { __typename?: 'Query', adminDashboardExpertUsers: { __typename?: 'ExpertUsersCursorPagination', edges: Array<{ __typename?: 'ExpertUserEdge', node: { __typename?: 'ExpertUser', id: number, email: string, capabilities: Array<string>, isMain?: boolean | null, timezone: string, onboardingToken?: string | null, expert: { __typename?: 'Expert', id: number, businessName: string, users?: Array<{ __typename?: 'ExpertUser', id: number }> | null, tradeLicenses: { __typename?: 'TradeLicenses', edges: Array<{ __typename?: 'TradeLicenseEdge', node: { __typename?: 'TradeLicense', isActive: boolean } }> } } } }>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type AdminSignInAsExpertUserQueryVariables = Exact<{
  expertUserId: Scalars['Int'];
}>;


export type AdminSignInAsExpertUserQuery = { __typename?: 'Query', adminSignInAsExpertUser: string };

export type CreateExpertFromAdminDashboardMutationVariables = Exact<{
  input: CreateExpertFromAdminDashboardInput;
}>;


export type CreateExpertFromAdminDashboardMutation = { __typename?: 'Mutation', createExpertFromAdminDashboard: { __typename?: 'Expert', id: number } };

export type AdminExpertPickerQueryVariables = Exact<{
  input?: InputMaybe<AdminDashboardExpertsInput>;
}>;


export type AdminExpertPickerQuery = { __typename?: 'Query', adminDashboardExperts: { __typename?: 'ExpertsCursorPagination', edges: Array<{ __typename?: 'ExpertEdge', node: { __typename?: 'Expert', id: number, businessName: string, profileName?: string | null, status: ExpertStatus, slug: string } }> } };

export type AdminUpdateExpertMutationVariables = Exact<{
  input: AdminUpdateExpertInput;
}>;


export type AdminUpdateExpertMutation = { __typename?: 'Mutation', adminUpdateExpert: { __typename?: 'Expert', id: number } };

export type CreateAttachmentMutationVariables = Exact<{
  input: CreateAttachmentInput;
}>;


export type CreateAttachmentMutation = { __typename?: 'Mutation', createAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } };

export type CreateVideoAttachmentMutationVariables = Exact<{
  input: CreateAttachmentInput;
}>;


export type CreateVideoAttachmentMutation = { __typename?: 'Mutation', createVideoAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } };

export type GetBreadcrumbsByPathQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type GetBreadcrumbsByPathQuery = { __typename?: 'Query', getBreadcrumbsByPath: Array<{ __typename?: 'Breadcrumb', ariaLabel?: string | null, label: string, link: string, disabled: boolean }> };

export type CalculatePriceCheckoutQueryVariables = Exact<{
  input: CheckoutInput;
}>;


export type CalculatePriceCheckoutQuery = { __typename?: 'Query', calculatePriceCheckout: { __typename?: 'CheckoutPriceCalculation', discountPercentage?: number | null, vatToPayWithoutPaymentMethodDiscounts?: number | null, isTaxExemptionApplied?: boolean | null, totalPrice?: { __typename?: 'Price', total: number, vat: number, base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', currencyIsoCode: CurrencyIsoCode, total: number }> } | null, priceToPay?: { __typename?: 'Price', total: number, vat: number, base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', currencyIsoCode: CurrencyIsoCode, total: number }> } | null, totalDiscount?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', currencyIsoCode: CurrencyIsoCode, total: number }> } | null, nonPaymentMethodDiscountSum?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', currencyIsoCode: CurrencyIsoCode, total: number }> } | null, couponDiscountSum?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', currencyIsoCode: CurrencyIsoCode, total: number }> } | null, shippingPrice?: { __typename?: 'Price', base: number, vat: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, priceToPayWithoutShipping?: { __typename?: 'Price', base: number, vat: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, discountItems: Array<{ __typename?: 'DiscountItem', checkoutItemId: number, itemId: number, itemType: DiscountItemType, itemUnitDiscount: { __typename?: 'Price', base: number, total: number } }>, leftovers?: { __typename?: 'LeftoverItem', coupon: number } | null, retailSubtotalPrice?: { __typename?: 'Price', base: number, vat: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, tradeSubtotalPrice?: { __typename?: 'Price', base: number, vat: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null } };

export type CartFieldsFragment = { __typename?: 'Cart', id: number, email?: string | null, promoCode?: { __typename?: 'PromoCode', code: string, id: number, linkToTac?: string | null, isValid: boolean } | null, couponCode?: { __typename?: 'Coupon', code: string, id: number } | null, summary: { __typename?: 'Summary', itemsCount: number, totalPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode } }, items: Array<{ __typename?: 'CartItemProductVariant', id: number, cartId: number, cartQuantity: number, productVariant: { __typename?: 'ProductVariant', id: number, sku: string, title: string, quantity: number, price: { __typename?: 'Price', vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode, base: number }, tradePrice?: { __typename?: 'Price', vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode, base: number } | null, sourceAddress: { __typename?: 'SourceAddress', id: string }, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, source: { __typename?: 'Source', id: number }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null, vendorShipping: boolean, vendorShippingMethod?: string | null, freightClubMethod?: string | null, minimumQuantity?: string | null, quantityUnitSingular?: string | null, quantityUnitPlural?: string | null, artaMethod?: string | null, artaServices?: string | null, artaPackaging?: string | null, artaSubtype?: string | null, artaSetQuantity?: string | null, returnNotEligible?: boolean | null, freightClubCategory?: string | null, shippingCarrier?: string | null } | null, product: { __typename?: 'Product', id: number, title: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', name: string } | null, categoryThree?: { __typename?: 'ProductCategory', name: string } | null, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', title: string } | null> } } } }> };

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: number, email?: string | null, items: Array<{ __typename?: 'CartItemProductVariant', id: number, cartId: number, cartQuantity: number, metadata?: { __typename?: 'ItemMetadata', ga4?: { __typename?: 'ItemGA4MetaData', listIndex?: number | null, listName?: string | null } | null } | null, productVariant: { __typename?: 'ProductVariant', id: number, sku: string, title: string, quantity: number, price: { __typename?: 'Price', vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode, base: number }, tradePrice?: { __typename?: 'Price', vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode, base: number } | null, sourceAddress: { __typename?: 'SourceAddress', id: string }, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, source: { __typename?: 'Source', id: number }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null, vendorShipping: boolean, vendorShippingMethod?: string | null, freightClubMethod?: string | null, minimumQuantity?: string | null, quantityUnitSingular?: string | null, quantityUnitPlural?: string | null, artaMethod?: string | null, artaServices?: string | null, artaPackaging?: string | null, artaSubtype?: string | null, artaSetQuantity?: string | null, returnNotEligible?: boolean | null, freightClubCategory?: string | null, shippingCarrier?: string | null } | null, product: { __typename?: 'Product', id: number, title: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', name: string } | null, categoryThree?: { __typename?: 'ProductCategory', name: string } | null, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', title: string } | null> } } } }>, promoCode?: { __typename?: 'PromoCode', code: string, id: number, linkToTac?: string | null, isValid: boolean } | null, couponCode?: { __typename?: 'Coupon', code: string, id: number } | null, summary: { __typename?: 'Summary', itemsCount: number, totalPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode } } } | null };

export type UpdateCartShipmentAddressMutationVariables = Exact<{
  input: ShipmentAddress;
}>;


export type UpdateCartShipmentAddressMutation = { __typename?: 'Mutation', updateCartShipmentAddress: { __typename?: 'Cart', id: number, email?: string | null, items: Array<{ __typename?: 'CartItemProductVariant', id: number, cartId: number, cartQuantity: number, metadata?: { __typename?: 'ItemMetadata', ga4?: { __typename?: 'ItemGA4MetaData', listIndex?: number | null, listName?: string | null } | null } | null, productVariant: { __typename?: 'ProductVariant', id: number, sku: string, title: string, quantity: number, price: { __typename?: 'Price', vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode, base: number }, tradePrice?: { __typename?: 'Price', vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode, base: number } | null, sourceAddress: { __typename?: 'SourceAddress', id: string }, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, source: { __typename?: 'Source', id: number }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null, vendorShipping: boolean, vendorShippingMethod?: string | null, freightClubMethod?: string | null, minimumQuantity?: string | null, quantityUnitSingular?: string | null, quantityUnitPlural?: string | null, artaMethod?: string | null, artaServices?: string | null, artaPackaging?: string | null, artaSubtype?: string | null, artaSetQuantity?: string | null, returnNotEligible?: boolean | null, freightClubCategory?: string | null, shippingCarrier?: string | null } | null, product: { __typename?: 'Product', id: number, title: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', name: string } | null, categoryThree?: { __typename?: 'ProductCategory', name: string } | null, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', title: string } | null> } } } }>, promoCode?: { __typename?: 'PromoCode', code: string, id: number, linkToTac?: string | null, isValid: boolean } | null, couponCode?: { __typename?: 'Coupon', code: string, id: number } | null, summary: { __typename?: 'Summary', itemsCount: number, totalPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode } } } };

export type CreateCheckoutMutationVariables = Exact<{
  input: CheckoutInput;
  requestSecret: Scalars['Boolean'];
}>;


export type CreateCheckoutMutation = { __typename?: 'Mutation', createCheckout: { __typename?: 'Checkout', id: number, stripePaymentId?: string | null, email?: string | null, stripeClientSecret?: string | null, totalPrice?: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode } | null, coupon?: { __typename?: 'Coupon', id: number } | null, promoCode?: { __typename?: 'PromoCode', code: string } | null, checkoutItems?: { __typename?: 'CheckoutItems', edges: Array<{ __typename?: 'CheckoutItemEdge', node: { __typename?: 'CheckoutItem', sessionBooking?: { __typename?: 'SessionClient', id: number, price: { __typename?: 'Price', base: number, vat: number, total: number } } | null, orderItem?: { __typename?: 'OrderItem', orderId: number, quantity: number, price: { __typename?: 'Price', base: number, vat: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode }, productVariant: { __typename?: 'ProductVariant', id: number, title: string, sku: string, quantity: number, product: { __typename?: 'Product', title: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', name: string } | null, categoryThree?: { __typename?: 'ProductCategory', name: string } | null }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null }, metadata?: { __typename?: 'ItemMetadata', ga4?: { __typename?: 'ItemGA4MetaData', listName?: string | null, listIndex?: number | null } | null } | null } | null, orderShipment?: { __typename?: 'OrderShipment', orderId: number, price: { __typename?: 'Price', base: number }, shipmentData?: { __typename?: 'OrderShipmentArtaQuote', name: string, type: string, services: Array<{ __typename?: 'OrderShipmentArtaQuoteService', name: string, subtype: string }> } | { __typename?: 'OrderShipmentFreightClubQuote', name: string, type: string } | { __typename?: 'OrderShipmentVendorShipping', name: string, type: string } | null } | null, purchase?: { __typename?: 'Purchase', id: number, totalPrice: { __typename?: 'Price', base: number }, tax: { __typename?: 'Price', base: number }, retailPrice: { __typename?: 'Price', base: number }, shippingPrice: { __typename?: 'Price', base: number } } | null, discountedPrice: { __typename?: 'Price', base: number, vat: number, total: number }, discounts?: Array<{ __typename?: 'Discount', unitDiscount: { __typename?: 'Price', total: number } }> | null } }> } | null } };

export type ConfirmCheckoutMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ConfirmCheckoutMutation = { __typename?: 'Mutation', confirmCheckout: { __typename?: 'Checkout', stripePaymentStatus?: string | null } };

export type ClientMeOrdersQueryVariables = Exact<{
  id: Scalars['Int'];
  paginationInput: CursorPaginationInput;
}>;


export type ClientMeOrdersQuery = { __typename?: 'Query', clientMe: { __typename?: 'Client', id: number, orders: { __typename?: 'Orders', edges: Array<{ __typename?: 'OrderEdge', node?: { __typename?: 'Order', id: number, status: OrderStatus, shippingFullName?: string | null, shippingCompany?: string | null, shippingAddressLine1?: string | null, shippingAddressLine2?: string | null, shippingCountryIsoCode?: string | null, shippingCountryState?: string | null, shippingCity?: string | null, shippingZipCode?: string | null, shippingPhone?: string | null, billingFullName?: string | null, billingCompany?: string | null, billingAddressLine1?: string | null, billingAddressLine2?: string | null, billingCountryIsoCode?: string | null, billingCountryState?: string | null, billingCity?: string | null, billingZipCode?: string | null, billingPhone?: string | null, buyerEmail: string, orderItems: Array<{ __typename?: 'OrderItem', id: number, quantity: number, status: OrderItemStatus, trackingUrl?: string | null, price: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, productVariant: { __typename?: 'ProductVariant', id: number, slug: string, title: string, length?: number | null, width?: number | null, height?: number | null, dimensionUnit?: string | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', depth?: number | null, leadTime?: string | null } | null, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, product: { __typename?: 'Product', title: string, slug: string, customContent?: { __typename?: 'ProductCustomContentFields', customDimensions?: string | null } | null, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }> } }, checkoutItem?: { __typename?: 'CheckoutItem', id: number, discounts?: Array<{ __typename?: 'Discount', id: number, type: DiscountType, unitDiscount: { __typename?: 'Price', base: number, vat: number, total: number, vatRate: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', currencyIsoCode: CurrencyIsoCode, total: number }> } }> | null } | null, orderShipment?: { __typename?: 'OrderShipment', id: number, price: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, shipmentData?: { __typename?: 'OrderShipmentArtaQuote', id: number, type: string, name: string, additionalServices: Array<string>, services: Array<{ __typename?: 'OrderShipmentArtaQuoteService', id: number, name: string, type: string, subtype: string, subSubtype: string }> } | { __typename?: 'OrderShipmentFreightClubQuote', id: number, type: string, name: string } | { __typename?: 'OrderShipmentVendorShipping', id: number, name: string, type: string } | null } | null }>, checkout?: { __typename?: 'Checkout', promoCode?: { __typename?: 'PromoCode', linkToTac?: string | null } | null, discountsSum: Array<{ __typename?: 'DiscountsSum', type?: DiscountType | null, discount?: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode } | null }>, tradeLicense?: { __typename?: 'TradeLicense', id: number } | null } | null, totalDiscount: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode }, totalPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, tax: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, paymentDetails?: { __typename?: 'PaymentDetails', isCreditsPayment?: boolean | null, isCouponPayment?: boolean | null, card?: { __typename?: 'ClientCreditCard', brand: string, last4: string } | null, paidAtUtc?: { __typename?: 'Datetime', isoFormat: string } | null } | null, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, price: { __typename?: 'OrderPriceType', currencyIsoCode?: string | null, originalPrice?: number | null, discount?: number | null, vat?: number | null, subtotal?: number | null, total?: number | null, itemsSum?: { __typename?: 'SumPrice', originalPrice?: number | null, retailPrice?: number | null, discount?: number | null } | null, shipmentsSum?: { __typename?: 'SumPrice', subtotal?: number | null } | null, payment?: { __typename?: 'OrderPayment', methods?: string | null, paidAtUtc?: string | null, credit?: number | null, coupon?: number | null, card?: number | null } | null } } | null }> }, purchases: { __typename?: 'ClientPurchases', edges: Array<{ __typename?: 'PurchaseEdge', node?: { __typename?: 'Purchase', id: number, status: PurchaseStatus, buyerType: BuyerType, trackingUrl?: string | null, description: string, shippingFullName?: string | null, shippingCompany?: string | null, shippingAddressLine1?: string | null, shippingAddressLine2?: string | null, shippingCountryIsoCode?: string | null, shippingCountryState?: string | null, shippingCity?: string | null, shippingZipCode?: string | null, shippingPhone?: string | null, billingFullName?: string | null, billingCompany?: string | null, billingAddressLine1?: string | null, billingAddressLine2?: string | null, billingCountryIsoCode?: string | null, billingCountryState?: string | null, billingCity?: string | null, billingZipCode?: string | null, billingPhone?: string | null, client?: { __typename?: 'Client', contactEmail: string } | null, expertUser?: { __typename?: 'ExpertUser', email: string } | null, vendor?: { __typename?: 'Vendor', name: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | null, expert?: { __typename?: 'Expert', profileName?: string | null, slug: string } | null, totalPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, tax: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, shippingPrice: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, retailPrice: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, paymentDetails?: { __typename?: 'PaymentDetails', isCreditsPayment?: boolean | null, isCouponPayment?: boolean | null, card?: { __typename?: 'ClientCreditCard', brand: string, last4: string } | null, paidAtUtc?: { __typename?: 'Datetime', isoFormat: string } | null } | null, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, price?: { __typename?: 'PurchasePriceType', currencyIsoCode?: string | null, payment?: { __typename?: 'PurchasePayment', coupon?: number | null, card?: number | null } | null } | null, tradeLicense?: { __typename?: 'TradeLicense', id: number } | null } | null }> } } };

export type ClientMeQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ClientMeQuery = { __typename?: 'Query', clientMe: { __typename?: 'Client', id: number, credits: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', total: number, currencyIsoCode: CurrencyIsoCode }> }, cards: Array<{ __typename?: 'ClientCreditCard', stripeId: string, last4: string, expiryYear: string, expiryMonth: string }>, addresses: Array<{ __typename?: 'ClientAddress', id: number, fullName: string, company?: string | null, phone?: string | null, addressLine1: string, addressLine2?: string | null, zipCode: string, countryIsoCode: string, countryState?: string | null, city: string, isPrimary: boolean }> } };

export type CreateClientAddressMutationVariables = Exact<{
  input: CreateClientAddressInput;
}>;


export type CreateClientAddressMutation = { __typename?: 'Mutation', createClientAddress: { __typename?: 'ClientAddress', id: number } };

export type UpdateClientAddressMutationVariables = Exact<{
  input: UpdateClientAddressInput;
}>;


export type UpdateClientAddressMutation = { __typename?: 'Mutation', updateClientAddress: { __typename?: 'ClientAddress', id: number } };

export type DeleteClientAddressMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteClientAddressMutation = { __typename?: 'Mutation', deleteClientAddress: { __typename?: 'ClientAddress', id: number } };

export type ClientSubscribeToExpertAvailabilitiesMutationVariables = Exact<{
  input: ClientExpertAvailabilitySubscriptionInput;
}>;


export type ClientSubscribeToExpertAvailabilitiesMutation = { __typename?: 'Mutation', subscribeToExpertAvailability: boolean };

export type SessionClientQueryVariables = Exact<{
  input: SessionClientInput;
}>;


export type SessionClientQuery = { __typename?: 'Query', sessionClient: { __typename?: 'PastSessionClient', id: number, questionnaireData?: any | null, attachments?: Array<{ __typename?: 'Attachment', id: number, name?: string | null, url: string, alt?: string | null }> | null } };

export type SessionClientDeleteAttachmentMutationVariables = Exact<{
  input: DeleteSessionClientAttachmentInput;
}>;


export type SessionClientDeleteAttachmentMutation = { __typename?: 'Mutation', deleteSessionClientAttachment: { __typename?: 'SessionClientAttachment', id: number } };

export type SessionClientUploadAttachmentMutationVariables = Exact<{
  input: CreateSessionClientAttachmentInput;
}>;


export type SessionClientUploadAttachmentMutation = { __typename?: 'Mutation', createSessionClientAttachment: { __typename?: 'SessionClientAttachment', id: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } };

export type UpdateClientBusinessNameMutationVariables = Exact<{
  input: UpdateClientBusinessNameInput;
}>;


export type UpdateClientBusinessNameMutation = { __typename?: 'Mutation', updateClientBusinessName: { __typename?: 'Client', id: number } };

export type MigrateClientToExpertMutationVariables = Exact<{
  input: MigrateClientToExpertInput;
}>;


export type MigrateClientToExpertMutation = { __typename?: 'Mutation', migrateClientToExpert: { __typename?: 'Expert', id: number } };

export type ClientPastSessionsQueryVariables = Exact<{
  input?: InputMaybe<ClientBookedSessionsInput>;
}>;


export type ClientPastSessionsQuery = { __typename?: 'Query', clientBookedSessions: { __typename?: 'ClientBookedSessions', data: Array<{ __typename?: 'PublicSession', id: number, promoCodeAmount?: number | null, expertUser: { __typename?: 'ExpertUser', firstName?: string | null, lastName?: string | null }, sessionData: { __typename?: 'PublicExpertSession', title: string, lengthInMinutes: number, price: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode } }, sessionClient: { __typename?: 'SessionClient', reviewToken?: string | null, report?: { __typename?: 'SessionReport', id: number } | null }, startAtUtc: { __typename?: 'Datetime', isoFormat: string }, endAtUtc: { __typename?: 'Datetime', isoFormat: string }, couponDiscountPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, payPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', total: number, currencyIsoCode: CurrencyIsoCode }> } } | null> } };

export type ClientUpcomingSessionsQueryVariables = Exact<{
  input?: InputMaybe<ClientBookedSessionsInput>;
}>;


export type ClientUpcomingSessionsQuery = { __typename?: 'Query', clientBookedSessions: { __typename?: 'ClientBookedSessions', data: Array<{ __typename?: 'PublicSession', id: number, promoCodeAmount?: number | null, status: SessionStatus, expert: { __typename?: 'Expert', slug: string, profileName?: string | null }, sessionClient: { __typename?: 'SessionClient', id: number, clientDescription?: string | null, guests?: Array<string> | null, questionnaireData?: any | null, attachments?: Array<{ __typename?: 'Attachment', name?: string | null, id: number }> | null }, sessionData: { __typename?: 'PublicExpertSession', title: string, sessionType: SessionTypeField, lengthInMinutes: number, price: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode } }, startAtUtc: { __typename?: 'Datetime', isoFormat: string }, endAtUtc: { __typename?: 'Datetime', isoFormat: string }, zoomSession?: { __typename?: 'PublicZoomSession', id?: string | null, url?: string | null } | null, couponDiscountPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, payPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', total: number, currencyIsoCode: CurrencyIsoCode }> } } | null> } };

export type CmsArticlePageSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type CmsArticlePageSlugsQuery = { __typename?: 'Query', cmsArticlePageSlugs: Array<string> };

export type DeleteCmsArticlePageMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCmsArticlePageMutation = { __typename?: 'Mutation', deleteCmsArticlePage: { __typename?: 'CMSArticlePage', id: number } };

export type UpdateCmsArticlePageMutationVariables = Exact<{
  input: UpdateCmsArticlePageInput;
}>;


export type UpdateCmsArticlePageMutation = { __typename?: 'Mutation', updateCmsArticlePage: { __typename?: 'CMSArticlePage', id: number, tag?: string | null, author: string, previewText?: string | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null }, previewAttachment?: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } | null } };

export type AdminCmsArticlePageFieldsFragment = { __typename?: 'CMSArticlePage', id: number, tag?: string | null, author: string, previewText?: string | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null }, previewAttachment?: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } | null };

export type CmsArticlePageQueryVariables = Exact<{
  input: CmsArticlePageInput;
}>;


export type CmsArticlePageQuery = { __typename?: 'Query', cmsArticlePage: { __typename?: 'CMSArticlePage', id: number, tag?: string | null, author: string, previewText?: string | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null }, previewAttachment?: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } | null } };

export type ValidateAvailableCmsArticlePageSlugQueryVariables = Exact<{
  input: ValidateAvailableCmsPageSlugInput;
}>;


export type ValidateAvailableCmsArticlePageSlugQuery = { __typename?: 'Query', validateAvailableCmsArticlePageSlug?: boolean | null };

export type CreateCmsArticlePageMutationVariables = Exact<{
  input: CreateCmsArticlePageInput;
}>;


export type CreateCmsArticlePageMutation = { __typename?: 'Mutation', createCmsArticlePage: { __typename?: 'CMSArticlePage', id: number, tag?: string | null, author: string, previewText?: string | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null }, previewAttachment?: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } | null } };

export type CmsBrandPageBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  widgetsDefaultInputs?: InputMaybe<WidgetsDefaultInputs>;
}>;


export type CmsBrandPageBySlugQuery = { __typename?: 'Query', cmsBrandPageBySlug: { __typename?: 'CMSBrandPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, href: string, widgets?: Array<{ __typename?: 'CMSWidget', id: number, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, cmsAlphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType, data: Array<{ __typename?: 'AlphabeticalIndexWidgetData', title: string, url: string }> } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, previewText?: string | null, tag?: string | null, previewAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSBannerWidget', id: number, title: string, buttonText: string, buttonLink: string } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, headshotImageUrl?: string | null, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } }, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } } | null, expert?: { __typename?: 'Expert', id: number, slug: string } | null, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean, expertItems: { __typename?: 'PublicExperts', paginationInfo: { __typename?: 'PaginationInfo', nextPage?: number | null }, data: Array<{ __typename?: 'Expert', slug: string, id: number, primaryLocation?: string | null, countryIsoCode?: string | null, city?: string | null, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } | null> } } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, slug: string, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', cmsPage: { __typename?: 'CMSPage', slug: string } } | null, expert?: { __typename?: 'Expert', slug: string } | null, brands: Array<{ __typename?: 'Brand', id: string }>, maxPrice?: { __typename?: 'Price', total: number } | null, categoriesOne: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null }> }> }>, categoriesTwo: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, categoriesThree: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }>, items: { __typename?: 'CollectionItems', data: Array<{ __typename?: 'CollectionItem', id: string, product?: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, title: string, sku: string, slug: string, quantity: number, status: ProductVariantStatus, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, carouselImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, leadImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, product: { __typename?: 'Product', id: number, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null } }>, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> }, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }> } | null, productVariant?: { __typename?: 'ProductVariant', id: number, title: string, slug: string, quantity: number, availability: ProductAvailability, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }>, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, breakoutVariant?: { __typename?: 'ProductBreakoutVariant', id: number, sku: string, slug: string, title: string, quantity: number, availability: ProductAvailability, minPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, maxPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradeMinPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, tradeMaxPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, product: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> } }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | null }>, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, slug: string, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', id: number, title: string, testimonials?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, video: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSVideoWidget', id: number, title: string, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null } | null }> | null } } };

export type CmsBrandPageSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type CmsBrandPageSlugsQuery = { __typename?: 'Query', cmsBrandPageSlugs: Array<string> };

export type CmsBrandPageBySlug2QueryVariables = Exact<{
  slug: Scalars['String'];
  widgetsDefaultInputs?: InputMaybe<WidgetsDefaultInputs>;
}>;


export type CmsBrandPageBySlug2Query = { __typename?: 'Query', cmsBrandPageBySlug: { __typename?: 'CMSBrandPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, href: string } } };

export type CmsCategoryPageSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type CmsCategoryPageSlugsQuery = { __typename?: 'Query', cmsCategoryPageSlugs: Array<string> };

export type AdminCmsCategoryPageFieldsFragment = { __typename?: 'CMSCategoryPage', id: number, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, parentCategory?: { __typename?: 'ProductCategory', name: string, cmsPage?: { __typename?: 'CMSPage', content?: { __typename?: 'CMSArticlePage' } | { __typename?: 'CMSBrandPage' } | { __typename?: 'CMSCategoryPage', id: number } | { __typename?: 'CMSConsultationPage' } | { __typename?: 'CMSShowroomPage' } | null } | null } | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } };

export type CmsCategoryPageAdminQueryVariables = Exact<{
  input: CmsCategoryPageInput;
}>;


export type CmsCategoryPageAdminQuery = { __typename?: 'Query', cmsCategoryPage: { __typename?: 'CMSCategoryPage', id: number, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, parentCategory?: { __typename?: 'ProductCategory', name: string, cmsPage?: { __typename?: 'CMSPage', content?: { __typename?: 'CMSArticlePage' } | { __typename?: 'CMSBrandPage' } | { __typename?: 'CMSCategoryPage', id: number } | { __typename?: 'CMSConsultationPage' } | { __typename?: 'CMSShowroomPage' } | null } | null } | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } } };

export type UpdateCmsCategoryPageMutationVariables = Exact<{
  input: UpdateCmsCategoryPageInput;
}>;


export type UpdateCmsCategoryPageMutation = { __typename?: 'Mutation', updateCmsCategoryPage: { __typename?: 'CMSCategoryPage', id: number, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, parentCategory?: { __typename?: 'ProductCategory', name: string, cmsPage?: { __typename?: 'CMSPage', content?: { __typename?: 'CMSArticlePage' } | { __typename?: 'CMSBrandPage' } | { __typename?: 'CMSCategoryPage', id: number } | { __typename?: 'CMSConsultationPage' } | { __typename?: 'CMSShowroomPage' } | null } | null } | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } } };

export type CmsCategoryPageBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  widgetsDefaultInputs?: InputMaybe<WidgetsDefaultInputs>;
}>;


export type CmsCategoryPageBySlugQuery = { __typename?: 'Query', cmsCategoryPageBySlug: { __typename?: 'CMSCategoryPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, href: string, widgets?: Array<{ __typename?: 'CMSWidget', id: number, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, cmsAlphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType, data: Array<{ __typename?: 'AlphabeticalIndexWidgetData', title: string, url: string }> } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, previewText?: string | null, tag?: string | null, previewAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSBannerWidget', id: number, title: string, buttonText: string, buttonLink: string } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, headshotImageUrl?: string | null, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } }, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } } | null, expert?: { __typename?: 'Expert', id: number, slug: string } | null, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean, expertItems: { __typename?: 'PublicExperts', paginationInfo: { __typename?: 'PaginationInfo', nextPage?: number | null }, data: Array<{ __typename?: 'Expert', slug: string, id: number, primaryLocation?: string | null, countryIsoCode?: string | null, city?: string | null, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } | null> } } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, slug: string, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', cmsPage: { __typename?: 'CMSPage', slug: string } } | null, expert?: { __typename?: 'Expert', slug: string } | null, brands: Array<{ __typename?: 'Brand', id: string }>, maxPrice?: { __typename?: 'Price', total: number } | null, categoriesOne: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null }> }> }>, categoriesTwo: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, categoriesThree: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }>, items: { __typename?: 'CollectionItems', data: Array<{ __typename?: 'CollectionItem', id: string, product?: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, title: string, sku: string, slug: string, quantity: number, status: ProductVariantStatus, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, carouselImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, leadImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, product: { __typename?: 'Product', id: number, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null } }>, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> }, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }> } | null, productVariant?: { __typename?: 'ProductVariant', id: number, title: string, slug: string, quantity: number, availability: ProductAvailability, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }>, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, breakoutVariant?: { __typename?: 'ProductBreakoutVariant', id: number, sku: string, slug: string, title: string, quantity: number, availability: ProductAvailability, minPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, maxPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradeMinPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, tradeMaxPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, product: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> } }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | null }>, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, slug: string, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', id: number, title: string, testimonials?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, video: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSVideoWidget', id: number, title: string, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null } | null }> | null }, productCategory: { __typename?: 'ProductCategory', name: string, parentCategory?: { __typename?: 'ProductCategory', name: string, parentCategory?: { __typename?: 'ProductCategory', name: string } | null } | null } } };

export type CmsConsultationPageBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  widgetsDefaultInputs?: InputMaybe<WidgetsDefaultInputs>;
}>;


export type CmsConsultationPageBySlugQuery = { __typename?: 'Query', cmsConsultationPageBySlug: { __typename?: 'CMSConsultationPage', cmsPage: { __typename?: 'CMSPage', title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, href: string, widgets?: Array<{ __typename?: 'CMSWidget', id: number, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, cmsAlphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType, data: Array<{ __typename?: 'AlphabeticalIndexWidgetData', title: string, url: string }> } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, previewText?: string | null, tag?: string | null, previewAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSBannerWidget', id: number, title: string, buttonText: string, buttonLink: string } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, headshotImageUrl?: string | null, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } }, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } } | null, expert?: { __typename?: 'Expert', id: number, slug: string } | null, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean, expertItems: { __typename?: 'PublicExperts', paginationInfo: { __typename?: 'PaginationInfo', nextPage?: number | null }, data: Array<{ __typename?: 'Expert', slug: string, id: number, primaryLocation?: string | null, countryIsoCode?: string | null, city?: string | null, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } | null> } } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, slug: string, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', cmsPage: { __typename?: 'CMSPage', slug: string } } | null, expert?: { __typename?: 'Expert', slug: string } | null, brands: Array<{ __typename?: 'Brand', id: string }>, maxPrice?: { __typename?: 'Price', total: number } | null, categoriesOne: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null }> }> }>, categoriesTwo: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, categoriesThree: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }>, items: { __typename?: 'CollectionItems', data: Array<{ __typename?: 'CollectionItem', id: string, product?: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, title: string, sku: string, slug: string, quantity: number, status: ProductVariantStatus, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, carouselImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, leadImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, product: { __typename?: 'Product', id: number, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null } }>, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> }, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }> } | null, productVariant?: { __typename?: 'ProductVariant', id: number, title: string, slug: string, quantity: number, availability: ProductAvailability, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }>, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, breakoutVariant?: { __typename?: 'ProductBreakoutVariant', id: number, sku: string, slug: string, title: string, quantity: number, availability: ProductAvailability, minPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, maxPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradeMinPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, tradeMaxPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, product: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> } }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | null }>, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, slug: string, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', id: number, title: string, testimonials?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, video: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSVideoWidget', id: number, title: string, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null } | null }> | null } } };

export type CmsConsultationPagePreviewQueryVariables = Exact<{
  slug: Scalars['String'];
  widgetsDefaultInputs?: InputMaybe<WidgetsDefaultInputs>;
}>;


export type CmsConsultationPagePreviewQuery = { __typename?: 'Query', cmsConsultationPagePreview: { __typename?: 'CMSConsultationPage', cmsPage: { __typename?: 'CMSPage', title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, href: string, widgets?: Array<{ __typename?: 'CMSWidget', id: number, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, cmsAlphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType, data: Array<{ __typename?: 'AlphabeticalIndexWidgetData', title: string, url: string }> } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, previewText?: string | null, tag?: string | null, previewAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSBannerWidget', id: number, title: string, buttonText: string, buttonLink: string } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, headshotImageUrl?: string | null, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } }, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } } | null, expert?: { __typename?: 'Expert', id: number, slug: string } | null, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean, expertItems: { __typename?: 'PublicExperts', paginationInfo: { __typename?: 'PaginationInfo', nextPage?: number | null }, data: Array<{ __typename?: 'Expert', slug: string, id: number, primaryLocation?: string | null, countryIsoCode?: string | null, city?: string | null, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } | null> } } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, slug: string, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', cmsPage: { __typename?: 'CMSPage', slug: string } } | null, expert?: { __typename?: 'Expert', slug: string } | null, brands: Array<{ __typename?: 'Brand', id: string }>, maxPrice?: { __typename?: 'Price', total: number } | null, categoriesOne: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null }> }> }>, categoriesTwo: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, categoriesThree: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }>, items: { __typename?: 'CollectionItems', data: Array<{ __typename?: 'CollectionItem', id: string, product?: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, title: string, sku: string, slug: string, quantity: number, status: ProductVariantStatus, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, carouselImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, leadImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, product: { __typename?: 'Product', id: number, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null } }>, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> }, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }> } | null, productVariant?: { __typename?: 'ProductVariant', id: number, title: string, slug: string, quantity: number, availability: ProductAvailability, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }>, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, breakoutVariant?: { __typename?: 'ProductBreakoutVariant', id: number, sku: string, slug: string, title: string, quantity: number, availability: ProductAvailability, minPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, maxPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradeMinPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, tradeMaxPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, product: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> } }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | null }>, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, slug: string, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', id: number, title: string, testimonials?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, video: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSVideoWidget', id: number, title: string, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null } | null }> | null } } };

export type CmsConsultationPageSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type CmsConsultationPageSlugsQuery = { __typename?: 'Query', cmsConsultationPageSlugs: Array<string> };

export type CmsExpertPageBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  widgetsDefaultInputs?: InputMaybe<WidgetsDefaultInputs>;
}>;


export type CmsExpertPageBySlugQuery = { __typename?: 'Query', cmsExpertPageBySlug: { __typename?: 'CMSExpertPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, href: string, widgets?: Array<{ __typename?: 'CMSWidget', id: number, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, cmsAlphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType, data: Array<{ __typename?: 'AlphabeticalIndexWidgetData', title: string, url: string }> } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, previewText?: string | null, tag?: string | null, previewAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSBannerWidget', id: number, title: string, buttonText: string, buttonLink: string } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, headshotImageUrl?: string | null, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } }, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } } | null, expert?: { __typename?: 'Expert', id: number, slug: string } | null, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean, expertItems: { __typename?: 'PublicExperts', paginationInfo: { __typename?: 'PaginationInfo', nextPage?: number | null }, data: Array<{ __typename?: 'Expert', slug: string, id: number, primaryLocation?: string | null, countryIsoCode?: string | null, city?: string | null, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } | null> } } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, slug: string, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', cmsPage: { __typename?: 'CMSPage', slug: string } } | null, expert?: { __typename?: 'Expert', slug: string } | null, brands: Array<{ __typename?: 'Brand', id: string }>, maxPrice?: { __typename?: 'Price', total: number } | null, categoriesOne: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null }> }> }>, categoriesTwo: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, categoriesThree: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }>, items: { __typename?: 'CollectionItems', data: Array<{ __typename?: 'CollectionItem', id: string, product?: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, title: string, sku: string, slug: string, quantity: number, status: ProductVariantStatus, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, carouselImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, leadImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, product: { __typename?: 'Product', id: number, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null } }>, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> }, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }> } | null, productVariant?: { __typename?: 'ProductVariant', id: number, title: string, slug: string, quantity: number, availability: ProductAvailability, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }>, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, breakoutVariant?: { __typename?: 'ProductBreakoutVariant', id: number, sku: string, slug: string, title: string, quantity: number, availability: ProductAvailability, minPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, maxPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradeMinPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, tradeMaxPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, product: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> } }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | null }>, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, slug: string, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', id: number, title: string, testimonials?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, video: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSVideoWidget', id: number, title: string, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null } | null }> | null } } };

export type GetExpertSessionsByExpertIdQueryVariables = Exact<{
  input: Scalars['Int'];
}>;


export type GetExpertSessionsByExpertIdQuery = { __typename?: 'Query', expert: { __typename?: 'Expert', sessions: Array<{ __typename?: 'PublicExpertSession', lengthInMinutes: number, price: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode } }> } };

export type PublishCmsPageMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PublishCmsPageMutation = { __typename?: 'Mutation', publishCmsPage: { __typename?: 'CMSPage', id: number, isPublished: boolean } };

export type UnpublishCmsPageMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UnpublishCmsPageMutation = { __typename?: 'Mutation', unpublishCmsPage: { __typename?: 'CMSPage', id: number, isPublished: boolean } };

export type AdminCmsPagesQueryVariables = Exact<{
  input: AdminCmsPagesInput;
}>;


export type AdminCmsPagesQuery = { __typename?: 'Query', adminCmsPages: { __typename?: 'CMSPages', edges: Array<{ __typename?: 'CMSPageEdge', node?: { __typename?: 'CMSPage', id: number, title: string, slug: string } | null }>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type AdminCmsPagesByLimitQueryVariables = Exact<{
  input: AdminCmsPagesByLimitInput;
}>;


export type AdminCmsPagesByLimitQuery = { __typename?: 'Query', adminCmsPagesByLimit: { __typename?: 'CMSPagesByLimit', data: Array<{ __typename?: 'CMSPage', id: number, title: string, isStatic: boolean, isPublished: boolean, href: string, slug: string, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string }, content?: { __typename?: 'CMSArticlePage', id: number, author: string } | { __typename?: 'CMSBrandPage', id: number } | { __typename?: 'CMSCategoryPage', id: number } | { __typename?: 'CMSConsultationPage', id: number } | { __typename?: 'CMSShowroomPage', id: number } | null }>, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, firstPage: number, lastPage: number, currentPage: number, nextPage?: number | null, previousPage?: number | null } } };

export type CmsShowroomPageSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type CmsShowroomPageSlugsQuery = { __typename?: 'Query', cmsShowroomPageSlugs: Array<string> };

export type ValidateAvailableCmsShowroomPageSlugQueryVariables = Exact<{
  input: ValidateAvailableCmsPageSlugInput;
}>;


export type ValidateAvailableCmsShowroomPageSlugQuery = { __typename?: 'Query', validateAvailableCmsShowroomPageSlug?: boolean | null };

export type CmsShowroomNavigationPageSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type CmsShowroomNavigationPageSlugsQuery = { __typename?: 'Query', cmsShowroomNavigationPageSlugs: Array<string> };

export type CmsShowroomPagePickerQueryVariables = Exact<{
  input: CmsShowroomPagesInput;
}>;


export type CmsShowroomPagePickerQuery = { __typename?: 'Query', cmsShowroomPages: { __typename?: 'CMSShowroomPages', data?: Array<{ __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }> | null } };

export type AdminCmsShowroomPageFieldsFragment = { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } };

export type CmsShowroomPageQueryVariables = Exact<{
  input: CmsShowroomPageInput;
}>;


export type CmsShowroomPageQuery = { __typename?: 'Query', cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } } };

export type CreateCmsShowroomPageMutationVariables = Exact<{
  input: CreateCmsShowroomPageInput;
}>;


export type CreateCmsShowroomPageMutation = { __typename?: 'Mutation', createCmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } } };

export type DeleteCmsShowroomPageMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCmsShowroomPageMutation = { __typename?: 'Mutation', deleteCmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number } };

export type UpdateCmsShowroomPageMutationVariables = Exact<{
  input: UpdateCmsShowroomPageInput;
}>;


export type UpdateCmsShowroomPageMutation = { __typename?: 'Mutation', updateCmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, metaDescription?: string | null, metaTitle?: string | null, keywords?: Array<string> | null, isPublished: boolean, isStatic: boolean, widgets?: Array<{ __typename?: 'CMSWidget', id: number, positionIndexWeight?: number | null, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, alphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null } } | { __typename?: 'CMSBannerWidget', id: number, title: string, href?: string | null, buttonText: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } }, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, previewImageAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } }> | null } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, firstPublishedAtFilter?: number | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, title: string, slug: string } } | null, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }> } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, href?: string | null, buttonText: string, description: string, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null, businessName: string } | null, attachment: { __typename?: 'Attachment', url: string, id: number, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', title: string, id: number, cmsTestimonialsWidgetItems?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, video: { __typename?: 'Attachment', id: number, url: string }, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSVideoWidget', id: number, title: string, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null }> | null } } };

export type CmsArticlesArticleFieldsFragment = { __typename?: 'CMSArticlePage', id: number, previewText?: string | null, tag?: string | null, previewAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } };

export type CmsExpertsListingWidgetFieldsFragment = { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean, expertItems: { __typename?: 'PublicExperts', paginationInfo: { __typename?: 'PaginationInfo', nextPage?: number | null }, data: Array<{ __typename?: 'Expert', slug: string, id: number, primaryLocation?: string | null, countryIsoCode?: string | null, city?: string | null, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } | null> } };

export type CmsListingWidgetFieldsFragment = { __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null };

export type CmsCardNavigationWidgetClientFieldsFragment = { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, href: string } }> };

export type CmsWidgetFieldsFragment = { __typename?: 'CMSWidget', id: number, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, cmsAlphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType, data: Array<{ __typename?: 'AlphabeticalIndexWidgetData', title: string, url: string }> } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, previewText?: string | null, tag?: string | null, previewAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSBannerWidget', id: number, title: string, buttonText: string, buttonLink: string } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, headshotImageUrl?: string | null, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } }, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } } | null, expert?: { __typename?: 'Expert', id: number, slug: string } | null, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean, expertItems: { __typename?: 'PublicExperts', paginationInfo: { __typename?: 'PaginationInfo', nextPage?: number | null }, data: Array<{ __typename?: 'Expert', slug: string, id: number, primaryLocation?: string | null, countryIsoCode?: string | null, city?: string | null, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } | null> } } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, slug: string, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', cmsPage: { __typename?: 'CMSPage', slug: string } } | null, expert?: { __typename?: 'Expert', slug: string } | null, brands: Array<{ __typename?: 'Brand', id: string }>, maxPrice?: { __typename?: 'Price', total: number } | null, categoriesOne: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null }> }> }>, categoriesTwo: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, categoriesThree: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }>, items: { __typename?: 'CollectionItems', data: Array<{ __typename?: 'CollectionItem', id: string, product?: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, title: string, sku: string, slug: string, quantity: number, status: ProductVariantStatus, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, carouselImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, leadImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, product: { __typename?: 'Product', id: number, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null } }>, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> }, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }> } | null, productVariant?: { __typename?: 'ProductVariant', id: number, title: string, slug: string, quantity: number, availability: ProductAvailability, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }>, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, breakoutVariant?: { __typename?: 'ProductBreakoutVariant', id: number, sku: string, slug: string, title: string, quantity: number, availability: ProductAvailability, minPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, maxPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradeMinPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, tradeMaxPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, product: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> } }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | null }>, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, slug: string, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', id: number, title: string, testimonials?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, video: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSVideoWidget', id: number, title: string, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null } | null };

export type CmsWidgetByIdQueryVariables = Exact<{
  input: WidgetsByIdInput;
}>;


export type CmsWidgetByIdQuery = { __typename?: 'Query', cmsWidgetById: { __typename?: 'CMSWidget', id: number, content?: { __typename?: 'CMSAlphabeticalIndexWidget', id: number, cmsAlphabeticalIndexWidgetTitle?: string | null, cmsAlphabeticalIndexWidgetType: CmsAlphabeticalIndexWidgetType, data: Array<{ __typename?: 'AlphabeticalIndexWidgetData', title: string, url: string }> } | { __typename?: 'CMSAltExpertsListingWidget', id: number } | { __typename?: 'CMSAltValuePropositionWidget', id: number } | { __typename?: 'CMSArticleHeadingWidget', id: number, title: string, author: string, caption?: string | null } | { __typename?: 'CMSArticlesWidget', id: number, title: string, subtitle?: string | null, cmsArticlesWidgetItems: { __typename?: 'CMSArticlesWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSArticlesWidgetItem', id: number, article: { __typename?: 'CMSArticlePage', id: number, previewText?: string | null, tag?: string | null, previewAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string } } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSBannerWidget', id: number, title: string, buttonText: string, buttonLink: string } | { __typename?: 'CMSCardNavigationWidget', id: number, subtitle?: string | null, cardNavigationWidgetTitle?: string | null, cardNavigationWidgetPlacement: CardNavigationPlacement, cardNavigationWidgetButtonText?: string | null, cardNavigationWidgetButtonLink?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, href: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget', id: number, title: string, subtitle?: string | null, categoryHeaderWidgetType: CategoryHeaderType, expert?: { __typename?: 'Expert', id: number, headshotImageUrl?: string | null, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, cmsCategoryHeaderWidgetItems: Array<{ __typename?: 'CMSCategoryHeaderWidgetItem', id: number, positionIndexWeight?: number | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSCollectionHeaderWidget', id: number, title: string, subtitle?: string | null, collectionHeaderType: CollectionHeaderType, headerImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, mobileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | { __typename?: 'CMSCollectionsCarouselWidget', id: number, title: string, subtitle?: string | null, hasExploreAllButton: boolean, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, id: number } } | null, cmsCollectionsCarouselWidgetItems: Array<{ __typename?: 'CMSCollectionsCarouselWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } }, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSConciergeWidget', id: number } | { __typename?: 'CMSDoubleImageWidget', id: number, firstCaption?: string | null, secondCaption?: string | null, firstAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSExpertCollectionsWidget', id: number, cmsExpertCollectionsWidgetItems: Array<{ __typename?: 'CMSExpertCollectionsWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', id: number, cmsPage: { __typename?: 'CMSPage', slug: string, title: string } } | null, expert?: { __typename?: 'Expert', id: number, slug: string } | null, previewImageAttachment: { __typename?: 'Attachment', url: string, alt?: string | null }, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }> } | { __typename?: 'CMSExpertsListingWidget', id: number, isFilterEnabled: boolean, expertItems: { __typename?: 'PublicExperts', paginationInfo: { __typename?: 'PaginationInfo', nextPage?: number | null }, data: Array<{ __typename?: 'Expert', slug: string, id: number, primaryLocation?: string | null, countryIsoCode?: string | null, city?: string | null, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } | null> } } | { __typename?: 'CMSExpertsWidget', id: number, title: string, isButtonHidden: boolean, mobilePageSize: number, desktopPageSize: number, cmsExpertsWidgetItems: { __typename?: 'CMSExpertsWidgetItems', widgetId: number, data?: Array<{ __typename?: 'CMSExpertsWidgetItem', id: number, expert: { __typename?: 'Expert', id: number, slug: string, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null, categories: Array<{ __typename?: 'ExpertCategory', category: { __typename?: 'Category', id: number, title: string } }> } }> | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSFeaturedInWidget', id: number } | { __typename?: 'CMSGalleryWidget', title: string, id: number, cmsGalleryWidgetItems?: Array<{ __typename?: 'CMSGalleryWidgetItem', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, expert?: { __typename?: 'Expert', slug: string, id: number, profileName?: string | null } | null }> | null } | { __typename?: 'CMSGiftCardWidget', id: number, title: string, description: string } | { __typename?: 'CMSHeroCarouselWidget', id: number, isAutoRotationEnabled: boolean, cmsHeroCarouselWidgetItems: Array<{ __typename?: 'CMSHeroCarouselWidgetItem', id: number, preTitle?: string | null, headline?: string | null, subheadline?: string | null, hasButton: boolean, buttonText?: string | null, buttonLink?: string | null, positionIndexWeight: number, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } }> } | { __typename?: 'CMSHeroMainWidget', id: number, headline: string, subheadline?: string | null, mainButtonText: string, mainButtonLink: string, hasSecondaryButton: boolean, secondaryButtonText?: string | null, secondaryButtonLink?: string | null, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSHeroWidget', id: number, hasLandingPageButtons: boolean, title: string, attachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename?: 'CMSInfoCardsWidget', id: number } | { __typename?: 'CMSIntroductionWidget', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSMultiCollectionWidget', id: number, isShopAllProductsButtonEnabled: boolean, headline: string, isSortEnabled: boolean, useBreakoutVariants: boolean, defaultSortField?: ProductSorterField | null, defaultSortDirection?: SortDirection | null, multiCollectionWidgetType: MultiCollectionType, cmsShowroomPage?: { __typename?: 'CMSShowroomPage', cmsPage: { __typename?: 'CMSPage', slug: string } } | null, expert?: { __typename?: 'Expert', slug: string } | null, brands: Array<{ __typename?: 'Brand', id: string }>, maxPrice?: { __typename?: 'Price', total: number } | null, categoriesOne: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null }> }> }>, categoriesTwo: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, categoriesThree: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, cmsListingWidgets: Array<{ __typename?: 'CMSListingWidget', id: number, type: CmsListingWidgetType, name: string, content?: { __typename?: 'CMSConsultationListingWidget', id: number, headline: string, buttonCopy: string, isButtonIconShown: boolean, isConsultationDetailShown: boolean, duration?: string | null, price?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null }, expert: { __typename?: 'Expert', id: number, profileName?: string | null, headshotImageUrl?: string | null, slug: string, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } } | { __typename?: 'CMSHelpListingWidget', id: number, headline: string, body: string } | { __typename?: 'CMSInfoListingWidget', id: number, headline: string, body: string, hasButton: boolean, buttonText?: string | null, hasCustomLink: boolean, customButtonUrl?: string | null, previewAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null, name?: string | null } } | { __typename?: 'CMSQuotationListingWidget', id: number, body: string, author: string } | null }>, cmsMultiCollectionWidgetItems: Array<{ __typename?: 'CMSMultiCollectionWidgetItem', id: number, caption?: string | null, positionIndexWeight?: number | null, collection: { __typename?: 'Collection', id: number, title: string } }>, items: { __typename?: 'CollectionItems', data: Array<{ __typename?: 'CollectionItem', id: string, product?: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, title: string, sku: string, slug: string, quantity: number, status: ProductVariantStatus, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, carouselImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, leadImage?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, product: { __typename?: 'Product', id: number, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null } }>, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> }, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }> } | null, productVariant?: { __typename?: 'ProductVariant', id: number, title: string, slug: string, quantity: number, availability: ProductAvailability, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }>, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null, breakoutVariant?: { __typename?: 'ProductBreakoutVariant', id: number, sku: string, slug: string, title: string, quantity: number, availability: ProductAvailability, minPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, maxPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradeMinPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, tradeMaxPrice?: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number } | null, price: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, product: { __typename?: 'Product', id: number, sku: string, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, expert?: { __typename?: 'Expert', id: number, slug: string } | null } | null> } }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | null }>, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, nextPage?: number | null } } } | { __typename?: 'CMSProductsWidget', id: number, cmsProductsWidgetItems?: Array<{ __typename?: 'CMSProductsWidgetItem', id: number, title: string, pretitle?: string | null, posttitle?: string | null, description?: string | null, href?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } }> | null } | { __typename?: 'CMSQAWidget', id: number, cmsQAWidgetItems?: Array<{ __typename?: 'CMSQAWidgetItem', id: number, slug: string, question: string, answer: string }> | null } | { __typename?: 'CMSRichTextWidget', id: number, richText: string } | { __typename?: 'CMSSectionWidget', id: number, widgetItems: Array<{ __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } }> } | { __typename?: 'CMSSingleImageWidget', id: number, caption?: string | null, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSSpotlightWidget', id: number, title: string, subTitle: string, description: string, buttonText: string, buttonLink: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | { __typename?: 'CMSTestimonialsWidget', id: number, title: string, testimonials?: Array<{ __typename?: 'CMSTestimonialsWidgetItem', id: number, feedback: string, clientInfo: string }> | null } | { __typename?: 'CMSValuePropositionWidget', id: number } | { __typename?: 'CMSVideoSectionWidget', id: number, title: string, subtitle?: string | null, hasCtaButton?: boolean | null, ctaCopy?: string | null, ctaCopyUrl?: string | null, thumbnail: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, video: { __typename?: 'Attachment', id: number, url: string } } | { __typename?: 'CMSVideoWidget', id: number, title: string, thumbnailAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, videoAttachment?: { __typename?: 'Attachment', id: number, url: string } | null } | null } };

export type CmsWidgetItemFieldsFragment = { __typename?: 'CMSWidgetItem', id: number, positionIndexWeight: number, content: { __typename: 'CMSWidgetItemButton', id: number, text: string, link: string } | { __typename: 'CMSWidgetItemHeadline', id: number, headline: string, subheadline?: string | null } | { __typename: 'CMSWidgetItemThreeColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, thirdTitle: string, thirdLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, thirdAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } | { __typename: 'CMSWidgetItemTwoColumnCard', id: number, firstTitle: string, firstLink?: string | null, secondTitle: string, secondLink?: string | null, firstAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null }, secondAttachment: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } } };

export type AdminCollectionQueryVariables = Exact<{
  id: Scalars['Int'];
  input?: InputMaybe<ProductsInput>;
}>;


export type AdminCollectionQuery = { __typename?: 'Query', collection: { __typename?: 'Collection', id: number, title: string, isGenerated: boolean, status: CollectionStatus, subtype: CollectionSubtype, maxPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, categoriesOne: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null }> }> }>, categoriesTwo: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, categoriesThree: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, brands?: Array<{ __typename?: 'Brand', id: string }> | null, expert?: { __typename?: 'Expert', id: number, slug: string } | null, items: { __typename?: 'CollectionItems', paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, firstPage: number, lastPage: number, currentPage: number, nextPage?: number | null, previousPage?: number | null }, data: Array<{ __typename?: 'CollectionItem', id: string, minPublishedPrice?: number | null, maxPublishedPrice?: number | null, product?: { __typename?: 'Product', id: number, slug: string, sku: string, title: string, status: ProductStatus, positionIndexWeight?: number | null, availability: ProductAvailability, variants: Array<{ __typename?: 'ProductVariant', id: number, status: ProductVariantStatus, isPublishedFirstTime: boolean }>, brand?: { __typename?: 'Brand', id: string } | null, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string }, images: Array<{ __typename?: 'Attachment', url: string }> } | null, productVariant?: { __typename?: 'ProductVariant', id: number, sku: string, slug: string, title: string, status: ProductVariantStatus, isPublishedFirstTime: boolean, availability: ProductAvailability, quantity: number, tradePrice?: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, base: number, vatRate: number } | null, price: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, base: number, vatRate: number }, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string }, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', id: number, name: string } }> } | null }> } } };

export type ExpertShowroomCollectionCollectionItemQueryVariables = Exact<{
  productVariantId: Scalars['Int'];
}>;


export type ExpertShowroomCollectionCollectionItemQuery = { __typename?: 'Query', expertShowroomCollectionCollectionItem?: { __typename?: 'CollectionItem', id: string } | null };

export type AddCollectionProductMutationVariables = Exact<{
  input: AddCollectionProductInput;
}>;


export type AddCollectionProductMutation = { __typename?: 'Mutation', addCollectionProduct: { __typename?: 'Collection', id: number } };

export type EditCollectionProductMutationVariables = Exact<{
  input: EditCollectionProductInput;
}>;


export type EditCollectionProductMutation = { __typename?: 'Mutation', editCollectionProduct: { __typename?: 'Collection', id: number } };

export type RemoveCollectionProductMutationVariables = Exact<{
  input: RemoveCollectionProductInput;
}>;


export type RemoveCollectionProductMutation = { __typename?: 'Mutation', removeCollectionProduct: { __typename?: 'Collection', id: number } };

export type UpdateCollectionMutationVariables = Exact<{
  input: UpdateCollectionInput;
}>;


export type UpdateCollectionMutation = { __typename?: 'Mutation', updateCollection: { __typename?: 'Collection', id: number } };

export type RequestCollectionReviewMutationVariables = Exact<{
  input: RequestCollectionReviewInput;
}>;


export type RequestCollectionReviewMutation = { __typename?: 'Mutation', requestCollectionReview: { __typename?: 'Collection', id: number } };

export type CancelCollectionReviewMutationVariables = Exact<{
  input: CancelCollectionReviewInput;
}>;


export type CancelCollectionReviewMutation = { __typename?: 'Mutation', cancelCollectionReview: { __typename?: 'Collection', id: number } };

export type SendContactUsHelloEmailMutationVariables = Exact<{
  input: SendContactUsEmailInput;
}>;


export type SendContactUsHelloEmailMutation = { __typename?: 'Mutation', sendContactUsHelloEmail?: boolean | null };

export type SendContactUsShowroomEmailMutationVariables = Exact<{
  input: SendContactUsEmailInput;
}>;


export type SendContactUsShowroomEmailMutation = { __typename?: 'Mutation', sendContactUsShowroomEmail?: boolean | null };

export type CountriesQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', title: string, isoCode: string } | null> };

export type ApplyCouponMutationVariables = Exact<{
  couponCode: Scalars['String'];
}>;


export type ApplyCouponMutation = { __typename?: 'Mutation', applyCoupon: boolean };

export type RemoveCouponMutationVariables = Exact<{
  couponCode: Scalars['String'];
}>;


export type RemoveCouponMutation = { __typename?: 'Mutation', removeCoupon: boolean };

export type CreateExpertApplicationMutationVariables = Exact<{
  input: CreateExpertApplicationInput;
}>;


export type CreateExpertApplicationMutation = { __typename?: 'Mutation', createExpertApplication: { __typename?: 'ExpertApplication', id: number } };

export type ExpertMeOrdersQueryVariables = Exact<{
  id: Scalars['Int'];
  paginationInput: CursorPaginationInput;
}>;


export type ExpertMeOrdersQuery = { __typename?: 'Query', expertMe: { __typename?: 'Expert', id: number, orders: { __typename?: 'Orders', edges: Array<{ __typename?: 'OrderEdge', node?: { __typename?: 'Order', id: number, status: OrderStatus, shippingFullName?: string | null, shippingCompany?: string | null, shippingAddressLine1?: string | null, shippingAddressLine2?: string | null, shippingCountryIsoCode?: string | null, shippingCountryState?: string | null, shippingCity?: string | null, shippingZipCode?: string | null, shippingPhone?: string | null, billingFullName?: string | null, billingCompany?: string | null, billingAddressLine1?: string | null, billingAddressLine2?: string | null, billingCountryIsoCode?: string | null, billingCountryState?: string | null, billingCity?: string | null, billingZipCode?: string | null, billingPhone?: string | null, buyerEmail: string, orderItems: Array<{ __typename?: 'OrderItem', id: number, quantity: number, status: OrderItemStatus, trackingUrl?: string | null, price: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, productVariant: { __typename?: 'ProductVariant', id: number, slug: string, title: string, length?: number | null, width?: number | null, height?: number | null, dimensionUnit?: string | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', depth?: number | null, leadTime?: string | null } | null, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, product: { __typename?: 'Product', title: string, slug: string, customContent?: { __typename?: 'ProductCustomContentFields', customDimensions?: string | null } | null, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }> } }, checkoutItem?: { __typename?: 'CheckoutItem', id: number, discounts?: Array<{ __typename?: 'Discount', id: number, type: DiscountType, unitDiscount: { __typename?: 'Price', base: number, vat: number, total: number, vatRate: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', currencyIsoCode: CurrencyIsoCode, total: number }> } }> | null } | null, orderShipment?: { __typename?: 'OrderShipment', id: number, price: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, shipmentData?: { __typename?: 'OrderShipmentArtaQuote', id: number, type: string, name: string, additionalServices: Array<string>, services: Array<{ __typename?: 'OrderShipmentArtaQuoteService', id: number, name: string, type: string, subtype: string, subSubtype: string }> } | { __typename?: 'OrderShipmentFreightClubQuote', id: number, type: string, name: string } | { __typename?: 'OrderShipmentVendorShipping', id: number, name: string, type: string } | null } | null }>, checkout?: { __typename?: 'Checkout', promoCode?: { __typename?: 'PromoCode', linkToTac?: string | null } | null, discountsSum: Array<{ __typename?: 'DiscountsSum', type?: DiscountType | null, discount?: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode } | null }>, tradeLicense?: { __typename?: 'TradeLicense', id: number } | null } | null, totalDiscount: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode }, totalPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, tax: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, paymentDetails?: { __typename?: 'PaymentDetails', isCreditsPayment?: boolean | null, isCouponPayment?: boolean | null, card?: { __typename?: 'ClientCreditCard', brand: string, last4: string } | null, paidAtUtc?: { __typename?: 'Datetime', isoFormat: string } | null } | null, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, price: { __typename?: 'OrderPriceType', currencyIsoCode?: string | null, originalPrice?: number | null, discount?: number | null, vat?: number | null, subtotal?: number | null, total?: number | null, itemsSum?: { __typename?: 'SumPrice', originalPrice?: number | null, retailPrice?: number | null, discount?: number | null } | null, shipmentsSum?: { __typename?: 'SumPrice', subtotal?: number | null } | null, payment?: { __typename?: 'OrderPayment', methods?: string | null, paidAtUtc?: string | null, credit?: number | null, coupon?: number | null, card?: number | null } | null } } | null }> }, purchasesWithoutCommission: { __typename?: 'ExpertPurchases', edges: Array<{ __typename?: 'PurchaseEdge', node?: { __typename?: 'Purchase', id: number, status: PurchaseStatus, buyerType: BuyerType, trackingUrl?: string | null, description: string, shippingFullName?: string | null, shippingCompany?: string | null, shippingAddressLine1?: string | null, shippingAddressLine2?: string | null, shippingCountryIsoCode?: string | null, shippingCountryState?: string | null, shippingCity?: string | null, shippingZipCode?: string | null, shippingPhone?: string | null, billingFullName?: string | null, billingCompany?: string | null, billingAddressLine1?: string | null, billingAddressLine2?: string | null, billingCountryIsoCode?: string | null, billingCountryState?: string | null, billingCity?: string | null, billingZipCode?: string | null, billingPhone?: string | null, client?: { __typename?: 'Client', contactEmail: string } | null, expertUser?: { __typename?: 'ExpertUser', email: string } | null, vendor?: { __typename?: 'Vendor', name: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | null, expert?: { __typename?: 'Expert', profileName?: string | null, slug: string } | null, totalPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, tax: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, shippingPrice: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, retailPrice: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, paymentDetails?: { __typename?: 'PaymentDetails', isCreditsPayment?: boolean | null, isCouponPayment?: boolean | null, card?: { __typename?: 'ClientCreditCard', brand: string, last4: string } | null, paidAtUtc?: { __typename?: 'Datetime', isoFormat: string } | null } | null, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, price?: { __typename?: 'PurchasePriceType', currencyIsoCode?: string | null, payment?: { __typename?: 'PurchasePayment', coupon?: number | null, card?: number | null } | null } | null, tradeLicense?: { __typename?: 'TradeLicense', id: number } | null } | null } | null> } } };

export type ExpertMeCollectionsQueryVariables = Exact<{
  id: Scalars['Int'];
  input: ProductsInput;
}>;


export type ExpertMeCollectionsQuery = { __typename?: 'Query', expertMe: { __typename?: 'Expert', id: number, slug: string, expertShowroomCollection?: { __typename?: 'Collection', id: number, status: CollectionStatus, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string }, maxPrice: { __typename?: 'Price', total: number, base: number, currencyIsoCode: CurrencyIsoCode, vatRate: number }, categoriesOne: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, children: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null }> }> }>, categoriesTwo: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, categoriesThree: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, brands?: Array<{ __typename?: 'Brand', id: string }> | null, items: { __typename?: 'CollectionItems', paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, firstPage: number, lastPage: number, currentPage: number, nextPage?: number | null, previousPage?: number | null }, data: Array<{ __typename?: 'CollectionItem', id: string, minPublishedPrice?: number | null, maxPublishedPrice?: number | null, product?: { __typename?: 'Product', id: number, sku: string, slug: string, title: string, status: ProductStatus, positionIndexWeight?: number | null, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, status: ProductVariantStatus, isPublishedFirstTime: boolean }>, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string }, images: Array<{ __typename?: 'Attachment', url: string }> } | null, productVariant?: { __typename?: 'ProductVariant', id: number, slug: string, sku: string, title: string, status: ProductVariantStatus, isPublishedFirstTime: boolean, availability: ProductAvailability, quantity: number, tradePrice?: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, base: number, vatRate: number } | null, price: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, base: number, vatRate: number }, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string }, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }>, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', id: number, name: string } }> } | null }> } } | null } };

export type ExpertDetailPageFieldFragment = { __typename?: 'Expert', id: number, slug: string, profileName?: string | null, countryIsoCode?: string | null, city?: string | null, primaryLocation?: string | null, shortDescription?: string | null, longDescription?: string | null, profileImageUrl?: string | null, instagramAccountUrl?: string | null, headshotImageAttachment?: { __typename?: 'Attachment', id: number, alt?: string | null, url: string } | null, images: Array<{ __typename?: 'Attachment', id: number, name?: string | null, url: string, alt?: string | null } | null> };

export type AvailableExpertDetailTabsByExpertSlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type AvailableExpertDetailTabsByExpertSlugQuery = { __typename?: 'Query', expertBySlug: { __typename?: 'Expert', id: number, availableExpertDetailTabs: Array<string> } };

export type PublicExpertDetailSharedHeaderQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PublicExpertDetailSharedHeaderQuery = { __typename?: 'Query', expert: { __typename?: 'Expert', availableExpertDetailTabs: Array<string>, id: number, slug: string, profileName?: string | null, countryIsoCode?: string | null, city?: string | null, primaryLocation?: string | null, shortDescription?: string | null, longDescription?: string | null, profileImageUrl?: string | null, instagramAccountUrl?: string | null, headshotImageAttachment?: { __typename?: 'Attachment', id: number, alt?: string | null, url: string } | null, images: Array<{ __typename?: 'Attachment', id: number, name?: string | null, url: string, alt?: string | null } | null> } };

export type PublicExpertDetailConsultationTabQueryVariables = Exact<{
  slug: Scalars['String'];
  reviewsInput?: InputMaybe<ReviewsInput>;
}>;


export type PublicExpertDetailConsultationTabQuery = { __typename?: 'Query', expertBySlug: { __typename?: 'Expert', id: number, slug: string, longDescription?: string | null, profileName?: string | null, jobTitle?: string | null, customCancelationPolicy?: string | null, hasRequiredServicesActivated: boolean, tags?: Array<{ __typename?: 'Tag', title: string, id: number }> | null, testimonials?: { __typename?: 'Testimonials', data?: Array<{ __typename?: 'ExpertTestimonial', id: number, feedback: string, clientName: string, consultationName?: string | null, expertUser: { __typename?: 'ExpertUser', firstName?: string | null, lastName?: string | null, title?: string | null } }> | null } | null, expertises?: Array<{ __typename?: 'ExpertExpertise', id: number, expertise: string }> | null, sessions: Array<{ __typename?: 'PublicExpertSession', isAvailable: boolean, id: number, title: string, description: string, isUpToThreeGuestsAllowed: boolean, sessionType: SessionTypeField, lengthInMinutes: number, sessionCapacity?: number | null, minimumSessionSize?: number | null, price: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', total: number, currencyIsoCode: CurrencyIsoCode }> }, expertUser: { __typename?: 'ExpertUser', email: string, title?: string | null, firstName?: string | null, lastName?: string | null, id: number } }>, reviewsAverageRating?: { __typename?: 'ReviewsAverageRating', avg?: number | null, totalCount: number } | null, reviews?: { __typename?: 'Reviews', data?: Array<{ __typename?: 'SessionReview', id: number, rating: number, feedback?: string | null, client?: { __typename?: 'Client', id: number, firstName: string, lastName: string } | null }> | null, paginationInfo: { __typename?: 'PaginationInfo', nextPage?: number | null, totalCount: number } } | null } };

export type UpdateExpertBusinessNameMutationVariables = Exact<{
  input: UpdateExpertBusinessNameInput;
}>;


export type UpdateExpertBusinessNameMutation = { __typename?: 'Mutation', updateExpertBusinessName: { __typename?: 'Expert', id: number, businessName: string } };

export type AcceptContractAgreementMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptContractAgreementMutation = { __typename?: 'Mutation', acceptContractAgreement: boolean };

export type ExpertLegalBusinessNameQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ExpertLegalBusinessNameQuery = { __typename?: 'Query', expert: { __typename?: 'Expert', legalBusinessName?: string | null } };

export type CreateAccountLinkMutationVariables = Exact<{
  input: CreateAccountLinkInput;
}>;


export type CreateAccountLinkMutation = { __typename?: 'Mutation', createAccountLink: string };

export type ExpertQueryVariables = Exact<{
  id: Scalars['Int'];
  reviewsInput?: InputMaybe<ReviewsInput>;
}>;


export type ExpertQuery = { __typename?: 'Query', expert: { __typename?: 'Expert', id: number, customCancelationPolicy?: string | null, profileName?: string | null, slug: string, email: string, countryIsoCode?: string | null, countryState?: string | null, city?: string | null, facebookAccountUrl?: string | null, instagramAccountUrl?: string | null, youtubeAccountUrl?: string | null, twitterAccountUrl?: string | null, linkedInAccountUrl?: string | null, websiteUrl?: string | null, status: ExpertStatus, subscribersCount: number, isFeatured: boolean, isFundraiser: boolean, isStripeOnboarded: boolean, isStripeAccountActivated: boolean, isFindable: boolean, isPublicVisible: boolean, isConsultationRecapFormEnabled?: boolean | null, businessName: string, legalBusinessName?: string | null, currencyIsoCode: CurrencyIsoCode, platformFeePercentage: number, capabilities: Array<string>, regions: Array<{ __typename?: 'Region', id: number, title: string }>, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string }, mainUser: { __typename?: 'ExpertUser', id: number, timezone: string }, users?: Array<{ __typename?: 'ExpertUser', id: number, email: string, status: ExpertUserStatus, title?: string | null, firstName?: string | null, lastName?: string | null, timezone: string, profileImageUrl?: string | null, isMain?: boolean | null, zoomAccountId?: string | null, isZoomAccountActivated?: boolean | null, bookingsCount: number, activeSessionsCount: number, capabilities: Array<string>, nonBookedAvailabilityHours?: number | null, zoomAccountType?: ExpertUserZoomAccountType | null, zoomConnectedEmail?: string | null, totalEarned: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string }, notificationEmails: Array<{ __typename?: 'NotificationEmail', email: string }>, featureFlags?: Array<{ __typename?: 'FeatureFlag', id: number }> | null }> | null, testimonials?: { __typename?: 'Testimonials', data?: Array<{ __typename?: 'ExpertTestimonial', id: number, feedback: string, clientName: string, consultationName?: string | null, positionIndexWeight: number, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, expertUser: { __typename?: 'ExpertUser', id: number } }> | null } | null, tags?: Array<{ __typename?: 'Tag', id: number, title: string }> | null, reviews?: { __typename?: 'Reviews', data?: Array<{ __typename?: 'SessionReview', id: number, rating: number, feedback?: string | null, isVisible: boolean, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, client?: { __typename?: 'Client', firstName: string, lastName: string } | null }> | null } | null } };

export type PublicExpertAvailabilitiesQueryVariables = Exact<{
  input: PublicExpertAvailabilitiesInput;
}>;


export type PublicExpertAvailabilitiesQuery = { __typename?: 'Query', publicExpertAvailabilities: Array<{ __typename?: 'ExpertAvailability', id: number, startAtUtc: { __typename?: 'Datetime', isoFormat: string }, endAtUtc: { __typename?: 'Datetime', isoFormat: string } } | null> };

export type FirstPublicExpertAvailabilityQueryVariables = Exact<{
  expertSessionId: Scalars['Int'];
}>;


export type FirstPublicExpertAvailabilityQuery = { __typename?: 'Query', firstPublicExpertAvailability?: { __typename?: 'ExpertAvailability', id: number, startAtUtc: { __typename?: 'Datetime', isoFormat: string }, endAtUtc: { __typename?: 'Datetime', isoFormat: string } } | null };

export type AddExpertToFavoritesMutationVariables = Exact<{
  expertId: Scalars['Int'];
}>;


export type AddExpertToFavoritesMutation = { __typename?: 'Mutation', addExpertToFavorites: boolean };

export type RemoveExpertFromFavoritesMutationVariables = Exact<{
  expertId: Scalars['Int'];
}>;


export type RemoveExpertFromFavoritesMutation = { __typename?: 'Mutation', removeExpertFromFavorites: boolean };

export type FavoriteExpertsSlugsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FavoriteExpertsSlugsQuery = { __typename?: 'Query', clientMe: { __typename?: 'Client', id: number, favoriteExpertsSlugs?: Array<string> | null } };

export type ExpertMeWithStripeOnboardingTokenQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ExpertMeWithStripeOnboardingTokenQuery = { __typename?: 'Query', expertMe: { __typename?: 'Expert', id: number, stripeOnboardingToken?: string | null, stripeId?: string | null } };

export type ExpertPurchaseCommissionsQueryVariables = Exact<{
  id: Scalars['Int'];
  purchaseCommissionsInput: CursorPaginationInput;
}>;


export type ExpertPurchaseCommissionsQuery = { __typename?: 'Query', expertMe: { __typename?: 'Expert', id: number, purchaseCommissions: { __typename?: 'ExpertPurchases', edges: Array<{ __typename?: 'PurchaseEdge', cursor?: string | null, node?: { __typename?: 'Purchase', id: number, status: PurchaseStatus, description: string, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, vendorExpertCommissionAmount?: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode } | null, vendor?: { __typename?: 'Vendor', name: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | null, client?: { __typename?: 'Client', fullName: string } | null, totalPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | null } | null>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type ExpertPurchasesQueryVariables = Exact<{
  id: Scalars['Int'];
  purchasesInput: CursorPaginationInput;
}>;


export type ExpertPurchasesQuery = { __typename?: 'Query', expertMe: { __typename?: 'Expert', id: number, purchases: { __typename?: 'ExpertPurchases', edges: Array<{ __typename?: 'PurchaseEdge', cursor?: string | null, node?: { __typename?: 'Purchase', id: number, status: PurchaseStatus, description: string, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, vendorExpertCommissionAmount?: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode } | null, vendor?: { __typename?: 'Vendor', name: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | null, client?: { __typename?: 'Client', fullName: string } | null, totalPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null } | null } | null>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type AdminCreateExpertRegionMutationVariables = Exact<{
  input: CreateExpertRegionInput;
}>;


export type AdminCreateExpertRegionMutation = { __typename?: 'Mutation', adminCreateExpertRegion: { __typename?: 'Expert', id: number, regions: Array<{ __typename?: 'Region', id: number }> } };

export type AdminDeleteExpertRegionMutationVariables = Exact<{
  input: DeleteExpertRegionInput;
}>;


export type AdminDeleteExpertRegionMutation = { __typename?: 'Mutation', adminDeleteExpertRegion: { __typename?: 'Expert', id: number, regions: Array<{ __typename?: 'Region', id: number }> } };

export type AdminUpdateExpertRegionMutationVariables = Exact<{
  input: UpdateExpertRegionInput;
}>;


export type AdminUpdateExpertRegionMutation = { __typename?: 'Mutation', adminUpdateExpertRegion: { __typename?: 'Expert', id: number, regions: Array<{ __typename?: 'Region', positionIndexWeight?: number | null }> } };

export type ClientExpertSessionQueryVariables = Exact<{
  input: ExpertSessionClientInput;
}>;


export type ClientExpertSessionQuery = { __typename?: 'Query', clientExpertSession?: { __typename?: 'PublicExpertSession', id: number, lengthInMinutes: number, title: string, isUpToThreeGuestsAllowed: boolean, sessionType: SessionTypeField, description: string, couponCode?: string | null, expert: { __typename?: 'Expert', id: number, profileName?: string | null, customCancelationPolicy?: string | null, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null, id: number } | null }, expertUser: { __typename?: 'ExpertUser', id: number, firstName?: string | null, lastName?: string | null }, payPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', total: number, currencyIsoCode: CurrencyIsoCode }> }, creditPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', total: number, currencyIsoCode: CurrencyIsoCode }> }, couponPrice?: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', total: number, currencyIsoCode: CurrencyIsoCode }> } | null, promoCode?: { __typename?: 'PromoCode', code: string, amount: number, linkToTac?: string | null } | null, price: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', total: number, currencyIsoCode: CurrencyIsoCode }> } } | null };

export type ExpertShowroomCommissionsQueryVariables = Exact<{
  id: Scalars['Int'];
  showroomCommissionsInput: CursorPaginationInput;
}>;


export type ExpertShowroomCommissionsQuery = { __typename?: 'Query', expertMe: { __typename?: 'Expert', id: number, showroomCommissions: { __typename?: 'ExpertShowroomCommissions', edges: Array<{ __typename?: 'ExpertShowroomCommissionEdge', cursor?: string | null, node?: { __typename?: 'ExpertShowroomCommission', id: number, rate: number, status: CommissionStatus, quantity: number, productData: any, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } | null } | null>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type UpdateExpertUserMutationVariables = Exact<{
  input: InviteExpertUserInput;
}>;


export type UpdateExpertUserMutation = { __typename?: 'Mutation', inviteExpertUser: { __typename?: 'ExpertUser', id: number } };

export type SuspendExpertUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SuspendExpertUserMutation = { __typename?: 'Mutation', suspendExpertUser: { __typename?: 'ExpertUser', id: number } };

export type ActivateExpertUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ActivateExpertUserMutation = { __typename?: 'Mutation', activateExpertUser: { __typename?: 'ExpertUser', id: number } };

export type ResendExpertUserInvitationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ResendExpertUserInvitationMutation = { __typename?: 'Mutation', resendExpertUserInvitation: { __typename?: 'ExpertUser', id: number } };

export type ExpertUsersQueryVariables = Exact<{
  input?: InputMaybe<ExpertUsersInput>;
}>;


export type ExpertUsersQuery = { __typename?: 'Query', expertUsers: { __typename?: 'ExpertUsers', paginationInfo: { __typename?: 'PaginationInfo', nextPage?: number | null, totalCount: number, currentPage: number }, data: Array<{ __typename?: 'ExpertUser', id: number, email: string, firstName?: string | null, lastName?: string | null, status: ExpertUserStatus, isMain?: boolean | null, activeSessionsCount: number, bookingsCount: number, totalEarned: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } | null> } };

export type ExpertMeTradeLicensesQueryVariables = Exact<{
  id: Scalars['Int'];
  input: ExpertTradeLicensesInput;
}>;


export type ExpertMeTradeLicensesQuery = { __typename?: 'Query', expertMe: { __typename?: 'Expert', tradeLicenses: { __typename?: 'TradeLicenses', edges: Array<{ __typename?: 'TradeLicenseEdge', node: { __typename?: 'TradeLicense', id: number, name: string, isSingleUse: boolean, licenseNumber: string, isActive: boolean, countryStates: Array<string>, expiresAtUtc?: { __typename?: 'Datetime', isoFormat: string } | null, attachments: Array<{ __typename?: 'Attachment', name?: string | null, id: number, url: string }> } }> } } };

export type ExpertUpcomingSessionsQueryVariables = Exact<{
  input?: InputMaybe<ExpertBookedSessionsInput>;
}>;


export type ExpertUpcomingSessionsQuery = { __typename?: 'Query', expertBookedSessions: { __typename?: 'ExpertBookedSessions', stats?: { __typename?: 'ExpertBookedSessionsStats', totalPrice: Array<{ __typename?: 'Price', currencyIsoCode: CurrencyIsoCode, base: number }> } | null, paginationInfo: { __typename?: 'PaginationInfo', totalCount: number }, data: Array<{ __typename?: 'Session', id: number, status: SessionStatus, sessionData: { __typename?: 'ExpertSession', title: string, lengthInMinutes: number, sessionCapacity?: number | null, minimumSessionSize?: number | null, sessionType: SessionTypeField, price: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode } }, sessionClients: Array<{ __typename?: 'SessionClient', client: { __typename?: 'Client', id: number, firstName: string, lastName: string, contactEmail: string } }>, startAtUtc: { __typename?: 'Datetime', isoFormat: string }, endAtUtc: { __typename?: 'Datetime', isoFormat: string } } | null> } };

export type DeleteExpertUserCardMutationVariables = Exact<{
  stripeId: Scalars['String'];
}>;


export type DeleteExpertUserCardMutation = { __typename?: 'Mutation', deleteExpertUserCard?: boolean | null };

export type SetupExpertUserPaymentMethodMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupExpertUserPaymentMethodMutation = { __typename?: 'Mutation', setupClientPaymentMethod: string };

export type ExpertUserMeQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ExpertUserMeQuery = { __typename?: 'Query', expertMe: { __typename?: 'Expert', id: number } };

export type ExpertUserQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ExpertUserQuery = { __typename?: 'Query', expertUser: { __typename?: 'ExpertUser', id: number, expert: { __typename?: 'Expert', id: number, capabilities: Array<string> } } };

export type ExpertVendorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpertVendorsQuery = { __typename?: 'Query', vendors: Array<{ __typename?: 'Vendor', brands: Array<string>, expertCommission: number, id: number, name: string, websiteUrl?: string | null, attachment: { __typename?: 'Attachment', url: string, id: number, name?: string | null, alt?: string | null } }> };

export type AllPublicExpertsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPublicExpertsQuery = { __typename?: 'Query', allPublicExperts: Array<{ __typename?: 'Expert', id: number, slug: string, availableExpertDetailTabs: Array<string> } | null> };

export type FeaturedExpertsQueryVariables = Exact<{
  expertsInput?: InputMaybe<ExpertsInput>;
}>;


export type FeaturedExpertsQuery = { __typename?: 'Query', publicExperts: { __typename?: 'PublicExperts', data: Array<{ __typename?: 'Expert', slug: string, id: number, primaryLocation?: string | null, countryIsoCode?: string | null, city?: string | null, profileName?: string | null, jobTitle?: string | null, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null> } };

export type SpecificUsersFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type SpecificUsersFeatureFlagsQuery = { __typename?: 'Query', specificUsersFeatureFlags: Array<{ __typename?: 'FeatureFlag', id: number, label: FeatureFlagLabel, description: string, status: FeatureFlagStatus } | null> };

export type AddExpertUserFeatureFlagMutationVariables = Exact<{
  input: UpdateExpertUserFeatureFlagInput;
}>;


export type AddExpertUserFeatureFlagMutation = { __typename?: 'Mutation', addExpertUserFeatureFlag: { __typename?: 'Expert', users?: Array<{ __typename?: 'ExpertUser', id: number, featureFlags?: Array<{ __typename?: 'FeatureFlag', id: number }> | null }> | null } };

export type RemoveExpertUserFeatureFlagMutationVariables = Exact<{
  input: UpdateExpertUserFeatureFlagInput;
}>;


export type RemoveExpertUserFeatureFlagMutation = { __typename?: 'Mutation', removeExpertUserFeatureFlag: { __typename?: 'Expert', users?: Array<{ __typename?: 'ExpertUser', id: number, featureFlags?: Array<{ __typename?: 'FeatureFlag', id: number }> | null }> | null } };

export type AdminNavigationGroupQueryVariables = Exact<{
  input: AdminNavigationGroupInput;
}>;


export type AdminNavigationGroupQuery = { __typename?: 'Query', adminNavigationGroup?: { __typename?: 'NavigationGroup', id: number, title: string, navigations: Array<{ __typename?: 'Navigation', id: number, title: string, status: NavigationStatus, navigationGroupId: number, rootItem: { __typename?: 'NavigationItem', id: number, parentId?: number | null, title: string, positionIndexWeight: number, subItemsWithImages: boolean, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string }, attachment?: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } | null }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } }> } | null };

export type PublishedNavigationGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type PublishedNavigationGroupsQuery = { __typename?: 'Query', publishedNavigationGroups: Array<{ __typename?: 'NavigationGroup', id: number, publishedNavigation?: { __typename?: 'Navigation', id: number, rootItem: { __typename?: 'NavigationItem', id: number, title: string, cmsPage: { __typename?: 'CMSPage', id: number, href: string }, children: Array<{ __typename?: 'NavigationItem', id: number, title: string, subItemsWithImages: boolean, positionIndexWeight: number, cmsPage: { __typename?: 'CMSPage', id: number, href: string }, children: Array<{ __typename?: 'NavigationItem', id: number, title: string, positionIndexWeight: number, cmsPage: { __typename?: 'CMSPage', id: number, href: string }, attachment?: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } | null }> }> } } | null }> };

export type CreateNavigationItemMutationVariables = Exact<{
  input: CreateNavigationItemInput;
}>;


export type CreateNavigationItemMutation = { __typename?: 'Mutation', createNavigationItem: { __typename?: 'NavigationItem', id: number, parentId?: number | null, title: string, positionIndexWeight: number, subItemsWithImages: boolean, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string }, attachment?: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } | null } };

export type UpdateNavigationItemMutationVariables = Exact<{
  input: UpdateNavigationItemInput;
}>;


export type UpdateNavigationItemMutation = { __typename?: 'Mutation', updateNavigationItem: { __typename?: 'NavigationItem', id: number, parentId?: number | null, title: string, positionIndexWeight: number, subItemsWithImages: boolean, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string }, attachment?: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } | null } };

export type DeleteNavigationItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteNavigationItemMutation = { __typename?: 'Mutation', deleteNavigationItem: boolean };

export type ReorderNavigationItemsMutationVariables = Exact<{
  input: ReorderNavigationItemsInput;
}>;


export type ReorderNavigationItemsMutation = { __typename?: 'Mutation', reorderNavigationItems: { __typename?: 'NavigationItem', id: number } };

export type NavigationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type NavigationQuery = { __typename?: 'Query', navigation: { __typename?: 'Navigation', id: number, title: string, status: NavigationStatus, children: Array<{ __typename?: 'NavigationItem', id: number, parentId?: number | null, title: string, positionIndexWeight: number, subItemsWithImages: boolean, cmsPage: { __typename?: 'CMSPage', id: number, slug: string, title: string }, attachment?: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } | null }> } };

export type CreateNavigationMutationVariables = Exact<{
  input: CreateNavigationInput;
}>;


export type CreateNavigationMutation = { __typename?: 'Mutation', createNavigation: { __typename?: 'Navigation', id: number, status: NavigationStatus, children: Array<{ __typename?: 'NavigationItem', id: number, title: string }>, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } };

export type UpdateNavigationMutationVariables = Exact<{
  input: UpdateNavigationInput;
}>;


export type UpdateNavigationMutation = { __typename?: 'Mutation', updateNavigation: { __typename?: 'Navigation', id: number, status: NavigationStatus, children: Array<{ __typename?: 'NavigationItem', id: number, title: string }>, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } };

export type DeleteNavigationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteNavigationMutation = { __typename?: 'Mutation', deleteNavigation: boolean };

export type DuplicateNavigationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DuplicateNavigationMutation = { __typename?: 'Mutation', duplicateNavigation: { __typename?: 'Navigation', id: number, status: NavigationStatus, children: Array<{ __typename?: 'NavigationItem', id: number, title: string }>, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } };

export type OverrideOrderItemShippingIdMutationVariables = Exact<{
  input: OverrideOrderItemShippingIdMutationInput;
}>;


export type OverrideOrderItemShippingIdMutation = { __typename?: 'Mutation', overrideOrderItemShippingId: { __typename?: 'OrderItem', id: number } };

export type CreateOrderNoteMutationVariables = Exact<{
  input: CreateOrderNoteInput;
  notesInput?: InputMaybe<OrderNotesInput>;
}>;


export type CreateOrderNoteMutation = { __typename?: 'Mutation', createOrderNote: { __typename?: 'OrderNote', id: number, message: string, admin: { __typename?: 'Admin', id: number, email: string, name: string }, order: { __typename?: 'Order', id: number, notes: { __typename?: 'OrderNotes', edges: Array<{ __typename?: 'OrderNoteEdge', node?: { __typename?: 'OrderNote', id: number, message: string, admin: { __typename?: 'Admin', id: number, email: string, name: string, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } | null }>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } };

export type OrderNotesQueryVariables = Exact<{
  orderId: Scalars['Int'];
  notesInput?: InputMaybe<OrderNotesInput>;
}>;


export type OrderNotesQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: number, notes: { __typename?: 'OrderNotes', edges: Array<{ __typename?: 'OrderNoteEdge', node?: { __typename?: 'OrderNote', id: number, message: string, admin: { __typename?: 'Admin', id: number, email: string, name: string, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } | null }>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type OrderQueryVariables = Exact<{
  id: Scalars['Int'];
  notesInput?: InputMaybe<OrderNotesInput>;
}>;


export type OrderQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: number, flxId?: number | null, status: OrderStatus, stripeTransactionLink?: string | null, billingFullName?: string | null, billingCompany?: string | null, billingAddressLine1?: string | null, billingAddressLine2?: string | null, billingCountryState?: string | null, billingCity?: string | null, billingZipCode?: string | null, billingPhone?: string | null, shippingFullName?: string | null, shippingCompany?: string | null, shippingAddressLine1?: string | null, shippingAddressLine2?: string | null, shippingCountryState?: string | null, shippingCity?: string | null, shippingZipCode?: string | null, shippingPhone?: string | null, totalPrice: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode }, tax: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode }, totalDiscount: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode }, shippingPrice?: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode } | null, client?: { __typename?: 'Client', id: number, firstName: string, lastName: string, contactEmail: string } | null, guestUser?: { __typename?: 'GuestUser', email: string } | null, expertUser?: { __typename?: 'ExpertUser', id: number, firstName?: string | null, lastName?: string | null, email: string, expert: { __typename?: 'Expert', id: number } } | null, orderItems: Array<{ __typename?: 'OrderItem', id: number, trackingUrl?: string | null, flxPointUrl?: string | null, flxPurchaseOrderId?: number | null, flxPurchaseOrderNumber?: string | null, productData?: any | null, bookedQuote?: string | null, quantity: number, status: OrderItemStatus, leadTime?: string | null, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, price: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode, total: number, vat: number, vatRate: number }, unitRetailPrice: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode, vat: number, vatRate: number }, metadata?: { __typename?: 'ItemMetadata', acknowledgedAt?: { __typename?: 'Datetime', isoFormat: string } | null, secondaryAcknowledgedAt?: { __typename?: 'Datetime', isoFormat: string } | null } | null, productVariant: { __typename?: 'ProductVariant', id: number, sku: string, title: string, source: { __typename?: 'Source', companyName?: string | null }, price: { __typename?: 'Price', base: number, total: number, currencyIsoCode: CurrencyIsoCode, vat: number, vatRate: number }, cost?: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode } | null, product: { __typename?: 'Product', id: number, title: string, flxId: number, slug: string } }, orderShipment?: { __typename?: 'OrderShipment', shipmentData?: { __typename?: 'OrderShipmentArtaQuote', artaShipmentId?: string | null, rawData?: { __typename?: 'OrderShipmentRawData', artaId?: string | null } | null } | { __typename?: 'OrderShipmentFreightClubQuote', freightClubShipmentId?: string | null } | { __typename?: 'OrderShipmentVendorShipping', id: number, name: string, type: string } | null, price: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode } } | null, checkoutItem?: { __typename?: 'CheckoutItem', id: number, discounts?: Array<{ __typename?: 'Discount', id: number, type: DiscountType, unitDiscount: { __typename?: 'Price', base: number, vat: number, total: number, vatRate: number, currencyIsoCode: CurrencyIsoCode } }> | null } | null }>, checkout?: { __typename?: 'Checkout', id: number, discountsSum: Array<{ __typename?: 'DiscountsSum', type?: DiscountType | null, discount?: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode } | null }> } | null, price: { __typename?: 'OrderPriceType', currencyIsoCode?: string | null, originalPrice?: number | null, discount?: number | null, vat?: number | null, subtotal?: number | null, total?: number | null, itemsSum?: { __typename?: 'SumPrice', originalPrice?: number | null, retailPrice?: number | null, discount?: number | null } | null, shipmentsSum?: { __typename?: 'SumPrice', subtotal?: number | null } | null, payment?: { __typename?: 'OrderPayment', methods?: string | null, paidAtUtc?: string | null, credit?: number | null, coupon?: number | null, card?: number | null } | null }, notes: { __typename?: 'OrderNotes', edges: Array<{ __typename?: 'OrderNoteEdge', node?: { __typename?: 'OrderNote', id: number, message: string, admin: { __typename?: 'Admin', id: number, email: string, name: string, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } | null }>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type OrdersQueryVariables = Exact<{
  input: OrdersInput;
}>;


export type OrdersQuery = { __typename?: 'Query', orders: { __typename?: 'Orders', edges: Array<{ __typename?: 'OrderEdge', node?: { __typename?: 'Order', id: number, flxId?: number | null, buyerEmail: string, status: OrderStatus, totalPrice: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, price: { __typename?: 'OrderPriceType', currencyIsoCode?: string | null, originalPrice?: number | null, discount?: number | null, vat?: number | null, subtotal?: number | null, total?: number | null, itemsSum?: { __typename?: 'SumPrice', originalPrice?: number | null, retailPrice?: number | null, discount?: number | null } | null, shipmentsSum?: { __typename?: 'SumPrice', subtotal?: number | null } | null, payment?: { __typename?: 'OrderPayment', methods?: string | null, paidAtUtc?: string | null, credit?: number | null, coupon?: number | null, card?: number | null } | null } } | null }>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type AdminOrdersQueryVariables = Exact<{
  input: AdminsOrdersInput;
}>;


export type AdminOrdersQuery = { __typename?: 'Query', adminOrders: { __typename?: 'Orders', edges: Array<{ __typename?: 'OrderEdge', node?: { __typename?: 'Order', id: number, flxId?: number | null, buyerEmail: string, status: OrderStatus, totalPrice: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, price: { __typename?: 'OrderPriceType', currencyIsoCode?: string | null, originalPrice?: number | null, discount?: number | null, vat?: number | null, subtotal?: number | null, total?: number | null, itemsSum?: { __typename?: 'SumPrice', originalPrice?: number | null, retailPrice?: number | null, discount?: number | null } | null, shipmentsSum?: { __typename?: 'SumPrice', subtotal?: number | null } | null, payment?: { __typename?: 'OrderPayment', methods?: string | null, paidAtUtc?: string | null, credit?: number | null, coupon?: number | null, card?: number | null } | null } } | null }>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type MarkOrderItemsAsDeliveredMutationVariables = Exact<{
  input: MarkOrderITemsAsDeliveredInput;
}>;


export type MarkOrderItemsAsDeliveredMutation = { __typename?: 'Mutation', markOrderItemsAsDelivered: { __typename?: 'Order', id: number, orderItems: Array<{ __typename?: 'OrderItem', id: number, status: OrderItemStatus }> } };

export type OrderNotesFragment = { __typename?: 'Order', notes: { __typename?: 'OrderNotes', edges: Array<{ __typename?: 'OrderNoteEdge', node?: { __typename?: 'OrderNote', id: number, message: string, admin: { __typename?: 'Admin', id: number, email: string, name: string, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } | null }>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type BuyerOrdersDashboardOrdersDataFragment = { __typename?: 'Orders', edges: Array<{ __typename?: 'OrderEdge', node?: { __typename?: 'Order', id: number, status: OrderStatus, shippingFullName?: string | null, shippingCompany?: string | null, shippingAddressLine1?: string | null, shippingAddressLine2?: string | null, shippingCountryIsoCode?: string | null, shippingCountryState?: string | null, shippingCity?: string | null, shippingZipCode?: string | null, shippingPhone?: string | null, billingFullName?: string | null, billingCompany?: string | null, billingAddressLine1?: string | null, billingAddressLine2?: string | null, billingCountryIsoCode?: string | null, billingCountryState?: string | null, billingCity?: string | null, billingZipCode?: string | null, billingPhone?: string | null, buyerEmail: string, orderItems: Array<{ __typename?: 'OrderItem', id: number, quantity: number, status: OrderItemStatus, trackingUrl?: string | null, price: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, productVariant: { __typename?: 'ProductVariant', id: number, slug: string, title: string, length?: number | null, width?: number | null, height?: number | null, dimensionUnit?: string | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', depth?: number | null, leadTime?: string | null } | null, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, product: { __typename?: 'Product', title: string, slug: string, customContent?: { __typename?: 'ProductCustomContentFields', customDimensions?: string | null } | null, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }> } }, checkoutItem?: { __typename?: 'CheckoutItem', id: number, discounts?: Array<{ __typename?: 'Discount', id: number, type: DiscountType, unitDiscount: { __typename?: 'Price', base: number, vat: number, total: number, vatRate: number, currencyIsoCode: CurrencyIsoCode, calculatedPrices: Array<{ __typename?: 'CalculatedPrice', currencyIsoCode: CurrencyIsoCode, total: number }> } }> | null } | null, orderShipment?: { __typename?: 'OrderShipment', id: number, price: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, shipmentData?: { __typename?: 'OrderShipmentArtaQuote', id: number, type: string, name: string, additionalServices: Array<string>, services: Array<{ __typename?: 'OrderShipmentArtaQuoteService', id: number, name: string, type: string, subtype: string, subSubtype: string }> } | { __typename?: 'OrderShipmentFreightClubQuote', id: number, type: string, name: string } | { __typename?: 'OrderShipmentVendorShipping', id: number, name: string, type: string } | null } | null }>, checkout?: { __typename?: 'Checkout', promoCode?: { __typename?: 'PromoCode', linkToTac?: string | null } | null, discountsSum: Array<{ __typename?: 'DiscountsSum', type?: DiscountType | null, discount?: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode } | null }>, tradeLicense?: { __typename?: 'TradeLicense', id: number } | null } | null, totalDiscount: { __typename?: 'Price', base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode }, totalPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, tax: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, paymentDetails?: { __typename?: 'PaymentDetails', isCreditsPayment?: boolean | null, isCouponPayment?: boolean | null, card?: { __typename?: 'ClientCreditCard', brand: string, last4: string } | null, paidAtUtc?: { __typename?: 'Datetime', isoFormat: string } | null } | null, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, price: { __typename?: 'OrderPriceType', currencyIsoCode?: string | null, originalPrice?: number | null, discount?: number | null, vat?: number | null, subtotal?: number | null, total?: number | null, itemsSum?: { __typename?: 'SumPrice', originalPrice?: number | null, retailPrice?: number | null, discount?: number | null } | null, shipmentsSum?: { __typename?: 'SumPrice', subtotal?: number | null } | null, payment?: { __typename?: 'OrderPayment', methods?: string | null, paidAtUtc?: string | null, credit?: number | null, coupon?: number | null, card?: number | null } | null } } | null }> };

export type EmailActivityQueryVariables = Exact<{
  orderId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type EmailActivityQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: number, emailActivity: Array<{ __typename?: 'EmailEvent', id: number, type: string, sendgridMessageId: string, sendgridEventId: string, event: string, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string } }> } };

export type PrivateFormExpertUsersQueryVariables = Exact<{
  input: ExpertUsersInput;
}>;


export type PrivateFormExpertUsersQuery = { __typename?: 'Query', expertUsers: { __typename?: 'ExpertUsers', data: Array<{ __typename?: 'ExpertUser', id: number, firstName?: string | null, lastName?: string | null, email: string } | null> } };

export type PrivateFormExpertSessionQueryVariables = Exact<{
  input: ExpertSessionInput;
}>;


export type PrivateFormExpertSessionQuery = { __typename?: 'Query', expertSession: { __typename?: 'ExpertSession', title: string, description: string, isUpToThreeGuestsAllowed: boolean, lengthInMinutes: number, emailNote?: string | null, price: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, expertUser: { __typename?: 'ExpertUser', id: number } } };

export type CreatePrivateExpertSessionMutationVariables = Exact<{
  input: CreatePrivateExpertSessionInput;
}>;


export type CreatePrivateExpertSessionMutation = { __typename?: 'Mutation', createPrivateExpertSession: { __typename?: 'ExpertSession', id: number } };

export type UpdatePrivateExpertSessionMutationVariables = Exact<{
  input: UpdatePrivateExpertSessionInput;
}>;


export type UpdatePrivateExpertSessionMutation = { __typename?: 'Mutation', updatePrivateExpertSession: { __typename?: 'ExpertSession', id: number } };

export type DeleteExpertSessionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteExpertSessionMutation = { __typename?: 'Mutation', deleteExpertSession: { __typename?: 'ExpertSession', id: number } };

export type AdminProductQueryVariables = Exact<{
  input: ProductInput;
  recommendedProductsFilterInput?: InputMaybe<RecommendedProductsFilterInput>;
}>;


export type AdminProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: number, flxId: number, sku: string, status: ProductStatus, title: string, slug: string, description?: string | null, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, flxId: number, sku: string, title: string, status: ProductVariantStatus, slug: string, quantity: number, isPublishedFirstTime: boolean, fabricDetails?: string | null, fabricHeader?: string | null, fabricSubheader?: string | null, finishDetails?: string | null, finishHeader?: string | null, finishSubheader?: string | null, price: { __typename?: 'Price', total: number }, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, customContent?: { __typename?: 'ProductVariantCustomContentFields', aboveTheFold?: string | null, askExpertCopy?: string | null, customProductHeadline?: string | null, customProductDescription?: string | null, customDimensions?: string | null, accordionShipping?: string | null, accordionCare?: string | null, accordionDetails?: string | null, enquire?: boolean | null, askExpert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null } | null, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string }, carouselImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, fabricImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, finishImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, colorImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null }>, recommendedProducts: Array<{ __typename?: 'RecommendedProduct', id: number, positionIndexWeight: number, pairedProduct: { __typename?: 'Product', id: number, title: string, sku: string } }>, customContent?: { __typename?: 'ProductCustomContentFields', aboveTheFold?: string | null, askExpertCopy?: string | null, customProductHeadline?: string | null, customProductDescription?: string | null, customDimensions?: string | null, accordionShipping?: string | null, accordionCare?: string | null, accordionDetails?: string | null, askExpert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null } | null, forceRedirectToProduct?: { __typename?: 'Product', id: number, sku: string, title: string } | null } };

export type AdminProductsQueryVariables = Exact<{
  inputProduct?: InputMaybe<ProductsInput>;
  inputVariant?: InputMaybe<ProductVariantsInput>;
  recommendedProductsFilterInput?: InputMaybe<RecommendedProductsFilterInput>;
}>;


export type AdminProductsQuery = { __typename?: 'Query', products: { __typename?: 'Products', paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, firstPage: number, lastPage: number, currentPage: number, nextPage?: number | null, previousPage?: number | null }, data: Array<{ __typename?: 'Product', sku: string, id: number, flxId: number, status: ProductStatus, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string }, variants: Array<{ __typename?: 'ProductVariant', quantity: number, isPublishedFirstTime: boolean, status: ProductVariantStatus }>, recommendedProducts: Array<{ __typename?: 'RecommendedProduct', id: number }>, forceRedirectToProduct?: { __typename?: 'Product', id: number, sku: string, title: string } | null } | null> }, productVariants: { __typename?: 'ProductVariants', paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, firstPage: number, lastPage: number, currentPage: number, nextPage?: number | null, previousPage?: number | null }, data: Array<{ __typename?: 'ProductVariant', sku: string, id: number, flxId: number, status: ProductVariantStatus, title: string, slug: string, quantity: number, isPublishedFirstTime: boolean, price: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, product: { __typename?: 'Product', id: number, brand?: { __typename?: 'Brand', id: string } | null }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string } }> } };

export type AdminProductsPickerQueryVariables = Exact<{
  input: ProductsInput;
}>;


export type AdminProductsPickerQuery = { __typename?: 'Query', products: { __typename?: 'Products', data: Array<{ __typename?: 'Product', id: number, flxId: number, sku: string, status: ProductStatus, title: string, slug: string } | null> } };

export type AdminProductVariantsPickerQueryVariables = Exact<{
  input: ProductInput;
}>;


export type AdminProductVariantsPickerQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: number, variants: Array<{ __typename?: 'ProductVariant', id: number, title: string, sku: string }> } };

export type UpdateProductCustomContentMutationVariables = Exact<{
  input: ProductCustomContentInput;
}>;


export type UpdateProductCustomContentMutation = { __typename?: 'Mutation', updateProductCustomContentMutation: { __typename?: 'Product', id: number } };

export type FirstTimePublishProductMutationVariables = Exact<{
  input: FirstTimePublishInput;
}>;


export type FirstTimePublishProductMutation = { __typename?: 'Mutation', firstTimePublishProduct: { __typename?: 'Product', id: number } };

export type UpdateProductVariantCustomContentMutationVariables = Exact<{
  input: ProductVariantCustomContentInput;
}>;


export type UpdateProductVariantCustomContentMutation = { __typename?: 'Mutation', updateProductVariantCustomContentMutation: { __typename?: 'Product', id: number } };

export type FirstTimePublishProductVariantMutationVariables = Exact<{
  input: FirstTimePublishInput;
}>;


export type FirstTimePublishProductVariantMutation = { __typename?: 'Mutation', firstTimePublishProductVariant: { __typename?: 'ProductVariant', id: number } };

export type PublicProductQueryVariables = Exact<{
  productInput: ProductInput;
  variantStatuses?: InputMaybe<Array<ProductVariantStatus> | ProductVariantStatus>;
}>;


export type PublicProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: number, sku: string, slug: string, status: ProductStatus, title: string, description?: string | null, availability: ProductAvailability, previewImageAlt?: string | null, brand?: { __typename?: 'Brand', id: string, cmsBrandPage: { __typename?: 'CMSBrandPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string } } } | null, collections: { __typename?: 'Collections', data: Array<{ __typename?: 'Collection', id: number, title: string } | null> }, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null, options: Array<{ __typename?: 'ProductOption', id: number, name: string }>, variants: Array<{ __typename?: 'ProductVariant', id: number, sku: string, status: ProductVariantStatus, title: string, slug: string, quantity: number, fabricDetails?: string | null, fabricHeader?: string | null, fabricSubheader?: string | null, finishDetails?: string | null, finishHeader?: string | null, finishSubheader?: string | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnit?: string | null, dimensionUnit?: string | null, availability: ProductAvailability, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, price: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, optionValues: Array<{ __typename?: 'ProductOptionValue', value: string, productOption: { __typename?: 'ProductOption', name: string } }>, fabricImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, finishImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, colorImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, product: { __typename?: 'Product', id: number, title: string, slug: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null }, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null, minimumQuantity?: string | null, quantityUnitPlural?: string | null, quantityUnitSingular?: string | null, enableCounter: boolean, proposition65?: string | null, prop65Eligible?: boolean | null, returnNotEligible?: boolean | null, depth?: number | null } | null, estimatedShippingCost?: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode } | null, estimatedDropshipFee?: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode } | null, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }>, customContent?: { __typename?: 'ProductVariantCustomContentFields', aboveTheFold?: string | null, askExpertCopy?: string | null, customProductHeadline?: string | null, customProductDescription?: string | null, customDimensions?: string | null, accordionShipping?: string | null, accordionCare?: string | null, accordionDetails?: string | null, enquire?: boolean | null, askExpert?: { __typename?: 'Expert', id: number, slug: string, profileName?: string | null, profileImageUrl?: string | null, headshotImageUrl?: string | null, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null } | null }>, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }>, customContent?: { __typename?: 'ProductCustomContentFields', aboveTheFold?: string | null, askExpertCopy?: string | null, customProductHeadline?: string | null, customProductDescription?: string | null, customDimensions?: string | null, accordionShipping?: string | null, accordionCare?: string | null, accordionDetails?: string | null, askExpert?: { __typename?: 'Expert', id: number, slug: string, profileName?: string | null, profileImageUrl?: string | null, headshotImageUrl?: string | null, headshotImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, profileImageAttachment?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null } | null } | null, recommendedProducts: Array<{ __typename?: 'RecommendedProduct', id: number, pairedProduct: { __typename?: 'Product', id: number, title: string, slug: string, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, sku: string, title: string, quantity: number, status: ProductVariantStatus, availability: ProductAvailability, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, product: { __typename?: 'Product', id: number, title: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null }, price: { __typename?: 'Price', total: number, base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null }>, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }> } }>, mightAlsoLikeProducts: Array<{ __typename?: 'Product', id: number, title: string, slug: string, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, sku: string, title: string, quantity: number, status: ProductVariantStatus, availability: ProductAvailability, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, product: { __typename?: 'Product', id: number, title: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null }, price: { __typename?: 'Price', total: number, base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null }>, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }> }>, forceRedirectToProduct?: { __typename?: 'Product', slug: string, id: number } | null } };

export type CarouselProductFieldsFragment = { __typename?: 'Product', id: number, title: string, slug: string, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, sku: string, title: string, quantity: number, status: ProductVariantStatus, availability: ProductAvailability, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, product: { __typename?: 'Product', id: number, title: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null }, price: { __typename?: 'Price', total: number, base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null }>, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }> };

export type ProductCustomContentFragmentFragment = { __typename?: 'ProductCustomContentFields', aboveTheFold?: string | null, askExpertCopy?: string | null, customProductHeadline?: string | null, customProductDescription?: string | null, customDimensions?: string | null, accordionShipping?: string | null, accordionCare?: string | null, accordionDetails?: string | null };

export type ProductVariantCustomContentFragmentFragment = { __typename?: 'ProductVariantCustomContentFields', aboveTheFold?: string | null, askExpertCopy?: string | null, customProductHeadline?: string | null, customProductDescription?: string | null, customDimensions?: string | null, accordionShipping?: string | null, accordionCare?: string | null, accordionDetails?: string | null, enquire?: boolean | null };

export type ProductsSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsSlugsQuery = { __typename?: 'Query', productSlugs: Array<{ __typename?: 'Slugs', product: string, variant: string }> };

export type MightAlsoLikeProductsByProductIdQueryVariables = Exact<{
  input: ProductInput;
}>;


export type MightAlsoLikeProductsByProductIdQuery = { __typename?: 'Query', product: { __typename?: 'Product', mightAlsoLikeProducts: Array<{ __typename?: 'Product', id: number, title: string, slug: string, availability: ProductAvailability, brand?: { __typename?: 'Brand', id: string } | null, variants: Array<{ __typename?: 'ProductVariant', id: number, sku: string, title: string, quantity: number, status: ProductVariantStatus, availability: ProductAvailability, leadImage?: { __typename?: 'Attachment', id: number, url: string, alt?: string | null } | null, product: { __typename?: 'Product', id: number, title: string, brand?: { __typename?: 'Brand', id: string } | null, categoryOne?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryTwo?: { __typename?: 'ProductCategory', id: number, name: string } | null, categoryThree?: { __typename?: 'ProductCategory', id: number, name: string } | null }, price: { __typename?: 'Price', total: number, base: number, vatRate: number, currencyIsoCode: CurrencyIsoCode }, tradePrice?: { __typename?: 'Price', base: number, vatRate: number, total: number, currencyIsoCode: CurrencyIsoCode } | null, managedCustomFields?: { __typename?: 'ManagedCustomFields', leadTime?: string | null } | null }>, images: Array<{ __typename?: 'Attachment', url: string, alt?: string | null }> }> } };

export type ApplyPromoCodeMutationVariables = Exact<{
  promoCode: Scalars['String'];
}>;


export type ApplyPromoCodeMutation = { __typename?: 'Mutation', applyPromoCode: boolean };

export type RemovePromoCodeMutationVariables = Exact<{
  promoCode: Scalars['String'];
}>;


export type RemovePromoCodeMutation = { __typename?: 'Mutation', removePromoCode: boolean };

export type PublicCategoriesQueryVariables = Exact<{
  input: PublicCategoriesInput;
}>;


export type PublicCategoriesQuery = { __typename?: 'Query', publicCategories: Array<{ __typename?: 'PublicCategory', title: string, id: number, parentId?: number | null } | null> };

export type PublicRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicRegionsQuery = { __typename?: 'Query', publicRegions: Array<{ __typename?: 'Region', id: number, title: string, children: Array<{ __typename?: 'Region', id: number, title: string } | null> } | null> };

export type PublicTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicTagsQuery = { __typename?: 'Query', publicTags?: Array<{ __typename?: 'Tag', id: number, title: string }> | null };

export type PurchaseQueryVariables = Exact<{
  input: PurchaseInput;
}>;


export type PurchaseQuery = { __typename?: 'Query', purchase: { __typename?: 'Purchase', id: number, description: string, policy?: string | null, status: PurchaseStatus, trackingUrl?: string | null, vendorExpertCommission: number, shippingFullName?: string | null, shippingCompany?: string | null, shippingAddressLine1?: string | null, shippingAddressLine2?: string | null, shippingCountryIsoCode?: string | null, shippingCountryState?: string | null, shippingCity?: string | null, shippingZipCode?: string | null, shippingPhone?: string | null, isExpertCommissionPaid?: boolean | null, checkoutItem?: { __typename?: 'CheckoutItem', checkout: { __typename?: 'Checkout', id: number } } | null, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string }, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, totalPrice: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, expert?: { __typename?: 'Expert', id: number, profileName?: string | null, businessName: string } | null, vendor?: { __typename?: 'Vendor', id: number, expertCommission: number } | null, client?: { __typename?: 'Client', id: number, firstName: string, lastName: string, contactEmail: string } | null, expertUser?: { __typename?: 'ExpertUser', id: number, email: string, expert: { __typename?: 'Expert', id: number } } | null, retailPrice: { __typename?: 'Price', base: number }, tax: { __typename?: 'Price', base: number }, shippingPrice: { __typename?: 'Price', base: number }, vendorPrice: { __typename?: 'Price', base: number }, attachment?: { __typename?: 'Attachment', id: number, url: string, name?: string | null, alt?: string | null } | null, tradeLicense?: { __typename?: 'TradeLicense', id: number, name: string } | null } };

export type CreatePurchaseMutationVariables = Exact<{
  input: CreatePurchaseInput;
}>;


export type CreatePurchaseMutation = { __typename?: 'Mutation', createPurchase: { __typename?: 'Purchase', id: number } };

export type UpdatePurchaseMutationVariables = Exact<{
  input: UpdatePurchaseInput;
}>;


export type UpdatePurchaseMutation = { __typename?: 'Mutation', updatePurchase: { __typename?: 'Purchase', id: number } };

export type ResendPurchaseCheckoutEmailMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ResendPurchaseCheckoutEmailMutation = { __typename?: 'Mutation', resendPurchaseCheckoutEmail?: boolean | null };

export type PayExpertCommissionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PayExpertCommissionMutation = { __typename?: 'Mutation', payExpertCommission?: boolean | null };

export type BuyerOrdersDashboardPurchaseEdgesFragment = { __typename?: 'PurchaseEdge', node?: { __typename?: 'Purchase', id: number, status: PurchaseStatus, buyerType: BuyerType, trackingUrl?: string | null, description: string, shippingFullName?: string | null, shippingCompany?: string | null, shippingAddressLine1?: string | null, shippingAddressLine2?: string | null, shippingCountryIsoCode?: string | null, shippingCountryState?: string | null, shippingCity?: string | null, shippingZipCode?: string | null, shippingPhone?: string | null, billingFullName?: string | null, billingCompany?: string | null, billingAddressLine1?: string | null, billingAddressLine2?: string | null, billingCountryIsoCode?: string | null, billingCountryState?: string | null, billingCity?: string | null, billingZipCode?: string | null, billingPhone?: string | null, client?: { __typename?: 'Client', contactEmail: string } | null, expertUser?: { __typename?: 'ExpertUser', email: string } | null, vendor?: { __typename?: 'Vendor', name: string, attachment: { __typename?: 'Attachment', url: string, alt?: string | null } } | null, expert?: { __typename?: 'Expert', profileName?: string | null, slug: string } | null, totalPrice: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, tax: { __typename?: 'Price', total: number, currencyIsoCode: CurrencyIsoCode }, shippingPrice: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, retailPrice: { __typename?: 'Price', base: number, currencyIsoCode: CurrencyIsoCode }, attachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null, paymentDetails?: { __typename?: 'PaymentDetails', isCreditsPayment?: boolean | null, isCouponPayment?: boolean | null, card?: { __typename?: 'ClientCreditCard', brand: string, last4: string } | null, paidAtUtc?: { __typename?: 'Datetime', isoFormat: string } | null } | null, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, price?: { __typename?: 'PurchasePriceType', currencyIsoCode?: string | null, payment?: { __typename?: 'PurchasePayment', coupon?: number | null, card?: number | null } | null } | null, tradeLicense?: { __typename?: 'TradeLicense', id: number } | null } | null };

export type VerifyRecaptchaTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyRecaptchaTokenMutation = { __typename?: 'Mutation', verifyRecaptchaToken: { __typename?: 'Recaptcha', isSuccess: boolean } };

export type SearchQueryVariables = Exact<{
  searchInput: GlobalSearchInput;
}>;


export type SearchQuery = { __typename?: 'Query', globalSearch: { __typename?: 'GlobalSearchResults', searchValue: string, brands: Array<{ __typename?: 'Brand', id: string, cmsBrandPage: { __typename?: 'CMSBrandPage', id: number, cmsPage: { __typename?: 'CMSPage', id: number, slug: string } } }>, publicExperts: Array<{ __typename?: 'Expert', id: number, profileName?: string | null, jobTitle?: string | null, slug: string, profileImageAttachment?: { __typename?: 'Attachment', url: string, alt?: string | null } | null }>, navigationItems: Array<{ __typename?: 'NavigationItem', id: number, title: string, cmsPage: { __typename?: 'CMSPage', href: string }, parent?: { __typename?: 'NavigationItem', title: string } | null }>, productVariants: Array<{ __typename?: 'ProductVariant', id: number, title: string, slug: string, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }>, product: { __typename?: 'Product', id: number, slug: string, manufacturer?: string | null, images: Array<{ __typename?: 'Attachment', id: number, url: string, alt?: string | null }> } }> } };

export type SendFreeAssistanceEmailMutationVariables = Exact<{
  input: SendFreeAssistanceEmailInput;
}>;


export type SendFreeAssistanceEmailMutation = { __typename?: 'Mutation', sendFreeAssistanceEmail?: boolean | null };

export type SendItemInquireEmailMutationVariables = Exact<{
  input: SendItemInquireEmailInput;
}>;


export type SendItemInquireEmailMutation = { __typename?: 'Mutation', sendItemInquireEmail?: boolean | null };

export type AdminPutSessionOnHoldMutationVariables = Exact<{
  input: AdminPutSessionOnHoldInput;
}>;


export type AdminPutSessionOnHoldMutation = { __typename?: 'Mutation', adminPutSessionOnHold: { __typename?: 'Session', id: number } };

export type SessionReportDiscoverMoreQueryVariables = Exact<{
  input: WidgetsByIdInput;
}>;


export type SessionReportDiscoverMoreQuery = { __typename?: 'Query', cmsWidgetById: { __typename?: 'CMSWidget', id: number, content?: { __typename?: 'CMSAlphabeticalIndexWidget' } | { __typename?: 'CMSAltExpertsListingWidget' } | { __typename?: 'CMSAltValuePropositionWidget' } | { __typename?: 'CMSArticleHeadingWidget' } | { __typename?: 'CMSArticlesWidget' } | { __typename?: 'CMSBannerWidget' } | { __typename?: 'CMSCardNavigationWidget', id: number, title?: string | null, cmsCardNavigationWidgetItems: Array<{ __typename?: 'CMSCardNavigationWidgetItem', id: number, title: string, attachment: { __typename?: 'Attachment', id: number, url: string } }> } | { __typename?: 'CMSCategoryCollectionWidget' } | { __typename?: 'CMSCategoryHeaderWidget' } | { __typename?: 'CMSCollectionHeaderWidget' } | { __typename?: 'CMSCollectionsCarouselWidget' } | { __typename?: 'CMSConciergeWidget' } | { __typename?: 'CMSDoubleImageWidget' } | { __typename?: 'CMSExpertCollectionsWidget' } | { __typename?: 'CMSExpertsListingWidget' } | { __typename?: 'CMSExpertsWidget' } | { __typename?: 'CMSFeaturedInWidget' } | { __typename?: 'CMSGalleryWidget' } | { __typename?: 'CMSGiftCardWidget' } | { __typename?: 'CMSHeroCarouselWidget' } | { __typename?: 'CMSHeroMainWidget' } | { __typename?: 'CMSHeroWidget' } | { __typename?: 'CMSInfoCardsWidget' } | { __typename?: 'CMSIntroductionWidget' } | { __typename?: 'CMSMultiCollectionWidget' } | { __typename?: 'CMSProductsWidget' } | { __typename?: 'CMSQAWidget' } | { __typename?: 'CMSRichTextWidget' } | { __typename?: 'CMSSectionWidget' } | { __typename?: 'CMSSingleImageWidget' } | { __typename?: 'CMSSpotlightWidget' } | { __typename?: 'CMSTestimonialsWidget' } | { __typename?: 'CMSValuePropositionWidget' } | { __typename?: 'CMSVideoSectionWidget' } | { __typename?: 'CMSVideoWidget' } | null } };

export type SetupClientPaymentMethodMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupClientPaymentMethodMutation = { __typename?: 'Mutation', setupClientPaymentMethod: string };

export type SubscribeToMailingListMutationVariables = Exact<{
  input: SubscribeToMailingListInput;
}>;


export type SubscribeToMailingListMutation = { __typename?: 'Mutation', subscribeToMailingList: boolean };

export type AdminTradeLicensesQueryVariables = Exact<{
  input?: InputMaybe<TradeLicensesInput>;
}>;


export type AdminTradeLicensesQuery = { __typename?: 'Query', tradeLicenses: { __typename?: 'TradeLicenses', edges: Array<{ __typename?: 'TradeLicenseEdge', node: { __typename?: 'TradeLicense', id: number, name: string, isActive: boolean, isDisabled: boolean, isSingleUse: boolean, countryStates: Array<string>, expert: { __typename?: 'Expert', email: string, businessName: string, legalBusinessName?: string | null }, expiresAtUtc?: { __typename?: 'Datetime', isoFormat: string } | null, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } }>, pageInfo: { __typename?: 'CursorPaginationInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type AdminTradeLicenseQueryVariables = Exact<{
  input: TradeLicenseInput;
}>;


export type AdminTradeLicenseQuery = { __typename?: 'Query', tradeLicense: { __typename?: 'TradeLicense', id: number, name: string, isActive: boolean, isDisabled: boolean, isSingleUse: boolean, countryStates: Array<string>, licenseNumber: string, expert: { __typename?: 'Expert', id: number, businessName: string, legalBusinessName?: string | null }, attachments: Array<{ __typename?: 'Attachment', id: number, name?: string | null, url: string }>, expiresAtUtc?: { __typename?: 'Datetime', isoFormat: string } | null } };

export type ToggleIsDisabledTradeLicenseMutationVariables = Exact<{
  input: ToggleIsDisabledTradeLicenseInput;
}>;


export type ToggleIsDisabledTradeLicenseMutation = { __typename?: 'Mutation', toggleIsDisabledTradeLicense: { __typename?: 'TradeLicense', id: number, isDisabled: boolean } };

export type CreateTradeLicenseMutationVariables = Exact<{
  input: CreateTradeLicenseInput;
}>;


export type CreateTradeLicenseMutation = { __typename?: 'Mutation', createTradeLicense: { __typename?: 'TradeLicense', id: number } };

export type TrustedSourceDirectivesFragment = { __typename?: 'TrustedSource', childSrc: boolean, connectSrc: boolean, fontSrc: boolean, frameSrc: boolean, imgSrc: boolean, manifestSrc: boolean, mediaSrc: boolean, objectSrc: boolean, prefetchSrc: boolean, scriptSrc: boolean, scriptSrcElem: boolean, scriptSrcAttr: boolean, styleSrc: boolean, styleSrcElem: boolean, styleSrcAttr: boolean, workerSrc: boolean };

export type TrustedSourcesQueryVariables = Exact<{
  input?: InputMaybe<TrustedSourcesInput>;
}>;


export type TrustedSourcesQuery = { __typename?: 'Query', trustedSources: { __typename?: 'TrustedSources', paginationInfo: { __typename?: 'PaginationInfo', totalCount: number, firstPage: number, lastPage: number, currentPage: number, nextPage?: number | null, previousPage?: number | null }, data: Array<{ __typename?: 'TrustedSource', id: number, domain: string, childSrc: boolean, connectSrc: boolean, fontSrc: boolean, frameSrc: boolean, imgSrc: boolean, manifestSrc: boolean, mediaSrc: boolean, objectSrc: boolean, prefetchSrc: boolean, scriptSrc: boolean, scriptSrcElem: boolean, scriptSrcAttr: boolean, styleSrc: boolean, styleSrcElem: boolean, styleSrcAttr: boolean, workerSrc: boolean, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, updatedAtUtc: { __typename?: 'Datetime', isoFormat: string } } | null> } };

export type TrustedSourcesCounterQueryVariables = Exact<{
  input?: InputMaybe<TrustedSourcesInput>;
}>;


export type TrustedSourcesCounterQuery = { __typename?: 'Query', trustedSources: { __typename?: 'TrustedSources', data: Array<{ __typename?: 'TrustedSource', domain: string, childSrc: boolean, connectSrc: boolean, fontSrc: boolean, frameSrc: boolean, imgSrc: boolean, manifestSrc: boolean, mediaSrc: boolean, objectSrc: boolean, prefetchSrc: boolean, scriptSrc: boolean, scriptSrcElem: boolean, scriptSrcAttr: boolean, styleSrc: boolean, styleSrcElem: boolean, styleSrcAttr: boolean, workerSrc: boolean } | null> } };

export type CreateTrustedSourceMutationVariables = Exact<{
  input: CreateTrustedSourceInput;
}>;


export type CreateTrustedSourceMutation = { __typename?: 'Mutation', createTrustedSource: { __typename?: 'TrustedSource', id: number } };

export type UpdateTrustedSourceMutationVariables = Exact<{
  input: UpdateTrustedSourceInput;
}>;


export type UpdateTrustedSourceMutation = { __typename?: 'Mutation', updateTrustedSource: { __typename?: 'TrustedSource', id: number } };

export type DeleteTrustedSourceMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTrustedSourceMutation = { __typename?: 'Mutation', deleteTrustedSource: boolean };

export type CreateVendorMutationVariables = Exact<{
  input: CreateVendorInput;
}>;


export type CreateVendorMutation = { __typename?: 'Mutation', createVendor: { __typename?: 'Vendor', brands: Array<string>, expertCommission: number, id: number, isDeleted?: boolean | null, name: string, websiteUrl?: string | null, policy?: string | null, attachment: { __typename?: 'Attachment', url: string, name?: string | null, alt?: string | null } } };

export type DeleteVendorMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteVendorMutation = { __typename?: 'Mutation', deleteVendor: { __typename?: 'Vendor', id: number } };

export type UpdateVendorMutationVariables = Exact<{
  input: UpdateVendorInput;
}>;


export type UpdateVendorMutation = { __typename?: 'Mutation', updateVendor: { __typename?: 'Vendor', brands: Array<string>, expertCommission: number, id: number, isDeleted?: boolean | null, name: string, websiteUrl?: string | null, policy?: string | null, attachment: { __typename?: 'Attachment', url: string, id: number, name?: string | null, alt?: string | null } } };

export type AdminVendorsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminVendorsQuery = { __typename?: 'Query', vendors: Array<{ __typename?: 'Vendor', brands: Array<string>, expertCommission: number, id: number, name: string, websiteUrl?: string | null, policy?: string | null, attachment: { __typename?: 'Attachment', url: string, id: number, name?: string | null, alt?: string | null } }> };

export type ChangeVideoThumbnailMutationVariables = Exact<{
  input: ChangeVideoThumbnailInput;
}>;


export type ChangeVideoThumbnailMutation = { __typename?: 'Mutation', changeVideoThumbnail: boolean };

export const CmsCardNavigationWidgetFieldsFragmentDoc = gql`
    fragment CMSCardNavigationWidgetFields on CMSCardNavigationWidget {
  id
  cardNavigationWidgetTitle: title
  subtitle
  cardNavigationWidgetPlacement: placement
  cardNavigationWidgetButtonText: buttonText
  cardNavigationWidgetButtonLink: buttonLink
  cmsCardNavigationWidgetItems {
    id
    title
    attachment {
      id
      url
      alt
    }
    cmsPage {
      id
      slug
      title
      href
    }
    positionIndexWeight
  }
}
    `;
export const CmsHeroCarouselWidgetFieldsFragmentDoc = gql`
    fragment CMSHeroCarouselWidgetFields on CMSHeroCarouselWidget {
  id
  isAutoRotationEnabled
  cmsHeroCarouselWidgetItems {
    id
    preTitle
    headline
    subheadline
    hasButton
    buttonText
    buttonLink
    attachment {
      id
      url
      alt
    }
    positionIndexWeight
  }
}
    `;
export const AdminCmsArticlesWidgetFieldsFragmentDoc = gql`
    fragment AdminCMSArticlesWidgetFields on CMSArticlesWidget {
  id
  title
  subtitle
  cmsArticlesWidgetItems {
    widgetId
    data {
      id
      article {
        id
        cmsPage {
          id
          slug
          title
        }
      }
    }
  }
}
    `;
export const CmsListingWidgetFieldsFragmentDoc = gql`
    fragment CMSListingWidgetFields on CMSListingWidget {
  id
  type
  name
  content {
    ... on CMSInfoListingWidget {
      id
      headline
      body
      hasButton
      buttonText
      hasCustomLink
      customButtonUrl
      previewAttachment {
        id
        url
        alt
        name
      }
    }
    ... on CMSHelpListingWidget {
      id
      headline
      body
    }
    ... on CMSQuotationListingWidget {
      id
      body
      author
    }
    ... on CMSConsultationListingWidget {
      id
      headline
      previewAttachment {
        id
        url
        alt
        name
      }
      expert {
        id
        profileName
        headshotImageUrl
        headshotImageAttachment {
          id
          url
          alt
        }
        slug
      }
      buttonCopy
      isButtonIconShown
      isConsultationDetailShown
      duration
      price
    }
  }
}
    `;
export const CmsWidgetItemFieldsFragmentDoc = gql`
    fragment CMSWidgetItemFields on CMSWidgetItem {
  id
  positionIndexWeight
  content {
    __typename
    ... on CMSWidgetItemButton {
      id
      text
      link
    }
    ... on CMSWidgetItemHeadline {
      id
      headline
      subheadline
    }
    ... on CMSWidgetItemTwoColumnCard {
      id
      firstTitle
      firstLink
      firstAttachment {
        id
        url
        alt
      }
      secondTitle
      secondLink
      secondAttachment {
        id
        url
        alt
      }
    }
    ... on CMSWidgetItemThreeColumnCard {
      id
      firstTitle
      firstLink
      firstAttachment {
        id
        url
        alt
      }
      secondTitle
      secondLink
      secondAttachment {
        id
        url
        alt
      }
      thirdTitle
      thirdLink
      thirdAttachment {
        id
        url
        alt
      }
    }
  }
}
    `;
export const AdminCmsPageFieldsFragmentDoc = gql`
    fragment AdminCMSPageFields on CMSPage {
  id
  slug
  title
  metaDescription
  metaTitle
  keywords
  isPublished
  isStatic
  widgets {
    id
    positionIndexWeight
    content {
      ... on CMSCardNavigationWidget {
        ...CMSCardNavigationWidgetFields
      }
      ... on CMSAltValuePropositionWidget {
        id
      }
      ... on CMSHeroCarouselWidget {
        ...CMSHeroCarouselWidgetFields
      }
      ... on CMSHeroMainWidget {
        id
        headline
        subheadline
        mainButtonText
        mainButtonLink
        hasSecondaryButton
        secondaryButtonText
        secondaryButtonLink
        attachment {
          id
          url
          name
          alt
        }
      }
      ... on CMSHeroWidget {
        id
        hasLandingPageButtons
        title
        attachment {
          id
          url
          name
          alt
        }
      }
      ... on CMSGalleryWidget {
        title
        id
        cmsGalleryWidgetItems {
          id
          attachment {
            id
            url
            alt
          }
          expert {
            id
            profileName
            businessName
          }
          caption
        }
      }
      ... on CMSInfoCardsWidget {
        id
      }
      ... on CMSFeaturedInWidget {
        id
      }
      ... on CMSValuePropositionWidget {
        id
      }
      ... on CMSExpertsWidget {
        id
        title
        isButtonHidden
        mobilePageSize
        desktopPageSize
        cmsExpertsWidgetItems {
          widgetId
          data {
            id
            expert {
              id
              profileName
              businessName
            }
          }
        }
      }
      ... on CMSArticlesWidget {
        ...AdminCMSArticlesWidgetFields
      }
      ... on CMSVideoWidget {
        id
        title
        videoAttachment {
          id
          url
        }
        thumbnailAttachment {
          id
          url
          alt
        }
      }
      ... on CMSVideoSectionWidget {
        id
        title
        subtitle
        hasCtaButton
        ctaCopy
        ctaCopyUrl
        video: videoAttachment {
          id
          url
        }
        thumbnail: thumbnailAttachment {
          id
          url
          alt
        }
      }
      ... on CMSTestimonialsWidget {
        title
        id
        cmsTestimonialsWidgetItems {
          id
          feedback
          clientInfo
        }
      }
      ... on CMSSpotlightWidget {
        id
        title
        subTitle
        href
        expert {
          slug
          id
          profileName
          businessName
        }
        attachment {
          url
          id
          alt
        }
        buttonText
        description
      }
      ... on CMSRichTextWidget {
        id
        richText
      }
      ... on CMSArticleHeadingWidget {
        id
        title
        author
        caption
      }
      ... on CMSCategoryHeaderWidget {
        id
        categoryHeaderWidgetType: type
        title
        subtitle
        expert {
          id
          profileName
          businessName
        }
        cmsCategoryHeaderWidgetItems {
          id
          attachment {
            id
            url
            alt
          }
          positionIndexWeight
        }
      }
      ... on CMSBannerWidget {
        id
        title
        href
        expert {
          slug
          id
          profileName
          businessName
        }
        buttonText
      }
      ... on CMSSingleImageWidget {
        id
        caption
        attachment {
          id
          url
        }
      }
      ... on CMSDoubleImageWidget {
        id
        firstCaption
        secondCaption
        firstAttachment {
          id
          url
          alt
        }
        secondAttachment {
          id
          url
          alt
        }
      }
      ... on CMSProductsWidget {
        id
        cmsProductsWidgetItems {
          id
          title
          pretitle
          posttitle
          description
          href
          attachment {
            id
            url
            name
            alt
          }
        }
      }
      ... on CMSQAWidget {
        id
        cmsQAWidgetItems {
          id
          question
          answer
        }
      }
      ... on CMSGiftCardWidget {
        id
        title
        description
      }
      ... on CMSMultiCollectionWidget {
        id
        multiCollectionWidgetType: type
        isShopAllProductsButtonEnabled
        headline
        isSortEnabled
        useBreakoutVariants
        cmsShowroomPage {
          id
          cmsPage {
            id
            title
            slug
          }
        }
        expert {
          id
          profileName
          businessName
        }
        defaultSortField
        defaultSortDirection
        cmsListingWidgets {
          ...CMSListingWidgetFields
        }
        cmsMultiCollectionWidgetItems {
          id
          caption
          positionIndexWeight
          collection {
            id
            title
          }
        }
        firstPublishedAtFilter
      }
      ... on CMSExpertCollectionsWidget {
        id
        cmsExpertCollectionsWidgetItems {
          id
          caption
          positionIndexWeight
          cmsShowroomPage {
            id
            cmsPage {
              id
              title
              slug
            }
          }
          expert {
            id
            profileName
            businessName
          }
          previewImageAttachment {
            id
            url
            alt
          }
          profileImageAttachment {
            id
            url
            alt
          }
        }
      }
      ... on CMSCollectionHeaderWidget {
        id
        title
        subtitle
        collectionHeaderType
        headerImageAttachment {
          id
          url
          alt
        }
        mobileImageAttachment {
          id
          url
          alt
        }
      }
      ... on CMSCollectionsCarouselWidget {
        id
        title
        subtitle
        hasExploreAllButton
        cmsShowroomPage {
          id
          cmsPage {
            slug
            title
            id
          }
        }
        cmsCollectionsCarouselWidgetItems {
          id
          caption
          positionIndexWeight
          cmsShowroomPage {
            id
            cmsPage {
              id
              title
              slug
            }
          }
          previewImageAttachment {
            id
            url
            alt
          }
          profileImageAttachment {
            id
            url
            alt
          }
        }
      }
      ... on CMSIntroductionWidget {
        id
        title
        pretitle
        posttitle
        description
        attachment {
          url
          id
          alt
        }
        buttonText
        buttonLink
      }
      ... on CMSExpertsListingWidget {
        id
        isFilterEnabled
      }
      ... on CMSAlphabeticalIndexWidget {
        id
        cmsAlphabeticalIndexWidgetTitle: title
        alphabeticalIndexWidgetType: type
      }
      ... on CMSAltExpertsListingWidget {
        id
      }
      ... on CMSConciergeWidget {
        id
      }
      ... on CMSSectionWidget {
        id
        widgetItems {
          ...CMSWidgetItemFields
        }
      }
    }
  }
}
    ${CmsCardNavigationWidgetFieldsFragmentDoc}
${CmsHeroCarouselWidgetFieldsFragmentDoc}
${AdminCmsArticlesWidgetFieldsFragmentDoc}
${CmsListingWidgetFieldsFragmentDoc}
${CmsWidgetItemFieldsFragmentDoc}`;
export const AdminCmsBrandPageFieldsFragmentDoc = gql`
    fragment AdminCMSBrandPageFields on CMSBrandPage {
  id
  cmsPage {
    ...AdminCMSPageFields
  }
}
    ${AdminCmsPageFieldsFragmentDoc}`;
export const AdminCmsConsultationPageFieldsFragmentDoc = gql`
    fragment AdminCMSConsultationPageFields on CMSConsultationPage {
  id
  cmsPage {
    ...AdminCMSPageFields
  }
}
    ${AdminCmsPageFieldsFragmentDoc}`;
export const CartFieldsFragmentDoc = gql`
    fragment CartFields on Cart {
  id
  email
  promoCode {
    code
    id
    linkToTac
    isValid
  }
  couponCode {
    code
    id
  }
  summary {
    itemsCount
    totalPrice {
      total
      base
      currencyIsoCode
    }
  }
  items {
    ... on CartItemProductVariant {
      id
      cartId
      cartQuantity: quantity
      productVariant {
        id
        sku
        title
        quantity
        price {
          vatRate
          total
          currencyIsoCode
          base
        }
        tradePrice {
          vatRate
          total
          currencyIsoCode
          base
        }
        sourceAddress {
          id
        }
        images {
          id
          url
          alt
        }
        optionValues {
          value
          productOption {
            name
          }
        }
        source {
          id
        }
        managedCustomFields {
          leadTime
          vendorShipping
          vendorShippingMethod
          freightClubMethod
          minimumQuantity
          quantityUnitSingular
          quantityUnitPlural
          artaMethod
          artaServices
          artaPackaging
          artaSubtype
          artaSetQuantity
          returnNotEligible
          freightClubMethod
          freightClubCategory
          shippingCarrier
        }
        product {
          id
          title
          brand {
            id
          }
          categoryOne {
            name
          }
          categoryTwo {
            name
          }
          categoryThree {
            name
          }
          collections {
            data {
              title
            }
          }
        }
      }
    }
  }
}
    `;
export const AdminCmsArticlePageFieldsFragmentDoc = gql`
    fragment AdminCMSArticlePageFields on CMSArticlePage {
  id
  tag
  author
  previewText
  cmsPage {
    ...AdminCMSPageFields
  }
  previewAttachment {
    id
    url
    name
    alt
  }
}
    ${AdminCmsPageFieldsFragmentDoc}`;
export const AdminCmsCategoryPageFieldsFragmentDoc = gql`
    fragment AdminCMSCategoryPageFields on CMSCategoryPage {
  id
  productCategory {
    id
    name
    parentId
    parentCategory {
      name
      cmsPage {
        content {
          ... on CMSCategoryPage {
            id
          }
        }
      }
    }
  }
  cmsPage {
    ...AdminCMSPageFields
  }
}
    ${AdminCmsPageFieldsFragmentDoc}`;
export const AdminCmsShowroomPageFieldsFragmentDoc = gql`
    fragment AdminCMSShowroomPageFields on CMSShowroomPage {
  id
  cmsPage {
    ...AdminCMSPageFields
  }
}
    ${AdminCmsPageFieldsFragmentDoc}`;
export const CmsCardNavigationWidgetClientFieldsFragmentDoc = gql`
    fragment CMSCardNavigationWidgetClientFields on CMSCardNavigationWidget {
  id
  cardNavigationWidgetTitle: title
  subtitle
  cardNavigationWidgetPlacement: placement
  cardNavigationWidgetButtonText: buttonText
  cardNavigationWidgetButtonLink: buttonLink
  cmsCardNavigationWidgetItems {
    id
    title
    attachment {
      id
      url
      alt
    }
    cmsPage {
      id
      slug
      href
    }
    positionIndexWeight
  }
}
    `;
export const CmsArticlesArticleFieldsFragmentDoc = gql`
    fragment CMSArticlesArticleFields on CMSArticlePage {
  id
  previewText
  tag
  previewAttachment {
    url
    alt
  }
  cmsPage {
    id
    slug
    title
  }
}
    `;
export const CmsExpertsListingWidgetFieldsFragmentDoc = gql`
    fragment CMSExpertsListingWidgetFields on CMSExpertsListingWidget {
  id
  expertItems: items {
    paginationInfo {
      nextPage
    }
    data {
      slug
      id
      profileImageAttachment {
        url
        alt
        id
      }
      primaryLocation
      countryIsoCode
      city
      profileName
      jobTitle
      categories {
        category {
          id
          title
        }
      }
    }
  }
  isFilterEnabled
}
    `;
export const CmsWidgetFieldsFragmentDoc = gql`
    fragment CMSWidgetFields on CMSWidget {
  id
  content {
    ... on CMSCardNavigationWidget {
      ...CMSCardNavigationWidgetClientFields
    }
    ... on CMSVideoWidget {
      id
      title
      thumbnailAttachment {
        id
        url
        alt
      }
      videoAttachment {
        id
        url
      }
    }
    ... on CMSVideoSectionWidget {
      id
      title
      subtitle
      hasCtaButton
      ctaCopy
      ctaCopyUrl
      thumbnail: thumbnailAttachment {
        id
        url
        alt
      }
      video: videoAttachment {
        id
        url
      }
    }
    ... on CMSHeroWidget {
      id
      hasLandingPageButtons
      title
    }
    ... on CMSGalleryWidget {
      title
      id
      cmsGalleryWidgetItems {
        id
        attachment {
          id
          url
          alt
        }
        expert {
          slug
          id
          profileName
        }
        caption
      }
    }
    ... on CMSInfoCardsWidget {
      id
    }
    ... on CMSHeroWidget {
      id
      hasLandingPageButtons
      title
      attachment {
        id
        url
        alt
      }
    }
    ... on CMSHeroMainWidget {
      id
      headline
      subheadline
      mainButtonText
      mainButtonLink
      hasSecondaryButton
      secondaryButtonText
      secondaryButtonLink
      attachment {
        id
        url
        alt
      }
    }
    ... on CMSHeroCarouselWidget {
      id
      isAutoRotationEnabled
      cmsHeroCarouselWidgetItems {
        id
        preTitle
        headline
        subheadline
        hasButton
        buttonText
        buttonLink
        attachment {
          id
          url
          alt
        }
        positionIndexWeight
      }
    }
    ... on CMSFeaturedInWidget {
      id
    }
    ... on CMSValuePropositionWidget {
      id
    }
    ... on CMSExpertsWidget {
      id
      title
      isButtonHidden
      mobilePageSize
      desktopPageSize
      cmsExpertsWidgetItems {
        widgetId
        data {
          id
          expert {
            id
            slug
            profileImageAttachment {
              url
              alt
              id
            }
            profileName
            jobTitle
            categories {
              category {
                id
                title
              }
            }
          }
        }
        paginationInfo {
          totalCount
          nextPage
        }
      }
    }
    ... on CMSArticlesWidget {
      id
      title
      subtitle
      cmsArticlesWidgetItems {
        widgetId
        data {
          id
          article {
            ...CMSArticlesArticleFields
          }
        }
        paginationInfo {
          totalCount
          nextPage
        }
      }
    }
    ... on CMSTestimonialsWidget {
      id
      title
      testimonials: cmsTestimonialsWidgetItems {
        id
        feedback
        clientInfo
      }
    }
    ... on CMSVideoWidget {
      id
    }
    ... on CMSVideoSectionWidget {
      id
    }
    ... on CMSSpotlightWidget {
      id
      title
      subTitle
      description
      buttonText
      buttonLink
      attachment {
        url
        alt
      }
    }
    ... on CMSRichTextWidget {
      id
      richText
    }
    ... on CMSArticleHeadingWidget {
      id
      title
      author
      caption
    }
    ... on CMSCategoryHeaderWidget {
      id
      categoryHeaderWidgetType: type
      title
      subtitle
      expert {
        id
        headshotImageUrl
        headshotImageAttachment {
          id
          url
          alt
        }
      }
      cmsCategoryHeaderWidgetItems {
        id
        attachment {
          id
          url
          alt
        }
        positionIndexWeight
      }
    }
    ... on CMSBannerWidget {
      id
      title
      buttonText
      buttonLink
    }
    ... on CMSGiftCardWidget {
      id
      title
      description
    }
    ... on CMSSingleImageWidget {
      id
      caption
      attachment {
        url
        alt
      }
    }
    ... on CMSProductsWidget {
      id
      cmsProductsWidgetItems {
        id
        title
        pretitle
        posttitle
        description
        href
        attachment {
          url
          alt
        }
      }
    }
    ... on CMSDoubleImageWidget {
      id
      firstCaption
      secondCaption
      firstAttachment {
        url
        alt
      }
      secondAttachment {
        url
        alt
      }
    }
    ... on CMSQAWidget {
      id
      cmsQAWidgetItems {
        id
        slug
        question
        answer
      }
    }
    ... on CMSMultiCollectionWidget {
      id
      multiCollectionWidgetType: type
      isShopAllProductsButtonEnabled
      headline
      cmsShowroomPage {
        cmsPage {
          slug
        }
      }
      expert {
        slug
      }
      isSortEnabled
      useBreakoutVariants
      defaultSortField
      defaultSortDirection
      brands {
        id
      }
      maxPrice {
        total
      }
      categoriesOne {
        id
        name
        parentId
        children {
          id
          name
          parentId
          children {
            id
            name
            parentId
          }
        }
      }
      categoriesTwo {
        id
        name
      }
      categoriesThree {
        id
        name
      }
      cmsListingWidgets {
        ...CMSListingWidgetFields
      }
      cmsMultiCollectionWidgetItems {
        id
        caption
        positionIndexWeight
        collection {
          id
          title
        }
      }
      items {
        data {
          id
          product {
            id
            sku
            title
            slug
            availability
            brand {
              id
            }
            variants {
              id
              title
              sku
              slug
              quantity
              status
              price {
                total
                base
                currencyIsoCode
                vatRate
              }
              tradePrice {
                base
                vatRate
                total
                currencyIsoCode
              }
              managedCustomFields {
                leadTime
              }
              carouselImage {
                url
                alt
              }
              leadImage {
                url
                alt
              }
              images {
                url
              }
              optionValues {
                value
                productOption {
                  name
                }
              }
              product {
                id
                title
                slug
                brand {
                  id
                }
                categoryOne {
                  id
                  name
                }
                categoryTwo {
                  id
                  name
                }
                categoryThree {
                  id
                  name
                }
              }
            }
            collections {
              data {
                id
                expert {
                  id
                  slug
                }
              }
            }
            images {
              url
              alt
            }
          }
          productVariant {
            id
            title
            slug
            quantity
            availability
            price {
              total
              base
              currencyIsoCode
              vatRate
            }
            tradePrice {
              base
              vatRate
              total
              currencyIsoCode
            }
            managedCustomFields {
              leadTime
            }
            images {
              url
              alt
            }
            leadImage {
              id
              url
              alt
            }
          }
          breakoutVariant {
            id
            sku
            slug
            title
            quantity
            availability
            minPrice {
              total
              base
              currencyIsoCode
              vatRate
            }
            maxPrice {
              total
              base
              currencyIsoCode
              vatRate
            }
            tradeMinPrice {
              total
              base
              currencyIsoCode
              vatRate
            }
            tradeMaxPrice {
              total
              base
              currencyIsoCode
              vatRate
            }
            price {
              total
              base
              currencyIsoCode
              vatRate
            }
            tradePrice {
              base
              vatRate
              total
              currencyIsoCode
            }
            product {
              id
              sku
              title
              slug
              brand {
                id
              }
              categoryOne {
                id
                name
              }
              categoryTwo {
                id
                name
              }
              categoryThree {
                id
                name
              }
              collections {
                data {
                  id
                  expert {
                    id
                    slug
                  }
                }
              }
            }
            managedCustomFields {
              leadTime
            }
            attachment {
              url
              alt
            }
          }
        }
        paginationInfo {
          totalCount
          nextPage
        }
      }
    }
    ... on CMSExpertCollectionsWidget {
      id
      cmsExpertCollectionsWidgetItems {
        id
        caption
        positionIndexWeight
        cmsShowroomPage {
          id
          cmsPage {
            slug
            title
          }
        }
        expert {
          id
          slug
        }
        previewImageAttachment {
          url
          alt
        }
        profileImageAttachment {
          url
          alt
        }
      }
    }
    ... on CMSCollectionHeaderWidget {
      id
      title
      subtitle
      collectionHeaderType
      headerImageAttachment {
        url
        alt
      }
      mobileImageAttachment {
        url
        alt
      }
    }
    ... on CMSCollectionsCarouselWidget {
      id
      title
      subtitle
      hasExploreAllButton
      cmsShowroomPage {
        id
        cmsPage {
          slug
          id
        }
      }
      cmsCollectionsCarouselWidgetItems {
        id
        caption
        positionIndexWeight
        cmsShowroomPage {
          id
          cmsPage {
            slug
            title
          }
        }
        previewImageAttachment {
          url
          alt
        }
        profileImageAttachment {
          url
          alt
        }
      }
    }
    ... on CMSIntroductionWidget {
      id
      title
      pretitle
      posttitle
      description
      buttonText
      buttonLink
      attachment {
        url
        alt
      }
    }
    ... on CMSAlphabeticalIndexWidget {
      id
      cmsAlphabeticalIndexWidgetTitle: title
      cmsAlphabeticalIndexWidgetType: type
      data {
        title
        url
      }
    }
    ... on CMSAltExpertsListingWidget {
      id
    }
    ... on CMSAltValuePropositionWidget {
      id
    }
    ...CMSExpertsListingWidgetFields
    ... on CMSConciergeWidget {
      id
    }
    ... on CMSSectionWidget {
      id
      widgetItems {
        ...CMSWidgetItemFields
      }
    }
  }
}
    ${CmsCardNavigationWidgetClientFieldsFragmentDoc}
${CmsArticlesArticleFieldsFragmentDoc}
${CmsListingWidgetFieldsFragmentDoc}
${CmsExpertsListingWidgetFieldsFragmentDoc}
${CmsWidgetItemFieldsFragmentDoc}`;
export const ExpertDetailPageFieldFragmentDoc = gql`
    fragment ExpertDetailPageField on Expert {
  id
  slug
  profileName
  countryIsoCode
  city
  primaryLocation
  shortDescription
  longDescription
  profileImageUrl
  instagramAccountUrl
  headshotImageAttachment {
    id
    alt
    url
  }
  images {
    id
    name
    url
    alt
  }
}
    `;
export const OrderNotesFragmentDoc = gql`
    fragment OrderNotes on Order {
  notes(input: $notesInput) {
    edges {
      node {
        id
        admin {
          id
          email
          name
          createdAtUtc {
            isoFormat
          }
        }
        message
        createdAtUtc {
          isoFormat
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const BuyerOrdersDashboardOrdersDataFragmentDoc = gql`
    fragment BuyerOrdersDashboardOrdersData on Orders {
  edges {
    node {
      id
      status
      shippingFullName
      shippingCompany
      shippingAddressLine1
      shippingAddressLine2
      shippingCountryIsoCode
      shippingCountryState
      shippingCity
      shippingZipCode
      shippingPhone
      billingFullName
      billingCompany
      billingAddressLine1
      billingAddressLine2
      billingCountryIsoCode
      billingCountryState
      billingCity
      billingZipCode
      billingPhone
      buyerEmail
      orderItems {
        id
        quantity
        price {
          base
          currencyIsoCode
        }
        productVariant {
          id
          slug
          title
          length
          width
          height
          dimensionUnit
          managedCustomFields {
            depth
            leadTime
          }
          optionValues {
            value
            productOption {
              name
            }
          }
          product {
            title
            slug
            customContent {
              customDimensions
            }
            images {
              id
              url
              alt
            }
          }
        }
        checkoutItem {
          id
          discounts {
            id
            type
            unitDiscount {
              base
              vat
              total
              vatRate
              currencyIsoCode
              calculatedPrices {
                currencyIsoCode
                total
              }
            }
          }
        }
        status
        trackingUrl
        orderShipment {
          id
          price {
            base
            currencyIsoCode
          }
          shipmentData {
            ... on OrderShipmentArtaQuote {
              id
              type
              name
              services {
                id
                name
                type
                subtype
                subSubtype
              }
              additionalServices
            }
            ... on OrderShipmentFreightClubQuote {
              id
              type
              name
            }
            ... on OrderShipmentVendorShipping {
              id
              name
              type
            }
          }
        }
      }
      checkout {
        promoCode {
          linkToTac
        }
        discountsSum {
          discount {
            base
            vatRate
            currencyIsoCode
          }
          type
        }
        tradeLicense {
          id
        }
      }
      totalDiscount {
        base
        vatRate
        currencyIsoCode
      }
      totalPrice {
        total
        currencyIsoCode
      }
      tax {
        total
        currencyIsoCode
      }
      paymentDetails {
        isCreditsPayment
        isCouponPayment
        card {
          brand
          last4
        }
        paidAtUtc {
          isoFormat
        }
      }
      createdAtUtc {
        isoFormat
      }
      price {
        itemsSum {
          originalPrice
          retailPrice
          discount
        }
        shipmentsSum {
          subtotal
        }
        payment {
          methods
          paidAtUtc
          credit
          coupon
          card
        }
        currencyIsoCode
        originalPrice
        discount
        vat
        subtotal
        total
      }
    }
  }
}
    `;
export const CarouselProductFieldsFragmentDoc = gql`
    fragment CarouselProductFields on Product {
  id
  title
  slug
  availability
  brand {
    id
  }
  variants {
    id
    sku
    title
    quantity
    status
    leadImage {
      id
      url
      alt
    }
    product {
      id
      title
      brand {
        id
      }
      categoryOne {
        id
        name
      }
      categoryTwo {
        id
        name
      }
      categoryThree {
        id
        name
      }
    }
    price {
      total
      base
      vatRate
      currencyIsoCode
    }
    tradePrice {
      base
      vatRate
      total
      currencyIsoCode
    }
    managedCustomFields {
      leadTime
    }
    availability
  }
  images {
    url
    alt
  }
}
    `;
export const ProductCustomContentFragmentFragmentDoc = gql`
    fragment ProductCustomContentFragment on ProductCustomContentFields {
  aboveTheFold
  askExpertCopy
  customProductHeadline
  customProductDescription
  customDimensions
  accordionShipping
  accordionCare
  accordionDetails
}
    `;
export const ProductVariantCustomContentFragmentFragmentDoc = gql`
    fragment ProductVariantCustomContentFragment on ProductVariantCustomContentFields {
  aboveTheFold
  askExpertCopy
  customProductHeadline
  customProductDescription
  customDimensions
  accordionShipping
  accordionCare
  accordionDetails
  enquire
}
    `;
export const BuyerOrdersDashboardPurchaseEdgesFragmentDoc = gql`
    fragment BuyerOrdersDashboardPurchaseEdges on PurchaseEdge {
  node {
    id
    status
    buyerType
    client {
      contactEmail
    }
    expertUser {
      email
    }
    vendor {
      name
      attachment {
        url
        alt
      }
    }
    expert {
      profileName
      slug
    }
    totalPrice {
      total
      currencyIsoCode
    }
    tax {
      total
      currencyIsoCode
    }
    shippingPrice {
      base
      currencyIsoCode
    }
    retailPrice {
      base
      currencyIsoCode
    }
    attachment {
      url
      alt
    }
    trackingUrl
    description
    paymentDetails {
      isCreditsPayment
      isCouponPayment
      card {
        brand
        last4
      }
      paidAtUtc {
        isoFormat
      }
    }
    shippingFullName
    shippingCompany
    shippingAddressLine1
    shippingAddressLine2
    shippingCountryIsoCode
    shippingCountryState
    shippingCity
    shippingZipCode
    shippingPhone
    billingFullName
    billingCompany
    billingAddressLine1
    billingAddressLine2
    billingCountryIsoCode
    billingCountryState
    billingCity
    billingZipCode
    billingPhone
    createdAtUtc {
      isoFormat
    }
    price {
      currencyIsoCode
      payment {
        coupon
        card
      }
    }
    tradeLicense {
      id
    }
  }
}
    `;
export const TrustedSourceDirectivesFragmentDoc = gql`
    fragment trustedSourceDirectives on TrustedSource {
  childSrc
  connectSrc
  fontSrc
  frameSrc
  imgSrc
  manifestSrc
  mediaSrc
  objectSrc
  prefetchSrc
  scriptSrc
  scriptSrcElem
  scriptSrcAttr
  styleSrc
  styleSrcElem
  styleSrcAttr
  workerSrc
}
    `;
export const GetAddressesDocument = gql`
    query getAddresses($input: AutocompleteInput!) {
  addresses(input: $input) {
    fullAddress
    title
    zipCode
    city {
      title
    }
    state {
      title
      shortCode
    }
    country {
      title
      isoCode
    }
  }
}
    `;

/**
 * __useGetAddressesQuery__
 *
 * To run a query within a React component, call `useGetAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAddressesQuery(baseOptions: Apollo.QueryHookOptions<GetAddressesQuery, GetAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressesQuery, GetAddressesQueryVariables>(GetAddressesDocument, options);
      }
export function useGetAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressesQuery, GetAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressesQuery, GetAddressesQueryVariables>(GetAddressesDocument, options);
        }
export type GetAddressesQueryHookResult = ReturnType<typeof useGetAddressesQuery>;
export type GetAddressesLazyQueryHookResult = ReturnType<typeof useGetAddressesLazyQuery>;
export type GetAddressesQueryResult = Apollo.QueryResult<GetAddressesQuery, GetAddressesQueryVariables>;
export const CmsBrandPageDocument = gql`
    query cmsBrandPage($input: CMSBrandPageInput!) {
  cmsBrandPage(input: $input) {
    ...AdminCMSBrandPageFields
  }
}
    ${AdminCmsBrandPageFieldsFragmentDoc}`;

/**
 * __useCmsBrandPageQuery__
 *
 * To run a query within a React component, call `useCmsBrandPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsBrandPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsBrandPageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCmsBrandPageQuery(baseOptions: Apollo.QueryHookOptions<CmsBrandPageQuery, CmsBrandPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsBrandPageQuery, CmsBrandPageQueryVariables>(CmsBrandPageDocument, options);
      }
export function useCmsBrandPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsBrandPageQuery, CmsBrandPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsBrandPageQuery, CmsBrandPageQueryVariables>(CmsBrandPageDocument, options);
        }
export type CmsBrandPageQueryHookResult = ReturnType<typeof useCmsBrandPageQuery>;
export type CmsBrandPageLazyQueryHookResult = ReturnType<typeof useCmsBrandPageLazyQuery>;
export type CmsBrandPageQueryResult = Apollo.QueryResult<CmsBrandPageQuery, CmsBrandPageQueryVariables>;
export const UpdateCmsBrandPageDocument = gql`
    mutation updateCmsBrandPage($input: UpdateCMSBrandPageInput!) {
  updateCmsBrandPage(input: $input) {
    ...AdminCMSBrandPageFields
  }
}
    ${AdminCmsBrandPageFieldsFragmentDoc}`;
export type UpdateCmsBrandPageMutationFn = Apollo.MutationFunction<UpdateCmsBrandPageMutation, UpdateCmsBrandPageMutationVariables>;

/**
 * __useUpdateCmsBrandPageMutation__
 *
 * To run a mutation, you first call `useUpdateCmsBrandPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCmsBrandPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCmsBrandPageMutation, { data, loading, error }] = useUpdateCmsBrandPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCmsBrandPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCmsBrandPageMutation, UpdateCmsBrandPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCmsBrandPageMutation, UpdateCmsBrandPageMutationVariables>(UpdateCmsBrandPageDocument, options);
      }
export type UpdateCmsBrandPageMutationHookResult = ReturnType<typeof useUpdateCmsBrandPageMutation>;
export type UpdateCmsBrandPageMutationResult = Apollo.MutationResult<UpdateCmsBrandPageMutation>;
export type UpdateCmsBrandPageMutationOptions = Apollo.BaseMutationOptions<UpdateCmsBrandPageMutation, UpdateCmsBrandPageMutationVariables>;
export const CmsConsultationPageDocument = gql`
    query cmsConsultationPage($input: CMSConsultationPageInput!) {
  cmsConsultationPage(input: $input) {
    ...AdminCMSConsultationPageFields
  }
}
    ${AdminCmsConsultationPageFieldsFragmentDoc}`;

/**
 * __useCmsConsultationPageQuery__
 *
 * To run a query within a React component, call `useCmsConsultationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsConsultationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsConsultationPageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCmsConsultationPageQuery(baseOptions: Apollo.QueryHookOptions<CmsConsultationPageQuery, CmsConsultationPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsConsultationPageQuery, CmsConsultationPageQueryVariables>(CmsConsultationPageDocument, options);
      }
export function useCmsConsultationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsConsultationPageQuery, CmsConsultationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsConsultationPageQuery, CmsConsultationPageQueryVariables>(CmsConsultationPageDocument, options);
        }
export type CmsConsultationPageQueryHookResult = ReturnType<typeof useCmsConsultationPageQuery>;
export type CmsConsultationPageLazyQueryHookResult = ReturnType<typeof useCmsConsultationPageLazyQuery>;
export type CmsConsultationPageQueryResult = Apollo.QueryResult<CmsConsultationPageQuery, CmsConsultationPageQueryVariables>;
export const UpdateCmsConsultationPageDocument = gql`
    mutation updateCmsConsultationPage($input: UpdateCMSConsultationPageInput!) {
  updateCmsConsultationPage(input: $input) {
    ...AdminCMSConsultationPageFields
  }
}
    ${AdminCmsConsultationPageFieldsFragmentDoc}`;
export type UpdateCmsConsultationPageMutationFn = Apollo.MutationFunction<UpdateCmsConsultationPageMutation, UpdateCmsConsultationPageMutationVariables>;

/**
 * __useUpdateCmsConsultationPageMutation__
 *
 * To run a mutation, you first call `useUpdateCmsConsultationPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCmsConsultationPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCmsConsultationPageMutation, { data, loading, error }] = useUpdateCmsConsultationPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCmsConsultationPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCmsConsultationPageMutation, UpdateCmsConsultationPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCmsConsultationPageMutation, UpdateCmsConsultationPageMutationVariables>(UpdateCmsConsultationPageDocument, options);
      }
export type UpdateCmsConsultationPageMutationHookResult = ReturnType<typeof useUpdateCmsConsultationPageMutation>;
export type UpdateCmsConsultationPageMutationResult = Apollo.MutationResult<UpdateCmsConsultationPageMutation>;
export type UpdateCmsConsultationPageMutationOptions = Apollo.BaseMutationOptions<UpdateCmsConsultationPageMutation, UpdateCmsConsultationPageMutationVariables>;
export const CreateCmsConsultationPageDocument = gql`
    mutation createCmsConsultationPage($input: CreateCMSConsultationPageInput!) {
  createCmsConsultationPage(input: $input) {
    ...AdminCMSConsultationPageFields
  }
}
    ${AdminCmsConsultationPageFieldsFragmentDoc}`;
export type CreateCmsConsultationPageMutationFn = Apollo.MutationFunction<CreateCmsConsultationPageMutation, CreateCmsConsultationPageMutationVariables>;

/**
 * __useCreateCmsConsultationPageMutation__
 *
 * To run a mutation, you first call `useCreateCmsConsultationPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCmsConsultationPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCmsConsultationPageMutation, { data, loading, error }] = useCreateCmsConsultationPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCmsConsultationPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateCmsConsultationPageMutation, CreateCmsConsultationPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCmsConsultationPageMutation, CreateCmsConsultationPageMutationVariables>(CreateCmsConsultationPageDocument, options);
      }
export type CreateCmsConsultationPageMutationHookResult = ReturnType<typeof useCreateCmsConsultationPageMutation>;
export type CreateCmsConsultationPageMutationResult = Apollo.MutationResult<CreateCmsConsultationPageMutation>;
export type CreateCmsConsultationPageMutationOptions = Apollo.BaseMutationOptions<CreateCmsConsultationPageMutation, CreateCmsConsultationPageMutationVariables>;
export const DeleteCmsConsultationPageDocument = gql`
    mutation deleteCmsConsultationPage($id: Int!) {
  deleteCmsConsultationPage(id: $id) {
    id
  }
}
    `;
export type DeleteCmsConsultationPageMutationFn = Apollo.MutationFunction<DeleteCmsConsultationPageMutation, DeleteCmsConsultationPageMutationVariables>;

/**
 * __useDeleteCmsConsultationPageMutation__
 *
 * To run a mutation, you first call `useDeleteCmsConsultationPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCmsConsultationPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCmsConsultationPageMutation, { data, loading, error }] = useDeleteCmsConsultationPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCmsConsultationPageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCmsConsultationPageMutation, DeleteCmsConsultationPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCmsConsultationPageMutation, DeleteCmsConsultationPageMutationVariables>(DeleteCmsConsultationPageDocument, options);
      }
export type DeleteCmsConsultationPageMutationHookResult = ReturnType<typeof useDeleteCmsConsultationPageMutation>;
export type DeleteCmsConsultationPageMutationResult = Apollo.MutationResult<DeleteCmsConsultationPageMutation>;
export type DeleteCmsConsultationPageMutationOptions = Apollo.BaseMutationOptions<DeleteCmsConsultationPageMutation, DeleteCmsConsultationPageMutationVariables>;
export const ValidateAvailableCmsConsultationPageSlugDocument = gql`
    query validateAvailableCmsConsultationPageSlug($input: ValidateAvailableCmsPageSlugInput!) {
  validateAvailableCmsConsultationPageSlug(input: $input)
}
    `;

/**
 * __useValidateAvailableCmsConsultationPageSlugQuery__
 *
 * To run a query within a React component, call `useValidateAvailableCmsConsultationPageSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateAvailableCmsConsultationPageSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateAvailableCmsConsultationPageSlugQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateAvailableCmsConsultationPageSlugQuery(baseOptions: Apollo.QueryHookOptions<ValidateAvailableCmsConsultationPageSlugQuery, ValidateAvailableCmsConsultationPageSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateAvailableCmsConsultationPageSlugQuery, ValidateAvailableCmsConsultationPageSlugQueryVariables>(ValidateAvailableCmsConsultationPageSlugDocument, options);
      }
export function useValidateAvailableCmsConsultationPageSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateAvailableCmsConsultationPageSlugQuery, ValidateAvailableCmsConsultationPageSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateAvailableCmsConsultationPageSlugQuery, ValidateAvailableCmsConsultationPageSlugQueryVariables>(ValidateAvailableCmsConsultationPageSlugDocument, options);
        }
export type ValidateAvailableCmsConsultationPageSlugQueryHookResult = ReturnType<typeof useValidateAvailableCmsConsultationPageSlugQuery>;
export type ValidateAvailableCmsConsultationPageSlugLazyQueryHookResult = ReturnType<typeof useValidateAvailableCmsConsultationPageSlugLazyQuery>;
export type ValidateAvailableCmsConsultationPageSlugQueryResult = Apollo.QueryResult<ValidateAvailableCmsConsultationPageSlugQuery, ValidateAvailableCmsConsultationPageSlugQueryVariables>;
export const AdminDashboardCollectionsDocument = gql`
    query adminDashboardCollections($input: AdminDashboardCollectionsInput) {
  adminDashboardCollections(input: $input) {
    edges {
      node {
        id
        title
        expert {
          id
          profileName
          businessName
        }
        createdAtUtc {
          isoFormat
        }
        updatedAtUtc {
          isoFormat
        }
        status
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useAdminDashboardCollectionsQuery__
 *
 * To run a query within a React component, call `useAdminDashboardCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDashboardCollectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDashboardCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminDashboardCollectionsQuery, AdminDashboardCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDashboardCollectionsQuery, AdminDashboardCollectionsQueryVariables>(AdminDashboardCollectionsDocument, options);
      }
export function useAdminDashboardCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDashboardCollectionsQuery, AdminDashboardCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDashboardCollectionsQuery, AdminDashboardCollectionsQueryVariables>(AdminDashboardCollectionsDocument, options);
        }
export type AdminDashboardCollectionsQueryHookResult = ReturnType<typeof useAdminDashboardCollectionsQuery>;
export type AdminDashboardCollectionsLazyQueryHookResult = ReturnType<typeof useAdminDashboardCollectionsLazyQuery>;
export type AdminDashboardCollectionsQueryResult = Apollo.QueryResult<AdminDashboardCollectionsQuery, AdminDashboardCollectionsQueryVariables>;
export const AutocompleteAdminExpertsDocument = gql`
    query autocompleteAdminExperts($input: ExpertsInput) {
  experts(input: $input) {
    data {
      id
      profileName
      email
    }
  }
}
    `;

/**
 * __useAutocompleteAdminExpertsQuery__
 *
 * To run a query within a React component, call `useAutocompleteAdminExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteAdminExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteAdminExpertsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutocompleteAdminExpertsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteAdminExpertsQuery, AutocompleteAdminExpertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteAdminExpertsQuery, AutocompleteAdminExpertsQueryVariables>(AutocompleteAdminExpertsDocument, options);
      }
export function useAutocompleteAdminExpertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteAdminExpertsQuery, AutocompleteAdminExpertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteAdminExpertsQuery, AutocompleteAdminExpertsQueryVariables>(AutocompleteAdminExpertsDocument, options);
        }
export type AutocompleteAdminExpertsQueryHookResult = ReturnType<typeof useAutocompleteAdminExpertsQuery>;
export type AutocompleteAdminExpertsLazyQueryHookResult = ReturnType<typeof useAutocompleteAdminExpertsLazyQuery>;
export type AutocompleteAdminExpertsQueryResult = Apollo.QueryResult<AutocompleteAdminExpertsQuery, AutocompleteAdminExpertsQueryVariables>;
export const AdminExpertRegionsDocument = gql`
    query adminExpertRegions($input: ExpertsInput) {
  experts(input: $input) {
    paginationInfo {
      totalCount
      firstPage
      lastPage
      currentPage
      nextPage
      previousPage
    }
    data {
      id
      profileName
      email
      status
      regions {
        title
        expertPositionIndexWeight
      }
    }
  }
}
    `;

/**
 * __useAdminExpertRegionsQuery__
 *
 * To run a query within a React component, call `useAdminExpertRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminExpertRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminExpertRegionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminExpertRegionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminExpertRegionsQuery, AdminExpertRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminExpertRegionsQuery, AdminExpertRegionsQueryVariables>(AdminExpertRegionsDocument, options);
      }
export function useAdminExpertRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminExpertRegionsQuery, AdminExpertRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminExpertRegionsQuery, AdminExpertRegionsQueryVariables>(AdminExpertRegionsDocument, options);
        }
export type AdminExpertRegionsQueryHookResult = ReturnType<typeof useAdminExpertRegionsQuery>;
export type AdminExpertRegionsLazyQueryHookResult = ReturnType<typeof useAdminExpertRegionsLazyQuery>;
export type AdminExpertRegionsQueryResult = Apollo.QueryResult<AdminExpertRegionsQuery, AdminExpertRegionsQueryVariables>;
export const AdminDashboardExpertsDocument = gql`
    query adminDashboardExperts($input: AdminDashboardExpertsInput) {
  adminDashboardExperts(input: $input) {
    edges {
      node {
        id
        email
        businessName
        profileName
        status
        subscribersCount
        users {
          id
          onboardingToken
          expert {
            id
          }
        }
        nonBookedAvailabilityHours
        createdAtUtc {
          isoFormat
        }
        mainUser {
          id
        }
        isFindable
        isPublicVisible
        capabilities
        tradeLicenses(input: {filter: {isActive: true}, pagination: {limit: 1}}) {
          edges {
            node {
              isActive
            }
          }
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useAdminDashboardExpertsQuery__
 *
 * To run a query within a React component, call `useAdminDashboardExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDashboardExpertsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDashboardExpertsQuery(baseOptions?: Apollo.QueryHookOptions<AdminDashboardExpertsQuery, AdminDashboardExpertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDashboardExpertsQuery, AdminDashboardExpertsQueryVariables>(AdminDashboardExpertsDocument, options);
      }
export function useAdminDashboardExpertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDashboardExpertsQuery, AdminDashboardExpertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDashboardExpertsQuery, AdminDashboardExpertsQueryVariables>(AdminDashboardExpertsDocument, options);
        }
export type AdminDashboardExpertsQueryHookResult = ReturnType<typeof useAdminDashboardExpertsQuery>;
export type AdminDashboardExpertsLazyQueryHookResult = ReturnType<typeof useAdminDashboardExpertsLazyQuery>;
export type AdminDashboardExpertsQueryResult = Apollo.QueryResult<AdminDashboardExpertsQuery, AdminDashboardExpertsQueryVariables>;
export const AdminDashboardExpertUsersDocument = gql`
    query adminDashboardExpertUsers($input: AdminDashboardExpertUsersInput) {
  adminDashboardExpertUsers(input: $input) {
    edges {
      node {
        id
        email
        expert {
          id
          businessName
          users {
            id
          }
          tradeLicenses(input: {filter: {isActive: true}, pagination: {limit: 1}}) {
            edges {
              node {
                isActive
              }
            }
          }
        }
        capabilities
        isMain
        timezone
        onboardingToken
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useAdminDashboardExpertUsersQuery__
 *
 * To run a query within a React component, call `useAdminDashboardExpertUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardExpertUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDashboardExpertUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDashboardExpertUsersQuery(baseOptions?: Apollo.QueryHookOptions<AdminDashboardExpertUsersQuery, AdminDashboardExpertUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDashboardExpertUsersQuery, AdminDashboardExpertUsersQueryVariables>(AdminDashboardExpertUsersDocument, options);
      }
export function useAdminDashboardExpertUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDashboardExpertUsersQuery, AdminDashboardExpertUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDashboardExpertUsersQuery, AdminDashboardExpertUsersQueryVariables>(AdminDashboardExpertUsersDocument, options);
        }
export type AdminDashboardExpertUsersQueryHookResult = ReturnType<typeof useAdminDashboardExpertUsersQuery>;
export type AdminDashboardExpertUsersLazyQueryHookResult = ReturnType<typeof useAdminDashboardExpertUsersLazyQuery>;
export type AdminDashboardExpertUsersQueryResult = Apollo.QueryResult<AdminDashboardExpertUsersQuery, AdminDashboardExpertUsersQueryVariables>;
export const AdminSignInAsExpertUserDocument = gql`
    query adminSignInAsExpertUser($expertUserId: Int!) {
  adminSignInAsExpertUser(expertUserId: $expertUserId)
}
    `;

/**
 * __useAdminSignInAsExpertUserQuery__
 *
 * To run a query within a React component, call `useAdminSignInAsExpertUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSignInAsExpertUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSignInAsExpertUserQuery({
 *   variables: {
 *      expertUserId: // value for 'expertUserId'
 *   },
 * });
 */
export function useAdminSignInAsExpertUserQuery(baseOptions: Apollo.QueryHookOptions<AdminSignInAsExpertUserQuery, AdminSignInAsExpertUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSignInAsExpertUserQuery, AdminSignInAsExpertUserQueryVariables>(AdminSignInAsExpertUserDocument, options);
      }
export function useAdminSignInAsExpertUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSignInAsExpertUserQuery, AdminSignInAsExpertUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSignInAsExpertUserQuery, AdminSignInAsExpertUserQueryVariables>(AdminSignInAsExpertUserDocument, options);
        }
export type AdminSignInAsExpertUserQueryHookResult = ReturnType<typeof useAdminSignInAsExpertUserQuery>;
export type AdminSignInAsExpertUserLazyQueryHookResult = ReturnType<typeof useAdminSignInAsExpertUserLazyQuery>;
export type AdminSignInAsExpertUserQueryResult = Apollo.QueryResult<AdminSignInAsExpertUserQuery, AdminSignInAsExpertUserQueryVariables>;
export const CreateExpertFromAdminDashboardDocument = gql`
    mutation createExpertFromAdminDashboard($input: CreateExpertFromAdminDashboardInput!) {
  createExpertFromAdminDashboard(input: $input) {
    id
  }
}
    `;
export type CreateExpertFromAdminDashboardMutationFn = Apollo.MutationFunction<CreateExpertFromAdminDashboardMutation, CreateExpertFromAdminDashboardMutationVariables>;

/**
 * __useCreateExpertFromAdminDashboardMutation__
 *
 * To run a mutation, you first call `useCreateExpertFromAdminDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpertFromAdminDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpertFromAdminDashboardMutation, { data, loading, error }] = useCreateExpertFromAdminDashboardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExpertFromAdminDashboardMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpertFromAdminDashboardMutation, CreateExpertFromAdminDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExpertFromAdminDashboardMutation, CreateExpertFromAdminDashboardMutationVariables>(CreateExpertFromAdminDashboardDocument, options);
      }
export type CreateExpertFromAdminDashboardMutationHookResult = ReturnType<typeof useCreateExpertFromAdminDashboardMutation>;
export type CreateExpertFromAdminDashboardMutationResult = Apollo.MutationResult<CreateExpertFromAdminDashboardMutation>;
export type CreateExpertFromAdminDashboardMutationOptions = Apollo.BaseMutationOptions<CreateExpertFromAdminDashboardMutation, CreateExpertFromAdminDashboardMutationVariables>;
export const AdminExpertPickerDocument = gql`
    query adminExpertPicker($input: AdminDashboardExpertsInput) {
  adminDashboardExperts(input: $input) {
    edges {
      node {
        id
        businessName
        profileName
        status
        slug
      }
    }
  }
}
    `;

/**
 * __useAdminExpertPickerQuery__
 *
 * To run a query within a React component, call `useAdminExpertPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminExpertPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminExpertPickerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminExpertPickerQuery(baseOptions?: Apollo.QueryHookOptions<AdminExpertPickerQuery, AdminExpertPickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminExpertPickerQuery, AdminExpertPickerQueryVariables>(AdminExpertPickerDocument, options);
      }
export function useAdminExpertPickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminExpertPickerQuery, AdminExpertPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminExpertPickerQuery, AdminExpertPickerQueryVariables>(AdminExpertPickerDocument, options);
        }
export type AdminExpertPickerQueryHookResult = ReturnType<typeof useAdminExpertPickerQuery>;
export type AdminExpertPickerLazyQueryHookResult = ReturnType<typeof useAdminExpertPickerLazyQuery>;
export type AdminExpertPickerQueryResult = Apollo.QueryResult<AdminExpertPickerQuery, AdminExpertPickerQueryVariables>;
export const AdminUpdateExpertDocument = gql`
    mutation adminUpdateExpert($input: AdminUpdateExpertInput!) {
  adminUpdateExpert(input: $input) {
    id
  }
}
    `;
export type AdminUpdateExpertMutationFn = Apollo.MutationFunction<AdminUpdateExpertMutation, AdminUpdateExpertMutationVariables>;

/**
 * __useAdminUpdateExpertMutation__
 *
 * To run a mutation, you first call `useAdminUpdateExpertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateExpertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateExpertMutation, { data, loading, error }] = useAdminUpdateExpertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateExpertMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateExpertMutation, AdminUpdateExpertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateExpertMutation, AdminUpdateExpertMutationVariables>(AdminUpdateExpertDocument, options);
      }
export type AdminUpdateExpertMutationHookResult = ReturnType<typeof useAdminUpdateExpertMutation>;
export type AdminUpdateExpertMutationResult = Apollo.MutationResult<AdminUpdateExpertMutation>;
export type AdminUpdateExpertMutationOptions = Apollo.BaseMutationOptions<AdminUpdateExpertMutation, AdminUpdateExpertMutationVariables>;
export const CreateAttachmentDocument = gql`
    mutation createAttachment($input: CreateAttachmentInput!) {
  createAttachment(input: $input) {
    id
    url
    alt
    name
  }
}
    `;
export type CreateAttachmentMutationFn = Apollo.MutationFunction<CreateAttachmentMutation, CreateAttachmentMutationVariables>;

/**
 * __useCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentMutation, { data, loading, error }] = useCreateAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachmentMutation, CreateAttachmentMutationVariables>(CreateAttachmentDocument, options);
      }
export type CreateAttachmentMutationHookResult = ReturnType<typeof useCreateAttachmentMutation>;
export type CreateAttachmentMutationResult = Apollo.MutationResult<CreateAttachmentMutation>;
export type CreateAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>;
export const CreateVideoAttachmentDocument = gql`
    mutation createVideoAttachment($input: CreateAttachmentInput!) {
  createVideoAttachment(input: $input) {
    id
    url
    alt
  }
}
    `;
export type CreateVideoAttachmentMutationFn = Apollo.MutationFunction<CreateVideoAttachmentMutation, CreateVideoAttachmentMutationVariables>;

/**
 * __useCreateVideoAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateVideoAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoAttachmentMutation, { data, loading, error }] = useCreateVideoAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVideoAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoAttachmentMutation, CreateVideoAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoAttachmentMutation, CreateVideoAttachmentMutationVariables>(CreateVideoAttachmentDocument, options);
      }
export type CreateVideoAttachmentMutationHookResult = ReturnType<typeof useCreateVideoAttachmentMutation>;
export type CreateVideoAttachmentMutationResult = Apollo.MutationResult<CreateVideoAttachmentMutation>;
export type CreateVideoAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateVideoAttachmentMutation, CreateVideoAttachmentMutationVariables>;
export const GetBreadcrumbsByPathDocument = gql`
    query getBreadcrumbsByPath($path: String!) {
  getBreadcrumbsByPath(path: $path) {
    ariaLabel
    label
    link
    disabled
  }
}
    `;

/**
 * __useGetBreadcrumbsByPathQuery__
 *
 * To run a query within a React component, call `useGetBreadcrumbsByPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBreadcrumbsByPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBreadcrumbsByPathQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetBreadcrumbsByPathQuery(baseOptions: Apollo.QueryHookOptions<GetBreadcrumbsByPathQuery, GetBreadcrumbsByPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBreadcrumbsByPathQuery, GetBreadcrumbsByPathQueryVariables>(GetBreadcrumbsByPathDocument, options);
      }
export function useGetBreadcrumbsByPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBreadcrumbsByPathQuery, GetBreadcrumbsByPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBreadcrumbsByPathQuery, GetBreadcrumbsByPathQueryVariables>(GetBreadcrumbsByPathDocument, options);
        }
export type GetBreadcrumbsByPathQueryHookResult = ReturnType<typeof useGetBreadcrumbsByPathQuery>;
export type GetBreadcrumbsByPathLazyQueryHookResult = ReturnType<typeof useGetBreadcrumbsByPathLazyQuery>;
export type GetBreadcrumbsByPathQueryResult = Apollo.QueryResult<GetBreadcrumbsByPathQuery, GetBreadcrumbsByPathQueryVariables>;
export const CalculatePriceCheckoutDocument = gql`
    query calculatePriceCheckout($input: CheckoutInput!) {
  calculatePriceCheckout(input: $input) {
    totalPrice {
      total
      vat
      base
      vatRate
      currencyIsoCode
      calculatedPrices {
        currencyIsoCode
        total
      }
    }
    priceToPay {
      total
      vat
      base
      vatRate
      currencyIsoCode
      calculatedPrices {
        currencyIsoCode
        total
      }
    }
    totalDiscount {
      total
      base
      currencyIsoCode
      calculatedPrices {
        currencyIsoCode
        total
      }
    }
    nonPaymentMethodDiscountSum {
      total
      base
      currencyIsoCode
      calculatedPrices {
        currencyIsoCode
        total
      }
    }
    couponDiscountSum {
      total
      base
      currencyIsoCode
      calculatedPrices {
        currencyIsoCode
        total
      }
    }
    shippingPrice {
      base
      vat
      vatRate
      total
      currencyIsoCode
    }
    priceToPayWithoutShipping {
      base
      vat
      vatRate
      total
      currencyIsoCode
    }
    discountPercentage
    discountItems {
      checkoutItemId
      itemUnitDiscount {
        base
        total
      }
      itemId
      itemType
    }
    leftovers {
      coupon
    }
    vatToPayWithoutPaymentMethodDiscounts
    isTaxExemptionApplied
    retailSubtotalPrice {
      base
      vat
      vatRate
      total
      currencyIsoCode
    }
    tradeSubtotalPrice {
      base
      vat
      vatRate
      total
      currencyIsoCode
    }
  }
}
    `;

/**
 * __useCalculatePriceCheckoutQuery__
 *
 * To run a query within a React component, call `useCalculatePriceCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculatePriceCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculatePriceCheckoutQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculatePriceCheckoutQuery(baseOptions: Apollo.QueryHookOptions<CalculatePriceCheckoutQuery, CalculatePriceCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculatePriceCheckoutQuery, CalculatePriceCheckoutQueryVariables>(CalculatePriceCheckoutDocument, options);
      }
export function useCalculatePriceCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculatePriceCheckoutQuery, CalculatePriceCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculatePriceCheckoutQuery, CalculatePriceCheckoutQueryVariables>(CalculatePriceCheckoutDocument, options);
        }
export type CalculatePriceCheckoutQueryHookResult = ReturnType<typeof useCalculatePriceCheckoutQuery>;
export type CalculatePriceCheckoutLazyQueryHookResult = ReturnType<typeof useCalculatePriceCheckoutLazyQuery>;
export type CalculatePriceCheckoutQueryResult = Apollo.QueryResult<CalculatePriceCheckoutQuery, CalculatePriceCheckoutQueryVariables>;
export const CartDocument = gql`
    query Cart {
  cart {
    ...CartFields
    items {
      ... on CartItemProductVariant {
        metadata {
          ga4 {
            listIndex
            listName
          }
        }
      }
    }
  }
}
    ${CartFieldsFragmentDoc}`;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartQuery(baseOptions?: Apollo.QueryHookOptions<CartQuery, CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartQuery, CartQueryVariables>(CartDocument, options);
      }
export function useCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const UpdateCartShipmentAddressDocument = gql`
    mutation UpdateCartShipmentAddress($input: ShipmentAddress!) {
  updateCartShipmentAddress(input: $input) {
    ...CartFields
    items {
      ... on CartItemProductVariant {
        metadata {
          ga4 {
            listIndex
            listName
          }
        }
      }
    }
  }
}
    ${CartFieldsFragmentDoc}`;
export type UpdateCartShipmentAddressMutationFn = Apollo.MutationFunction<UpdateCartShipmentAddressMutation, UpdateCartShipmentAddressMutationVariables>;

/**
 * __useUpdateCartShipmentAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCartShipmentAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartShipmentAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartShipmentAddressMutation, { data, loading, error }] = useUpdateCartShipmentAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCartShipmentAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartShipmentAddressMutation, UpdateCartShipmentAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartShipmentAddressMutation, UpdateCartShipmentAddressMutationVariables>(UpdateCartShipmentAddressDocument, options);
      }
export type UpdateCartShipmentAddressMutationHookResult = ReturnType<typeof useUpdateCartShipmentAddressMutation>;
export type UpdateCartShipmentAddressMutationResult = Apollo.MutationResult<UpdateCartShipmentAddressMutation>;
export type UpdateCartShipmentAddressMutationOptions = Apollo.BaseMutationOptions<UpdateCartShipmentAddressMutation, UpdateCartShipmentAddressMutationVariables>;
export const CreateCheckoutDocument = gql`
    mutation createCheckout($input: CheckoutInput!, $requestSecret: Boolean!) {
  createCheckout(input: $input) {
    id
    stripePaymentId
    email
    totalPrice {
      total
      currencyIsoCode
    }
    coupon {
      id
    }
    promoCode {
      code
    }
    stripeClientSecret @include(if: $requestSecret)
    checkoutItems {
      edges {
        node {
          sessionBooking {
            id
            price {
              base
              vat
              total
            }
          }
          orderItem {
            orderId
            quantity
            price {
              base
              vat
              vatRate
              total
              currencyIsoCode
            }
            productVariant {
              id
              title
              sku
              product {
                title
                brand {
                  id
                }
                categoryOne {
                  name
                }
                categoryTwo {
                  name
                }
                categoryThree {
                  name
                }
              }
              managedCustomFields {
                leadTime
              }
              quantity
            }
            metadata {
              ga4 {
                listName
                listIndex
              }
            }
          }
          orderShipment {
            orderId
            price {
              base
            }
            shipmentData {
              ... on OrderShipmentArtaQuote {
                name
                type
                services {
                  name
                  subtype
                }
              }
              ... on OrderShipmentFreightClubQuote {
                name
                type
              }
              ... on OrderShipmentVendorShipping {
                name
                type
              }
            }
          }
          purchase {
            id
            totalPrice {
              base
            }
            tax {
              base
            }
            retailPrice {
              base
            }
            shippingPrice {
              base
            }
          }
          discountedPrice {
            base
            vat
            total
          }
          discounts {
            unitDiscount {
              total
            }
          }
        }
      }
    }
  }
}
    `;
export type CreateCheckoutMutationFn = Apollo.MutationFunction<CreateCheckoutMutation, CreateCheckoutMutationVariables>;

/**
 * __useCreateCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutMutation, { data, loading, error }] = useCreateCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *      requestSecret: // value for 'requestSecret'
 *   },
 * });
 */
export function useCreateCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutMutation, CreateCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutMutation, CreateCheckoutMutationVariables>(CreateCheckoutDocument, options);
      }
export type CreateCheckoutMutationHookResult = ReturnType<typeof useCreateCheckoutMutation>;
export type CreateCheckoutMutationResult = Apollo.MutationResult<CreateCheckoutMutation>;
export type CreateCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutMutation, CreateCheckoutMutationVariables>;
export const ConfirmCheckoutDocument = gql`
    mutation confirmCheckout($id: Int!) {
  confirmCheckout(id: $id) {
    stripePaymentStatus
  }
}
    `;
export type ConfirmCheckoutMutationFn = Apollo.MutationFunction<ConfirmCheckoutMutation, ConfirmCheckoutMutationVariables>;

/**
 * __useConfirmCheckoutMutation__
 *
 * To run a mutation, you first call `useConfirmCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCheckoutMutation, { data, loading, error }] = useConfirmCheckoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCheckoutMutation, ConfirmCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCheckoutMutation, ConfirmCheckoutMutationVariables>(ConfirmCheckoutDocument, options);
      }
export type ConfirmCheckoutMutationHookResult = ReturnType<typeof useConfirmCheckoutMutation>;
export type ConfirmCheckoutMutationResult = Apollo.MutationResult<ConfirmCheckoutMutation>;
export type ConfirmCheckoutMutationOptions = Apollo.BaseMutationOptions<ConfirmCheckoutMutation, ConfirmCheckoutMutationVariables>;
export const ClientMeOrdersDocument = gql`
    query clientMeOrders($id: Int!, $paginationInput: CursorPaginationInput!) {
  clientMe(id: $id) {
    id
    orders(input: $paginationInput) {
      ...BuyerOrdersDashboardOrdersData
    }
    purchases(input: $paginationInput) {
      edges {
        ...BuyerOrdersDashboardPurchaseEdges
      }
    }
  }
}
    ${BuyerOrdersDashboardOrdersDataFragmentDoc}
${BuyerOrdersDashboardPurchaseEdgesFragmentDoc}`;

/**
 * __useClientMeOrdersQuery__
 *
 * To run a query within a React component, call `useClientMeOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientMeOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientMeOrdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paginationInput: // value for 'paginationInput'
 *   },
 * });
 */
export function useClientMeOrdersQuery(baseOptions: Apollo.QueryHookOptions<ClientMeOrdersQuery, ClientMeOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientMeOrdersQuery, ClientMeOrdersQueryVariables>(ClientMeOrdersDocument, options);
      }
export function useClientMeOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientMeOrdersQuery, ClientMeOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientMeOrdersQuery, ClientMeOrdersQueryVariables>(ClientMeOrdersDocument, options);
        }
export type ClientMeOrdersQueryHookResult = ReturnType<typeof useClientMeOrdersQuery>;
export type ClientMeOrdersLazyQueryHookResult = ReturnType<typeof useClientMeOrdersLazyQuery>;
export type ClientMeOrdersQueryResult = Apollo.QueryResult<ClientMeOrdersQuery, ClientMeOrdersQueryVariables>;
export const ClientMeDocument = gql`
    query clientMe($id: Int!) {
  clientMe(id: $id) {
    id
    credits {
      total
      currencyIsoCode
      calculatedPrices {
        total
        currencyIsoCode
      }
    }
    cards {
      stripeId
      last4
      expiryYear
      expiryMonth
    }
    addresses {
      id
      fullName
      company
      phone
      addressLine1
      addressLine2
      zipCode
      countryIsoCode
      countryState
      city
      zipCode
      isPrimary
    }
  }
}
    `;

/**
 * __useClientMeQuery__
 *
 * To run a query within a React component, call `useClientMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientMeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientMeQuery(baseOptions: Apollo.QueryHookOptions<ClientMeQuery, ClientMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientMeQuery, ClientMeQueryVariables>(ClientMeDocument, options);
      }
export function useClientMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientMeQuery, ClientMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientMeQuery, ClientMeQueryVariables>(ClientMeDocument, options);
        }
export type ClientMeQueryHookResult = ReturnType<typeof useClientMeQuery>;
export type ClientMeLazyQueryHookResult = ReturnType<typeof useClientMeLazyQuery>;
export type ClientMeQueryResult = Apollo.QueryResult<ClientMeQuery, ClientMeQueryVariables>;
export const CreateClientAddressDocument = gql`
    mutation createClientAddress($input: CreateClientAddressInput!) {
  createClientAddress(input: $input) {
    id
  }
}
    `;
export type CreateClientAddressMutationFn = Apollo.MutationFunction<CreateClientAddressMutation, CreateClientAddressMutationVariables>;

/**
 * __useCreateClientAddressMutation__
 *
 * To run a mutation, you first call `useCreateClientAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientAddressMutation, { data, loading, error }] = useCreateClientAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientAddressMutation, CreateClientAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientAddressMutation, CreateClientAddressMutationVariables>(CreateClientAddressDocument, options);
      }
export type CreateClientAddressMutationHookResult = ReturnType<typeof useCreateClientAddressMutation>;
export type CreateClientAddressMutationResult = Apollo.MutationResult<CreateClientAddressMutation>;
export type CreateClientAddressMutationOptions = Apollo.BaseMutationOptions<CreateClientAddressMutation, CreateClientAddressMutationVariables>;
export const UpdateClientAddressDocument = gql`
    mutation updateClientAddress($input: UpdateClientAddressInput!) {
  updateClientAddress(input: $input) {
    id
  }
}
    `;
export type UpdateClientAddressMutationFn = Apollo.MutationFunction<UpdateClientAddressMutation, UpdateClientAddressMutationVariables>;

/**
 * __useUpdateClientAddressMutation__
 *
 * To run a mutation, you first call `useUpdateClientAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientAddressMutation, { data, loading, error }] = useUpdateClientAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientAddressMutation, UpdateClientAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientAddressMutation, UpdateClientAddressMutationVariables>(UpdateClientAddressDocument, options);
      }
export type UpdateClientAddressMutationHookResult = ReturnType<typeof useUpdateClientAddressMutation>;
export type UpdateClientAddressMutationResult = Apollo.MutationResult<UpdateClientAddressMutation>;
export type UpdateClientAddressMutationOptions = Apollo.BaseMutationOptions<UpdateClientAddressMutation, UpdateClientAddressMutationVariables>;
export const DeleteClientAddressDocument = gql`
    mutation deleteClientAddress($id: Int!) {
  deleteClientAddress(id: $id) {
    id
  }
}
    `;
export type DeleteClientAddressMutationFn = Apollo.MutationFunction<DeleteClientAddressMutation, DeleteClientAddressMutationVariables>;

/**
 * __useDeleteClientAddressMutation__
 *
 * To run a mutation, you first call `useDeleteClientAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientAddressMutation, { data, loading, error }] = useDeleteClientAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientAddressMutation, DeleteClientAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientAddressMutation, DeleteClientAddressMutationVariables>(DeleteClientAddressDocument, options);
      }
export type DeleteClientAddressMutationHookResult = ReturnType<typeof useDeleteClientAddressMutation>;
export type DeleteClientAddressMutationResult = Apollo.MutationResult<DeleteClientAddressMutation>;
export type DeleteClientAddressMutationOptions = Apollo.BaseMutationOptions<DeleteClientAddressMutation, DeleteClientAddressMutationVariables>;
export const ClientSubscribeToExpertAvailabilitiesDocument = gql`
    mutation clientSubscribeToExpertAvailabilities($input: ClientExpertAvailabilitySubscriptionInput!) {
  subscribeToExpertAvailability(input: $input)
}
    `;
export type ClientSubscribeToExpertAvailabilitiesMutationFn = Apollo.MutationFunction<ClientSubscribeToExpertAvailabilitiesMutation, ClientSubscribeToExpertAvailabilitiesMutationVariables>;

/**
 * __useClientSubscribeToExpertAvailabilitiesMutation__
 *
 * To run a mutation, you first call `useClientSubscribeToExpertAvailabilitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientSubscribeToExpertAvailabilitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientSubscribeToExpertAvailabilitiesMutation, { data, loading, error }] = useClientSubscribeToExpertAvailabilitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientSubscribeToExpertAvailabilitiesMutation(baseOptions?: Apollo.MutationHookOptions<ClientSubscribeToExpertAvailabilitiesMutation, ClientSubscribeToExpertAvailabilitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientSubscribeToExpertAvailabilitiesMutation, ClientSubscribeToExpertAvailabilitiesMutationVariables>(ClientSubscribeToExpertAvailabilitiesDocument, options);
      }
export type ClientSubscribeToExpertAvailabilitiesMutationHookResult = ReturnType<typeof useClientSubscribeToExpertAvailabilitiesMutation>;
export type ClientSubscribeToExpertAvailabilitiesMutationResult = Apollo.MutationResult<ClientSubscribeToExpertAvailabilitiesMutation>;
export type ClientSubscribeToExpertAvailabilitiesMutationOptions = Apollo.BaseMutationOptions<ClientSubscribeToExpertAvailabilitiesMutation, ClientSubscribeToExpertAvailabilitiesMutationVariables>;
export const SessionClientDocument = gql`
    query sessionClient($input: SessionClientInput!) {
  sessionClient(input: $input) {
    id
    attachments {
      id
      name
      url
      alt
    }
    questionnaireData
  }
}
    `;

/**
 * __useSessionClientQuery__
 *
 * To run a query within a React component, call `useSessionClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionClientQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionClientQuery(baseOptions: Apollo.QueryHookOptions<SessionClientQuery, SessionClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionClientQuery, SessionClientQueryVariables>(SessionClientDocument, options);
      }
export function useSessionClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionClientQuery, SessionClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionClientQuery, SessionClientQueryVariables>(SessionClientDocument, options);
        }
export type SessionClientQueryHookResult = ReturnType<typeof useSessionClientQuery>;
export type SessionClientLazyQueryHookResult = ReturnType<typeof useSessionClientLazyQuery>;
export type SessionClientQueryResult = Apollo.QueryResult<SessionClientQuery, SessionClientQueryVariables>;
export const SessionClientDeleteAttachmentDocument = gql`
    mutation sessionClientDeleteAttachment($input: DeleteSessionClientAttachmentInput!) {
  deleteSessionClientAttachment(input: $input) {
    id
  }
}
    `;
export type SessionClientDeleteAttachmentMutationFn = Apollo.MutationFunction<SessionClientDeleteAttachmentMutation, SessionClientDeleteAttachmentMutationVariables>;

/**
 * __useSessionClientDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useSessionClientDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionClientDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionClientDeleteAttachmentMutation, { data, loading, error }] = useSessionClientDeleteAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionClientDeleteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<SessionClientDeleteAttachmentMutation, SessionClientDeleteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionClientDeleteAttachmentMutation, SessionClientDeleteAttachmentMutationVariables>(SessionClientDeleteAttachmentDocument, options);
      }
export type SessionClientDeleteAttachmentMutationHookResult = ReturnType<typeof useSessionClientDeleteAttachmentMutation>;
export type SessionClientDeleteAttachmentMutationResult = Apollo.MutationResult<SessionClientDeleteAttachmentMutation>;
export type SessionClientDeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<SessionClientDeleteAttachmentMutation, SessionClientDeleteAttachmentMutationVariables>;
export const SessionClientUploadAttachmentDocument = gql`
    mutation sessionClientUploadAttachment($input: CreateSessionClientAttachmentInput!) {
  createSessionClientAttachment(input: $input) {
    id
    attachment {
      id
      url
      alt
    }
  }
}
    `;
export type SessionClientUploadAttachmentMutationFn = Apollo.MutationFunction<SessionClientUploadAttachmentMutation, SessionClientUploadAttachmentMutationVariables>;

/**
 * __useSessionClientUploadAttachmentMutation__
 *
 * To run a mutation, you first call `useSessionClientUploadAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionClientUploadAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionClientUploadAttachmentMutation, { data, loading, error }] = useSessionClientUploadAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionClientUploadAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<SessionClientUploadAttachmentMutation, SessionClientUploadAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionClientUploadAttachmentMutation, SessionClientUploadAttachmentMutationVariables>(SessionClientUploadAttachmentDocument, options);
      }
export type SessionClientUploadAttachmentMutationHookResult = ReturnType<typeof useSessionClientUploadAttachmentMutation>;
export type SessionClientUploadAttachmentMutationResult = Apollo.MutationResult<SessionClientUploadAttachmentMutation>;
export type SessionClientUploadAttachmentMutationOptions = Apollo.BaseMutationOptions<SessionClientUploadAttachmentMutation, SessionClientUploadAttachmentMutationVariables>;
export const UpdateClientBusinessNameDocument = gql`
    mutation updateClientBusinessName($input: UpdateClientBusinessNameInput!) {
  updateClientBusinessName(input: $input) {
    id
  }
}
    `;
export type UpdateClientBusinessNameMutationFn = Apollo.MutationFunction<UpdateClientBusinessNameMutation, UpdateClientBusinessNameMutationVariables>;

/**
 * __useUpdateClientBusinessNameMutation__
 *
 * To run a mutation, you first call `useUpdateClientBusinessNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientBusinessNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientBusinessNameMutation, { data, loading, error }] = useUpdateClientBusinessNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientBusinessNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientBusinessNameMutation, UpdateClientBusinessNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientBusinessNameMutation, UpdateClientBusinessNameMutationVariables>(UpdateClientBusinessNameDocument, options);
      }
export type UpdateClientBusinessNameMutationHookResult = ReturnType<typeof useUpdateClientBusinessNameMutation>;
export type UpdateClientBusinessNameMutationResult = Apollo.MutationResult<UpdateClientBusinessNameMutation>;
export type UpdateClientBusinessNameMutationOptions = Apollo.BaseMutationOptions<UpdateClientBusinessNameMutation, UpdateClientBusinessNameMutationVariables>;
export const MigrateClientToExpertDocument = gql`
    mutation migrateClientToExpert($input: MigrateClientToExpertInput!) {
  migrateClientToExpert(input: $input) {
    id
  }
}
    `;
export type MigrateClientToExpertMutationFn = Apollo.MutationFunction<MigrateClientToExpertMutation, MigrateClientToExpertMutationVariables>;

/**
 * __useMigrateClientToExpertMutation__
 *
 * To run a mutation, you first call `useMigrateClientToExpertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateClientToExpertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateClientToExpertMutation, { data, loading, error }] = useMigrateClientToExpertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMigrateClientToExpertMutation(baseOptions?: Apollo.MutationHookOptions<MigrateClientToExpertMutation, MigrateClientToExpertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateClientToExpertMutation, MigrateClientToExpertMutationVariables>(MigrateClientToExpertDocument, options);
      }
export type MigrateClientToExpertMutationHookResult = ReturnType<typeof useMigrateClientToExpertMutation>;
export type MigrateClientToExpertMutationResult = Apollo.MutationResult<MigrateClientToExpertMutation>;
export type MigrateClientToExpertMutationOptions = Apollo.BaseMutationOptions<MigrateClientToExpertMutation, MigrateClientToExpertMutationVariables>;
export const ClientPastSessionsDocument = gql`
    query clientPastSessions($input: ClientBookedSessionsInput) {
  clientBookedSessions(input: $input) {
    data {
      id
      expertUser {
        firstName
        lastName
      }
      sessionData {
        title
        price {
          total
          currencyIsoCode
        }
        lengthInMinutes
      }
      sessionClient {
        report {
          id
        }
        reviewToken
      }
      startAtUtc {
        isoFormat
      }
      endAtUtc {
        isoFormat
      }
      couponDiscountPrice {
        total
        currencyIsoCode
      }
      promoCodeAmount
      payPrice {
        total
        currencyIsoCode
        calculatedPrices {
          total
          currencyIsoCode
        }
      }
    }
  }
}
    `;

/**
 * __useClientPastSessionsQuery__
 *
 * To run a query within a React component, call `useClientPastSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientPastSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientPastSessionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientPastSessionsQuery(baseOptions?: Apollo.QueryHookOptions<ClientPastSessionsQuery, ClientPastSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientPastSessionsQuery, ClientPastSessionsQueryVariables>(ClientPastSessionsDocument, options);
      }
export function useClientPastSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientPastSessionsQuery, ClientPastSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientPastSessionsQuery, ClientPastSessionsQueryVariables>(ClientPastSessionsDocument, options);
        }
export type ClientPastSessionsQueryHookResult = ReturnType<typeof useClientPastSessionsQuery>;
export type ClientPastSessionsLazyQueryHookResult = ReturnType<typeof useClientPastSessionsLazyQuery>;
export type ClientPastSessionsQueryResult = Apollo.QueryResult<ClientPastSessionsQuery, ClientPastSessionsQueryVariables>;
export const ClientUpcomingSessionsDocument = gql`
    query clientUpcomingSessions($input: ClientBookedSessionsInput) {
  clientBookedSessions(input: $input) {
    data {
      id
      expert {
        slug
        profileName
      }
      sessionClient {
        id
        attachments {
          name
          id
        }
        clientDescription
        guests
        questionnaireData
      }
      sessionData {
        title
        sessionType
        lengthInMinutes
        price {
          total
          currencyIsoCode
        }
      }
      startAtUtc {
        isoFormat
      }
      endAtUtc {
        isoFormat
      }
      zoomSession {
        id
        url
      }
      promoCodeAmount
      couponDiscountPrice {
        total
        currencyIsoCode
      }
      payPrice {
        total
        currencyIsoCode
        calculatedPrices {
          total
          currencyIsoCode
        }
      }
      status
    }
  }
}
    `;

/**
 * __useClientUpcomingSessionsQuery__
 *
 * To run a query within a React component, call `useClientUpcomingSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientUpcomingSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientUpcomingSessionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientUpcomingSessionsQuery(baseOptions?: Apollo.QueryHookOptions<ClientUpcomingSessionsQuery, ClientUpcomingSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientUpcomingSessionsQuery, ClientUpcomingSessionsQueryVariables>(ClientUpcomingSessionsDocument, options);
      }
export function useClientUpcomingSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientUpcomingSessionsQuery, ClientUpcomingSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientUpcomingSessionsQuery, ClientUpcomingSessionsQueryVariables>(ClientUpcomingSessionsDocument, options);
        }
export type ClientUpcomingSessionsQueryHookResult = ReturnType<typeof useClientUpcomingSessionsQuery>;
export type ClientUpcomingSessionsLazyQueryHookResult = ReturnType<typeof useClientUpcomingSessionsLazyQuery>;
export type ClientUpcomingSessionsQueryResult = Apollo.QueryResult<ClientUpcomingSessionsQuery, ClientUpcomingSessionsQueryVariables>;
export const CmsArticlePageSlugsDocument = gql`
    query cmsArticlePageSlugs {
  cmsArticlePageSlugs
}
    `;

/**
 * __useCmsArticlePageSlugsQuery__
 *
 * To run a query within a React component, call `useCmsArticlePageSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsArticlePageSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsArticlePageSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCmsArticlePageSlugsQuery(baseOptions?: Apollo.QueryHookOptions<CmsArticlePageSlugsQuery, CmsArticlePageSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsArticlePageSlugsQuery, CmsArticlePageSlugsQueryVariables>(CmsArticlePageSlugsDocument, options);
      }
export function useCmsArticlePageSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsArticlePageSlugsQuery, CmsArticlePageSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsArticlePageSlugsQuery, CmsArticlePageSlugsQueryVariables>(CmsArticlePageSlugsDocument, options);
        }
export type CmsArticlePageSlugsQueryHookResult = ReturnType<typeof useCmsArticlePageSlugsQuery>;
export type CmsArticlePageSlugsLazyQueryHookResult = ReturnType<typeof useCmsArticlePageSlugsLazyQuery>;
export type CmsArticlePageSlugsQueryResult = Apollo.QueryResult<CmsArticlePageSlugsQuery, CmsArticlePageSlugsQueryVariables>;
export const DeleteCmsArticlePageDocument = gql`
    mutation deleteCmsArticlePage($id: Int!) {
  deleteCmsArticlePage(id: $id) {
    id
  }
}
    `;
export type DeleteCmsArticlePageMutationFn = Apollo.MutationFunction<DeleteCmsArticlePageMutation, DeleteCmsArticlePageMutationVariables>;

/**
 * __useDeleteCmsArticlePageMutation__
 *
 * To run a mutation, you first call `useDeleteCmsArticlePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCmsArticlePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCmsArticlePageMutation, { data, loading, error }] = useDeleteCmsArticlePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCmsArticlePageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCmsArticlePageMutation, DeleteCmsArticlePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCmsArticlePageMutation, DeleteCmsArticlePageMutationVariables>(DeleteCmsArticlePageDocument, options);
      }
export type DeleteCmsArticlePageMutationHookResult = ReturnType<typeof useDeleteCmsArticlePageMutation>;
export type DeleteCmsArticlePageMutationResult = Apollo.MutationResult<DeleteCmsArticlePageMutation>;
export type DeleteCmsArticlePageMutationOptions = Apollo.BaseMutationOptions<DeleteCmsArticlePageMutation, DeleteCmsArticlePageMutationVariables>;
export const UpdateCmsArticlePageDocument = gql`
    mutation updateCmsArticlePage($input: UpdateCMSArticlePageInput!) {
  updateCmsArticlePage(input: $input) {
    ...AdminCMSArticlePageFields
  }
}
    ${AdminCmsArticlePageFieldsFragmentDoc}`;
export type UpdateCmsArticlePageMutationFn = Apollo.MutationFunction<UpdateCmsArticlePageMutation, UpdateCmsArticlePageMutationVariables>;

/**
 * __useUpdateCmsArticlePageMutation__
 *
 * To run a mutation, you first call `useUpdateCmsArticlePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCmsArticlePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCmsArticlePageMutation, { data, loading, error }] = useUpdateCmsArticlePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCmsArticlePageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCmsArticlePageMutation, UpdateCmsArticlePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCmsArticlePageMutation, UpdateCmsArticlePageMutationVariables>(UpdateCmsArticlePageDocument, options);
      }
export type UpdateCmsArticlePageMutationHookResult = ReturnType<typeof useUpdateCmsArticlePageMutation>;
export type UpdateCmsArticlePageMutationResult = Apollo.MutationResult<UpdateCmsArticlePageMutation>;
export type UpdateCmsArticlePageMutationOptions = Apollo.BaseMutationOptions<UpdateCmsArticlePageMutation, UpdateCmsArticlePageMutationVariables>;
export const CmsArticlePageDocument = gql`
    query cmsArticlePage($input: CMSArticlePageInput!) {
  cmsArticlePage(input: $input) {
    ...AdminCMSArticlePageFields
  }
}
    ${AdminCmsArticlePageFieldsFragmentDoc}`;

/**
 * __useCmsArticlePageQuery__
 *
 * To run a query within a React component, call `useCmsArticlePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsArticlePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsArticlePageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCmsArticlePageQuery(baseOptions: Apollo.QueryHookOptions<CmsArticlePageQuery, CmsArticlePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsArticlePageQuery, CmsArticlePageQueryVariables>(CmsArticlePageDocument, options);
      }
export function useCmsArticlePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsArticlePageQuery, CmsArticlePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsArticlePageQuery, CmsArticlePageQueryVariables>(CmsArticlePageDocument, options);
        }
export type CmsArticlePageQueryHookResult = ReturnType<typeof useCmsArticlePageQuery>;
export type CmsArticlePageLazyQueryHookResult = ReturnType<typeof useCmsArticlePageLazyQuery>;
export type CmsArticlePageQueryResult = Apollo.QueryResult<CmsArticlePageQuery, CmsArticlePageQueryVariables>;
export const ValidateAvailableCmsArticlePageSlugDocument = gql`
    query validateAvailableCmsArticlePageSlug($input: ValidateAvailableCmsPageSlugInput!) {
  validateAvailableCmsArticlePageSlug(input: $input)
}
    `;

/**
 * __useValidateAvailableCmsArticlePageSlugQuery__
 *
 * To run a query within a React component, call `useValidateAvailableCmsArticlePageSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateAvailableCmsArticlePageSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateAvailableCmsArticlePageSlugQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateAvailableCmsArticlePageSlugQuery(baseOptions: Apollo.QueryHookOptions<ValidateAvailableCmsArticlePageSlugQuery, ValidateAvailableCmsArticlePageSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateAvailableCmsArticlePageSlugQuery, ValidateAvailableCmsArticlePageSlugQueryVariables>(ValidateAvailableCmsArticlePageSlugDocument, options);
      }
export function useValidateAvailableCmsArticlePageSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateAvailableCmsArticlePageSlugQuery, ValidateAvailableCmsArticlePageSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateAvailableCmsArticlePageSlugQuery, ValidateAvailableCmsArticlePageSlugQueryVariables>(ValidateAvailableCmsArticlePageSlugDocument, options);
        }
export type ValidateAvailableCmsArticlePageSlugQueryHookResult = ReturnType<typeof useValidateAvailableCmsArticlePageSlugQuery>;
export type ValidateAvailableCmsArticlePageSlugLazyQueryHookResult = ReturnType<typeof useValidateAvailableCmsArticlePageSlugLazyQuery>;
export type ValidateAvailableCmsArticlePageSlugQueryResult = Apollo.QueryResult<ValidateAvailableCmsArticlePageSlugQuery, ValidateAvailableCmsArticlePageSlugQueryVariables>;
export const CreateCmsArticlePageDocument = gql`
    mutation createCmsArticlePage($input: CreateCMSArticlePageInput!) {
  createCmsArticlePage(input: $input) {
    ...AdminCMSArticlePageFields
  }
}
    ${AdminCmsArticlePageFieldsFragmentDoc}`;
export type CreateCmsArticlePageMutationFn = Apollo.MutationFunction<CreateCmsArticlePageMutation, CreateCmsArticlePageMutationVariables>;

/**
 * __useCreateCmsArticlePageMutation__
 *
 * To run a mutation, you first call `useCreateCmsArticlePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCmsArticlePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCmsArticlePageMutation, { data, loading, error }] = useCreateCmsArticlePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCmsArticlePageMutation(baseOptions?: Apollo.MutationHookOptions<CreateCmsArticlePageMutation, CreateCmsArticlePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCmsArticlePageMutation, CreateCmsArticlePageMutationVariables>(CreateCmsArticlePageDocument, options);
      }
export type CreateCmsArticlePageMutationHookResult = ReturnType<typeof useCreateCmsArticlePageMutation>;
export type CreateCmsArticlePageMutationResult = Apollo.MutationResult<CreateCmsArticlePageMutation>;
export type CreateCmsArticlePageMutationOptions = Apollo.BaseMutationOptions<CreateCmsArticlePageMutation, CreateCmsArticlePageMutationVariables>;
export const CmsBrandPageBySlugDocument = gql`
    query cmsBrandPageBySlug($slug: String!, $widgetsDefaultInputs: WidgetsDefaultInputs) {
  cmsBrandPageBySlug(slug: $slug) {
    id
    cmsPage {
      id
      title
      metaDescription
      metaTitle
      keywords
      href
      widgets(widgetsDefaultInputs: $widgetsDefaultInputs) @connection(key: $slug) {
        ...CMSWidgetFields
      }
    }
  }
}
    ${CmsWidgetFieldsFragmentDoc}`;

/**
 * __useCmsBrandPageBySlugQuery__
 *
 * To run a query within a React component, call `useCmsBrandPageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsBrandPageBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsBrandPageBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      widgetsDefaultInputs: // value for 'widgetsDefaultInputs'
 *   },
 * });
 */
export function useCmsBrandPageBySlugQuery(baseOptions: Apollo.QueryHookOptions<CmsBrandPageBySlugQuery, CmsBrandPageBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsBrandPageBySlugQuery, CmsBrandPageBySlugQueryVariables>(CmsBrandPageBySlugDocument, options);
      }
export function useCmsBrandPageBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsBrandPageBySlugQuery, CmsBrandPageBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsBrandPageBySlugQuery, CmsBrandPageBySlugQueryVariables>(CmsBrandPageBySlugDocument, options);
        }
export type CmsBrandPageBySlugQueryHookResult = ReturnType<typeof useCmsBrandPageBySlugQuery>;
export type CmsBrandPageBySlugLazyQueryHookResult = ReturnType<typeof useCmsBrandPageBySlugLazyQuery>;
export type CmsBrandPageBySlugQueryResult = Apollo.QueryResult<CmsBrandPageBySlugQuery, CmsBrandPageBySlugQueryVariables>;
export const CmsBrandPageSlugsDocument = gql`
    query cmsBrandPageSlugs {
  cmsBrandPageSlugs
}
    `;

/**
 * __useCmsBrandPageSlugsQuery__
 *
 * To run a query within a React component, call `useCmsBrandPageSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsBrandPageSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsBrandPageSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCmsBrandPageSlugsQuery(baseOptions?: Apollo.QueryHookOptions<CmsBrandPageSlugsQuery, CmsBrandPageSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsBrandPageSlugsQuery, CmsBrandPageSlugsQueryVariables>(CmsBrandPageSlugsDocument, options);
      }
export function useCmsBrandPageSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsBrandPageSlugsQuery, CmsBrandPageSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsBrandPageSlugsQuery, CmsBrandPageSlugsQueryVariables>(CmsBrandPageSlugsDocument, options);
        }
export type CmsBrandPageSlugsQueryHookResult = ReturnType<typeof useCmsBrandPageSlugsQuery>;
export type CmsBrandPageSlugsLazyQueryHookResult = ReturnType<typeof useCmsBrandPageSlugsLazyQuery>;
export type CmsBrandPageSlugsQueryResult = Apollo.QueryResult<CmsBrandPageSlugsQuery, CmsBrandPageSlugsQueryVariables>;
export const CmsBrandPageBySlug2Document = gql`
    query cmsBrandPageBySlug2($slug: String!, $widgetsDefaultInputs: WidgetsDefaultInputs) {
  cmsBrandPageBySlug(slug: $slug) {
    id
    cmsPage {
      id
      title
      metaDescription
      metaTitle
      keywords
      href
    }
  }
}
    `;

/**
 * __useCmsBrandPageBySlug2Query__
 *
 * To run a query within a React component, call `useCmsBrandPageBySlug2Query` and pass it any options that fit your needs.
 * When your component renders, `useCmsBrandPageBySlug2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsBrandPageBySlug2Query({
 *   variables: {
 *      slug: // value for 'slug'
 *      widgetsDefaultInputs: // value for 'widgetsDefaultInputs'
 *   },
 * });
 */
export function useCmsBrandPageBySlug2Query(baseOptions: Apollo.QueryHookOptions<CmsBrandPageBySlug2Query, CmsBrandPageBySlug2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsBrandPageBySlug2Query, CmsBrandPageBySlug2QueryVariables>(CmsBrandPageBySlug2Document, options);
      }
export function useCmsBrandPageBySlug2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsBrandPageBySlug2Query, CmsBrandPageBySlug2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsBrandPageBySlug2Query, CmsBrandPageBySlug2QueryVariables>(CmsBrandPageBySlug2Document, options);
        }
export type CmsBrandPageBySlug2QueryHookResult = ReturnType<typeof useCmsBrandPageBySlug2Query>;
export type CmsBrandPageBySlug2LazyQueryHookResult = ReturnType<typeof useCmsBrandPageBySlug2LazyQuery>;
export type CmsBrandPageBySlug2QueryResult = Apollo.QueryResult<CmsBrandPageBySlug2Query, CmsBrandPageBySlug2QueryVariables>;
export const CmsCategoryPageSlugsDocument = gql`
    query cmsCategoryPageSlugs {
  cmsCategoryPageSlugs
}
    `;

/**
 * __useCmsCategoryPageSlugsQuery__
 *
 * To run a query within a React component, call `useCmsCategoryPageSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsCategoryPageSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsCategoryPageSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCmsCategoryPageSlugsQuery(baseOptions?: Apollo.QueryHookOptions<CmsCategoryPageSlugsQuery, CmsCategoryPageSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsCategoryPageSlugsQuery, CmsCategoryPageSlugsQueryVariables>(CmsCategoryPageSlugsDocument, options);
      }
export function useCmsCategoryPageSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsCategoryPageSlugsQuery, CmsCategoryPageSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsCategoryPageSlugsQuery, CmsCategoryPageSlugsQueryVariables>(CmsCategoryPageSlugsDocument, options);
        }
export type CmsCategoryPageSlugsQueryHookResult = ReturnType<typeof useCmsCategoryPageSlugsQuery>;
export type CmsCategoryPageSlugsLazyQueryHookResult = ReturnType<typeof useCmsCategoryPageSlugsLazyQuery>;
export type CmsCategoryPageSlugsQueryResult = Apollo.QueryResult<CmsCategoryPageSlugsQuery, CmsCategoryPageSlugsQueryVariables>;
export const CmsCategoryPageAdminDocument = gql`
    query cmsCategoryPageAdmin($input: CMSCategoryPageInput!) {
  cmsCategoryPage(input: $input) {
    ...AdminCMSCategoryPageFields
  }
}
    ${AdminCmsCategoryPageFieldsFragmentDoc}`;

/**
 * __useCmsCategoryPageAdminQuery__
 *
 * To run a query within a React component, call `useCmsCategoryPageAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsCategoryPageAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsCategoryPageAdminQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCmsCategoryPageAdminQuery(baseOptions: Apollo.QueryHookOptions<CmsCategoryPageAdminQuery, CmsCategoryPageAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsCategoryPageAdminQuery, CmsCategoryPageAdminQueryVariables>(CmsCategoryPageAdminDocument, options);
      }
export function useCmsCategoryPageAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsCategoryPageAdminQuery, CmsCategoryPageAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsCategoryPageAdminQuery, CmsCategoryPageAdminQueryVariables>(CmsCategoryPageAdminDocument, options);
        }
export type CmsCategoryPageAdminQueryHookResult = ReturnType<typeof useCmsCategoryPageAdminQuery>;
export type CmsCategoryPageAdminLazyQueryHookResult = ReturnType<typeof useCmsCategoryPageAdminLazyQuery>;
export type CmsCategoryPageAdminQueryResult = Apollo.QueryResult<CmsCategoryPageAdminQuery, CmsCategoryPageAdminQueryVariables>;
export const UpdateCmsCategoryPageDocument = gql`
    mutation updateCmsCategoryPage($input: UpdateCMSCategoryPageInput!) {
  updateCmsCategoryPage(input: $input) {
    ...AdminCMSCategoryPageFields
  }
}
    ${AdminCmsCategoryPageFieldsFragmentDoc}`;
export type UpdateCmsCategoryPageMutationFn = Apollo.MutationFunction<UpdateCmsCategoryPageMutation, UpdateCmsCategoryPageMutationVariables>;

/**
 * __useUpdateCmsCategoryPageMutation__
 *
 * To run a mutation, you first call `useUpdateCmsCategoryPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCmsCategoryPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCmsCategoryPageMutation, { data, loading, error }] = useUpdateCmsCategoryPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCmsCategoryPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCmsCategoryPageMutation, UpdateCmsCategoryPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCmsCategoryPageMutation, UpdateCmsCategoryPageMutationVariables>(UpdateCmsCategoryPageDocument, options);
      }
export type UpdateCmsCategoryPageMutationHookResult = ReturnType<typeof useUpdateCmsCategoryPageMutation>;
export type UpdateCmsCategoryPageMutationResult = Apollo.MutationResult<UpdateCmsCategoryPageMutation>;
export type UpdateCmsCategoryPageMutationOptions = Apollo.BaseMutationOptions<UpdateCmsCategoryPageMutation, UpdateCmsCategoryPageMutationVariables>;
export const CmsCategoryPageBySlugDocument = gql`
    query cmsCategoryPageBySlug($slug: String!, $widgetsDefaultInputs: WidgetsDefaultInputs) {
  cmsCategoryPageBySlug(slug: $slug) {
    id
    cmsPage {
      id
      title
      metaDescription
      metaTitle
      keywords
      href
      widgets(widgetsDefaultInputs: $widgetsDefaultInputs) @connection(key: $slug) {
        ...CMSWidgetFields
      }
    }
    productCategory {
      name
      parentCategory {
        name
        parentCategory {
          name
        }
      }
    }
  }
}
    ${CmsWidgetFieldsFragmentDoc}`;

/**
 * __useCmsCategoryPageBySlugQuery__
 *
 * To run a query within a React component, call `useCmsCategoryPageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsCategoryPageBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsCategoryPageBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      widgetsDefaultInputs: // value for 'widgetsDefaultInputs'
 *   },
 * });
 */
export function useCmsCategoryPageBySlugQuery(baseOptions: Apollo.QueryHookOptions<CmsCategoryPageBySlugQuery, CmsCategoryPageBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsCategoryPageBySlugQuery, CmsCategoryPageBySlugQueryVariables>(CmsCategoryPageBySlugDocument, options);
      }
export function useCmsCategoryPageBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsCategoryPageBySlugQuery, CmsCategoryPageBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsCategoryPageBySlugQuery, CmsCategoryPageBySlugQueryVariables>(CmsCategoryPageBySlugDocument, options);
        }
export type CmsCategoryPageBySlugQueryHookResult = ReturnType<typeof useCmsCategoryPageBySlugQuery>;
export type CmsCategoryPageBySlugLazyQueryHookResult = ReturnType<typeof useCmsCategoryPageBySlugLazyQuery>;
export type CmsCategoryPageBySlugQueryResult = Apollo.QueryResult<CmsCategoryPageBySlugQuery, CmsCategoryPageBySlugQueryVariables>;
export const CmsConsultationPageBySlugDocument = gql`
    query cmsConsultationPageBySlug($slug: String!, $widgetsDefaultInputs: WidgetsDefaultInputs) {
  cmsConsultationPageBySlug(slug: $slug) {
    cmsPage {
      title
      metaDescription
      metaTitle
      keywords
      href
      widgets(widgetsDefaultInputs: $widgetsDefaultInputs) @connection(key: $slug) {
        ...CMSWidgetFields
      }
    }
  }
}
    ${CmsWidgetFieldsFragmentDoc}`;

/**
 * __useCmsConsultationPageBySlugQuery__
 *
 * To run a query within a React component, call `useCmsConsultationPageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsConsultationPageBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsConsultationPageBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      widgetsDefaultInputs: // value for 'widgetsDefaultInputs'
 *   },
 * });
 */
export function useCmsConsultationPageBySlugQuery(baseOptions: Apollo.QueryHookOptions<CmsConsultationPageBySlugQuery, CmsConsultationPageBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsConsultationPageBySlugQuery, CmsConsultationPageBySlugQueryVariables>(CmsConsultationPageBySlugDocument, options);
      }
export function useCmsConsultationPageBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsConsultationPageBySlugQuery, CmsConsultationPageBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsConsultationPageBySlugQuery, CmsConsultationPageBySlugQueryVariables>(CmsConsultationPageBySlugDocument, options);
        }
export type CmsConsultationPageBySlugQueryHookResult = ReturnType<typeof useCmsConsultationPageBySlugQuery>;
export type CmsConsultationPageBySlugLazyQueryHookResult = ReturnType<typeof useCmsConsultationPageBySlugLazyQuery>;
export type CmsConsultationPageBySlugQueryResult = Apollo.QueryResult<CmsConsultationPageBySlugQuery, CmsConsultationPageBySlugQueryVariables>;
export const CmsConsultationPagePreviewDocument = gql`
    query cmsConsultationPagePreview($slug: String!, $widgetsDefaultInputs: WidgetsDefaultInputs) {
  cmsConsultationPagePreview(slug: $slug) {
    cmsPage {
      title
      metaDescription
      metaTitle
      keywords
      href
      widgets(widgetsDefaultInputs: $widgetsDefaultInputs) @connection(key: $slug) {
        ...CMSWidgetFields
      }
    }
  }
}
    ${CmsWidgetFieldsFragmentDoc}`;

/**
 * __useCmsConsultationPagePreviewQuery__
 *
 * To run a query within a React component, call `useCmsConsultationPagePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsConsultationPagePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsConsultationPagePreviewQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      widgetsDefaultInputs: // value for 'widgetsDefaultInputs'
 *   },
 * });
 */
export function useCmsConsultationPagePreviewQuery(baseOptions: Apollo.QueryHookOptions<CmsConsultationPagePreviewQuery, CmsConsultationPagePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsConsultationPagePreviewQuery, CmsConsultationPagePreviewQueryVariables>(CmsConsultationPagePreviewDocument, options);
      }
export function useCmsConsultationPagePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsConsultationPagePreviewQuery, CmsConsultationPagePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsConsultationPagePreviewQuery, CmsConsultationPagePreviewQueryVariables>(CmsConsultationPagePreviewDocument, options);
        }
export type CmsConsultationPagePreviewQueryHookResult = ReturnType<typeof useCmsConsultationPagePreviewQuery>;
export type CmsConsultationPagePreviewLazyQueryHookResult = ReturnType<typeof useCmsConsultationPagePreviewLazyQuery>;
export type CmsConsultationPagePreviewQueryResult = Apollo.QueryResult<CmsConsultationPagePreviewQuery, CmsConsultationPagePreviewQueryVariables>;
export const CmsConsultationPageSlugsDocument = gql`
    query cmsConsultationPageSlugs {
  cmsConsultationPageSlugs
}
    `;

/**
 * __useCmsConsultationPageSlugsQuery__
 *
 * To run a query within a React component, call `useCmsConsultationPageSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsConsultationPageSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsConsultationPageSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCmsConsultationPageSlugsQuery(baseOptions?: Apollo.QueryHookOptions<CmsConsultationPageSlugsQuery, CmsConsultationPageSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsConsultationPageSlugsQuery, CmsConsultationPageSlugsQueryVariables>(CmsConsultationPageSlugsDocument, options);
      }
export function useCmsConsultationPageSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsConsultationPageSlugsQuery, CmsConsultationPageSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsConsultationPageSlugsQuery, CmsConsultationPageSlugsQueryVariables>(CmsConsultationPageSlugsDocument, options);
        }
export type CmsConsultationPageSlugsQueryHookResult = ReturnType<typeof useCmsConsultationPageSlugsQuery>;
export type CmsConsultationPageSlugsLazyQueryHookResult = ReturnType<typeof useCmsConsultationPageSlugsLazyQuery>;
export type CmsConsultationPageSlugsQueryResult = Apollo.QueryResult<CmsConsultationPageSlugsQuery, CmsConsultationPageSlugsQueryVariables>;
export const CmsExpertPageBySlugDocument = gql`
    query cmsExpertPageBySlug($slug: String!, $widgetsDefaultInputs: WidgetsDefaultInputs) {
  cmsExpertPageBySlug(slug: $slug) {
    id
    cmsPage {
      id
      title
      metaDescription
      metaTitle
      keywords
      href
      widgets(widgetsDefaultInputs: $widgetsDefaultInputs) @connection(key: $slug) {
        ...CMSWidgetFields
      }
    }
  }
}
    ${CmsWidgetFieldsFragmentDoc}`;

/**
 * __useCmsExpertPageBySlugQuery__
 *
 * To run a query within a React component, call `useCmsExpertPageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsExpertPageBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsExpertPageBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      widgetsDefaultInputs: // value for 'widgetsDefaultInputs'
 *   },
 * });
 */
export function useCmsExpertPageBySlugQuery(baseOptions: Apollo.QueryHookOptions<CmsExpertPageBySlugQuery, CmsExpertPageBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsExpertPageBySlugQuery, CmsExpertPageBySlugQueryVariables>(CmsExpertPageBySlugDocument, options);
      }
export function useCmsExpertPageBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsExpertPageBySlugQuery, CmsExpertPageBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsExpertPageBySlugQuery, CmsExpertPageBySlugQueryVariables>(CmsExpertPageBySlugDocument, options);
        }
export type CmsExpertPageBySlugQueryHookResult = ReturnType<typeof useCmsExpertPageBySlugQuery>;
export type CmsExpertPageBySlugLazyQueryHookResult = ReturnType<typeof useCmsExpertPageBySlugLazyQuery>;
export type CmsExpertPageBySlugQueryResult = Apollo.QueryResult<CmsExpertPageBySlugQuery, CmsExpertPageBySlugQueryVariables>;
export const GetExpertSessionsByExpertIdDocument = gql`
    query getExpertSessionsByExpertId($input: Int!) {
  expert(id: $input) {
    sessions {
      price {
        total
        currencyIsoCode
      }
      lengthInMinutes
    }
  }
}
    `;

/**
 * __useGetExpertSessionsByExpertIdQuery__
 *
 * To run a query within a React component, call `useGetExpertSessionsByExpertIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpertSessionsByExpertIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpertSessionsByExpertIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetExpertSessionsByExpertIdQuery(baseOptions: Apollo.QueryHookOptions<GetExpertSessionsByExpertIdQuery, GetExpertSessionsByExpertIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpertSessionsByExpertIdQuery, GetExpertSessionsByExpertIdQueryVariables>(GetExpertSessionsByExpertIdDocument, options);
      }
export function useGetExpertSessionsByExpertIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpertSessionsByExpertIdQuery, GetExpertSessionsByExpertIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpertSessionsByExpertIdQuery, GetExpertSessionsByExpertIdQueryVariables>(GetExpertSessionsByExpertIdDocument, options);
        }
export type GetExpertSessionsByExpertIdQueryHookResult = ReturnType<typeof useGetExpertSessionsByExpertIdQuery>;
export type GetExpertSessionsByExpertIdLazyQueryHookResult = ReturnType<typeof useGetExpertSessionsByExpertIdLazyQuery>;
export type GetExpertSessionsByExpertIdQueryResult = Apollo.QueryResult<GetExpertSessionsByExpertIdQuery, GetExpertSessionsByExpertIdQueryVariables>;
export const PublishCmsPageDocument = gql`
    mutation publishCmsPage($id: Int!) {
  publishCmsPage(id: $id) {
    id
    isPublished
  }
}
    `;
export type PublishCmsPageMutationFn = Apollo.MutationFunction<PublishCmsPageMutation, PublishCmsPageMutationVariables>;

/**
 * __usePublishCmsPageMutation__
 *
 * To run a mutation, you first call `usePublishCmsPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCmsPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCmsPageMutation, { data, loading, error }] = usePublishCmsPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishCmsPageMutation(baseOptions?: Apollo.MutationHookOptions<PublishCmsPageMutation, PublishCmsPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishCmsPageMutation, PublishCmsPageMutationVariables>(PublishCmsPageDocument, options);
      }
export type PublishCmsPageMutationHookResult = ReturnType<typeof usePublishCmsPageMutation>;
export type PublishCmsPageMutationResult = Apollo.MutationResult<PublishCmsPageMutation>;
export type PublishCmsPageMutationOptions = Apollo.BaseMutationOptions<PublishCmsPageMutation, PublishCmsPageMutationVariables>;
export const UnpublishCmsPageDocument = gql`
    mutation unpublishCmsPage($id: Int!) {
  unpublishCmsPage(id: $id) {
    id
    isPublished
  }
}
    `;
export type UnpublishCmsPageMutationFn = Apollo.MutationFunction<UnpublishCmsPageMutation, UnpublishCmsPageMutationVariables>;

/**
 * __useUnpublishCmsPageMutation__
 *
 * To run a mutation, you first call `useUnpublishCmsPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishCmsPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishCmsPageMutation, { data, loading, error }] = useUnpublishCmsPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnpublishCmsPageMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishCmsPageMutation, UnpublishCmsPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishCmsPageMutation, UnpublishCmsPageMutationVariables>(UnpublishCmsPageDocument, options);
      }
export type UnpublishCmsPageMutationHookResult = ReturnType<typeof useUnpublishCmsPageMutation>;
export type UnpublishCmsPageMutationResult = Apollo.MutationResult<UnpublishCmsPageMutation>;
export type UnpublishCmsPageMutationOptions = Apollo.BaseMutationOptions<UnpublishCmsPageMutation, UnpublishCmsPageMutationVariables>;
export const AdminCmsPagesDocument = gql`
    query adminCmsPages($input: AdminCMSPagesInput!) {
  adminCmsPages(input: $input) {
    edges {
      node {
        id
        title
        slug
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useAdminCmsPagesQuery__
 *
 * To run a query within a React component, call `useAdminCmsPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCmsPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCmsPagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCmsPagesQuery(baseOptions: Apollo.QueryHookOptions<AdminCmsPagesQuery, AdminCmsPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCmsPagesQuery, AdminCmsPagesQueryVariables>(AdminCmsPagesDocument, options);
      }
export function useAdminCmsPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCmsPagesQuery, AdminCmsPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCmsPagesQuery, AdminCmsPagesQueryVariables>(AdminCmsPagesDocument, options);
        }
export type AdminCmsPagesQueryHookResult = ReturnType<typeof useAdminCmsPagesQuery>;
export type AdminCmsPagesLazyQueryHookResult = ReturnType<typeof useAdminCmsPagesLazyQuery>;
export type AdminCmsPagesQueryResult = Apollo.QueryResult<AdminCmsPagesQuery, AdminCmsPagesQueryVariables>;
export const AdminCmsPagesByLimitDocument = gql`
    query adminCmsPagesByLimit($input: AdminCMSPagesByLimitInput!) {
  adminCmsPagesByLimit(input: $input) {
    data {
      id
      title
      isStatic
      isPublished
      href
      slug
      createdAtUtc {
        isoFormat
      }
      updatedAtUtc {
        isoFormat
      }
      content {
        ... on CMSArticlePage {
          id
          author
        }
        ... on CMSCategoryPage {
          id
        }
        ... on CMSConsultationPage {
          id
        }
        ... on CMSShowroomPage {
          id
        }
        ... on CMSBrandPage {
          id
        }
      }
    }
    paginationInfo {
      totalCount
      firstPage
      lastPage
      currentPage
      nextPage
      previousPage
    }
  }
}
    `;

/**
 * __useAdminCmsPagesByLimitQuery__
 *
 * To run a query within a React component, call `useAdminCmsPagesByLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCmsPagesByLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCmsPagesByLimitQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCmsPagesByLimitQuery(baseOptions: Apollo.QueryHookOptions<AdminCmsPagesByLimitQuery, AdminCmsPagesByLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCmsPagesByLimitQuery, AdminCmsPagesByLimitQueryVariables>(AdminCmsPagesByLimitDocument, options);
      }
export function useAdminCmsPagesByLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCmsPagesByLimitQuery, AdminCmsPagesByLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCmsPagesByLimitQuery, AdminCmsPagesByLimitQueryVariables>(AdminCmsPagesByLimitDocument, options);
        }
export type AdminCmsPagesByLimitQueryHookResult = ReturnType<typeof useAdminCmsPagesByLimitQuery>;
export type AdminCmsPagesByLimitLazyQueryHookResult = ReturnType<typeof useAdminCmsPagesByLimitLazyQuery>;
export type AdminCmsPagesByLimitQueryResult = Apollo.QueryResult<AdminCmsPagesByLimitQuery, AdminCmsPagesByLimitQueryVariables>;
export const CmsShowroomPageSlugsDocument = gql`
    query cmsShowroomPageSlugs {
  cmsShowroomPageSlugs
}
    `;

/**
 * __useCmsShowroomPageSlugsQuery__
 *
 * To run a query within a React component, call `useCmsShowroomPageSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsShowroomPageSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsShowroomPageSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCmsShowroomPageSlugsQuery(baseOptions?: Apollo.QueryHookOptions<CmsShowroomPageSlugsQuery, CmsShowroomPageSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsShowroomPageSlugsQuery, CmsShowroomPageSlugsQueryVariables>(CmsShowroomPageSlugsDocument, options);
      }
export function useCmsShowroomPageSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsShowroomPageSlugsQuery, CmsShowroomPageSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsShowroomPageSlugsQuery, CmsShowroomPageSlugsQueryVariables>(CmsShowroomPageSlugsDocument, options);
        }
export type CmsShowroomPageSlugsQueryHookResult = ReturnType<typeof useCmsShowroomPageSlugsQuery>;
export type CmsShowroomPageSlugsLazyQueryHookResult = ReturnType<typeof useCmsShowroomPageSlugsLazyQuery>;
export type CmsShowroomPageSlugsQueryResult = Apollo.QueryResult<CmsShowroomPageSlugsQuery, CmsShowroomPageSlugsQueryVariables>;
export const ValidateAvailableCmsShowroomPageSlugDocument = gql`
    query validateAvailableCmsShowroomPageSlug($input: ValidateAvailableCmsPageSlugInput!) {
  validateAvailableCmsShowroomPageSlug(input: $input)
}
    `;

/**
 * __useValidateAvailableCmsShowroomPageSlugQuery__
 *
 * To run a query within a React component, call `useValidateAvailableCmsShowroomPageSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateAvailableCmsShowroomPageSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateAvailableCmsShowroomPageSlugQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateAvailableCmsShowroomPageSlugQuery(baseOptions: Apollo.QueryHookOptions<ValidateAvailableCmsShowroomPageSlugQuery, ValidateAvailableCmsShowroomPageSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateAvailableCmsShowroomPageSlugQuery, ValidateAvailableCmsShowroomPageSlugQueryVariables>(ValidateAvailableCmsShowroomPageSlugDocument, options);
      }
export function useValidateAvailableCmsShowroomPageSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateAvailableCmsShowroomPageSlugQuery, ValidateAvailableCmsShowroomPageSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateAvailableCmsShowroomPageSlugQuery, ValidateAvailableCmsShowroomPageSlugQueryVariables>(ValidateAvailableCmsShowroomPageSlugDocument, options);
        }
export type ValidateAvailableCmsShowroomPageSlugQueryHookResult = ReturnType<typeof useValidateAvailableCmsShowroomPageSlugQuery>;
export type ValidateAvailableCmsShowroomPageSlugLazyQueryHookResult = ReturnType<typeof useValidateAvailableCmsShowroomPageSlugLazyQuery>;
export type ValidateAvailableCmsShowroomPageSlugQueryResult = Apollo.QueryResult<ValidateAvailableCmsShowroomPageSlugQuery, ValidateAvailableCmsShowroomPageSlugQueryVariables>;
export const CmsShowroomNavigationPageSlugsDocument = gql`
    query cmsShowroomNavigationPageSlugs {
  cmsShowroomNavigationPageSlugs
}
    `;

/**
 * __useCmsShowroomNavigationPageSlugsQuery__
 *
 * To run a query within a React component, call `useCmsShowroomNavigationPageSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsShowroomNavigationPageSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsShowroomNavigationPageSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCmsShowroomNavigationPageSlugsQuery(baseOptions?: Apollo.QueryHookOptions<CmsShowroomNavigationPageSlugsQuery, CmsShowroomNavigationPageSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsShowroomNavigationPageSlugsQuery, CmsShowroomNavigationPageSlugsQueryVariables>(CmsShowroomNavigationPageSlugsDocument, options);
      }
export function useCmsShowroomNavigationPageSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsShowroomNavigationPageSlugsQuery, CmsShowroomNavigationPageSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsShowroomNavigationPageSlugsQuery, CmsShowroomNavigationPageSlugsQueryVariables>(CmsShowroomNavigationPageSlugsDocument, options);
        }
export type CmsShowroomNavigationPageSlugsQueryHookResult = ReturnType<typeof useCmsShowroomNavigationPageSlugsQuery>;
export type CmsShowroomNavigationPageSlugsLazyQueryHookResult = ReturnType<typeof useCmsShowroomNavigationPageSlugsLazyQuery>;
export type CmsShowroomNavigationPageSlugsQueryResult = Apollo.QueryResult<CmsShowroomNavigationPageSlugsQuery, CmsShowroomNavigationPageSlugsQueryVariables>;
export const CmsShowroomPagePickerDocument = gql`
    query cmsShowroomPagePicker($input: CMSShowroomPagesInput!) {
  cmsShowroomPages(input: $input) {
    data {
      id
      cmsPage {
        id
        title
        slug
      }
    }
  }
}
    `;

/**
 * __useCmsShowroomPagePickerQuery__
 *
 * To run a query within a React component, call `useCmsShowroomPagePickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsShowroomPagePickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsShowroomPagePickerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCmsShowroomPagePickerQuery(baseOptions: Apollo.QueryHookOptions<CmsShowroomPagePickerQuery, CmsShowroomPagePickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsShowroomPagePickerQuery, CmsShowroomPagePickerQueryVariables>(CmsShowroomPagePickerDocument, options);
      }
export function useCmsShowroomPagePickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsShowroomPagePickerQuery, CmsShowroomPagePickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsShowroomPagePickerQuery, CmsShowroomPagePickerQueryVariables>(CmsShowroomPagePickerDocument, options);
        }
export type CmsShowroomPagePickerQueryHookResult = ReturnType<typeof useCmsShowroomPagePickerQuery>;
export type CmsShowroomPagePickerLazyQueryHookResult = ReturnType<typeof useCmsShowroomPagePickerLazyQuery>;
export type CmsShowroomPagePickerQueryResult = Apollo.QueryResult<CmsShowroomPagePickerQuery, CmsShowroomPagePickerQueryVariables>;
export const CmsShowroomPageDocument = gql`
    query cmsShowroomPage($input: CMSShowroomPageInput!) {
  cmsShowroomPage(input: $input) {
    ...AdminCMSShowroomPageFields
  }
}
    ${AdminCmsShowroomPageFieldsFragmentDoc}`;

/**
 * __useCmsShowroomPageQuery__
 *
 * To run a query within a React component, call `useCmsShowroomPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsShowroomPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsShowroomPageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCmsShowroomPageQuery(baseOptions: Apollo.QueryHookOptions<CmsShowroomPageQuery, CmsShowroomPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsShowroomPageQuery, CmsShowroomPageQueryVariables>(CmsShowroomPageDocument, options);
      }
export function useCmsShowroomPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsShowroomPageQuery, CmsShowroomPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsShowroomPageQuery, CmsShowroomPageQueryVariables>(CmsShowroomPageDocument, options);
        }
export type CmsShowroomPageQueryHookResult = ReturnType<typeof useCmsShowroomPageQuery>;
export type CmsShowroomPageLazyQueryHookResult = ReturnType<typeof useCmsShowroomPageLazyQuery>;
export type CmsShowroomPageQueryResult = Apollo.QueryResult<CmsShowroomPageQuery, CmsShowroomPageQueryVariables>;
export const CreateCmsShowroomPageDocument = gql`
    mutation createCmsShowroomPage($input: CreateCMSShowroomPageInput!) {
  createCmsShowroomPage(input: $input) {
    ...AdminCMSShowroomPageFields
  }
}
    ${AdminCmsShowroomPageFieldsFragmentDoc}`;
export type CreateCmsShowroomPageMutationFn = Apollo.MutationFunction<CreateCmsShowroomPageMutation, CreateCmsShowroomPageMutationVariables>;

/**
 * __useCreateCmsShowroomPageMutation__
 *
 * To run a mutation, you first call `useCreateCmsShowroomPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCmsShowroomPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCmsShowroomPageMutation, { data, loading, error }] = useCreateCmsShowroomPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCmsShowroomPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateCmsShowroomPageMutation, CreateCmsShowroomPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCmsShowroomPageMutation, CreateCmsShowroomPageMutationVariables>(CreateCmsShowroomPageDocument, options);
      }
export type CreateCmsShowroomPageMutationHookResult = ReturnType<typeof useCreateCmsShowroomPageMutation>;
export type CreateCmsShowroomPageMutationResult = Apollo.MutationResult<CreateCmsShowroomPageMutation>;
export type CreateCmsShowroomPageMutationOptions = Apollo.BaseMutationOptions<CreateCmsShowroomPageMutation, CreateCmsShowroomPageMutationVariables>;
export const DeleteCmsShowroomPageDocument = gql`
    mutation deleteCmsShowroomPage($id: Int!) {
  deleteCmsShowroomPage(id: $id) {
    id
  }
}
    `;
export type DeleteCmsShowroomPageMutationFn = Apollo.MutationFunction<DeleteCmsShowroomPageMutation, DeleteCmsShowroomPageMutationVariables>;

/**
 * __useDeleteCmsShowroomPageMutation__
 *
 * To run a mutation, you first call `useDeleteCmsShowroomPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCmsShowroomPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCmsShowroomPageMutation, { data, loading, error }] = useDeleteCmsShowroomPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCmsShowroomPageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCmsShowroomPageMutation, DeleteCmsShowroomPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCmsShowroomPageMutation, DeleteCmsShowroomPageMutationVariables>(DeleteCmsShowroomPageDocument, options);
      }
export type DeleteCmsShowroomPageMutationHookResult = ReturnType<typeof useDeleteCmsShowroomPageMutation>;
export type DeleteCmsShowroomPageMutationResult = Apollo.MutationResult<DeleteCmsShowroomPageMutation>;
export type DeleteCmsShowroomPageMutationOptions = Apollo.BaseMutationOptions<DeleteCmsShowroomPageMutation, DeleteCmsShowroomPageMutationVariables>;
export const UpdateCmsShowroomPageDocument = gql`
    mutation updateCmsShowroomPage($input: UpdateCMSShowroomPageInput!) {
  updateCmsShowroomPage(input: $input) {
    ...AdminCMSShowroomPageFields
  }
}
    ${AdminCmsShowroomPageFieldsFragmentDoc}`;
export type UpdateCmsShowroomPageMutationFn = Apollo.MutationFunction<UpdateCmsShowroomPageMutation, UpdateCmsShowroomPageMutationVariables>;

/**
 * __useUpdateCmsShowroomPageMutation__
 *
 * To run a mutation, you first call `useUpdateCmsShowroomPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCmsShowroomPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCmsShowroomPageMutation, { data, loading, error }] = useUpdateCmsShowroomPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCmsShowroomPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCmsShowroomPageMutation, UpdateCmsShowroomPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCmsShowroomPageMutation, UpdateCmsShowroomPageMutationVariables>(UpdateCmsShowroomPageDocument, options);
      }
export type UpdateCmsShowroomPageMutationHookResult = ReturnType<typeof useUpdateCmsShowroomPageMutation>;
export type UpdateCmsShowroomPageMutationResult = Apollo.MutationResult<UpdateCmsShowroomPageMutation>;
export type UpdateCmsShowroomPageMutationOptions = Apollo.BaseMutationOptions<UpdateCmsShowroomPageMutation, UpdateCmsShowroomPageMutationVariables>;
export const CmsWidgetByIdDocument = gql`
    query cmsWidgetById($input: WidgetsByIdInput!) {
  cmsWidgetById(input: $input) {
    ...CMSWidgetFields
  }
}
    ${CmsWidgetFieldsFragmentDoc}`;

/**
 * __useCmsWidgetByIdQuery__
 *
 * To run a query within a React component, call `useCmsWidgetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsWidgetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsWidgetByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCmsWidgetByIdQuery(baseOptions: Apollo.QueryHookOptions<CmsWidgetByIdQuery, CmsWidgetByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsWidgetByIdQuery, CmsWidgetByIdQueryVariables>(CmsWidgetByIdDocument, options);
      }
export function useCmsWidgetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsWidgetByIdQuery, CmsWidgetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsWidgetByIdQuery, CmsWidgetByIdQueryVariables>(CmsWidgetByIdDocument, options);
        }
export type CmsWidgetByIdQueryHookResult = ReturnType<typeof useCmsWidgetByIdQuery>;
export type CmsWidgetByIdLazyQueryHookResult = ReturnType<typeof useCmsWidgetByIdLazyQuery>;
export type CmsWidgetByIdQueryResult = Apollo.QueryResult<CmsWidgetByIdQuery, CmsWidgetByIdQueryVariables>;
export const AdminCollectionDocument = gql`
    query adminCollection($id: Int!, $input: ProductsInput) {
  collection(id: $id) {
    id
    title
    isGenerated
    status
    maxPrice {
      total
      base
      currencyIsoCode
      vatRate
    }
    subtype
    categoriesOne {
      id
      name
      parentId
      children {
        id
        name
        parentId
        children {
          id
          name
          parentId
        }
      }
    }
    categoriesTwo {
      id
      name
    }
    categoriesThree {
      id
      name
    }
    brands {
      id
    }
    expert {
      id
      slug
    }
    items(input: $input) {
      paginationInfo {
        totalCount
        firstPage
        lastPage
        currentPage
        nextPage
        previousPage
      }
      data {
        id
        minPublishedPrice
        maxPublishedPrice
        product {
          id
          slug
          sku
          title
          status
          positionIndexWeight
          availability
          variants {
            id
            status
            isPublishedFirstTime
          }
          brand {
            id
          }
          updatedAtUtc {
            isoFormat
          }
          images {
            url
          }
        }
        productVariant {
          id
          sku
          slug
          title
          status
          isPublishedFirstTime
          availability
          quantity
          tradePrice {
            total
            currencyIsoCode
            base
            vatRate
          }
          price {
            total
            currencyIsoCode
            base
            vatRate
          }
          updatedAtUtc {
            isoFormat
          }
          leadImage {
            id
            url
            alt
          }
          images {
            id
            url
            alt
          }
          optionValues {
            value
            productOption {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdminCollectionQuery__
 *
 * To run a query within a React component, call `useAdminCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCollectionQuery(baseOptions: Apollo.QueryHookOptions<AdminCollectionQuery, AdminCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCollectionQuery, AdminCollectionQueryVariables>(AdminCollectionDocument, options);
      }
export function useAdminCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCollectionQuery, AdminCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCollectionQuery, AdminCollectionQueryVariables>(AdminCollectionDocument, options);
        }
export type AdminCollectionQueryHookResult = ReturnType<typeof useAdminCollectionQuery>;
export type AdminCollectionLazyQueryHookResult = ReturnType<typeof useAdminCollectionLazyQuery>;
export type AdminCollectionQueryResult = Apollo.QueryResult<AdminCollectionQuery, AdminCollectionQueryVariables>;
export const ExpertShowroomCollectionCollectionItemDocument = gql`
    query expertShowroomCollectionCollectionItem($productVariantId: Int!) {
  expertShowroomCollectionCollectionItem(productVariantId: $productVariantId) {
    id
  }
}
    `;

/**
 * __useExpertShowroomCollectionCollectionItemQuery__
 *
 * To run a query within a React component, call `useExpertShowroomCollectionCollectionItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertShowroomCollectionCollectionItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertShowroomCollectionCollectionItemQuery({
 *   variables: {
 *      productVariantId: // value for 'productVariantId'
 *   },
 * });
 */
export function useExpertShowroomCollectionCollectionItemQuery(baseOptions: Apollo.QueryHookOptions<ExpertShowroomCollectionCollectionItemQuery, ExpertShowroomCollectionCollectionItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertShowroomCollectionCollectionItemQuery, ExpertShowroomCollectionCollectionItemQueryVariables>(ExpertShowroomCollectionCollectionItemDocument, options);
      }
export function useExpertShowroomCollectionCollectionItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertShowroomCollectionCollectionItemQuery, ExpertShowroomCollectionCollectionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertShowroomCollectionCollectionItemQuery, ExpertShowroomCollectionCollectionItemQueryVariables>(ExpertShowroomCollectionCollectionItemDocument, options);
        }
export type ExpertShowroomCollectionCollectionItemQueryHookResult = ReturnType<typeof useExpertShowroomCollectionCollectionItemQuery>;
export type ExpertShowroomCollectionCollectionItemLazyQueryHookResult = ReturnType<typeof useExpertShowroomCollectionCollectionItemLazyQuery>;
export type ExpertShowroomCollectionCollectionItemQueryResult = Apollo.QueryResult<ExpertShowroomCollectionCollectionItemQuery, ExpertShowroomCollectionCollectionItemQueryVariables>;
export const AddCollectionProductDocument = gql`
    mutation addCollectionProduct($input: AddCollectionProductInput!) {
  addCollectionProduct(input: $input) {
    id
  }
}
    `;
export type AddCollectionProductMutationFn = Apollo.MutationFunction<AddCollectionProductMutation, AddCollectionProductMutationVariables>;

/**
 * __useAddCollectionProductMutation__
 *
 * To run a mutation, you first call `useAddCollectionProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCollectionProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCollectionProductMutation, { data, loading, error }] = useAddCollectionProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCollectionProductMutation(baseOptions?: Apollo.MutationHookOptions<AddCollectionProductMutation, AddCollectionProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCollectionProductMutation, AddCollectionProductMutationVariables>(AddCollectionProductDocument, options);
      }
export type AddCollectionProductMutationHookResult = ReturnType<typeof useAddCollectionProductMutation>;
export type AddCollectionProductMutationResult = Apollo.MutationResult<AddCollectionProductMutation>;
export type AddCollectionProductMutationOptions = Apollo.BaseMutationOptions<AddCollectionProductMutation, AddCollectionProductMutationVariables>;
export const EditCollectionProductDocument = gql`
    mutation editCollectionProduct($input: EditCollectionProductInput!) {
  editCollectionProduct(input: $input) {
    id
  }
}
    `;
export type EditCollectionProductMutationFn = Apollo.MutationFunction<EditCollectionProductMutation, EditCollectionProductMutationVariables>;

/**
 * __useEditCollectionProductMutation__
 *
 * To run a mutation, you first call `useEditCollectionProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCollectionProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCollectionProductMutation, { data, loading, error }] = useEditCollectionProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCollectionProductMutation(baseOptions?: Apollo.MutationHookOptions<EditCollectionProductMutation, EditCollectionProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCollectionProductMutation, EditCollectionProductMutationVariables>(EditCollectionProductDocument, options);
      }
export type EditCollectionProductMutationHookResult = ReturnType<typeof useEditCollectionProductMutation>;
export type EditCollectionProductMutationResult = Apollo.MutationResult<EditCollectionProductMutation>;
export type EditCollectionProductMutationOptions = Apollo.BaseMutationOptions<EditCollectionProductMutation, EditCollectionProductMutationVariables>;
export const RemoveCollectionProductDocument = gql`
    mutation removeCollectionProduct($input: RemoveCollectionProductInput!) {
  removeCollectionProduct(input: $input) {
    id
  }
}
    `;
export type RemoveCollectionProductMutationFn = Apollo.MutationFunction<RemoveCollectionProductMutation, RemoveCollectionProductMutationVariables>;

/**
 * __useRemoveCollectionProductMutation__
 *
 * To run a mutation, you first call `useRemoveCollectionProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCollectionProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCollectionProductMutation, { data, loading, error }] = useRemoveCollectionProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCollectionProductMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCollectionProductMutation, RemoveCollectionProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCollectionProductMutation, RemoveCollectionProductMutationVariables>(RemoveCollectionProductDocument, options);
      }
export type RemoveCollectionProductMutationHookResult = ReturnType<typeof useRemoveCollectionProductMutation>;
export type RemoveCollectionProductMutationResult = Apollo.MutationResult<RemoveCollectionProductMutation>;
export type RemoveCollectionProductMutationOptions = Apollo.BaseMutationOptions<RemoveCollectionProductMutation, RemoveCollectionProductMutationVariables>;
export const UpdateCollectionDocument = gql`
    mutation updateCollection($input: UpdateCollectionInput!) {
  updateCollection(input: $input) {
    id
  }
}
    `;
export type UpdateCollectionMutationFn = Apollo.MutationFunction<UpdateCollectionMutation, UpdateCollectionMutationVariables>;

/**
 * __useUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMutation, { data, loading, error }] = useUpdateCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollectionMutation, UpdateCollectionMutationVariables>(UpdateCollectionDocument, options);
      }
export type UpdateCollectionMutationHookResult = ReturnType<typeof useUpdateCollectionMutation>;
export type UpdateCollectionMutationResult = Apollo.MutationResult<UpdateCollectionMutation>;
export type UpdateCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>;
export const RequestCollectionReviewDocument = gql`
    mutation requestCollectionReview($input: RequestCollectionReviewInput!) {
  requestCollectionReview(input: $input) {
    id
  }
}
    `;
export type RequestCollectionReviewMutationFn = Apollo.MutationFunction<RequestCollectionReviewMutation, RequestCollectionReviewMutationVariables>;

/**
 * __useRequestCollectionReviewMutation__
 *
 * To run a mutation, you first call `useRequestCollectionReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCollectionReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCollectionReviewMutation, { data, loading, error }] = useRequestCollectionReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCollectionReviewMutation(baseOptions?: Apollo.MutationHookOptions<RequestCollectionReviewMutation, RequestCollectionReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCollectionReviewMutation, RequestCollectionReviewMutationVariables>(RequestCollectionReviewDocument, options);
      }
export type RequestCollectionReviewMutationHookResult = ReturnType<typeof useRequestCollectionReviewMutation>;
export type RequestCollectionReviewMutationResult = Apollo.MutationResult<RequestCollectionReviewMutation>;
export type RequestCollectionReviewMutationOptions = Apollo.BaseMutationOptions<RequestCollectionReviewMutation, RequestCollectionReviewMutationVariables>;
export const CancelCollectionReviewDocument = gql`
    mutation cancelCollectionReview($input: CancelCollectionReviewInput!) {
  cancelCollectionReview(input: $input) {
    id
  }
}
    `;
export type CancelCollectionReviewMutationFn = Apollo.MutationFunction<CancelCollectionReviewMutation, CancelCollectionReviewMutationVariables>;

/**
 * __useCancelCollectionReviewMutation__
 *
 * To run a mutation, you first call `useCancelCollectionReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCollectionReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCollectionReviewMutation, { data, loading, error }] = useCancelCollectionReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelCollectionReviewMutation(baseOptions?: Apollo.MutationHookOptions<CancelCollectionReviewMutation, CancelCollectionReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCollectionReviewMutation, CancelCollectionReviewMutationVariables>(CancelCollectionReviewDocument, options);
      }
export type CancelCollectionReviewMutationHookResult = ReturnType<typeof useCancelCollectionReviewMutation>;
export type CancelCollectionReviewMutationResult = Apollo.MutationResult<CancelCollectionReviewMutation>;
export type CancelCollectionReviewMutationOptions = Apollo.BaseMutationOptions<CancelCollectionReviewMutation, CancelCollectionReviewMutationVariables>;
export const SendContactUsHelloEmailDocument = gql`
    mutation sendContactUsHelloEmail($input: SendContactUsEmailInput!) {
  sendContactUsHelloEmail(input: $input)
}
    `;
export type SendContactUsHelloEmailMutationFn = Apollo.MutationFunction<SendContactUsHelloEmailMutation, SendContactUsHelloEmailMutationVariables>;

/**
 * __useSendContactUsHelloEmailMutation__
 *
 * To run a mutation, you first call `useSendContactUsHelloEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactUsHelloEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactUsHelloEmailMutation, { data, loading, error }] = useSendContactUsHelloEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendContactUsHelloEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendContactUsHelloEmailMutation, SendContactUsHelloEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendContactUsHelloEmailMutation, SendContactUsHelloEmailMutationVariables>(SendContactUsHelloEmailDocument, options);
      }
export type SendContactUsHelloEmailMutationHookResult = ReturnType<typeof useSendContactUsHelloEmailMutation>;
export type SendContactUsHelloEmailMutationResult = Apollo.MutationResult<SendContactUsHelloEmailMutation>;
export type SendContactUsHelloEmailMutationOptions = Apollo.BaseMutationOptions<SendContactUsHelloEmailMutation, SendContactUsHelloEmailMutationVariables>;
export const SendContactUsShowroomEmailDocument = gql`
    mutation sendContactUsShowroomEmail($input: SendContactUsEmailInput!) {
  sendContactUsShowroomEmail(input: $input)
}
    `;
export type SendContactUsShowroomEmailMutationFn = Apollo.MutationFunction<SendContactUsShowroomEmailMutation, SendContactUsShowroomEmailMutationVariables>;

/**
 * __useSendContactUsShowroomEmailMutation__
 *
 * To run a mutation, you first call `useSendContactUsShowroomEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactUsShowroomEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactUsShowroomEmailMutation, { data, loading, error }] = useSendContactUsShowroomEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendContactUsShowroomEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendContactUsShowroomEmailMutation, SendContactUsShowroomEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendContactUsShowroomEmailMutation, SendContactUsShowroomEmailMutationVariables>(SendContactUsShowroomEmailDocument, options);
      }
export type SendContactUsShowroomEmailMutationHookResult = ReturnType<typeof useSendContactUsShowroomEmailMutation>;
export type SendContactUsShowroomEmailMutationResult = Apollo.MutationResult<SendContactUsShowroomEmailMutation>;
export type SendContactUsShowroomEmailMutationOptions = Apollo.BaseMutationOptions<SendContactUsShowroomEmailMutation, SendContactUsShowroomEmailMutationVariables>;
export const CountriesDocument = gql`
    query countries($search: String!) {
  countries(search: $search) {
    title
    isoCode
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCountriesQuery(baseOptions: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const ApplyCouponDocument = gql`
    mutation applyCoupon($couponCode: String!) {
  applyCoupon(couponCode: $couponCode)
}
    `;
export type ApplyCouponMutationFn = Apollo.MutationFunction<ApplyCouponMutation, ApplyCouponMutationVariables>;

/**
 * __useApplyCouponMutation__
 *
 * To run a mutation, you first call `useApplyCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCouponMutation, { data, loading, error }] = useApplyCouponMutation({
 *   variables: {
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useApplyCouponMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCouponMutation, ApplyCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCouponMutation, ApplyCouponMutationVariables>(ApplyCouponDocument, options);
      }
export type ApplyCouponMutationHookResult = ReturnType<typeof useApplyCouponMutation>;
export type ApplyCouponMutationResult = Apollo.MutationResult<ApplyCouponMutation>;
export type ApplyCouponMutationOptions = Apollo.BaseMutationOptions<ApplyCouponMutation, ApplyCouponMutationVariables>;
export const RemoveCouponDocument = gql`
    mutation removeCoupon($couponCode: String!) {
  removeCoupon(couponCode: $couponCode)
}
    `;
export type RemoveCouponMutationFn = Apollo.MutationFunction<RemoveCouponMutation, RemoveCouponMutationVariables>;

/**
 * __useRemoveCouponMutation__
 *
 * To run a mutation, you first call `useRemoveCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCouponMutation, { data, loading, error }] = useRemoveCouponMutation({
 *   variables: {
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useRemoveCouponMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCouponMutation, RemoveCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCouponMutation, RemoveCouponMutationVariables>(RemoveCouponDocument, options);
      }
export type RemoveCouponMutationHookResult = ReturnType<typeof useRemoveCouponMutation>;
export type RemoveCouponMutationResult = Apollo.MutationResult<RemoveCouponMutation>;
export type RemoveCouponMutationOptions = Apollo.BaseMutationOptions<RemoveCouponMutation, RemoveCouponMutationVariables>;
export const CreateExpertApplicationDocument = gql`
    mutation createExpertApplication($input: CreateExpertApplicationInput!) {
  createExpertApplication(input: $input) {
    id
  }
}
    `;
export type CreateExpertApplicationMutationFn = Apollo.MutationFunction<CreateExpertApplicationMutation, CreateExpertApplicationMutationVariables>;

/**
 * __useCreateExpertApplicationMutation__
 *
 * To run a mutation, you first call `useCreateExpertApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpertApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpertApplicationMutation, { data, loading, error }] = useCreateExpertApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExpertApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpertApplicationMutation, CreateExpertApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExpertApplicationMutation, CreateExpertApplicationMutationVariables>(CreateExpertApplicationDocument, options);
      }
export type CreateExpertApplicationMutationHookResult = ReturnType<typeof useCreateExpertApplicationMutation>;
export type CreateExpertApplicationMutationResult = Apollo.MutationResult<CreateExpertApplicationMutation>;
export type CreateExpertApplicationMutationOptions = Apollo.BaseMutationOptions<CreateExpertApplicationMutation, CreateExpertApplicationMutationVariables>;
export const ExpertMeOrdersDocument = gql`
    query expertMeOrders($id: Int!, $paginationInput: CursorPaginationInput!) {
  expertMe(id: $id) {
    id
    orders(input: $paginationInput) {
      ...BuyerOrdersDashboardOrdersData
    }
    purchasesWithoutCommission(input: $paginationInput) {
      edges {
        ...BuyerOrdersDashboardPurchaseEdges
      }
    }
  }
}
    ${BuyerOrdersDashboardOrdersDataFragmentDoc}
${BuyerOrdersDashboardPurchaseEdgesFragmentDoc}`;

/**
 * __useExpertMeOrdersQuery__
 *
 * To run a query within a React component, call `useExpertMeOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertMeOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertMeOrdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paginationInput: // value for 'paginationInput'
 *   },
 * });
 */
export function useExpertMeOrdersQuery(baseOptions: Apollo.QueryHookOptions<ExpertMeOrdersQuery, ExpertMeOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertMeOrdersQuery, ExpertMeOrdersQueryVariables>(ExpertMeOrdersDocument, options);
      }
export function useExpertMeOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertMeOrdersQuery, ExpertMeOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertMeOrdersQuery, ExpertMeOrdersQueryVariables>(ExpertMeOrdersDocument, options);
        }
export type ExpertMeOrdersQueryHookResult = ReturnType<typeof useExpertMeOrdersQuery>;
export type ExpertMeOrdersLazyQueryHookResult = ReturnType<typeof useExpertMeOrdersLazyQuery>;
export type ExpertMeOrdersQueryResult = Apollo.QueryResult<ExpertMeOrdersQuery, ExpertMeOrdersQueryVariables>;
export const ExpertMeCollectionsDocument = gql`
    query expertMeCollections($id: Int!, $input: ProductsInput!) {
  expertMe(id: $id) {
    id
    slug
    expertShowroomCollection {
      id
      status
      updatedAtUtc {
        isoFormat
      }
      maxPrice {
        total
        base
        currencyIsoCode
        vatRate
      }
      categoriesOne {
        id
        name
        parentId
        children {
          id
          name
          parentId
          children {
            id
            name
            parentId
          }
        }
      }
      categoriesTwo {
        id
        name
      }
      categoriesThree {
        id
        name
      }
      brands {
        id
      }
      items(input: $input) {
        paginationInfo {
          totalCount
          firstPage
          lastPage
          currentPage
          nextPage
          previousPage
        }
        data {
          id
          minPublishedPrice
          maxPublishedPrice
          product {
            id
            sku
            slug
            title
            status
            positionIndexWeight
            availability
            brand {
              id
            }
            variants {
              id
              status
              isPublishedFirstTime
            }
            updatedAtUtc {
              isoFormat
            }
            images {
              url
            }
          }
          productVariant {
            id
            slug
            sku
            title
            status
            isPublishedFirstTime
            availability
            quantity
            tradePrice {
              total
              currencyIsoCode
              base
              vatRate
            }
            price {
              total
              currencyIsoCode
              base
              vatRate
            }
            updatedAtUtc {
              isoFormat
            }
            leadImage {
              id
              url
              alt
            }
            images {
              id
              url
              alt
            }
            optionValues {
              value
              productOption {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useExpertMeCollectionsQuery__
 *
 * To run a query within a React component, call `useExpertMeCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertMeCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertMeCollectionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExpertMeCollectionsQuery(baseOptions: Apollo.QueryHookOptions<ExpertMeCollectionsQuery, ExpertMeCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertMeCollectionsQuery, ExpertMeCollectionsQueryVariables>(ExpertMeCollectionsDocument, options);
      }
export function useExpertMeCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertMeCollectionsQuery, ExpertMeCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertMeCollectionsQuery, ExpertMeCollectionsQueryVariables>(ExpertMeCollectionsDocument, options);
        }
export type ExpertMeCollectionsQueryHookResult = ReturnType<typeof useExpertMeCollectionsQuery>;
export type ExpertMeCollectionsLazyQueryHookResult = ReturnType<typeof useExpertMeCollectionsLazyQuery>;
export type ExpertMeCollectionsQueryResult = Apollo.QueryResult<ExpertMeCollectionsQuery, ExpertMeCollectionsQueryVariables>;
export const AvailableExpertDetailTabsByExpertSlugDocument = gql`
    query availableExpertDetailTabsByExpertSlug($slug: String!) {
  expertBySlug(slug: $slug) {
    id
    availableExpertDetailTabs
  }
}
    `;

/**
 * __useAvailableExpertDetailTabsByExpertSlugQuery__
 *
 * To run a query within a React component, call `useAvailableExpertDetailTabsByExpertSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableExpertDetailTabsByExpertSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableExpertDetailTabsByExpertSlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAvailableExpertDetailTabsByExpertSlugQuery(baseOptions: Apollo.QueryHookOptions<AvailableExpertDetailTabsByExpertSlugQuery, AvailableExpertDetailTabsByExpertSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableExpertDetailTabsByExpertSlugQuery, AvailableExpertDetailTabsByExpertSlugQueryVariables>(AvailableExpertDetailTabsByExpertSlugDocument, options);
      }
export function useAvailableExpertDetailTabsByExpertSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableExpertDetailTabsByExpertSlugQuery, AvailableExpertDetailTabsByExpertSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableExpertDetailTabsByExpertSlugQuery, AvailableExpertDetailTabsByExpertSlugQueryVariables>(AvailableExpertDetailTabsByExpertSlugDocument, options);
        }
export type AvailableExpertDetailTabsByExpertSlugQueryHookResult = ReturnType<typeof useAvailableExpertDetailTabsByExpertSlugQuery>;
export type AvailableExpertDetailTabsByExpertSlugLazyQueryHookResult = ReturnType<typeof useAvailableExpertDetailTabsByExpertSlugLazyQuery>;
export type AvailableExpertDetailTabsByExpertSlugQueryResult = Apollo.QueryResult<AvailableExpertDetailTabsByExpertSlugQuery, AvailableExpertDetailTabsByExpertSlugQueryVariables>;
export const PublicExpertDetailSharedHeaderDocument = gql`
    query publicExpertDetailSharedHeader($id: Int!) {
  expert(id: $id) {
    ...ExpertDetailPageField
    availableExpertDetailTabs
  }
}
    ${ExpertDetailPageFieldFragmentDoc}`;

/**
 * __usePublicExpertDetailSharedHeaderQuery__
 *
 * To run a query within a React component, call `usePublicExpertDetailSharedHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicExpertDetailSharedHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicExpertDetailSharedHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicExpertDetailSharedHeaderQuery(baseOptions: Apollo.QueryHookOptions<PublicExpertDetailSharedHeaderQuery, PublicExpertDetailSharedHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicExpertDetailSharedHeaderQuery, PublicExpertDetailSharedHeaderQueryVariables>(PublicExpertDetailSharedHeaderDocument, options);
      }
export function usePublicExpertDetailSharedHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicExpertDetailSharedHeaderQuery, PublicExpertDetailSharedHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicExpertDetailSharedHeaderQuery, PublicExpertDetailSharedHeaderQueryVariables>(PublicExpertDetailSharedHeaderDocument, options);
        }
export type PublicExpertDetailSharedHeaderQueryHookResult = ReturnType<typeof usePublicExpertDetailSharedHeaderQuery>;
export type PublicExpertDetailSharedHeaderLazyQueryHookResult = ReturnType<typeof usePublicExpertDetailSharedHeaderLazyQuery>;
export type PublicExpertDetailSharedHeaderQueryResult = Apollo.QueryResult<PublicExpertDetailSharedHeaderQuery, PublicExpertDetailSharedHeaderQueryVariables>;
export const PublicExpertDetailConsultationTabDocument = gql`
    query publicExpertDetailConsultationTab($slug: String!, $reviewsInput: ReviewsInput) {
  expertBySlug(slug: $slug) {
    id
    slug
    longDescription
    profileName
    jobTitle
    tags {
      title
      id
    }
    customCancelationPolicy
    hasRequiredServicesActivated
    testimonials {
      data {
        id
        feedback
        clientName
        consultationName
        expertUser {
          firstName
          lastName
          title
        }
      }
    }
    expertises {
      id
      expertise
    }
    sessions {
      isAvailable
      id
      title
      description
      isUpToThreeGuestsAllowed
      sessionType
      lengthInMinutes
      sessionCapacity
      minimumSessionSize
      price {
        total
        currencyIsoCode
        calculatedPrices {
          total
          currencyIsoCode
        }
      }
      expertUser {
        email
        title
        firstName
        lastName
        id
      }
    }
    reviewsAverageRating {
      avg
      totalCount
    }
    reviews(input: $reviewsInput) {
      data {
        id
        rating
        feedback
        client {
          id
          firstName
          lastName
        }
      }
      paginationInfo {
        nextPage
        totalCount
      }
    }
  }
}
    `;

/**
 * __usePublicExpertDetailConsultationTabQuery__
 *
 * To run a query within a React component, call `usePublicExpertDetailConsultationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicExpertDetailConsultationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicExpertDetailConsultationTabQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      reviewsInput: // value for 'reviewsInput'
 *   },
 * });
 */
export function usePublicExpertDetailConsultationTabQuery(baseOptions: Apollo.QueryHookOptions<PublicExpertDetailConsultationTabQuery, PublicExpertDetailConsultationTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicExpertDetailConsultationTabQuery, PublicExpertDetailConsultationTabQueryVariables>(PublicExpertDetailConsultationTabDocument, options);
      }
export function usePublicExpertDetailConsultationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicExpertDetailConsultationTabQuery, PublicExpertDetailConsultationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicExpertDetailConsultationTabQuery, PublicExpertDetailConsultationTabQueryVariables>(PublicExpertDetailConsultationTabDocument, options);
        }
export type PublicExpertDetailConsultationTabQueryHookResult = ReturnType<typeof usePublicExpertDetailConsultationTabQuery>;
export type PublicExpertDetailConsultationTabLazyQueryHookResult = ReturnType<typeof usePublicExpertDetailConsultationTabLazyQuery>;
export type PublicExpertDetailConsultationTabQueryResult = Apollo.QueryResult<PublicExpertDetailConsultationTabQuery, PublicExpertDetailConsultationTabQueryVariables>;
export const UpdateExpertBusinessNameDocument = gql`
    mutation updateExpertBusinessName($input: UpdateExpertBusinessNameInput!) {
  updateExpertBusinessName(input: $input) {
    id
    businessName
  }
}
    `;
export type UpdateExpertBusinessNameMutationFn = Apollo.MutationFunction<UpdateExpertBusinessNameMutation, UpdateExpertBusinessNameMutationVariables>;

/**
 * __useUpdateExpertBusinessNameMutation__
 *
 * To run a mutation, you first call `useUpdateExpertBusinessNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpertBusinessNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpertBusinessNameMutation, { data, loading, error }] = useUpdateExpertBusinessNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpertBusinessNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpertBusinessNameMutation, UpdateExpertBusinessNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpertBusinessNameMutation, UpdateExpertBusinessNameMutationVariables>(UpdateExpertBusinessNameDocument, options);
      }
export type UpdateExpertBusinessNameMutationHookResult = ReturnType<typeof useUpdateExpertBusinessNameMutation>;
export type UpdateExpertBusinessNameMutationResult = Apollo.MutationResult<UpdateExpertBusinessNameMutation>;
export type UpdateExpertBusinessNameMutationOptions = Apollo.BaseMutationOptions<UpdateExpertBusinessNameMutation, UpdateExpertBusinessNameMutationVariables>;
export const AcceptContractAgreementDocument = gql`
    mutation acceptContractAgreement {
  acceptContractAgreement
}
    `;
export type AcceptContractAgreementMutationFn = Apollo.MutationFunction<AcceptContractAgreementMutation, AcceptContractAgreementMutationVariables>;

/**
 * __useAcceptContractAgreementMutation__
 *
 * To run a mutation, you first call `useAcceptContractAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptContractAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptContractAgreementMutation, { data, loading, error }] = useAcceptContractAgreementMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptContractAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AcceptContractAgreementMutation, AcceptContractAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptContractAgreementMutation, AcceptContractAgreementMutationVariables>(AcceptContractAgreementDocument, options);
      }
export type AcceptContractAgreementMutationHookResult = ReturnType<typeof useAcceptContractAgreementMutation>;
export type AcceptContractAgreementMutationResult = Apollo.MutationResult<AcceptContractAgreementMutation>;
export type AcceptContractAgreementMutationOptions = Apollo.BaseMutationOptions<AcceptContractAgreementMutation, AcceptContractAgreementMutationVariables>;
export const ExpertLegalBusinessNameDocument = gql`
    query expertLegalBusinessName($id: Int!) {
  expert(id: $id) {
    legalBusinessName
  }
}
    `;

/**
 * __useExpertLegalBusinessNameQuery__
 *
 * To run a query within a React component, call `useExpertLegalBusinessNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertLegalBusinessNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertLegalBusinessNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpertLegalBusinessNameQuery(baseOptions: Apollo.QueryHookOptions<ExpertLegalBusinessNameQuery, ExpertLegalBusinessNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertLegalBusinessNameQuery, ExpertLegalBusinessNameQueryVariables>(ExpertLegalBusinessNameDocument, options);
      }
export function useExpertLegalBusinessNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertLegalBusinessNameQuery, ExpertLegalBusinessNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertLegalBusinessNameQuery, ExpertLegalBusinessNameQueryVariables>(ExpertLegalBusinessNameDocument, options);
        }
export type ExpertLegalBusinessNameQueryHookResult = ReturnType<typeof useExpertLegalBusinessNameQuery>;
export type ExpertLegalBusinessNameLazyQueryHookResult = ReturnType<typeof useExpertLegalBusinessNameLazyQuery>;
export type ExpertLegalBusinessNameQueryResult = Apollo.QueryResult<ExpertLegalBusinessNameQuery, ExpertLegalBusinessNameQueryVariables>;
export const CreateAccountLinkDocument = gql`
    mutation createAccountLink($input: CreateAccountLinkInput!) {
  createAccountLink(input: $input)
}
    `;
export type CreateAccountLinkMutationFn = Apollo.MutationFunction<CreateAccountLinkMutation, CreateAccountLinkMutationVariables>;

/**
 * __useCreateAccountLinkMutation__
 *
 * To run a mutation, you first call `useCreateAccountLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountLinkMutation, { data, loading, error }] = useCreateAccountLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountLinkMutation, CreateAccountLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountLinkMutation, CreateAccountLinkMutationVariables>(CreateAccountLinkDocument, options);
      }
export type CreateAccountLinkMutationHookResult = ReturnType<typeof useCreateAccountLinkMutation>;
export type CreateAccountLinkMutationResult = Apollo.MutationResult<CreateAccountLinkMutation>;
export type CreateAccountLinkMutationOptions = Apollo.BaseMutationOptions<CreateAccountLinkMutation, CreateAccountLinkMutationVariables>;
export const ExpertDocument = gql`
    query expert($id: Int!, $reviewsInput: ReviewsInput) {
  expert(id: $id) {
    id
    customCancelationPolicy
    profileName
    slug
    email
    countryIsoCode
    countryState
    city
    facebookAccountUrl
    instagramAccountUrl
    youtubeAccountUrl
    twitterAccountUrl
    linkedInAccountUrl
    websiteUrl
    status
    subscribersCount
    isFeatured
    isFundraiser
    isStripeOnboarded
    isStripeAccountActivated
    isFindable
    isPublicVisible
    isConsultationRecapFormEnabled
    businessName
    legalBusinessName
    currencyIsoCode
    platformFeePercentage
    capabilities
    regions {
      id
      title
    }
    createdAtUtc {
      isoFormat
    }
    updatedAtUtc {
      isoFormat
    }
    mainUser {
      id
      timezone
    }
    users {
      id
      email
      status
      title
      firstName
      lastName
      timezone
      profileImageUrl
      isMain
      zoomAccountId
      isZoomAccountActivated
      bookingsCount
      activeSessionsCount
      capabilities
      totalEarned {
        total
        currencyIsoCode
      }
      nonBookedAvailabilityHours
      zoomAccountType
      createdAtUtc {
        isoFormat
      }
      updatedAtUtc {
        isoFormat
      }
      notificationEmails {
        email
      }
      zoomConnectedEmail
      featureFlags {
        id
      }
    }
    testimonials {
      data {
        id
        feedback
        clientName
        consultationName
        positionIndexWeight
        createdAtUtc {
          isoFormat
        }
        expertUser {
          id
        }
      }
    }
    tags {
      id
      title
    }
    reviews(input: $reviewsInput) {
      data {
        id
        rating
        feedback
        isVisible
        createdAtUtc {
          isoFormat
        }
        client {
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useExpertQuery__
 *
 * To run a query within a React component, call `useExpertQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertQuery({
 *   variables: {
 *      id: // value for 'id'
 *      reviewsInput: // value for 'reviewsInput'
 *   },
 * });
 */
export function useExpertQuery(baseOptions: Apollo.QueryHookOptions<ExpertQuery, ExpertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertQuery, ExpertQueryVariables>(ExpertDocument, options);
      }
export function useExpertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertQuery, ExpertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertQuery, ExpertQueryVariables>(ExpertDocument, options);
        }
export type ExpertQueryHookResult = ReturnType<typeof useExpertQuery>;
export type ExpertLazyQueryHookResult = ReturnType<typeof useExpertLazyQuery>;
export type ExpertQueryResult = Apollo.QueryResult<ExpertQuery, ExpertQueryVariables>;
export const PublicExpertAvailabilitiesDocument = gql`
    query publicExpertAvailabilities($input: PublicExpertAvailabilitiesInput!) {
  publicExpertAvailabilities(input: $input) {
    id
    startAtUtc {
      isoFormat
    }
    endAtUtc {
      isoFormat
    }
  }
}
    `;

/**
 * __usePublicExpertAvailabilitiesQuery__
 *
 * To run a query within a React component, call `usePublicExpertAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicExpertAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicExpertAvailabilitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicExpertAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<PublicExpertAvailabilitiesQuery, PublicExpertAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicExpertAvailabilitiesQuery, PublicExpertAvailabilitiesQueryVariables>(PublicExpertAvailabilitiesDocument, options);
      }
export function usePublicExpertAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicExpertAvailabilitiesQuery, PublicExpertAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicExpertAvailabilitiesQuery, PublicExpertAvailabilitiesQueryVariables>(PublicExpertAvailabilitiesDocument, options);
        }
export type PublicExpertAvailabilitiesQueryHookResult = ReturnType<typeof usePublicExpertAvailabilitiesQuery>;
export type PublicExpertAvailabilitiesLazyQueryHookResult = ReturnType<typeof usePublicExpertAvailabilitiesLazyQuery>;
export type PublicExpertAvailabilitiesQueryResult = Apollo.QueryResult<PublicExpertAvailabilitiesQuery, PublicExpertAvailabilitiesQueryVariables>;
export const FirstPublicExpertAvailabilityDocument = gql`
    query firstPublicExpertAvailability($expertSessionId: Int!) {
  firstPublicExpertAvailability(expertSessionId: $expertSessionId) {
    id
    startAtUtc {
      isoFormat
    }
    endAtUtc {
      isoFormat
    }
  }
}
    `;

/**
 * __useFirstPublicExpertAvailabilityQuery__
 *
 * To run a query within a React component, call `useFirstPublicExpertAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirstPublicExpertAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirstPublicExpertAvailabilityQuery({
 *   variables: {
 *      expertSessionId: // value for 'expertSessionId'
 *   },
 * });
 */
export function useFirstPublicExpertAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<FirstPublicExpertAvailabilityQuery, FirstPublicExpertAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirstPublicExpertAvailabilityQuery, FirstPublicExpertAvailabilityQueryVariables>(FirstPublicExpertAvailabilityDocument, options);
      }
export function useFirstPublicExpertAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirstPublicExpertAvailabilityQuery, FirstPublicExpertAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirstPublicExpertAvailabilityQuery, FirstPublicExpertAvailabilityQueryVariables>(FirstPublicExpertAvailabilityDocument, options);
        }
export type FirstPublicExpertAvailabilityQueryHookResult = ReturnType<typeof useFirstPublicExpertAvailabilityQuery>;
export type FirstPublicExpertAvailabilityLazyQueryHookResult = ReturnType<typeof useFirstPublicExpertAvailabilityLazyQuery>;
export type FirstPublicExpertAvailabilityQueryResult = Apollo.QueryResult<FirstPublicExpertAvailabilityQuery, FirstPublicExpertAvailabilityQueryVariables>;
export const AddExpertToFavoritesDocument = gql`
    mutation addExpertToFavorites($expertId: Int!) {
  addExpertToFavorites(expertId: $expertId)
}
    `;
export type AddExpertToFavoritesMutationFn = Apollo.MutationFunction<AddExpertToFavoritesMutation, AddExpertToFavoritesMutationVariables>;

/**
 * __useAddExpertToFavoritesMutation__
 *
 * To run a mutation, you first call `useAddExpertToFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExpertToFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExpertToFavoritesMutation, { data, loading, error }] = useAddExpertToFavoritesMutation({
 *   variables: {
 *      expertId: // value for 'expertId'
 *   },
 * });
 */
export function useAddExpertToFavoritesMutation(baseOptions?: Apollo.MutationHookOptions<AddExpertToFavoritesMutation, AddExpertToFavoritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExpertToFavoritesMutation, AddExpertToFavoritesMutationVariables>(AddExpertToFavoritesDocument, options);
      }
export type AddExpertToFavoritesMutationHookResult = ReturnType<typeof useAddExpertToFavoritesMutation>;
export type AddExpertToFavoritesMutationResult = Apollo.MutationResult<AddExpertToFavoritesMutation>;
export type AddExpertToFavoritesMutationOptions = Apollo.BaseMutationOptions<AddExpertToFavoritesMutation, AddExpertToFavoritesMutationVariables>;
export const RemoveExpertFromFavoritesDocument = gql`
    mutation removeExpertFromFavorites($expertId: Int!) {
  removeExpertFromFavorites(expertId: $expertId)
}
    `;
export type RemoveExpertFromFavoritesMutationFn = Apollo.MutationFunction<RemoveExpertFromFavoritesMutation, RemoveExpertFromFavoritesMutationVariables>;

/**
 * __useRemoveExpertFromFavoritesMutation__
 *
 * To run a mutation, you first call `useRemoveExpertFromFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExpertFromFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExpertFromFavoritesMutation, { data, loading, error }] = useRemoveExpertFromFavoritesMutation({
 *   variables: {
 *      expertId: // value for 'expertId'
 *   },
 * });
 */
export function useRemoveExpertFromFavoritesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExpertFromFavoritesMutation, RemoveExpertFromFavoritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveExpertFromFavoritesMutation, RemoveExpertFromFavoritesMutationVariables>(RemoveExpertFromFavoritesDocument, options);
      }
export type RemoveExpertFromFavoritesMutationHookResult = ReturnType<typeof useRemoveExpertFromFavoritesMutation>;
export type RemoveExpertFromFavoritesMutationResult = Apollo.MutationResult<RemoveExpertFromFavoritesMutation>;
export type RemoveExpertFromFavoritesMutationOptions = Apollo.BaseMutationOptions<RemoveExpertFromFavoritesMutation, RemoveExpertFromFavoritesMutationVariables>;
export const FavoriteExpertsSlugsDocument = gql`
    query favoriteExpertsSlugs($id: Int!) {
  clientMe(id: $id) {
    id
    favoriteExpertsSlugs
  }
}
    `;

/**
 * __useFavoriteExpertsSlugsQuery__
 *
 * To run a query within a React component, call `useFavoriteExpertsSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteExpertsSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteExpertsSlugsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFavoriteExpertsSlugsQuery(baseOptions: Apollo.QueryHookOptions<FavoriteExpertsSlugsQuery, FavoriteExpertsSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteExpertsSlugsQuery, FavoriteExpertsSlugsQueryVariables>(FavoriteExpertsSlugsDocument, options);
      }
export function useFavoriteExpertsSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteExpertsSlugsQuery, FavoriteExpertsSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteExpertsSlugsQuery, FavoriteExpertsSlugsQueryVariables>(FavoriteExpertsSlugsDocument, options);
        }
export type FavoriteExpertsSlugsQueryHookResult = ReturnType<typeof useFavoriteExpertsSlugsQuery>;
export type FavoriteExpertsSlugsLazyQueryHookResult = ReturnType<typeof useFavoriteExpertsSlugsLazyQuery>;
export type FavoriteExpertsSlugsQueryResult = Apollo.QueryResult<FavoriteExpertsSlugsQuery, FavoriteExpertsSlugsQueryVariables>;
export const ExpertMeWithStripeOnboardingTokenDocument = gql`
    query expertMeWithStripeOnboardingToken($id: Int!) {
  expertMe(id: $id) {
    id
    stripeOnboardingToken
    stripeId
  }
}
    `;

/**
 * __useExpertMeWithStripeOnboardingTokenQuery__
 *
 * To run a query within a React component, call `useExpertMeWithStripeOnboardingTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertMeWithStripeOnboardingTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertMeWithStripeOnboardingTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpertMeWithStripeOnboardingTokenQuery(baseOptions: Apollo.QueryHookOptions<ExpertMeWithStripeOnboardingTokenQuery, ExpertMeWithStripeOnboardingTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertMeWithStripeOnboardingTokenQuery, ExpertMeWithStripeOnboardingTokenQueryVariables>(ExpertMeWithStripeOnboardingTokenDocument, options);
      }
export function useExpertMeWithStripeOnboardingTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertMeWithStripeOnboardingTokenQuery, ExpertMeWithStripeOnboardingTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertMeWithStripeOnboardingTokenQuery, ExpertMeWithStripeOnboardingTokenQueryVariables>(ExpertMeWithStripeOnboardingTokenDocument, options);
        }
export type ExpertMeWithStripeOnboardingTokenQueryHookResult = ReturnType<typeof useExpertMeWithStripeOnboardingTokenQuery>;
export type ExpertMeWithStripeOnboardingTokenLazyQueryHookResult = ReturnType<typeof useExpertMeWithStripeOnboardingTokenLazyQuery>;
export type ExpertMeWithStripeOnboardingTokenQueryResult = Apollo.QueryResult<ExpertMeWithStripeOnboardingTokenQuery, ExpertMeWithStripeOnboardingTokenQueryVariables>;
export const ExpertPurchaseCommissionsDocument = gql`
    query expertPurchaseCommissions($id: Int!, $purchaseCommissionsInput: CursorPaginationInput!) {
  expertMe(id: $id) {
    id
    purchaseCommissions(input: $purchaseCommissionsInput) {
      edges {
        node {
          id
          status
          description
          createdAtUtc {
            isoFormat
          }
          vendorExpertCommissionAmount {
            total
            currencyIsoCode
          }
          vendor {
            name
            attachment {
              url
              alt
            }
          }
          client {
            fullName
          }
          totalPrice {
            total
            currencyIsoCode
          }
          attachment {
            url
            alt
          }
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    `;

/**
 * __useExpertPurchaseCommissionsQuery__
 *
 * To run a query within a React component, call `useExpertPurchaseCommissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertPurchaseCommissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertPurchaseCommissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      purchaseCommissionsInput: // value for 'purchaseCommissionsInput'
 *   },
 * });
 */
export function useExpertPurchaseCommissionsQuery(baseOptions: Apollo.QueryHookOptions<ExpertPurchaseCommissionsQuery, ExpertPurchaseCommissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertPurchaseCommissionsQuery, ExpertPurchaseCommissionsQueryVariables>(ExpertPurchaseCommissionsDocument, options);
      }
export function useExpertPurchaseCommissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertPurchaseCommissionsQuery, ExpertPurchaseCommissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertPurchaseCommissionsQuery, ExpertPurchaseCommissionsQueryVariables>(ExpertPurchaseCommissionsDocument, options);
        }
export type ExpertPurchaseCommissionsQueryHookResult = ReturnType<typeof useExpertPurchaseCommissionsQuery>;
export type ExpertPurchaseCommissionsLazyQueryHookResult = ReturnType<typeof useExpertPurchaseCommissionsLazyQuery>;
export type ExpertPurchaseCommissionsQueryResult = Apollo.QueryResult<ExpertPurchaseCommissionsQuery, ExpertPurchaseCommissionsQueryVariables>;
export const ExpertPurchasesDocument = gql`
    query expertPurchases($id: Int!, $purchasesInput: CursorPaginationInput!) {
  expertMe(id: $id) {
    id
    purchases(input: $purchasesInput) {
      edges {
        node {
          id
          status
          description
          createdAtUtc {
            isoFormat
          }
          vendorExpertCommissionAmount {
            total
            currencyIsoCode
          }
          vendor {
            name
            attachment {
              url
              alt
            }
          }
          client {
            fullName
          }
          totalPrice {
            total
            currencyIsoCode
          }
          attachment {
            url
            alt
          }
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    `;

/**
 * __useExpertPurchasesQuery__
 *
 * To run a query within a React component, call `useExpertPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertPurchasesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      purchasesInput: // value for 'purchasesInput'
 *   },
 * });
 */
export function useExpertPurchasesQuery(baseOptions: Apollo.QueryHookOptions<ExpertPurchasesQuery, ExpertPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertPurchasesQuery, ExpertPurchasesQueryVariables>(ExpertPurchasesDocument, options);
      }
export function useExpertPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertPurchasesQuery, ExpertPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertPurchasesQuery, ExpertPurchasesQueryVariables>(ExpertPurchasesDocument, options);
        }
export type ExpertPurchasesQueryHookResult = ReturnType<typeof useExpertPurchasesQuery>;
export type ExpertPurchasesLazyQueryHookResult = ReturnType<typeof useExpertPurchasesLazyQuery>;
export type ExpertPurchasesQueryResult = Apollo.QueryResult<ExpertPurchasesQuery, ExpertPurchasesQueryVariables>;
export const AdminCreateExpertRegionDocument = gql`
    mutation adminCreateExpertRegion($input: CreateExpertRegionInput!) {
  adminCreateExpertRegion(input: $input) {
    id
    regions {
      id
    }
  }
}
    `;
export type AdminCreateExpertRegionMutationFn = Apollo.MutationFunction<AdminCreateExpertRegionMutation, AdminCreateExpertRegionMutationVariables>;

/**
 * __useAdminCreateExpertRegionMutation__
 *
 * To run a mutation, you first call `useAdminCreateExpertRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateExpertRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateExpertRegionMutation, { data, loading, error }] = useAdminCreateExpertRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateExpertRegionMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateExpertRegionMutation, AdminCreateExpertRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateExpertRegionMutation, AdminCreateExpertRegionMutationVariables>(AdminCreateExpertRegionDocument, options);
      }
export type AdminCreateExpertRegionMutationHookResult = ReturnType<typeof useAdminCreateExpertRegionMutation>;
export type AdminCreateExpertRegionMutationResult = Apollo.MutationResult<AdminCreateExpertRegionMutation>;
export type AdminCreateExpertRegionMutationOptions = Apollo.BaseMutationOptions<AdminCreateExpertRegionMutation, AdminCreateExpertRegionMutationVariables>;
export const AdminDeleteExpertRegionDocument = gql`
    mutation adminDeleteExpertRegion($input: DeleteExpertRegionInput!) {
  adminDeleteExpertRegion(input: $input) {
    id
    regions {
      id
    }
  }
}
    `;
export type AdminDeleteExpertRegionMutationFn = Apollo.MutationFunction<AdminDeleteExpertRegionMutation, AdminDeleteExpertRegionMutationVariables>;

/**
 * __useAdminDeleteExpertRegionMutation__
 *
 * To run a mutation, you first call `useAdminDeleteExpertRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteExpertRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteExpertRegionMutation, { data, loading, error }] = useAdminDeleteExpertRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDeleteExpertRegionMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteExpertRegionMutation, AdminDeleteExpertRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteExpertRegionMutation, AdminDeleteExpertRegionMutationVariables>(AdminDeleteExpertRegionDocument, options);
      }
export type AdminDeleteExpertRegionMutationHookResult = ReturnType<typeof useAdminDeleteExpertRegionMutation>;
export type AdminDeleteExpertRegionMutationResult = Apollo.MutationResult<AdminDeleteExpertRegionMutation>;
export type AdminDeleteExpertRegionMutationOptions = Apollo.BaseMutationOptions<AdminDeleteExpertRegionMutation, AdminDeleteExpertRegionMutationVariables>;
export const AdminUpdateExpertRegionDocument = gql`
    mutation adminUpdateExpertRegion($input: UpdateExpertRegionInput!) {
  adminUpdateExpertRegion(input: $input) {
    id
    regions {
      positionIndexWeight
    }
  }
}
    `;
export type AdminUpdateExpertRegionMutationFn = Apollo.MutationFunction<AdminUpdateExpertRegionMutation, AdminUpdateExpertRegionMutationVariables>;

/**
 * __useAdminUpdateExpertRegionMutation__
 *
 * To run a mutation, you first call `useAdminUpdateExpertRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateExpertRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateExpertRegionMutation, { data, loading, error }] = useAdminUpdateExpertRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateExpertRegionMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateExpertRegionMutation, AdminUpdateExpertRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateExpertRegionMutation, AdminUpdateExpertRegionMutationVariables>(AdminUpdateExpertRegionDocument, options);
      }
export type AdminUpdateExpertRegionMutationHookResult = ReturnType<typeof useAdminUpdateExpertRegionMutation>;
export type AdminUpdateExpertRegionMutationResult = Apollo.MutationResult<AdminUpdateExpertRegionMutation>;
export type AdminUpdateExpertRegionMutationOptions = Apollo.BaseMutationOptions<AdminUpdateExpertRegionMutation, AdminUpdateExpertRegionMutationVariables>;
export const ClientExpertSessionDocument = gql`
    query clientExpertSession($input: ExpertSessionClientInput!) {
  clientExpertSession(input: $input) {
    id
    lengthInMinutes
    title
    isUpToThreeGuestsAllowed
    sessionType
    description
    expert {
      id
      profileName
      customCancelationPolicy
      profileImageAttachment {
        url
        alt
        id
      }
    }
    expertUser {
      id
      firstName
      lastName
    }
    payPrice {
      total
      currencyIsoCode
      calculatedPrices {
        total
        currencyIsoCode
      }
    }
    creditPrice {
      total
      currencyIsoCode
      calculatedPrices {
        total
        currencyIsoCode
      }
    }
    couponPrice {
      total
      currencyIsoCode
      calculatedPrices {
        total
        currencyIsoCode
      }
    }
    couponCode
    promoCode {
      code
      amount
      linkToTac
    }
    price {
      total
      currencyIsoCode
      calculatedPrices {
        total
        currencyIsoCode
      }
    }
  }
}
    `;

/**
 * __useClientExpertSessionQuery__
 *
 * To run a query within a React component, call `useClientExpertSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientExpertSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientExpertSessionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientExpertSessionQuery(baseOptions: Apollo.QueryHookOptions<ClientExpertSessionQuery, ClientExpertSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientExpertSessionQuery, ClientExpertSessionQueryVariables>(ClientExpertSessionDocument, options);
      }
export function useClientExpertSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientExpertSessionQuery, ClientExpertSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientExpertSessionQuery, ClientExpertSessionQueryVariables>(ClientExpertSessionDocument, options);
        }
export type ClientExpertSessionQueryHookResult = ReturnType<typeof useClientExpertSessionQuery>;
export type ClientExpertSessionLazyQueryHookResult = ReturnType<typeof useClientExpertSessionLazyQuery>;
export type ClientExpertSessionQueryResult = Apollo.QueryResult<ClientExpertSessionQuery, ClientExpertSessionQueryVariables>;
export const ExpertShowroomCommissionsDocument = gql`
    query expertShowroomCommissions($id: Int!, $showroomCommissionsInput: CursorPaginationInput!) {
  expertMe(id: $id) {
    id
    showroomCommissions(input: $showroomCommissionsInput) {
      edges {
        node {
          id
          createdAtUtc {
            isoFormat
          }
          rate
          status
          quantity
          productData
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    `;

/**
 * __useExpertShowroomCommissionsQuery__
 *
 * To run a query within a React component, call `useExpertShowroomCommissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertShowroomCommissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertShowroomCommissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      showroomCommissionsInput: // value for 'showroomCommissionsInput'
 *   },
 * });
 */
export function useExpertShowroomCommissionsQuery(baseOptions: Apollo.QueryHookOptions<ExpertShowroomCommissionsQuery, ExpertShowroomCommissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertShowroomCommissionsQuery, ExpertShowroomCommissionsQueryVariables>(ExpertShowroomCommissionsDocument, options);
      }
export function useExpertShowroomCommissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertShowroomCommissionsQuery, ExpertShowroomCommissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertShowroomCommissionsQuery, ExpertShowroomCommissionsQueryVariables>(ExpertShowroomCommissionsDocument, options);
        }
export type ExpertShowroomCommissionsQueryHookResult = ReturnType<typeof useExpertShowroomCommissionsQuery>;
export type ExpertShowroomCommissionsLazyQueryHookResult = ReturnType<typeof useExpertShowroomCommissionsLazyQuery>;
export type ExpertShowroomCommissionsQueryResult = Apollo.QueryResult<ExpertShowroomCommissionsQuery, ExpertShowroomCommissionsQueryVariables>;
export const UpdateExpertUserDocument = gql`
    mutation updateExpertUser($input: InviteExpertUserInput!) {
  inviteExpertUser(input: $input) {
    id
  }
}
    `;
export type UpdateExpertUserMutationFn = Apollo.MutationFunction<UpdateExpertUserMutation, UpdateExpertUserMutationVariables>;

/**
 * __useUpdateExpertUserMutation__
 *
 * To run a mutation, you first call `useUpdateExpertUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpertUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpertUserMutation, { data, loading, error }] = useUpdateExpertUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpertUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpertUserMutation, UpdateExpertUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpertUserMutation, UpdateExpertUserMutationVariables>(UpdateExpertUserDocument, options);
      }
export type UpdateExpertUserMutationHookResult = ReturnType<typeof useUpdateExpertUserMutation>;
export type UpdateExpertUserMutationResult = Apollo.MutationResult<UpdateExpertUserMutation>;
export type UpdateExpertUserMutationOptions = Apollo.BaseMutationOptions<UpdateExpertUserMutation, UpdateExpertUserMutationVariables>;
export const SuspendExpertUserDocument = gql`
    mutation suspendExpertUser($id: Int!) {
  suspendExpertUser(id: $id) {
    id
  }
}
    `;
export type SuspendExpertUserMutationFn = Apollo.MutationFunction<SuspendExpertUserMutation, SuspendExpertUserMutationVariables>;

/**
 * __useSuspendExpertUserMutation__
 *
 * To run a mutation, you first call `useSuspendExpertUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendExpertUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendExpertUserMutation, { data, loading, error }] = useSuspendExpertUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuspendExpertUserMutation(baseOptions?: Apollo.MutationHookOptions<SuspendExpertUserMutation, SuspendExpertUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendExpertUserMutation, SuspendExpertUserMutationVariables>(SuspendExpertUserDocument, options);
      }
export type SuspendExpertUserMutationHookResult = ReturnType<typeof useSuspendExpertUserMutation>;
export type SuspendExpertUserMutationResult = Apollo.MutationResult<SuspendExpertUserMutation>;
export type SuspendExpertUserMutationOptions = Apollo.BaseMutationOptions<SuspendExpertUserMutation, SuspendExpertUserMutationVariables>;
export const ActivateExpertUserDocument = gql`
    mutation activateExpertUser($id: Int!) {
  activateExpertUser(id: $id) {
    id
  }
}
    `;
export type ActivateExpertUserMutationFn = Apollo.MutationFunction<ActivateExpertUserMutation, ActivateExpertUserMutationVariables>;

/**
 * __useActivateExpertUserMutation__
 *
 * To run a mutation, you first call `useActivateExpertUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateExpertUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateExpertUserMutation, { data, loading, error }] = useActivateExpertUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateExpertUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateExpertUserMutation, ActivateExpertUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateExpertUserMutation, ActivateExpertUserMutationVariables>(ActivateExpertUserDocument, options);
      }
export type ActivateExpertUserMutationHookResult = ReturnType<typeof useActivateExpertUserMutation>;
export type ActivateExpertUserMutationResult = Apollo.MutationResult<ActivateExpertUserMutation>;
export type ActivateExpertUserMutationOptions = Apollo.BaseMutationOptions<ActivateExpertUserMutation, ActivateExpertUserMutationVariables>;
export const ResendExpertUserInvitationDocument = gql`
    mutation resendExpertUserInvitation($id: Int!) {
  resendExpertUserInvitation(id: $id) {
    id
  }
}
    `;
export type ResendExpertUserInvitationMutationFn = Apollo.MutationFunction<ResendExpertUserInvitationMutation, ResendExpertUserInvitationMutationVariables>;

/**
 * __useResendExpertUserInvitationMutation__
 *
 * To run a mutation, you first call `useResendExpertUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendExpertUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendExpertUserInvitationMutation, { data, loading, error }] = useResendExpertUserInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendExpertUserInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendExpertUserInvitationMutation, ResendExpertUserInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendExpertUserInvitationMutation, ResendExpertUserInvitationMutationVariables>(ResendExpertUserInvitationDocument, options);
      }
export type ResendExpertUserInvitationMutationHookResult = ReturnType<typeof useResendExpertUserInvitationMutation>;
export type ResendExpertUserInvitationMutationResult = Apollo.MutationResult<ResendExpertUserInvitationMutation>;
export type ResendExpertUserInvitationMutationOptions = Apollo.BaseMutationOptions<ResendExpertUserInvitationMutation, ResendExpertUserInvitationMutationVariables>;
export const ExpertUsersDocument = gql`
    query expertUsers($input: ExpertUsersInput) {
  expertUsers(input: $input) {
    paginationInfo {
      nextPage
      totalCount
      currentPage
    }
    data {
      id
      email
      firstName
      lastName
      status
      isMain
      activeSessionsCount
      bookingsCount
      totalEarned {
        total
        currencyIsoCode
      }
      createdAtUtc {
        isoFormat
      }
    }
  }
}
    `;

/**
 * __useExpertUsersQuery__
 *
 * To run a query within a React component, call `useExpertUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExpertUsersQuery(baseOptions?: Apollo.QueryHookOptions<ExpertUsersQuery, ExpertUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertUsersQuery, ExpertUsersQueryVariables>(ExpertUsersDocument, options);
      }
export function useExpertUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertUsersQuery, ExpertUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertUsersQuery, ExpertUsersQueryVariables>(ExpertUsersDocument, options);
        }
export type ExpertUsersQueryHookResult = ReturnType<typeof useExpertUsersQuery>;
export type ExpertUsersLazyQueryHookResult = ReturnType<typeof useExpertUsersLazyQuery>;
export type ExpertUsersQueryResult = Apollo.QueryResult<ExpertUsersQuery, ExpertUsersQueryVariables>;
export const ExpertMeTradeLicensesDocument = gql`
    query expertMeTradeLicenses($id: Int!, $input: ExpertTradeLicensesInput!) {
  expertMe(id: $id) {
    tradeLicenses(input: $input) {
      edges {
        node {
          id
          name
          isSingleUse
          licenseNumber
          expiresAtUtc {
            isoFormat
          }
          isActive
          countryStates
          attachments {
            name
            id
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useExpertMeTradeLicensesQuery__
 *
 * To run a query within a React component, call `useExpertMeTradeLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertMeTradeLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertMeTradeLicensesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExpertMeTradeLicensesQuery(baseOptions: Apollo.QueryHookOptions<ExpertMeTradeLicensesQuery, ExpertMeTradeLicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertMeTradeLicensesQuery, ExpertMeTradeLicensesQueryVariables>(ExpertMeTradeLicensesDocument, options);
      }
export function useExpertMeTradeLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertMeTradeLicensesQuery, ExpertMeTradeLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertMeTradeLicensesQuery, ExpertMeTradeLicensesQueryVariables>(ExpertMeTradeLicensesDocument, options);
        }
export type ExpertMeTradeLicensesQueryHookResult = ReturnType<typeof useExpertMeTradeLicensesQuery>;
export type ExpertMeTradeLicensesLazyQueryHookResult = ReturnType<typeof useExpertMeTradeLicensesLazyQuery>;
export type ExpertMeTradeLicensesQueryResult = Apollo.QueryResult<ExpertMeTradeLicensesQuery, ExpertMeTradeLicensesQueryVariables>;
export const ExpertUpcomingSessionsDocument = gql`
    query expertUpcomingSessions($input: ExpertBookedSessionsInput) {
  expertBookedSessions(input: $input) {
    stats {
      totalPrice {
        currencyIsoCode
        base
      }
    }
    paginationInfo {
      totalCount
    }
    data {
      id
      sessionData {
        title
        lengthInMinutes
        sessionCapacity
        minimumSessionSize
        sessionType
        price {
          total
          currencyIsoCode
        }
      }
      status
      sessionClients {
        client {
          id
          firstName
          lastName
          contactEmail
        }
      }
      startAtUtc {
        isoFormat
      }
      endAtUtc {
        isoFormat
      }
    }
  }
}
    `;

/**
 * __useExpertUpcomingSessionsQuery__
 *
 * To run a query within a React component, call `useExpertUpcomingSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertUpcomingSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertUpcomingSessionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExpertUpcomingSessionsQuery(baseOptions?: Apollo.QueryHookOptions<ExpertUpcomingSessionsQuery, ExpertUpcomingSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertUpcomingSessionsQuery, ExpertUpcomingSessionsQueryVariables>(ExpertUpcomingSessionsDocument, options);
      }
export function useExpertUpcomingSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertUpcomingSessionsQuery, ExpertUpcomingSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertUpcomingSessionsQuery, ExpertUpcomingSessionsQueryVariables>(ExpertUpcomingSessionsDocument, options);
        }
export type ExpertUpcomingSessionsQueryHookResult = ReturnType<typeof useExpertUpcomingSessionsQuery>;
export type ExpertUpcomingSessionsLazyQueryHookResult = ReturnType<typeof useExpertUpcomingSessionsLazyQuery>;
export type ExpertUpcomingSessionsQueryResult = Apollo.QueryResult<ExpertUpcomingSessionsQuery, ExpertUpcomingSessionsQueryVariables>;
export const DeleteExpertUserCardDocument = gql`
    mutation deleteExpertUserCard($stripeId: String!) {
  deleteExpertUserCard(stripeId: $stripeId)
}
    `;
export type DeleteExpertUserCardMutationFn = Apollo.MutationFunction<DeleteExpertUserCardMutation, DeleteExpertUserCardMutationVariables>;

/**
 * __useDeleteExpertUserCardMutation__
 *
 * To run a mutation, you first call `useDeleteExpertUserCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpertUserCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpertUserCardMutation, { data, loading, error }] = useDeleteExpertUserCardMutation({
 *   variables: {
 *      stripeId: // value for 'stripeId'
 *   },
 * });
 */
export function useDeleteExpertUserCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExpertUserCardMutation, DeleteExpertUserCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExpertUserCardMutation, DeleteExpertUserCardMutationVariables>(DeleteExpertUserCardDocument, options);
      }
export type DeleteExpertUserCardMutationHookResult = ReturnType<typeof useDeleteExpertUserCardMutation>;
export type DeleteExpertUserCardMutationResult = Apollo.MutationResult<DeleteExpertUserCardMutation>;
export type DeleteExpertUserCardMutationOptions = Apollo.BaseMutationOptions<DeleteExpertUserCardMutation, DeleteExpertUserCardMutationVariables>;
export const SetupExpertUserPaymentMethodDocument = gql`
    mutation setupExpertUserPaymentMethod {
  setupClientPaymentMethod
}
    `;
export type SetupExpertUserPaymentMethodMutationFn = Apollo.MutationFunction<SetupExpertUserPaymentMethodMutation, SetupExpertUserPaymentMethodMutationVariables>;

/**
 * __useSetupExpertUserPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetupExpertUserPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupExpertUserPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupExpertUserPaymentMethodMutation, { data, loading, error }] = useSetupExpertUserPaymentMethodMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetupExpertUserPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetupExpertUserPaymentMethodMutation, SetupExpertUserPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupExpertUserPaymentMethodMutation, SetupExpertUserPaymentMethodMutationVariables>(SetupExpertUserPaymentMethodDocument, options);
      }
export type SetupExpertUserPaymentMethodMutationHookResult = ReturnType<typeof useSetupExpertUserPaymentMethodMutation>;
export type SetupExpertUserPaymentMethodMutationResult = Apollo.MutationResult<SetupExpertUserPaymentMethodMutation>;
export type SetupExpertUserPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetupExpertUserPaymentMethodMutation, SetupExpertUserPaymentMethodMutationVariables>;
export const ExpertUserMeDocument = gql`
    query expertUserMe($id: Int!) {
  expertMe(id: $id) {
    id
  }
}
    `;

/**
 * __useExpertUserMeQuery__
 *
 * To run a query within a React component, call `useExpertUserMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertUserMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertUserMeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpertUserMeQuery(baseOptions: Apollo.QueryHookOptions<ExpertUserMeQuery, ExpertUserMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertUserMeQuery, ExpertUserMeQueryVariables>(ExpertUserMeDocument, options);
      }
export function useExpertUserMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertUserMeQuery, ExpertUserMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertUserMeQuery, ExpertUserMeQueryVariables>(ExpertUserMeDocument, options);
        }
export type ExpertUserMeQueryHookResult = ReturnType<typeof useExpertUserMeQuery>;
export type ExpertUserMeLazyQueryHookResult = ReturnType<typeof useExpertUserMeLazyQuery>;
export type ExpertUserMeQueryResult = Apollo.QueryResult<ExpertUserMeQuery, ExpertUserMeQueryVariables>;
export const ExpertUserDocument = gql`
    query expertUser($id: Int!) {
  expertUser(id: $id) {
    id
    expert {
      id
      capabilities
    }
  }
}
    `;

/**
 * __useExpertUserQuery__
 *
 * To run a query within a React component, call `useExpertUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpertUserQuery(baseOptions: Apollo.QueryHookOptions<ExpertUserQuery, ExpertUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertUserQuery, ExpertUserQueryVariables>(ExpertUserDocument, options);
      }
export function useExpertUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertUserQuery, ExpertUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertUserQuery, ExpertUserQueryVariables>(ExpertUserDocument, options);
        }
export type ExpertUserQueryHookResult = ReturnType<typeof useExpertUserQuery>;
export type ExpertUserLazyQueryHookResult = ReturnType<typeof useExpertUserLazyQuery>;
export type ExpertUserQueryResult = Apollo.QueryResult<ExpertUserQuery, ExpertUserQueryVariables>;
export const ExpertVendorsDocument = gql`
    query expertVendors {
  vendors {
    attachment {
      url
      id
      name
      alt
    }
    brands
    expertCommission
    id
    name
    websiteUrl
  }
}
    `;

/**
 * __useExpertVendorsQuery__
 *
 * To run a query within a React component, call `useExpertVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpertVendorsQuery(baseOptions?: Apollo.QueryHookOptions<ExpertVendorsQuery, ExpertVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertVendorsQuery, ExpertVendorsQueryVariables>(ExpertVendorsDocument, options);
      }
export function useExpertVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertVendorsQuery, ExpertVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertVendorsQuery, ExpertVendorsQueryVariables>(ExpertVendorsDocument, options);
        }
export type ExpertVendorsQueryHookResult = ReturnType<typeof useExpertVendorsQuery>;
export type ExpertVendorsLazyQueryHookResult = ReturnType<typeof useExpertVendorsLazyQuery>;
export type ExpertVendorsQueryResult = Apollo.QueryResult<ExpertVendorsQuery, ExpertVendorsQueryVariables>;
export const AllPublicExpertsDocument = gql`
    query allPublicExperts {
  allPublicExperts {
    id
    slug
    availableExpertDetailTabs
  }
}
    `;

/**
 * __useAllPublicExpertsQuery__
 *
 * To run a query within a React component, call `useAllPublicExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPublicExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPublicExpertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPublicExpertsQuery(baseOptions?: Apollo.QueryHookOptions<AllPublicExpertsQuery, AllPublicExpertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPublicExpertsQuery, AllPublicExpertsQueryVariables>(AllPublicExpertsDocument, options);
      }
export function useAllPublicExpertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPublicExpertsQuery, AllPublicExpertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPublicExpertsQuery, AllPublicExpertsQueryVariables>(AllPublicExpertsDocument, options);
        }
export type AllPublicExpertsQueryHookResult = ReturnType<typeof useAllPublicExpertsQuery>;
export type AllPublicExpertsLazyQueryHookResult = ReturnType<typeof useAllPublicExpertsLazyQuery>;
export type AllPublicExpertsQueryResult = Apollo.QueryResult<AllPublicExpertsQuery, AllPublicExpertsQueryVariables>;
export const FeaturedExpertsDocument = gql`
    query featuredExperts($expertsInput: ExpertsInput) {
  publicExperts(input: $expertsInput) {
    data {
      slug
      id
      profileImageAttachment {
        id
        url
        alt
      }
      primaryLocation
      countryIsoCode
      city
      profileName
      jobTitle
    }
  }
}
    `;

/**
 * __useFeaturedExpertsQuery__
 *
 * To run a query within a React component, call `useFeaturedExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedExpertsQuery({
 *   variables: {
 *      expertsInput: // value for 'expertsInput'
 *   },
 * });
 */
export function useFeaturedExpertsQuery(baseOptions?: Apollo.QueryHookOptions<FeaturedExpertsQuery, FeaturedExpertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturedExpertsQuery, FeaturedExpertsQueryVariables>(FeaturedExpertsDocument, options);
      }
export function useFeaturedExpertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturedExpertsQuery, FeaturedExpertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturedExpertsQuery, FeaturedExpertsQueryVariables>(FeaturedExpertsDocument, options);
        }
export type FeaturedExpertsQueryHookResult = ReturnType<typeof useFeaturedExpertsQuery>;
export type FeaturedExpertsLazyQueryHookResult = ReturnType<typeof useFeaturedExpertsLazyQuery>;
export type FeaturedExpertsQueryResult = Apollo.QueryResult<FeaturedExpertsQuery, FeaturedExpertsQueryVariables>;
export const SpecificUsersFeatureFlagsDocument = gql`
    query specificUsersFeatureFlags {
  specificUsersFeatureFlags {
    id
    label
    description
    status
  }
}
    `;

/**
 * __useSpecificUsersFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useSpecificUsersFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecificUsersFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecificUsersFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpecificUsersFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<SpecificUsersFeatureFlagsQuery, SpecificUsersFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecificUsersFeatureFlagsQuery, SpecificUsersFeatureFlagsQueryVariables>(SpecificUsersFeatureFlagsDocument, options);
      }
export function useSpecificUsersFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecificUsersFeatureFlagsQuery, SpecificUsersFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecificUsersFeatureFlagsQuery, SpecificUsersFeatureFlagsQueryVariables>(SpecificUsersFeatureFlagsDocument, options);
        }
export type SpecificUsersFeatureFlagsQueryHookResult = ReturnType<typeof useSpecificUsersFeatureFlagsQuery>;
export type SpecificUsersFeatureFlagsLazyQueryHookResult = ReturnType<typeof useSpecificUsersFeatureFlagsLazyQuery>;
export type SpecificUsersFeatureFlagsQueryResult = Apollo.QueryResult<SpecificUsersFeatureFlagsQuery, SpecificUsersFeatureFlagsQueryVariables>;
export const AddExpertUserFeatureFlagDocument = gql`
    mutation addExpertUserFeatureFlag($input: UpdateExpertUserFeatureFlagInput!) {
  addExpertUserFeatureFlag(input: $input) {
    users {
      id
      featureFlags {
        id
      }
    }
  }
}
    `;
export type AddExpertUserFeatureFlagMutationFn = Apollo.MutationFunction<AddExpertUserFeatureFlagMutation, AddExpertUserFeatureFlagMutationVariables>;

/**
 * __useAddExpertUserFeatureFlagMutation__
 *
 * To run a mutation, you first call `useAddExpertUserFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExpertUserFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExpertUserFeatureFlagMutation, { data, loading, error }] = useAddExpertUserFeatureFlagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddExpertUserFeatureFlagMutation(baseOptions?: Apollo.MutationHookOptions<AddExpertUserFeatureFlagMutation, AddExpertUserFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExpertUserFeatureFlagMutation, AddExpertUserFeatureFlagMutationVariables>(AddExpertUserFeatureFlagDocument, options);
      }
export type AddExpertUserFeatureFlagMutationHookResult = ReturnType<typeof useAddExpertUserFeatureFlagMutation>;
export type AddExpertUserFeatureFlagMutationResult = Apollo.MutationResult<AddExpertUserFeatureFlagMutation>;
export type AddExpertUserFeatureFlagMutationOptions = Apollo.BaseMutationOptions<AddExpertUserFeatureFlagMutation, AddExpertUserFeatureFlagMutationVariables>;
export const RemoveExpertUserFeatureFlagDocument = gql`
    mutation removeExpertUserFeatureFlag($input: UpdateExpertUserFeatureFlagInput!) {
  removeExpertUserFeatureFlag(input: $input) {
    users {
      id
      featureFlags {
        id
      }
    }
  }
}
    `;
export type RemoveExpertUserFeatureFlagMutationFn = Apollo.MutationFunction<RemoveExpertUserFeatureFlagMutation, RemoveExpertUserFeatureFlagMutationVariables>;

/**
 * __useRemoveExpertUserFeatureFlagMutation__
 *
 * To run a mutation, you first call `useRemoveExpertUserFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExpertUserFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExpertUserFeatureFlagMutation, { data, loading, error }] = useRemoveExpertUserFeatureFlagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveExpertUserFeatureFlagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExpertUserFeatureFlagMutation, RemoveExpertUserFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveExpertUserFeatureFlagMutation, RemoveExpertUserFeatureFlagMutationVariables>(RemoveExpertUserFeatureFlagDocument, options);
      }
export type RemoveExpertUserFeatureFlagMutationHookResult = ReturnType<typeof useRemoveExpertUserFeatureFlagMutation>;
export type RemoveExpertUserFeatureFlagMutationResult = Apollo.MutationResult<RemoveExpertUserFeatureFlagMutation>;
export type RemoveExpertUserFeatureFlagMutationOptions = Apollo.BaseMutationOptions<RemoveExpertUserFeatureFlagMutation, RemoveExpertUserFeatureFlagMutationVariables>;
export const AdminNavigationGroupDocument = gql`
    query adminNavigationGroup($input: AdminNavigationGroupInput!) {
  adminNavigationGroup(input: $input) {
    id
    title
    navigations {
      id
      title
      status
      navigationGroupId
      rootItem {
        id
        parentId
        title
        positionIndexWeight
        subItemsWithImages
        cmsPage {
          id
          slug
          title
        }
        attachment {
          id
          url
          name
          alt
        }
      }
      createdAtUtc {
        isoFormat
      }
    }
  }
}
    `;

/**
 * __useAdminNavigationGroupQuery__
 *
 * To run a query within a React component, call `useAdminNavigationGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminNavigationGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminNavigationGroupQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminNavigationGroupQuery(baseOptions: Apollo.QueryHookOptions<AdminNavigationGroupQuery, AdminNavigationGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminNavigationGroupQuery, AdminNavigationGroupQueryVariables>(AdminNavigationGroupDocument, options);
      }
export function useAdminNavigationGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminNavigationGroupQuery, AdminNavigationGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminNavigationGroupQuery, AdminNavigationGroupQueryVariables>(AdminNavigationGroupDocument, options);
        }
export type AdminNavigationGroupQueryHookResult = ReturnType<typeof useAdminNavigationGroupQuery>;
export type AdminNavigationGroupLazyQueryHookResult = ReturnType<typeof useAdminNavigationGroupLazyQuery>;
export type AdminNavigationGroupQueryResult = Apollo.QueryResult<AdminNavigationGroupQuery, AdminNavigationGroupQueryVariables>;
export const PublishedNavigationGroupsDocument = gql`
    query publishedNavigationGroups {
  publishedNavigationGroups {
    id
    publishedNavigation {
      id
      rootItem {
        id
        title
        cmsPage {
          id
          href
        }
        children {
          id
          title
          subItemsWithImages
          positionIndexWeight
          cmsPage {
            id
            href
          }
          children {
            id
            title
            cmsPage {
              id
              href
            }
            attachment {
              id
              url
              name
              alt
            }
            positionIndexWeight
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePublishedNavigationGroupsQuery__
 *
 * To run a query within a React component, call `usePublishedNavigationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedNavigationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedNavigationGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublishedNavigationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<PublishedNavigationGroupsQuery, PublishedNavigationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedNavigationGroupsQuery, PublishedNavigationGroupsQueryVariables>(PublishedNavigationGroupsDocument, options);
      }
export function usePublishedNavigationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedNavigationGroupsQuery, PublishedNavigationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedNavigationGroupsQuery, PublishedNavigationGroupsQueryVariables>(PublishedNavigationGroupsDocument, options);
        }
export type PublishedNavigationGroupsQueryHookResult = ReturnType<typeof usePublishedNavigationGroupsQuery>;
export type PublishedNavigationGroupsLazyQueryHookResult = ReturnType<typeof usePublishedNavigationGroupsLazyQuery>;
export type PublishedNavigationGroupsQueryResult = Apollo.QueryResult<PublishedNavigationGroupsQuery, PublishedNavigationGroupsQueryVariables>;
export const CreateNavigationItemDocument = gql`
    mutation createNavigationItem($input: CreateNavigationItemInput!) {
  createNavigationItem(input: $input) {
    id
    parentId
    title
    positionIndexWeight
    subItemsWithImages
    cmsPage {
      id
      slug
      title
    }
    attachment {
      id
      url
      name
      alt
    }
  }
}
    `;
export type CreateNavigationItemMutationFn = Apollo.MutationFunction<CreateNavigationItemMutation, CreateNavigationItemMutationVariables>;

/**
 * __useCreateNavigationItemMutation__
 *
 * To run a mutation, you first call `useCreateNavigationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNavigationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNavigationItemMutation, { data, loading, error }] = useCreateNavigationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNavigationItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateNavigationItemMutation, CreateNavigationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNavigationItemMutation, CreateNavigationItemMutationVariables>(CreateNavigationItemDocument, options);
      }
export type CreateNavigationItemMutationHookResult = ReturnType<typeof useCreateNavigationItemMutation>;
export type CreateNavigationItemMutationResult = Apollo.MutationResult<CreateNavigationItemMutation>;
export type CreateNavigationItemMutationOptions = Apollo.BaseMutationOptions<CreateNavigationItemMutation, CreateNavigationItemMutationVariables>;
export const UpdateNavigationItemDocument = gql`
    mutation updateNavigationItem($input: UpdateNavigationItemInput!) {
  updateNavigationItem(input: $input) {
    id
    parentId
    title
    positionIndexWeight
    subItemsWithImages
    cmsPage {
      id
      slug
      title
    }
    attachment {
      id
      url
      name
      alt
    }
  }
}
    `;
export type UpdateNavigationItemMutationFn = Apollo.MutationFunction<UpdateNavigationItemMutation, UpdateNavigationItemMutationVariables>;

/**
 * __useUpdateNavigationItemMutation__
 *
 * To run a mutation, you first call `useUpdateNavigationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNavigationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNavigationItemMutation, { data, loading, error }] = useUpdateNavigationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNavigationItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNavigationItemMutation, UpdateNavigationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNavigationItemMutation, UpdateNavigationItemMutationVariables>(UpdateNavigationItemDocument, options);
      }
export type UpdateNavigationItemMutationHookResult = ReturnType<typeof useUpdateNavigationItemMutation>;
export type UpdateNavigationItemMutationResult = Apollo.MutationResult<UpdateNavigationItemMutation>;
export type UpdateNavigationItemMutationOptions = Apollo.BaseMutationOptions<UpdateNavigationItemMutation, UpdateNavigationItemMutationVariables>;
export const DeleteNavigationItemDocument = gql`
    mutation deleteNavigationItem($id: Int!) {
  deleteNavigationItem(id: $id)
}
    `;
export type DeleteNavigationItemMutationFn = Apollo.MutationFunction<DeleteNavigationItemMutation, DeleteNavigationItemMutationVariables>;

/**
 * __useDeleteNavigationItemMutation__
 *
 * To run a mutation, you first call `useDeleteNavigationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNavigationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNavigationItemMutation, { data, loading, error }] = useDeleteNavigationItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNavigationItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNavigationItemMutation, DeleteNavigationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNavigationItemMutation, DeleteNavigationItemMutationVariables>(DeleteNavigationItemDocument, options);
      }
export type DeleteNavigationItemMutationHookResult = ReturnType<typeof useDeleteNavigationItemMutation>;
export type DeleteNavigationItemMutationResult = Apollo.MutationResult<DeleteNavigationItemMutation>;
export type DeleteNavigationItemMutationOptions = Apollo.BaseMutationOptions<DeleteNavigationItemMutation, DeleteNavigationItemMutationVariables>;
export const ReorderNavigationItemsDocument = gql`
    mutation reorderNavigationItems($input: ReorderNavigationItemsInput!) {
  reorderNavigationItems(input: $input) {
    id
  }
}
    `;
export type ReorderNavigationItemsMutationFn = Apollo.MutationFunction<ReorderNavigationItemsMutation, ReorderNavigationItemsMutationVariables>;

/**
 * __useReorderNavigationItemsMutation__
 *
 * To run a mutation, you first call `useReorderNavigationItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderNavigationItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderNavigationItemsMutation, { data, loading, error }] = useReorderNavigationItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderNavigationItemsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderNavigationItemsMutation, ReorderNavigationItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderNavigationItemsMutation, ReorderNavigationItemsMutationVariables>(ReorderNavigationItemsDocument, options);
      }
export type ReorderNavigationItemsMutationHookResult = ReturnType<typeof useReorderNavigationItemsMutation>;
export type ReorderNavigationItemsMutationResult = Apollo.MutationResult<ReorderNavigationItemsMutation>;
export type ReorderNavigationItemsMutationOptions = Apollo.BaseMutationOptions<ReorderNavigationItemsMutation, ReorderNavigationItemsMutationVariables>;
export const NavigationDocument = gql`
    query navigation($id: Int!) {
  navigation(id: $id) {
    id
    title
    status
    children {
      id
      parentId
      title
      positionIndexWeight
      subItemsWithImages
      cmsPage {
        id
        slug
        title
      }
      attachment {
        id
        url
        name
        alt
      }
    }
  }
}
    `;

/**
 * __useNavigationQuery__
 *
 * To run a query within a React component, call `useNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNavigationQuery(baseOptions: Apollo.QueryHookOptions<NavigationQuery, NavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationQuery, NavigationQueryVariables>(NavigationDocument, options);
      }
export function useNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationQuery, NavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationQuery, NavigationQueryVariables>(NavigationDocument, options);
        }
export type NavigationQueryHookResult = ReturnType<typeof useNavigationQuery>;
export type NavigationLazyQueryHookResult = ReturnType<typeof useNavigationLazyQuery>;
export type NavigationQueryResult = Apollo.QueryResult<NavigationQuery, NavigationQueryVariables>;
export const CreateNavigationDocument = gql`
    mutation createNavigation($input: CreateNavigationInput!) {
  createNavigation(input: $input) {
    id
    status
    children {
      id
      title
    }
    createdAtUtc {
      isoFormat
    }
  }
}
    `;
export type CreateNavigationMutationFn = Apollo.MutationFunction<CreateNavigationMutation, CreateNavigationMutationVariables>;

/**
 * __useCreateNavigationMutation__
 *
 * To run a mutation, you first call `useCreateNavigationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNavigationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNavigationMutation, { data, loading, error }] = useCreateNavigationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNavigationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNavigationMutation, CreateNavigationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNavigationMutation, CreateNavigationMutationVariables>(CreateNavigationDocument, options);
      }
export type CreateNavigationMutationHookResult = ReturnType<typeof useCreateNavigationMutation>;
export type CreateNavigationMutationResult = Apollo.MutationResult<CreateNavigationMutation>;
export type CreateNavigationMutationOptions = Apollo.BaseMutationOptions<CreateNavigationMutation, CreateNavigationMutationVariables>;
export const UpdateNavigationDocument = gql`
    mutation updateNavigation($input: UpdateNavigationInput!) {
  updateNavigation(input: $input) {
    id
    status
    children {
      id
      title
    }
    createdAtUtc {
      isoFormat
    }
  }
}
    `;
export type UpdateNavigationMutationFn = Apollo.MutationFunction<UpdateNavigationMutation, UpdateNavigationMutationVariables>;

/**
 * __useUpdateNavigationMutation__
 *
 * To run a mutation, you first call `useUpdateNavigationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNavigationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNavigationMutation, { data, loading, error }] = useUpdateNavigationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNavigationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNavigationMutation, UpdateNavigationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNavigationMutation, UpdateNavigationMutationVariables>(UpdateNavigationDocument, options);
      }
export type UpdateNavigationMutationHookResult = ReturnType<typeof useUpdateNavigationMutation>;
export type UpdateNavigationMutationResult = Apollo.MutationResult<UpdateNavigationMutation>;
export type UpdateNavigationMutationOptions = Apollo.BaseMutationOptions<UpdateNavigationMutation, UpdateNavigationMutationVariables>;
export const DeleteNavigationDocument = gql`
    mutation deleteNavigation($id: Int!) {
  deleteNavigation(id: $id)
}
    `;
export type DeleteNavigationMutationFn = Apollo.MutationFunction<DeleteNavigationMutation, DeleteNavigationMutationVariables>;

/**
 * __useDeleteNavigationMutation__
 *
 * To run a mutation, you first call `useDeleteNavigationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNavigationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNavigationMutation, { data, loading, error }] = useDeleteNavigationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNavigationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNavigationMutation, DeleteNavigationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNavigationMutation, DeleteNavigationMutationVariables>(DeleteNavigationDocument, options);
      }
export type DeleteNavigationMutationHookResult = ReturnType<typeof useDeleteNavigationMutation>;
export type DeleteNavigationMutationResult = Apollo.MutationResult<DeleteNavigationMutation>;
export type DeleteNavigationMutationOptions = Apollo.BaseMutationOptions<DeleteNavigationMutation, DeleteNavigationMutationVariables>;
export const DuplicateNavigationDocument = gql`
    mutation duplicateNavigation($id: Int!) {
  duplicateNavigation(id: $id) {
    id
    status
    children {
      id
      title
    }
    createdAtUtc {
      isoFormat
    }
  }
}
    `;
export type DuplicateNavigationMutationFn = Apollo.MutationFunction<DuplicateNavigationMutation, DuplicateNavigationMutationVariables>;

/**
 * __useDuplicateNavigationMutation__
 *
 * To run a mutation, you first call `useDuplicateNavigationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateNavigationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateNavigationMutation, { data, loading, error }] = useDuplicateNavigationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateNavigationMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateNavigationMutation, DuplicateNavigationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateNavigationMutation, DuplicateNavigationMutationVariables>(DuplicateNavigationDocument, options);
      }
export type DuplicateNavigationMutationHookResult = ReturnType<typeof useDuplicateNavigationMutation>;
export type DuplicateNavigationMutationResult = Apollo.MutationResult<DuplicateNavigationMutation>;
export type DuplicateNavigationMutationOptions = Apollo.BaseMutationOptions<DuplicateNavigationMutation, DuplicateNavigationMutationVariables>;
export const OverrideOrderItemShippingIdDocument = gql`
    mutation overrideOrderItemShippingId($input: OverrideOrderItemShippingIdMutationInput!) {
  overrideOrderItemShippingId(input: $input) {
    id
  }
}
    `;
export type OverrideOrderItemShippingIdMutationFn = Apollo.MutationFunction<OverrideOrderItemShippingIdMutation, OverrideOrderItemShippingIdMutationVariables>;

/**
 * __useOverrideOrderItemShippingIdMutation__
 *
 * To run a mutation, you first call `useOverrideOrderItemShippingIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideOrderItemShippingIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideOrderItemShippingIdMutation, { data, loading, error }] = useOverrideOrderItemShippingIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOverrideOrderItemShippingIdMutation(baseOptions?: Apollo.MutationHookOptions<OverrideOrderItemShippingIdMutation, OverrideOrderItemShippingIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideOrderItemShippingIdMutation, OverrideOrderItemShippingIdMutationVariables>(OverrideOrderItemShippingIdDocument, options);
      }
export type OverrideOrderItemShippingIdMutationHookResult = ReturnType<typeof useOverrideOrderItemShippingIdMutation>;
export type OverrideOrderItemShippingIdMutationResult = Apollo.MutationResult<OverrideOrderItemShippingIdMutation>;
export type OverrideOrderItemShippingIdMutationOptions = Apollo.BaseMutationOptions<OverrideOrderItemShippingIdMutation, OverrideOrderItemShippingIdMutationVariables>;
export const CreateOrderNoteDocument = gql`
    mutation createOrderNote($input: CreateOrderNoteInput!, $notesInput: OrderNotesInput) {
  createOrderNote(input: $input) {
    id
    admin {
      id
      email
      name
    }
    order {
      id
      ...OrderNotes
    }
    message
    createdAtUtc {
      isoFormat
    }
  }
}
    ${OrderNotesFragmentDoc}`;
export type CreateOrderNoteMutationFn = Apollo.MutationFunction<CreateOrderNoteMutation, CreateOrderNoteMutationVariables>;

/**
 * __useCreateOrderNoteMutation__
 *
 * To run a mutation, you first call `useCreateOrderNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderNoteMutation, { data, loading, error }] = useCreateOrderNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *      notesInput: // value for 'notesInput'
 *   },
 * });
 */
export function useCreateOrderNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderNoteMutation, CreateOrderNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderNoteMutation, CreateOrderNoteMutationVariables>(CreateOrderNoteDocument, options);
      }
export type CreateOrderNoteMutationHookResult = ReturnType<typeof useCreateOrderNoteMutation>;
export type CreateOrderNoteMutationResult = Apollo.MutationResult<CreateOrderNoteMutation>;
export type CreateOrderNoteMutationOptions = Apollo.BaseMutationOptions<CreateOrderNoteMutation, CreateOrderNoteMutationVariables>;
export const OrderNotesDocument = gql`
    query orderNotes($orderId: Int!, $notesInput: OrderNotesInput) {
  order(id: $orderId) {
    id
    ...OrderNotes
  }
}
    ${OrderNotesFragmentDoc}`;

/**
 * __useOrderNotesQuery__
 *
 * To run a query within a React component, call `useOrderNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderNotesQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      notesInput: // value for 'notesInput'
 *   },
 * });
 */
export function useOrderNotesQuery(baseOptions: Apollo.QueryHookOptions<OrderNotesQuery, OrderNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderNotesQuery, OrderNotesQueryVariables>(OrderNotesDocument, options);
      }
export function useOrderNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderNotesQuery, OrderNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderNotesQuery, OrderNotesQueryVariables>(OrderNotesDocument, options);
        }
export type OrderNotesQueryHookResult = ReturnType<typeof useOrderNotesQuery>;
export type OrderNotesLazyQueryHookResult = ReturnType<typeof useOrderNotesLazyQuery>;
export type OrderNotesQueryResult = Apollo.QueryResult<OrderNotesQuery, OrderNotesQueryVariables>;
export const OrderDocument = gql`
    query order($id: Int!, $notesInput: OrderNotesInput) {
  order(id: $id) {
    id
    flxId
    status
    totalPrice {
      base
      vatRate
      currencyIsoCode
    }
    tax {
      base
      vatRate
      currencyIsoCode
    }
    totalDiscount {
      base
      vatRate
      currencyIsoCode
    }
    shippingPrice {
      base
      vatRate
      currencyIsoCode
    }
    client {
      id
      firstName
      lastName
      contactEmail
    }
    guestUser {
      email
    }
    expertUser {
      id
      firstName
      lastName
      email
      expert {
        id
      }
    }
    orderItems {
      id
      trackingUrl
      flxPointUrl
      flxPurchaseOrderId
      flxPurchaseOrderNumber
      productData
      createdAtUtc {
        isoFormat
      }
      price {
        base
        currencyIsoCode
        total
        vat
        vatRate
      }
      unitRetailPrice {
        base
        currencyIsoCode
        vat
        vatRate
      }
      metadata {
        acknowledgedAt {
          isoFormat
        }
        secondaryAcknowledgedAt {
          isoFormat
        }
      }
      productVariant {
        id
        sku
        source {
          companyName
        }
        title
        price {
          base
          total
          currencyIsoCode
          vat
          vatRate
        }
        cost {
          base
          vatRate
          currencyIsoCode
        }
        product {
          id
          title
          flxId
          slug
        }
      }
      bookedQuote
      quantity
      status
      orderShipment {
        shipmentData {
          ... on OrderShipmentArtaQuote {
            artaShipmentId
            rawData {
              artaId
            }
          }
          ... on OrderShipmentFreightClubQuote {
            freightClubShipmentId
          }
          ... on OrderShipmentVendorShipping {
            id
            name
            type
          }
        }
        price {
          base
          currencyIsoCode
        }
      }
      leadTime
      checkoutItem {
        id
        discounts {
          id
          type
          unitDiscount {
            base
            vat
            total
            vatRate
            currencyIsoCode
          }
        }
      }
    }
    stripeTransactionLink
    billingFullName
    billingCompany
    billingAddressLine1
    billingAddressLine2
    billingCountryState
    billingCity
    billingZipCode
    billingPhone
    shippingFullName
    shippingCompany
    shippingAddressLine1
    shippingAddressLine2
    shippingCountryState
    shippingCity
    shippingZipCode
    shippingPhone
    ...OrderNotes
    checkout {
      id
      discountsSum {
        discount {
          base
          vatRate
          currencyIsoCode
        }
        type
      }
    }
    price {
      itemsSum {
        originalPrice
        retailPrice
        discount
      }
      shipmentsSum {
        subtotal
      }
      payment {
        methods
        paidAtUtc
        credit
        coupon
        card
      }
      currencyIsoCode
      originalPrice
      discount
      vat
      subtotal
      total
    }
  }
}
    ${OrderNotesFragmentDoc}`;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      notesInput: // value for 'notesInput'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const OrdersDocument = gql`
    query orders($input: OrdersInput!) {
  orders(input: $input) {
    edges {
      node {
        id
        flxId
        totalPrice {
          base
          currencyIsoCode
        }
        buyerEmail
        createdAtUtc {
          isoFormat
        }
        status
        price {
          itemsSum {
            originalPrice
            retailPrice
            discount
          }
          shipmentsSum {
            subtotal
          }
          payment {
            methods
            paidAtUtc
            credit
            coupon
            card
          }
          currencyIsoCode
          originalPrice
          discount
          vat
          subtotal
          total
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions: Apollo.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
      }
export function useOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const AdminOrdersDocument = gql`
    query adminOrders($input: AdminsOrdersInput!) {
  adminOrders(input: $input) {
    edges {
      node {
        id
        flxId
        totalPrice {
          base
          currencyIsoCode
        }
        buyerEmail
        createdAtUtc {
          isoFormat
        }
        status
        price {
          itemsSum {
            originalPrice
            retailPrice
            discount
          }
          shipmentsSum {
            subtotal
          }
          payment {
            methods
            paidAtUtc
            credit
            coupon
            card
          }
          currencyIsoCode
          originalPrice
          discount
          vat
          subtotal
          total
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useAdminOrdersQuery__
 *
 * To run a query within a React component, call `useAdminOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminOrdersQuery(baseOptions: Apollo.QueryHookOptions<AdminOrdersQuery, AdminOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrdersQuery, AdminOrdersQueryVariables>(AdminOrdersDocument, options);
      }
export function useAdminOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrdersQuery, AdminOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrdersQuery, AdminOrdersQueryVariables>(AdminOrdersDocument, options);
        }
export type AdminOrdersQueryHookResult = ReturnType<typeof useAdminOrdersQuery>;
export type AdminOrdersLazyQueryHookResult = ReturnType<typeof useAdminOrdersLazyQuery>;
export type AdminOrdersQueryResult = Apollo.QueryResult<AdminOrdersQuery, AdminOrdersQueryVariables>;
export const MarkOrderItemsAsDeliveredDocument = gql`
    mutation markOrderItemsAsDelivered($input: MarkOrderITemsAsDeliveredInput!) {
  markOrderItemsAsDelivered(input: $input) {
    id
    orderItems {
      id
      status
    }
  }
}
    `;
export type MarkOrderItemsAsDeliveredMutationFn = Apollo.MutationFunction<MarkOrderItemsAsDeliveredMutation, MarkOrderItemsAsDeliveredMutationVariables>;

/**
 * __useMarkOrderItemsAsDeliveredMutation__
 *
 * To run a mutation, you first call `useMarkOrderItemsAsDeliveredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOrderItemsAsDeliveredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOrderItemsAsDeliveredMutation, { data, loading, error }] = useMarkOrderItemsAsDeliveredMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkOrderItemsAsDeliveredMutation(baseOptions?: Apollo.MutationHookOptions<MarkOrderItemsAsDeliveredMutation, MarkOrderItemsAsDeliveredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkOrderItemsAsDeliveredMutation, MarkOrderItemsAsDeliveredMutationVariables>(MarkOrderItemsAsDeliveredDocument, options);
      }
export type MarkOrderItemsAsDeliveredMutationHookResult = ReturnType<typeof useMarkOrderItemsAsDeliveredMutation>;
export type MarkOrderItemsAsDeliveredMutationResult = Apollo.MutationResult<MarkOrderItemsAsDeliveredMutation>;
export type MarkOrderItemsAsDeliveredMutationOptions = Apollo.BaseMutationOptions<MarkOrderItemsAsDeliveredMutation, MarkOrderItemsAsDeliveredMutationVariables>;
export const EmailActivityDocument = gql`
    query emailActivity($orderId: Int!, $limit: Int = 50) {
  order(id: $orderId) {
    id
    emailActivity(limit: $limit) {
      id
      type
      sendgridMessageId
      sendgridEventId
      event
      createdAtUtc {
        isoFormat
      }
      updatedAtUtc {
        isoFormat
      }
    }
  }
}
    `;

/**
 * __useEmailActivityQuery__
 *
 * To run a query within a React component, call `useEmailActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailActivityQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEmailActivityQuery(baseOptions: Apollo.QueryHookOptions<EmailActivityQuery, EmailActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailActivityQuery, EmailActivityQueryVariables>(EmailActivityDocument, options);
      }
export function useEmailActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailActivityQuery, EmailActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailActivityQuery, EmailActivityQueryVariables>(EmailActivityDocument, options);
        }
export type EmailActivityQueryHookResult = ReturnType<typeof useEmailActivityQuery>;
export type EmailActivityLazyQueryHookResult = ReturnType<typeof useEmailActivityLazyQuery>;
export type EmailActivityQueryResult = Apollo.QueryResult<EmailActivityQuery, EmailActivityQueryVariables>;
export const PrivateFormExpertUsersDocument = gql`
    query privateFormExpertUsers($input: ExpertUsersInput!) {
  expertUsers(input: $input) {
    data {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __usePrivateFormExpertUsersQuery__
 *
 * To run a query within a React component, call `usePrivateFormExpertUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivateFormExpertUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivateFormExpertUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrivateFormExpertUsersQuery(baseOptions: Apollo.QueryHookOptions<PrivateFormExpertUsersQuery, PrivateFormExpertUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivateFormExpertUsersQuery, PrivateFormExpertUsersQueryVariables>(PrivateFormExpertUsersDocument, options);
      }
export function usePrivateFormExpertUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivateFormExpertUsersQuery, PrivateFormExpertUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivateFormExpertUsersQuery, PrivateFormExpertUsersQueryVariables>(PrivateFormExpertUsersDocument, options);
        }
export type PrivateFormExpertUsersQueryHookResult = ReturnType<typeof usePrivateFormExpertUsersQuery>;
export type PrivateFormExpertUsersLazyQueryHookResult = ReturnType<typeof usePrivateFormExpertUsersLazyQuery>;
export type PrivateFormExpertUsersQueryResult = Apollo.QueryResult<PrivateFormExpertUsersQuery, PrivateFormExpertUsersQueryVariables>;
export const PrivateFormExpertSessionDocument = gql`
    query privateFormExpertSession($input: ExpertSessionInput!) {
  expertSession(input: $input) {
    title
    description
    isUpToThreeGuestsAllowed
    price {
      total
      currencyIsoCode
    }
    lengthInMinutes
    emailNote
    expertUser {
      id
    }
  }
}
    `;

/**
 * __usePrivateFormExpertSessionQuery__
 *
 * To run a query within a React component, call `usePrivateFormExpertSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivateFormExpertSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivateFormExpertSessionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrivateFormExpertSessionQuery(baseOptions: Apollo.QueryHookOptions<PrivateFormExpertSessionQuery, PrivateFormExpertSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivateFormExpertSessionQuery, PrivateFormExpertSessionQueryVariables>(PrivateFormExpertSessionDocument, options);
      }
export function usePrivateFormExpertSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivateFormExpertSessionQuery, PrivateFormExpertSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivateFormExpertSessionQuery, PrivateFormExpertSessionQueryVariables>(PrivateFormExpertSessionDocument, options);
        }
export type PrivateFormExpertSessionQueryHookResult = ReturnType<typeof usePrivateFormExpertSessionQuery>;
export type PrivateFormExpertSessionLazyQueryHookResult = ReturnType<typeof usePrivateFormExpertSessionLazyQuery>;
export type PrivateFormExpertSessionQueryResult = Apollo.QueryResult<PrivateFormExpertSessionQuery, PrivateFormExpertSessionQueryVariables>;
export const CreatePrivateExpertSessionDocument = gql`
    mutation createPrivateExpertSession($input: CreatePrivateExpertSessionInput!) {
  createPrivateExpertSession(input: $input) {
    id
  }
}
    `;
export type CreatePrivateExpertSessionMutationFn = Apollo.MutationFunction<CreatePrivateExpertSessionMutation, CreatePrivateExpertSessionMutationVariables>;

/**
 * __useCreatePrivateExpertSessionMutation__
 *
 * To run a mutation, you first call `useCreatePrivateExpertSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrivateExpertSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrivateExpertSessionMutation, { data, loading, error }] = useCreatePrivateExpertSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePrivateExpertSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrivateExpertSessionMutation, CreatePrivateExpertSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrivateExpertSessionMutation, CreatePrivateExpertSessionMutationVariables>(CreatePrivateExpertSessionDocument, options);
      }
export type CreatePrivateExpertSessionMutationHookResult = ReturnType<typeof useCreatePrivateExpertSessionMutation>;
export type CreatePrivateExpertSessionMutationResult = Apollo.MutationResult<CreatePrivateExpertSessionMutation>;
export type CreatePrivateExpertSessionMutationOptions = Apollo.BaseMutationOptions<CreatePrivateExpertSessionMutation, CreatePrivateExpertSessionMutationVariables>;
export const UpdatePrivateExpertSessionDocument = gql`
    mutation updatePrivateExpertSession($input: UpdatePrivateExpertSessionInput!) {
  updatePrivateExpertSession(input: $input) {
    id
  }
}
    `;
export type UpdatePrivateExpertSessionMutationFn = Apollo.MutationFunction<UpdatePrivateExpertSessionMutation, UpdatePrivateExpertSessionMutationVariables>;

/**
 * __useUpdatePrivateExpertSessionMutation__
 *
 * To run a mutation, you first call `useUpdatePrivateExpertSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrivateExpertSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrivateExpertSessionMutation, { data, loading, error }] = useUpdatePrivateExpertSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePrivateExpertSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrivateExpertSessionMutation, UpdatePrivateExpertSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrivateExpertSessionMutation, UpdatePrivateExpertSessionMutationVariables>(UpdatePrivateExpertSessionDocument, options);
      }
export type UpdatePrivateExpertSessionMutationHookResult = ReturnType<typeof useUpdatePrivateExpertSessionMutation>;
export type UpdatePrivateExpertSessionMutationResult = Apollo.MutationResult<UpdatePrivateExpertSessionMutation>;
export type UpdatePrivateExpertSessionMutationOptions = Apollo.BaseMutationOptions<UpdatePrivateExpertSessionMutation, UpdatePrivateExpertSessionMutationVariables>;
export const DeleteExpertSessionDocument = gql`
    mutation deleteExpertSession($id: Int!) {
  deleteExpertSession(id: $id) {
    id
  }
}
    `;
export type DeleteExpertSessionMutationFn = Apollo.MutationFunction<DeleteExpertSessionMutation, DeleteExpertSessionMutationVariables>;

/**
 * __useDeleteExpertSessionMutation__
 *
 * To run a mutation, you first call `useDeleteExpertSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpertSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpertSessionMutation, { data, loading, error }] = useDeleteExpertSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExpertSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExpertSessionMutation, DeleteExpertSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExpertSessionMutation, DeleteExpertSessionMutationVariables>(DeleteExpertSessionDocument, options);
      }
export type DeleteExpertSessionMutationHookResult = ReturnType<typeof useDeleteExpertSessionMutation>;
export type DeleteExpertSessionMutationResult = Apollo.MutationResult<DeleteExpertSessionMutation>;
export type DeleteExpertSessionMutationOptions = Apollo.BaseMutationOptions<DeleteExpertSessionMutation, DeleteExpertSessionMutationVariables>;
export const AdminProductDocument = gql`
    query adminProduct($input: ProductInput!, $recommendedProductsFilterInput: RecommendedProductsFilterInput) {
  product(input: $input) {
    id
    flxId
    sku
    status
    title
    slug
    description
    brand {
      id
    }
    variants {
      id
      flxId
      sku
      title
      status
      slug
      price {
        total
      }
      quantity
      isPublishedFirstTime
      optionValues {
        productOption {
          name
        }
        value
      }
      customContent {
        ...ProductVariantCustomContentFragment
        askExpert {
          id
          profileName
          businessName
        }
      }
      updatedAtUtc {
        isoFormat
      }
      carouselImage {
        id
        url
        alt
      }
      leadImage {
        id
        url
        alt
      }
      fabricDetails
      fabricHeader
      fabricSubheader
      fabricImage {
        id
        url
        alt
      }
      finishDetails
      finishHeader
      finishSubheader
      finishImage {
        id
        url
        alt
      }
      colorImage {
        id
        url
        alt
      }
    }
    recommendedProducts(input: $recommendedProductsFilterInput) {
      id
      positionIndexWeight
      pairedProduct {
        id
        title
        sku
      }
    }
    customContent {
      ...ProductCustomContentFragment
      askExpert {
        id
        profileName
        businessName
      }
    }
    forceRedirectToProduct {
      id
      sku
      title
    }
  }
}
    ${ProductVariantCustomContentFragmentFragmentDoc}
${ProductCustomContentFragmentFragmentDoc}`;

/**
 * __useAdminProductQuery__
 *
 * To run a query within a React component, call `useAdminProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProductQuery({
 *   variables: {
 *      input: // value for 'input'
 *      recommendedProductsFilterInput: // value for 'recommendedProductsFilterInput'
 *   },
 * });
 */
export function useAdminProductQuery(baseOptions: Apollo.QueryHookOptions<AdminProductQuery, AdminProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProductQuery, AdminProductQueryVariables>(AdminProductDocument, options);
      }
export function useAdminProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProductQuery, AdminProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProductQuery, AdminProductQueryVariables>(AdminProductDocument, options);
        }
export type AdminProductQueryHookResult = ReturnType<typeof useAdminProductQuery>;
export type AdminProductLazyQueryHookResult = ReturnType<typeof useAdminProductLazyQuery>;
export type AdminProductQueryResult = Apollo.QueryResult<AdminProductQuery, AdminProductQueryVariables>;
export const AdminProductsDocument = gql`
    query adminProducts($inputProduct: ProductsInput, $inputVariant: ProductVariantsInput, $recommendedProductsFilterInput: RecommendedProductsFilterInput) {
  products(input: $inputProduct) {
    paginationInfo {
      totalCount
      firstPage
      lastPage
      currentPage
      nextPage
      previousPage
    }
    data {
      sku
      id
      brand {
        id
      }
      flxId
      status
      title
      slug
      createdAtUtc {
        isoFormat
      }
      updatedAtUtc {
        isoFormat
      }
      variants {
        quantity
        isPublishedFirstTime
        status
      }
      recommendedProducts(input: $recommendedProductsFilterInput) {
        id
      }
      forceRedirectToProduct {
        id
        sku
        title
      }
    }
  }
  productVariants(input: $inputVariant) {
    paginationInfo {
      totalCount
      firstPage
      lastPage
      currentPage
      nextPage
      previousPage
    }
    data {
      sku
      id
      flxId
      status
      title
      slug
      quantity
      price {
        total
        currencyIsoCode
      }
      optionValues {
        value
        productOption {
          name
        }
      }
      product {
        id
        brand {
          id
        }
      }
      createdAtUtc {
        isoFormat
      }
      updatedAtUtc {
        isoFormat
      }
      isPublishedFirstTime
    }
  }
}
    `;

/**
 * __useAdminProductsQuery__
 *
 * To run a query within a React component, call `useAdminProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProductsQuery({
 *   variables: {
 *      inputProduct: // value for 'inputProduct'
 *      inputVariant: // value for 'inputVariant'
 *      recommendedProductsFilterInput: // value for 'recommendedProductsFilterInput'
 *   },
 * });
 */
export function useAdminProductsQuery(baseOptions?: Apollo.QueryHookOptions<AdminProductsQuery, AdminProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProductsQuery, AdminProductsQueryVariables>(AdminProductsDocument, options);
      }
export function useAdminProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProductsQuery, AdminProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProductsQuery, AdminProductsQueryVariables>(AdminProductsDocument, options);
        }
export type AdminProductsQueryHookResult = ReturnType<typeof useAdminProductsQuery>;
export type AdminProductsLazyQueryHookResult = ReturnType<typeof useAdminProductsLazyQuery>;
export type AdminProductsQueryResult = Apollo.QueryResult<AdminProductsQuery, AdminProductsQueryVariables>;
export const AdminProductsPickerDocument = gql`
    query adminProductsPicker($input: ProductsInput!) {
  products(input: $input) {
    data {
      id
      flxId
      sku
      status
      title
      slug
    }
  }
}
    `;

/**
 * __useAdminProductsPickerQuery__
 *
 * To run a query within a React component, call `useAdminProductsPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductsPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProductsPickerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminProductsPickerQuery(baseOptions: Apollo.QueryHookOptions<AdminProductsPickerQuery, AdminProductsPickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProductsPickerQuery, AdminProductsPickerQueryVariables>(AdminProductsPickerDocument, options);
      }
export function useAdminProductsPickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProductsPickerQuery, AdminProductsPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProductsPickerQuery, AdminProductsPickerQueryVariables>(AdminProductsPickerDocument, options);
        }
export type AdminProductsPickerQueryHookResult = ReturnType<typeof useAdminProductsPickerQuery>;
export type AdminProductsPickerLazyQueryHookResult = ReturnType<typeof useAdminProductsPickerLazyQuery>;
export type AdminProductsPickerQueryResult = Apollo.QueryResult<AdminProductsPickerQuery, AdminProductsPickerQueryVariables>;
export const AdminProductVariantsPickerDocument = gql`
    query adminProductVariantsPicker($input: ProductInput!) {
  product(input: $input) {
    id
    variants {
      id
      title
      sku
    }
  }
}
    `;

/**
 * __useAdminProductVariantsPickerQuery__
 *
 * To run a query within a React component, call `useAdminProductVariantsPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductVariantsPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProductVariantsPickerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminProductVariantsPickerQuery(baseOptions: Apollo.QueryHookOptions<AdminProductVariantsPickerQuery, AdminProductVariantsPickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProductVariantsPickerQuery, AdminProductVariantsPickerQueryVariables>(AdminProductVariantsPickerDocument, options);
      }
export function useAdminProductVariantsPickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProductVariantsPickerQuery, AdminProductVariantsPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProductVariantsPickerQuery, AdminProductVariantsPickerQueryVariables>(AdminProductVariantsPickerDocument, options);
        }
export type AdminProductVariantsPickerQueryHookResult = ReturnType<typeof useAdminProductVariantsPickerQuery>;
export type AdminProductVariantsPickerLazyQueryHookResult = ReturnType<typeof useAdminProductVariantsPickerLazyQuery>;
export type AdminProductVariantsPickerQueryResult = Apollo.QueryResult<AdminProductVariantsPickerQuery, AdminProductVariantsPickerQueryVariables>;
export const UpdateProductCustomContentDocument = gql`
    mutation updateProductCustomContent($input: ProductCustomContentInput!) {
  updateProductCustomContentMutation(input: $input) {
    id
  }
}
    `;
export type UpdateProductCustomContentMutationFn = Apollo.MutationFunction<UpdateProductCustomContentMutation, UpdateProductCustomContentMutationVariables>;

/**
 * __useUpdateProductCustomContentMutation__
 *
 * To run a mutation, you first call `useUpdateProductCustomContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductCustomContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductCustomContentMutation, { data, loading, error }] = useUpdateProductCustomContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductCustomContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductCustomContentMutation, UpdateProductCustomContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductCustomContentMutation, UpdateProductCustomContentMutationVariables>(UpdateProductCustomContentDocument, options);
      }
export type UpdateProductCustomContentMutationHookResult = ReturnType<typeof useUpdateProductCustomContentMutation>;
export type UpdateProductCustomContentMutationResult = Apollo.MutationResult<UpdateProductCustomContentMutation>;
export type UpdateProductCustomContentMutationOptions = Apollo.BaseMutationOptions<UpdateProductCustomContentMutation, UpdateProductCustomContentMutationVariables>;
export const FirstTimePublishProductDocument = gql`
    mutation firstTimePublishProduct($input: FirstTimePublishInput!) {
  firstTimePublishProduct(input: $input) {
    id
  }
}
    `;
export type FirstTimePublishProductMutationFn = Apollo.MutationFunction<FirstTimePublishProductMutation, FirstTimePublishProductMutationVariables>;

/**
 * __useFirstTimePublishProductMutation__
 *
 * To run a mutation, you first call `useFirstTimePublishProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFirstTimePublishProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [firstTimePublishProductMutation, { data, loading, error }] = useFirstTimePublishProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFirstTimePublishProductMutation(baseOptions?: Apollo.MutationHookOptions<FirstTimePublishProductMutation, FirstTimePublishProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FirstTimePublishProductMutation, FirstTimePublishProductMutationVariables>(FirstTimePublishProductDocument, options);
      }
export type FirstTimePublishProductMutationHookResult = ReturnType<typeof useFirstTimePublishProductMutation>;
export type FirstTimePublishProductMutationResult = Apollo.MutationResult<FirstTimePublishProductMutation>;
export type FirstTimePublishProductMutationOptions = Apollo.BaseMutationOptions<FirstTimePublishProductMutation, FirstTimePublishProductMutationVariables>;
export const UpdateProductVariantCustomContentDocument = gql`
    mutation updateProductVariantCustomContent($input: ProductVariantCustomContentInput!) {
  updateProductVariantCustomContentMutation(input: $input) {
    id
  }
}
    `;
export type UpdateProductVariantCustomContentMutationFn = Apollo.MutationFunction<UpdateProductVariantCustomContentMutation, UpdateProductVariantCustomContentMutationVariables>;

/**
 * __useUpdateProductVariantCustomContentMutation__
 *
 * To run a mutation, you first call `useUpdateProductVariantCustomContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductVariantCustomContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductVariantCustomContentMutation, { data, loading, error }] = useUpdateProductVariantCustomContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductVariantCustomContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductVariantCustomContentMutation, UpdateProductVariantCustomContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductVariantCustomContentMutation, UpdateProductVariantCustomContentMutationVariables>(UpdateProductVariantCustomContentDocument, options);
      }
export type UpdateProductVariantCustomContentMutationHookResult = ReturnType<typeof useUpdateProductVariantCustomContentMutation>;
export type UpdateProductVariantCustomContentMutationResult = Apollo.MutationResult<UpdateProductVariantCustomContentMutation>;
export type UpdateProductVariantCustomContentMutationOptions = Apollo.BaseMutationOptions<UpdateProductVariantCustomContentMutation, UpdateProductVariantCustomContentMutationVariables>;
export const FirstTimePublishProductVariantDocument = gql`
    mutation firstTimePublishProductVariant($input: FirstTimePublishInput!) {
  firstTimePublishProductVariant(input: $input) {
    id
  }
}
    `;
export type FirstTimePublishProductVariantMutationFn = Apollo.MutationFunction<FirstTimePublishProductVariantMutation, FirstTimePublishProductVariantMutationVariables>;

/**
 * __useFirstTimePublishProductVariantMutation__
 *
 * To run a mutation, you first call `useFirstTimePublishProductVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFirstTimePublishProductVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [firstTimePublishProductVariantMutation, { data, loading, error }] = useFirstTimePublishProductVariantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFirstTimePublishProductVariantMutation(baseOptions?: Apollo.MutationHookOptions<FirstTimePublishProductVariantMutation, FirstTimePublishProductVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FirstTimePublishProductVariantMutation, FirstTimePublishProductVariantMutationVariables>(FirstTimePublishProductVariantDocument, options);
      }
export type FirstTimePublishProductVariantMutationHookResult = ReturnType<typeof useFirstTimePublishProductVariantMutation>;
export type FirstTimePublishProductVariantMutationResult = Apollo.MutationResult<FirstTimePublishProductVariantMutation>;
export type FirstTimePublishProductVariantMutationOptions = Apollo.BaseMutationOptions<FirstTimePublishProductVariantMutation, FirstTimePublishProductVariantMutationVariables>;
export const PublicProductDocument = gql`
    query publicProduct($productInput: ProductInput!, $variantStatuses: [ProductVariantStatus!]) {
  product(input: $productInput) {
    id
    sku
    slug
    status
    title
    description
    availability
    brand {
      id
      cmsBrandPage {
        id
        cmsPage {
          id
          slug
        }
      }
    }
    collections {
      data {
        id
        title
      }
    }
    categoryOne {
      id
      name
    }
    categoryTwo {
      id
      name
    }
    categoryThree {
      id
      name
    }
    options {
      id
      name
    }
    variants(statuses: $variantStatuses) {
      id
      sku
      status
      title
      slug
      quantity
      status
      leadImage {
        id
        url
        alt
      }
      price {
        base
        vatRate
        total
        currencyIsoCode
      }
      tradePrice {
        base
        vatRate
        total
        currencyIsoCode
      }
      optionValues {
        value
        productOption {
          name
        }
      }
      fabricDetails
      fabricHeader
      fabricSubheader
      fabricImage {
        id
        url
        alt
      }
      finishDetails
      finishHeader
      finishSubheader
      finishImage {
        id
        url
        alt
      }
      colorImage {
        id
        url
        alt
      }
      product {
        id
        title
        slug
        brand {
          id
        }
        categoryOne {
          id
          name
        }
        categoryTwo {
          id
          name
        }
        categoryThree {
          id
          name
        }
      }
      managedCustomFields {
        leadTime
        minimumQuantity
        quantityUnitPlural
        quantityUnitSingular
        enableCounter
        proposition65
        prop65Eligible
        returnNotEligible
        depth
      }
      estimatedShippingCost {
        total
        currencyIsoCode
      }
      estimatedDropshipFee {
        total
        currencyIsoCode
      }
      weight
      length
      width
      height
      weightUnit
      dimensionUnit
      images {
        id
        url
        alt
      }
      availability
      customContent {
        ...ProductVariantCustomContentFragment
        askExpert {
          id
          slug
          profileName
          profileImageUrl
          headshotImageUrl
          headshotImageAttachment {
            id
            url
            alt
          }
          profileImageAttachment {
            id
            url
            alt
          }
        }
      }
    }
    images {
      id
      url
      alt
    }
    previewImageAlt
    customContent {
      ...ProductCustomContentFragment
      askExpert {
        id
        slug
        profileName
        profileImageUrl
        headshotImageUrl
        headshotImageAttachment {
          id
          url
          alt
        }
        profileImageAttachment {
          id
          url
          alt
        }
      }
    }
    recommendedProducts {
      id
      pairedProduct {
        ...CarouselProductFields
      }
    }
    mightAlsoLikeProducts {
      ...CarouselProductFields
    }
    forceRedirectToProduct {
      slug
      id
    }
  }
}
    ${ProductVariantCustomContentFragmentFragmentDoc}
${ProductCustomContentFragmentFragmentDoc}
${CarouselProductFieldsFragmentDoc}`;

/**
 * __usePublicProductQuery__
 *
 * To run a query within a React component, call `usePublicProductQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductQuery({
 *   variables: {
 *      productInput: // value for 'productInput'
 *      variantStatuses: // value for 'variantStatuses'
 *   },
 * });
 */
export function usePublicProductQuery(baseOptions: Apollo.QueryHookOptions<PublicProductQuery, PublicProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicProductQuery, PublicProductQueryVariables>(PublicProductDocument, options);
      }
export function usePublicProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicProductQuery, PublicProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicProductQuery, PublicProductQueryVariables>(PublicProductDocument, options);
        }
export type PublicProductQueryHookResult = ReturnType<typeof usePublicProductQuery>;
export type PublicProductLazyQueryHookResult = ReturnType<typeof usePublicProductLazyQuery>;
export type PublicProductQueryResult = Apollo.QueryResult<PublicProductQuery, PublicProductQueryVariables>;
export const ProductsSlugsDocument = gql`
    query ProductsSlugs {
  productSlugs {
    product
    variant
  }
}
    `;

/**
 * __useProductsSlugsQuery__
 *
 * To run a query within a React component, call `useProductsSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsSlugsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsSlugsQuery, ProductsSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsSlugsQuery, ProductsSlugsQueryVariables>(ProductsSlugsDocument, options);
      }
export function useProductsSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsSlugsQuery, ProductsSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsSlugsQuery, ProductsSlugsQueryVariables>(ProductsSlugsDocument, options);
        }
export type ProductsSlugsQueryHookResult = ReturnType<typeof useProductsSlugsQuery>;
export type ProductsSlugsLazyQueryHookResult = ReturnType<typeof useProductsSlugsLazyQuery>;
export type ProductsSlugsQueryResult = Apollo.QueryResult<ProductsSlugsQuery, ProductsSlugsQueryVariables>;
export const MightAlsoLikeProductsByProductIdDocument = gql`
    query MightAlsoLikeProductsByProductId($input: ProductInput!) {
  product(input: $input) {
    mightAlsoLikeProducts {
      ...CarouselProductFields
    }
  }
}
    ${CarouselProductFieldsFragmentDoc}`;

/**
 * __useMightAlsoLikeProductsByProductIdQuery__
 *
 * To run a query within a React component, call `useMightAlsoLikeProductsByProductIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMightAlsoLikeProductsByProductIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMightAlsoLikeProductsByProductIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMightAlsoLikeProductsByProductIdQuery(baseOptions: Apollo.QueryHookOptions<MightAlsoLikeProductsByProductIdQuery, MightAlsoLikeProductsByProductIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MightAlsoLikeProductsByProductIdQuery, MightAlsoLikeProductsByProductIdQueryVariables>(MightAlsoLikeProductsByProductIdDocument, options);
      }
export function useMightAlsoLikeProductsByProductIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MightAlsoLikeProductsByProductIdQuery, MightAlsoLikeProductsByProductIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MightAlsoLikeProductsByProductIdQuery, MightAlsoLikeProductsByProductIdQueryVariables>(MightAlsoLikeProductsByProductIdDocument, options);
        }
export type MightAlsoLikeProductsByProductIdQueryHookResult = ReturnType<typeof useMightAlsoLikeProductsByProductIdQuery>;
export type MightAlsoLikeProductsByProductIdLazyQueryHookResult = ReturnType<typeof useMightAlsoLikeProductsByProductIdLazyQuery>;
export type MightAlsoLikeProductsByProductIdQueryResult = Apollo.QueryResult<MightAlsoLikeProductsByProductIdQuery, MightAlsoLikeProductsByProductIdQueryVariables>;
export const ApplyPromoCodeDocument = gql`
    mutation applyPromoCode($promoCode: String!) {
  applyPromoCode(promoCode: $promoCode)
}
    `;
export type ApplyPromoCodeMutationFn = Apollo.MutationFunction<ApplyPromoCodeMutation, ApplyPromoCodeMutationVariables>;

/**
 * __useApplyPromoCodeMutation__
 *
 * To run a mutation, you first call `useApplyPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyPromoCodeMutation, { data, loading, error }] = useApplyPromoCodeMutation({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useApplyPromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<ApplyPromoCodeMutation, ApplyPromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyPromoCodeMutation, ApplyPromoCodeMutationVariables>(ApplyPromoCodeDocument, options);
      }
export type ApplyPromoCodeMutationHookResult = ReturnType<typeof useApplyPromoCodeMutation>;
export type ApplyPromoCodeMutationResult = Apollo.MutationResult<ApplyPromoCodeMutation>;
export type ApplyPromoCodeMutationOptions = Apollo.BaseMutationOptions<ApplyPromoCodeMutation, ApplyPromoCodeMutationVariables>;
export const RemovePromoCodeDocument = gql`
    mutation removePromoCode($promoCode: String!) {
  removePromoCode(promoCode: $promoCode)
}
    `;
export type RemovePromoCodeMutationFn = Apollo.MutationFunction<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>;

/**
 * __useRemovePromoCodeMutation__
 *
 * To run a mutation, you first call `useRemovePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePromoCodeMutation, { data, loading, error }] = useRemovePromoCodeMutation({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useRemovePromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>(RemovePromoCodeDocument, options);
      }
export type RemovePromoCodeMutationHookResult = ReturnType<typeof useRemovePromoCodeMutation>;
export type RemovePromoCodeMutationResult = Apollo.MutationResult<RemovePromoCodeMutation>;
export type RemovePromoCodeMutationOptions = Apollo.BaseMutationOptions<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>;
export const PublicCategoriesDocument = gql`
    query publicCategories($input: PublicCategoriesInput!) {
  publicCategories(input: $input) {
    title
    id
    parentId
  }
}
    `;

/**
 * __usePublicCategoriesQuery__
 *
 * To run a query within a React component, call `usePublicCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicCategoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicCategoriesQuery(baseOptions: Apollo.QueryHookOptions<PublicCategoriesQuery, PublicCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicCategoriesQuery, PublicCategoriesQueryVariables>(PublicCategoriesDocument, options);
      }
export function usePublicCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicCategoriesQuery, PublicCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicCategoriesQuery, PublicCategoriesQueryVariables>(PublicCategoriesDocument, options);
        }
export type PublicCategoriesQueryHookResult = ReturnType<typeof usePublicCategoriesQuery>;
export type PublicCategoriesLazyQueryHookResult = ReturnType<typeof usePublicCategoriesLazyQuery>;
export type PublicCategoriesQueryResult = Apollo.QueryResult<PublicCategoriesQuery, PublicCategoriesQueryVariables>;
export const PublicRegionsDocument = gql`
    query publicRegions {
  publicRegions {
    id
    title
    children {
      id
      title
    }
  }
}
    `;

/**
 * __usePublicRegionsQuery__
 *
 * To run a query within a React component, call `usePublicRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicRegionsQuery(baseOptions?: Apollo.QueryHookOptions<PublicRegionsQuery, PublicRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicRegionsQuery, PublicRegionsQueryVariables>(PublicRegionsDocument, options);
      }
export function usePublicRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicRegionsQuery, PublicRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicRegionsQuery, PublicRegionsQueryVariables>(PublicRegionsDocument, options);
        }
export type PublicRegionsQueryHookResult = ReturnType<typeof usePublicRegionsQuery>;
export type PublicRegionsLazyQueryHookResult = ReturnType<typeof usePublicRegionsLazyQuery>;
export type PublicRegionsQueryResult = Apollo.QueryResult<PublicRegionsQuery, PublicRegionsQueryVariables>;
export const PublicTagsDocument = gql`
    query publicTags {
  publicTags {
    id
    title
  }
}
    `;

/**
 * __usePublicTagsQuery__
 *
 * To run a query within a React component, call `usePublicTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicTagsQuery(baseOptions?: Apollo.QueryHookOptions<PublicTagsQuery, PublicTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicTagsQuery, PublicTagsQueryVariables>(PublicTagsDocument, options);
      }
export function usePublicTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicTagsQuery, PublicTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicTagsQuery, PublicTagsQueryVariables>(PublicTagsDocument, options);
        }
export type PublicTagsQueryHookResult = ReturnType<typeof usePublicTagsQuery>;
export type PublicTagsLazyQueryHookResult = ReturnType<typeof usePublicTagsLazyQuery>;
export type PublicTagsQueryResult = Apollo.QueryResult<PublicTagsQuery, PublicTagsQueryVariables>;
export const PurchaseDocument = gql`
    query purchase($input: PurchaseInput!) {
  purchase(input: $input) {
    id
    description
    policy
    status
    checkoutItem {
      checkout {
        id
      }
    }
    updatedAtUtc {
      isoFormat
    }
    createdAtUtc {
      isoFormat
    }
    totalPrice {
      base
      currencyIsoCode
    }
    expert {
      id
      profileName
      businessName
    }
    vendor {
      id
      expertCommission
    }
    client {
      id
      firstName
      lastName
      contactEmail
    }
    expertUser {
      id
      email
      expert {
        id
      }
    }
    retailPrice {
      base
    }
    tax {
      base
    }
    shippingPrice {
      base
    }
    vendorPrice {
      base
    }
    trackingUrl
    vendorExpertCommission
    shippingFullName
    shippingCompany
    shippingAddressLine1
    shippingAddressLine2
    shippingCountryIsoCode
    shippingCountryState
    shippingCity
    shippingZipCode
    shippingPhone
    attachment {
      id
      url
      name
      alt
    }
    isExpertCommissionPaid
    tradeLicense {
      id
      name
    }
  }
}
    `;

/**
 * __usePurchaseQuery__
 *
 * To run a query within a React component, call `usePurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseQuery(baseOptions: Apollo.QueryHookOptions<PurchaseQuery, PurchaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseQuery, PurchaseQueryVariables>(PurchaseDocument, options);
      }
export function usePurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseQuery, PurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseQuery, PurchaseQueryVariables>(PurchaseDocument, options);
        }
export type PurchaseQueryHookResult = ReturnType<typeof usePurchaseQuery>;
export type PurchaseLazyQueryHookResult = ReturnType<typeof usePurchaseLazyQuery>;
export type PurchaseQueryResult = Apollo.QueryResult<PurchaseQuery, PurchaseQueryVariables>;
export const CreatePurchaseDocument = gql`
    mutation createPurchase($input: CreatePurchaseInput!) {
  createPurchase(input: $input) {
    id
  }
}
    `;
export type CreatePurchaseMutationFn = Apollo.MutationFunction<CreatePurchaseMutation, CreatePurchaseMutationVariables>;

/**
 * __useCreatePurchaseMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseMutation, { data, loading, error }] = useCreatePurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePurchaseMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchaseMutation, CreatePurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePurchaseMutation, CreatePurchaseMutationVariables>(CreatePurchaseDocument, options);
      }
export type CreatePurchaseMutationHookResult = ReturnType<typeof useCreatePurchaseMutation>;
export type CreatePurchaseMutationResult = Apollo.MutationResult<CreatePurchaseMutation>;
export type CreatePurchaseMutationOptions = Apollo.BaseMutationOptions<CreatePurchaseMutation, CreatePurchaseMutationVariables>;
export const UpdatePurchaseDocument = gql`
    mutation updatePurchase($input: UpdatePurchaseInput!) {
  updatePurchase(input: $input) {
    id
  }
}
    `;
export type UpdatePurchaseMutationFn = Apollo.MutationFunction<UpdatePurchaseMutation, UpdatePurchaseMutationVariables>;

/**
 * __useUpdatePurchaseMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseMutation, { data, loading, error }] = useUpdatePurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePurchaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchaseMutation, UpdatePurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchaseMutation, UpdatePurchaseMutationVariables>(UpdatePurchaseDocument, options);
      }
export type UpdatePurchaseMutationHookResult = ReturnType<typeof useUpdatePurchaseMutation>;
export type UpdatePurchaseMutationResult = Apollo.MutationResult<UpdatePurchaseMutation>;
export type UpdatePurchaseMutationOptions = Apollo.BaseMutationOptions<UpdatePurchaseMutation, UpdatePurchaseMutationVariables>;
export const ResendPurchaseCheckoutEmailDocument = gql`
    mutation resendPurchaseCheckoutEmail($id: Int!) {
  resendPurchaseCheckoutEmail(id: $id)
}
    `;
export type ResendPurchaseCheckoutEmailMutationFn = Apollo.MutationFunction<ResendPurchaseCheckoutEmailMutation, ResendPurchaseCheckoutEmailMutationVariables>;

/**
 * __useResendPurchaseCheckoutEmailMutation__
 *
 * To run a mutation, you first call `useResendPurchaseCheckoutEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPurchaseCheckoutEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPurchaseCheckoutEmailMutation, { data, loading, error }] = useResendPurchaseCheckoutEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendPurchaseCheckoutEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendPurchaseCheckoutEmailMutation, ResendPurchaseCheckoutEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendPurchaseCheckoutEmailMutation, ResendPurchaseCheckoutEmailMutationVariables>(ResendPurchaseCheckoutEmailDocument, options);
      }
export type ResendPurchaseCheckoutEmailMutationHookResult = ReturnType<typeof useResendPurchaseCheckoutEmailMutation>;
export type ResendPurchaseCheckoutEmailMutationResult = Apollo.MutationResult<ResendPurchaseCheckoutEmailMutation>;
export type ResendPurchaseCheckoutEmailMutationOptions = Apollo.BaseMutationOptions<ResendPurchaseCheckoutEmailMutation, ResendPurchaseCheckoutEmailMutationVariables>;
export const PayExpertCommissionDocument = gql`
    mutation payExpertCommission($id: Int!) {
  payExpertCommission(id: $id)
}
    `;
export type PayExpertCommissionMutationFn = Apollo.MutationFunction<PayExpertCommissionMutation, PayExpertCommissionMutationVariables>;

/**
 * __usePayExpertCommissionMutation__
 *
 * To run a mutation, you first call `usePayExpertCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayExpertCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payExpertCommissionMutation, { data, loading, error }] = usePayExpertCommissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePayExpertCommissionMutation(baseOptions?: Apollo.MutationHookOptions<PayExpertCommissionMutation, PayExpertCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayExpertCommissionMutation, PayExpertCommissionMutationVariables>(PayExpertCommissionDocument, options);
      }
export type PayExpertCommissionMutationHookResult = ReturnType<typeof usePayExpertCommissionMutation>;
export type PayExpertCommissionMutationResult = Apollo.MutationResult<PayExpertCommissionMutation>;
export type PayExpertCommissionMutationOptions = Apollo.BaseMutationOptions<PayExpertCommissionMutation, PayExpertCommissionMutationVariables>;
export const VerifyRecaptchaTokenDocument = gql`
    mutation verifyRecaptchaToken($token: String!) {
  verifyRecaptchaToken(token: $token) {
    isSuccess
  }
}
    `;
export type VerifyRecaptchaTokenMutationFn = Apollo.MutationFunction<VerifyRecaptchaTokenMutation, VerifyRecaptchaTokenMutationVariables>;

/**
 * __useVerifyRecaptchaTokenMutation__
 *
 * To run a mutation, you first call `useVerifyRecaptchaTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyRecaptchaTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyRecaptchaTokenMutation, { data, loading, error }] = useVerifyRecaptchaTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyRecaptchaTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyRecaptchaTokenMutation, VerifyRecaptchaTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyRecaptchaTokenMutation, VerifyRecaptchaTokenMutationVariables>(VerifyRecaptchaTokenDocument, options);
      }
export type VerifyRecaptchaTokenMutationHookResult = ReturnType<typeof useVerifyRecaptchaTokenMutation>;
export type VerifyRecaptchaTokenMutationResult = Apollo.MutationResult<VerifyRecaptchaTokenMutation>;
export type VerifyRecaptchaTokenMutationOptions = Apollo.BaseMutationOptions<VerifyRecaptchaTokenMutation, VerifyRecaptchaTokenMutationVariables>;
export const SearchDocument = gql`
    query search($searchInput: GlobalSearchInput!) {
  globalSearch(input: $searchInput) {
    brands {
      id
      cmsBrandPage {
        id
        cmsPage {
          id
          slug
        }
      }
    }
    publicExperts {
      id
      profileImageAttachment {
        url
        alt
      }
      profileName
      jobTitle
      slug
    }
    navigationItems {
      id
      title
      cmsPage {
        href
      }
      parent {
        title
      }
    }
    productVariants {
      id
      title
      slug
      images {
        id
        url
        alt
      }
      product {
        id
        slug
        manufacturer
        images {
          id
          url
          alt
        }
      }
    }
    searchValue
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      searchInput: // value for 'searchInput'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const SendFreeAssistanceEmailDocument = gql`
    mutation sendFreeAssistanceEmail($input: SendFreeAssistanceEmailInput!) {
  sendFreeAssistanceEmail(input: $input)
}
    `;
export type SendFreeAssistanceEmailMutationFn = Apollo.MutationFunction<SendFreeAssistanceEmailMutation, SendFreeAssistanceEmailMutationVariables>;

/**
 * __useSendFreeAssistanceEmailMutation__
 *
 * To run a mutation, you first call `useSendFreeAssistanceEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFreeAssistanceEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFreeAssistanceEmailMutation, { data, loading, error }] = useSendFreeAssistanceEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendFreeAssistanceEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendFreeAssistanceEmailMutation, SendFreeAssistanceEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFreeAssistanceEmailMutation, SendFreeAssistanceEmailMutationVariables>(SendFreeAssistanceEmailDocument, options);
      }
export type SendFreeAssistanceEmailMutationHookResult = ReturnType<typeof useSendFreeAssistanceEmailMutation>;
export type SendFreeAssistanceEmailMutationResult = Apollo.MutationResult<SendFreeAssistanceEmailMutation>;
export type SendFreeAssistanceEmailMutationOptions = Apollo.BaseMutationOptions<SendFreeAssistanceEmailMutation, SendFreeAssistanceEmailMutationVariables>;
export const SendItemInquireEmailDocument = gql`
    mutation sendItemInquireEmail($input: SendItemInquireEmailInput!) {
  sendItemInquireEmail(input: $input)
}
    `;
export type SendItemInquireEmailMutationFn = Apollo.MutationFunction<SendItemInquireEmailMutation, SendItemInquireEmailMutationVariables>;

/**
 * __useSendItemInquireEmailMutation__
 *
 * To run a mutation, you first call `useSendItemInquireEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendItemInquireEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendItemInquireEmailMutation, { data, loading, error }] = useSendItemInquireEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendItemInquireEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendItemInquireEmailMutation, SendItemInquireEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendItemInquireEmailMutation, SendItemInquireEmailMutationVariables>(SendItemInquireEmailDocument, options);
      }
export type SendItemInquireEmailMutationHookResult = ReturnType<typeof useSendItemInquireEmailMutation>;
export type SendItemInquireEmailMutationResult = Apollo.MutationResult<SendItemInquireEmailMutation>;
export type SendItemInquireEmailMutationOptions = Apollo.BaseMutationOptions<SendItemInquireEmailMutation, SendItemInquireEmailMutationVariables>;
export const AdminPutSessionOnHoldDocument = gql`
    mutation adminPutSessionOnHold($input: AdminPutSessionOnHoldInput!) {
  adminPutSessionOnHold(input: $input) {
    id
  }
}
    `;
export type AdminPutSessionOnHoldMutationFn = Apollo.MutationFunction<AdminPutSessionOnHoldMutation, AdminPutSessionOnHoldMutationVariables>;

/**
 * __useAdminPutSessionOnHoldMutation__
 *
 * To run a mutation, you first call `useAdminPutSessionOnHoldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminPutSessionOnHoldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminPutSessionOnHoldMutation, { data, loading, error }] = useAdminPutSessionOnHoldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminPutSessionOnHoldMutation(baseOptions?: Apollo.MutationHookOptions<AdminPutSessionOnHoldMutation, AdminPutSessionOnHoldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminPutSessionOnHoldMutation, AdminPutSessionOnHoldMutationVariables>(AdminPutSessionOnHoldDocument, options);
      }
export type AdminPutSessionOnHoldMutationHookResult = ReturnType<typeof useAdminPutSessionOnHoldMutation>;
export type AdminPutSessionOnHoldMutationResult = Apollo.MutationResult<AdminPutSessionOnHoldMutation>;
export type AdminPutSessionOnHoldMutationOptions = Apollo.BaseMutationOptions<AdminPutSessionOnHoldMutation, AdminPutSessionOnHoldMutationVariables>;
export const SessionReportDiscoverMoreDocument = gql`
    query sessionReportDiscoverMore($input: WidgetsByIdInput!) {
  cmsWidgetById(input: $input) {
    id
    content {
      ... on CMSCardNavigationWidget {
        id
        title
        cmsCardNavigationWidgetItems {
          id
          title
          attachment {
            id
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSessionReportDiscoverMoreQuery__
 *
 * To run a query within a React component, call `useSessionReportDiscoverMoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionReportDiscoverMoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionReportDiscoverMoreQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionReportDiscoverMoreQuery(baseOptions: Apollo.QueryHookOptions<SessionReportDiscoverMoreQuery, SessionReportDiscoverMoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionReportDiscoverMoreQuery, SessionReportDiscoverMoreQueryVariables>(SessionReportDiscoverMoreDocument, options);
      }
export function useSessionReportDiscoverMoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionReportDiscoverMoreQuery, SessionReportDiscoverMoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionReportDiscoverMoreQuery, SessionReportDiscoverMoreQueryVariables>(SessionReportDiscoverMoreDocument, options);
        }
export type SessionReportDiscoverMoreQueryHookResult = ReturnType<typeof useSessionReportDiscoverMoreQuery>;
export type SessionReportDiscoverMoreLazyQueryHookResult = ReturnType<typeof useSessionReportDiscoverMoreLazyQuery>;
export type SessionReportDiscoverMoreQueryResult = Apollo.QueryResult<SessionReportDiscoverMoreQuery, SessionReportDiscoverMoreQueryVariables>;
export const SetupClientPaymentMethodDocument = gql`
    mutation setupClientPaymentMethod {
  setupClientPaymentMethod
}
    `;
export type SetupClientPaymentMethodMutationFn = Apollo.MutationFunction<SetupClientPaymentMethodMutation, SetupClientPaymentMethodMutationVariables>;

/**
 * __useSetupClientPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetupClientPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupClientPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupClientPaymentMethodMutation, { data, loading, error }] = useSetupClientPaymentMethodMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetupClientPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetupClientPaymentMethodMutation, SetupClientPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupClientPaymentMethodMutation, SetupClientPaymentMethodMutationVariables>(SetupClientPaymentMethodDocument, options);
      }
export type SetupClientPaymentMethodMutationHookResult = ReturnType<typeof useSetupClientPaymentMethodMutation>;
export type SetupClientPaymentMethodMutationResult = Apollo.MutationResult<SetupClientPaymentMethodMutation>;
export type SetupClientPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetupClientPaymentMethodMutation, SetupClientPaymentMethodMutationVariables>;
export const SubscribeToMailingListDocument = gql`
    mutation subscribeToMailingList($input: SubscribeToMailingListInput!) {
  subscribeToMailingList(input: $input)
}
    `;
export type SubscribeToMailingListMutationFn = Apollo.MutationFunction<SubscribeToMailingListMutation, SubscribeToMailingListMutationVariables>;

/**
 * __useSubscribeToMailingListMutation__
 *
 * To run a mutation, you first call `useSubscribeToMailingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToMailingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToMailingListMutation, { data, loading, error }] = useSubscribeToMailingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToMailingListMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToMailingListMutation, SubscribeToMailingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToMailingListMutation, SubscribeToMailingListMutationVariables>(SubscribeToMailingListDocument, options);
      }
export type SubscribeToMailingListMutationHookResult = ReturnType<typeof useSubscribeToMailingListMutation>;
export type SubscribeToMailingListMutationResult = Apollo.MutationResult<SubscribeToMailingListMutation>;
export type SubscribeToMailingListMutationOptions = Apollo.BaseMutationOptions<SubscribeToMailingListMutation, SubscribeToMailingListMutationVariables>;
export const AdminTradeLicensesDocument = gql`
    query adminTradeLicenses($input: TradeLicensesInput) {
  tradeLicenses(input: $input) {
    edges {
      node {
        id
        name
        isActive
        isDisabled
        isSingleUse
        countryStates
        expert {
          email
          businessName
          legalBusinessName
        }
        expiresAtUtc {
          isoFormat
        }
        createdAtUtc {
          isoFormat
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useAdminTradeLicensesQuery__
 *
 * To run a query within a React component, call `useAdminTradeLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTradeLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTradeLicensesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminTradeLicensesQuery(baseOptions?: Apollo.QueryHookOptions<AdminTradeLicensesQuery, AdminTradeLicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminTradeLicensesQuery, AdminTradeLicensesQueryVariables>(AdminTradeLicensesDocument, options);
      }
export function useAdminTradeLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminTradeLicensesQuery, AdminTradeLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminTradeLicensesQuery, AdminTradeLicensesQueryVariables>(AdminTradeLicensesDocument, options);
        }
export type AdminTradeLicensesQueryHookResult = ReturnType<typeof useAdminTradeLicensesQuery>;
export type AdminTradeLicensesLazyQueryHookResult = ReturnType<typeof useAdminTradeLicensesLazyQuery>;
export type AdminTradeLicensesQueryResult = Apollo.QueryResult<AdminTradeLicensesQuery, AdminTradeLicensesQueryVariables>;
export const AdminTradeLicenseDocument = gql`
    query adminTradeLicense($input: TradeLicenseInput!) {
  tradeLicense(input: $input) {
    id
    name
    isActive
    isDisabled
    isSingleUse
    countryStates
    licenseNumber
    expert {
      id
      businessName
      legalBusinessName
    }
    attachments {
      id
      name
      url
    }
    expiresAtUtc {
      isoFormat
    }
  }
}
    `;

/**
 * __useAdminTradeLicenseQuery__
 *
 * To run a query within a React component, call `useAdminTradeLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTradeLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTradeLicenseQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminTradeLicenseQuery(baseOptions: Apollo.QueryHookOptions<AdminTradeLicenseQuery, AdminTradeLicenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminTradeLicenseQuery, AdminTradeLicenseQueryVariables>(AdminTradeLicenseDocument, options);
      }
export function useAdminTradeLicenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminTradeLicenseQuery, AdminTradeLicenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminTradeLicenseQuery, AdminTradeLicenseQueryVariables>(AdminTradeLicenseDocument, options);
        }
export type AdminTradeLicenseQueryHookResult = ReturnType<typeof useAdminTradeLicenseQuery>;
export type AdminTradeLicenseLazyQueryHookResult = ReturnType<typeof useAdminTradeLicenseLazyQuery>;
export type AdminTradeLicenseQueryResult = Apollo.QueryResult<AdminTradeLicenseQuery, AdminTradeLicenseQueryVariables>;
export const ToggleIsDisabledTradeLicenseDocument = gql`
    mutation toggleIsDisabledTradeLicense($input: ToggleIsDisabledTradeLicenseInput!) {
  toggleIsDisabledTradeLicense(input: $input) {
    id
    isDisabled
  }
}
    `;
export type ToggleIsDisabledTradeLicenseMutationFn = Apollo.MutationFunction<ToggleIsDisabledTradeLicenseMutation, ToggleIsDisabledTradeLicenseMutationVariables>;

/**
 * __useToggleIsDisabledTradeLicenseMutation__
 *
 * To run a mutation, you first call `useToggleIsDisabledTradeLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleIsDisabledTradeLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleIsDisabledTradeLicenseMutation, { data, loading, error }] = useToggleIsDisabledTradeLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleIsDisabledTradeLicenseMutation(baseOptions?: Apollo.MutationHookOptions<ToggleIsDisabledTradeLicenseMutation, ToggleIsDisabledTradeLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleIsDisabledTradeLicenseMutation, ToggleIsDisabledTradeLicenseMutationVariables>(ToggleIsDisabledTradeLicenseDocument, options);
      }
export type ToggleIsDisabledTradeLicenseMutationHookResult = ReturnType<typeof useToggleIsDisabledTradeLicenseMutation>;
export type ToggleIsDisabledTradeLicenseMutationResult = Apollo.MutationResult<ToggleIsDisabledTradeLicenseMutation>;
export type ToggleIsDisabledTradeLicenseMutationOptions = Apollo.BaseMutationOptions<ToggleIsDisabledTradeLicenseMutation, ToggleIsDisabledTradeLicenseMutationVariables>;
export const CreateTradeLicenseDocument = gql`
    mutation createTradeLicense($input: CreateTradeLicenseInput!) {
  createTradeLicense(input: $input) {
    id
  }
}
    `;
export type CreateTradeLicenseMutationFn = Apollo.MutationFunction<CreateTradeLicenseMutation, CreateTradeLicenseMutationVariables>;

/**
 * __useCreateTradeLicenseMutation__
 *
 * To run a mutation, you first call `useCreateTradeLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTradeLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTradeLicenseMutation, { data, loading, error }] = useCreateTradeLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTradeLicenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateTradeLicenseMutation, CreateTradeLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTradeLicenseMutation, CreateTradeLicenseMutationVariables>(CreateTradeLicenseDocument, options);
      }
export type CreateTradeLicenseMutationHookResult = ReturnType<typeof useCreateTradeLicenseMutation>;
export type CreateTradeLicenseMutationResult = Apollo.MutationResult<CreateTradeLicenseMutation>;
export type CreateTradeLicenseMutationOptions = Apollo.BaseMutationOptions<CreateTradeLicenseMutation, CreateTradeLicenseMutationVariables>;
export const TrustedSourcesDocument = gql`
    query trustedSources($input: TrustedSourcesInput) {
  trustedSources(input: $input) {
    paginationInfo {
      totalCount
      firstPage
      lastPage
      currentPage
      nextPage
      previousPage
    }
    data {
      id
      domain
      ...trustedSourceDirectives
      createdAtUtc {
        isoFormat
      }
      updatedAtUtc {
        isoFormat
      }
    }
  }
}
    ${TrustedSourceDirectivesFragmentDoc}`;

/**
 * __useTrustedSourcesQuery__
 *
 * To run a query within a React component, call `useTrustedSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustedSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustedSourcesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrustedSourcesQuery(baseOptions?: Apollo.QueryHookOptions<TrustedSourcesQuery, TrustedSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrustedSourcesQuery, TrustedSourcesQueryVariables>(TrustedSourcesDocument, options);
      }
export function useTrustedSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrustedSourcesQuery, TrustedSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrustedSourcesQuery, TrustedSourcesQueryVariables>(TrustedSourcesDocument, options);
        }
export type TrustedSourcesQueryHookResult = ReturnType<typeof useTrustedSourcesQuery>;
export type TrustedSourcesLazyQueryHookResult = ReturnType<typeof useTrustedSourcesLazyQuery>;
export type TrustedSourcesQueryResult = Apollo.QueryResult<TrustedSourcesQuery, TrustedSourcesQueryVariables>;
export const TrustedSourcesCounterDocument = gql`
    query trustedSourcesCounter($input: TrustedSourcesInput) {
  trustedSources(input: $input) {
    data {
      domain
      ...trustedSourceDirectives
    }
  }
}
    ${TrustedSourceDirectivesFragmentDoc}`;

/**
 * __useTrustedSourcesCounterQuery__
 *
 * To run a query within a React component, call `useTrustedSourcesCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustedSourcesCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustedSourcesCounterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrustedSourcesCounterQuery(baseOptions?: Apollo.QueryHookOptions<TrustedSourcesCounterQuery, TrustedSourcesCounterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrustedSourcesCounterQuery, TrustedSourcesCounterQueryVariables>(TrustedSourcesCounterDocument, options);
      }
export function useTrustedSourcesCounterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrustedSourcesCounterQuery, TrustedSourcesCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrustedSourcesCounterQuery, TrustedSourcesCounterQueryVariables>(TrustedSourcesCounterDocument, options);
        }
export type TrustedSourcesCounterQueryHookResult = ReturnType<typeof useTrustedSourcesCounterQuery>;
export type TrustedSourcesCounterLazyQueryHookResult = ReturnType<typeof useTrustedSourcesCounterLazyQuery>;
export type TrustedSourcesCounterQueryResult = Apollo.QueryResult<TrustedSourcesCounterQuery, TrustedSourcesCounterQueryVariables>;
export const CreateTrustedSourceDocument = gql`
    mutation createTrustedSource($input: CreateTrustedSourceInput!) {
  createTrustedSource(input: $input) {
    id
  }
}
    `;
export type CreateTrustedSourceMutationFn = Apollo.MutationFunction<CreateTrustedSourceMutation, CreateTrustedSourceMutationVariables>;

/**
 * __useCreateTrustedSourceMutation__
 *
 * To run a mutation, you first call `useCreateTrustedSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrustedSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrustedSourceMutation, { data, loading, error }] = useCreateTrustedSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrustedSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrustedSourceMutation, CreateTrustedSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrustedSourceMutation, CreateTrustedSourceMutationVariables>(CreateTrustedSourceDocument, options);
      }
export type CreateTrustedSourceMutationHookResult = ReturnType<typeof useCreateTrustedSourceMutation>;
export type CreateTrustedSourceMutationResult = Apollo.MutationResult<CreateTrustedSourceMutation>;
export type CreateTrustedSourceMutationOptions = Apollo.BaseMutationOptions<CreateTrustedSourceMutation, CreateTrustedSourceMutationVariables>;
export const UpdateTrustedSourceDocument = gql`
    mutation updateTrustedSource($input: UpdateTrustedSourceInput!) {
  updateTrustedSource(input: $input) {
    id
  }
}
    `;
export type UpdateTrustedSourceMutationFn = Apollo.MutationFunction<UpdateTrustedSourceMutation, UpdateTrustedSourceMutationVariables>;

/**
 * __useUpdateTrustedSourceMutation__
 *
 * To run a mutation, you first call `useUpdateTrustedSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrustedSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrustedSourceMutation, { data, loading, error }] = useUpdateTrustedSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrustedSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrustedSourceMutation, UpdateTrustedSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrustedSourceMutation, UpdateTrustedSourceMutationVariables>(UpdateTrustedSourceDocument, options);
      }
export type UpdateTrustedSourceMutationHookResult = ReturnType<typeof useUpdateTrustedSourceMutation>;
export type UpdateTrustedSourceMutationResult = Apollo.MutationResult<UpdateTrustedSourceMutation>;
export type UpdateTrustedSourceMutationOptions = Apollo.BaseMutationOptions<UpdateTrustedSourceMutation, UpdateTrustedSourceMutationVariables>;
export const DeleteTrustedSourceDocument = gql`
    mutation deleteTrustedSource($id: Int!) {
  deleteTrustedSource(id: $id)
}
    `;
export type DeleteTrustedSourceMutationFn = Apollo.MutationFunction<DeleteTrustedSourceMutation, DeleteTrustedSourceMutationVariables>;

/**
 * __useDeleteTrustedSourceMutation__
 *
 * To run a mutation, you first call `useDeleteTrustedSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrustedSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrustedSourceMutation, { data, loading, error }] = useDeleteTrustedSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrustedSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrustedSourceMutation, DeleteTrustedSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrustedSourceMutation, DeleteTrustedSourceMutationVariables>(DeleteTrustedSourceDocument, options);
      }
export type DeleteTrustedSourceMutationHookResult = ReturnType<typeof useDeleteTrustedSourceMutation>;
export type DeleteTrustedSourceMutationResult = Apollo.MutationResult<DeleteTrustedSourceMutation>;
export type DeleteTrustedSourceMutationOptions = Apollo.BaseMutationOptions<DeleteTrustedSourceMutation, DeleteTrustedSourceMutationVariables>;
export const CreateVendorDocument = gql`
    mutation createVendor($input: CreateVendorInput!) {
  createVendor(input: $input) {
    attachment {
      url
      name
      alt
    }
    brands
    expertCommission
    id
    isDeleted
    name
    websiteUrl
    policy
  }
}
    `;
export type CreateVendorMutationFn = Apollo.MutationFunction<CreateVendorMutation, CreateVendorMutationVariables>;

/**
 * __useCreateVendorMutation__
 *
 * To run a mutation, you first call `useCreateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorMutation, { data, loading, error }] = useCreateVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVendorMutation(baseOptions?: Apollo.MutationHookOptions<CreateVendorMutation, CreateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVendorMutation, CreateVendorMutationVariables>(CreateVendorDocument, options);
      }
export type CreateVendorMutationHookResult = ReturnType<typeof useCreateVendorMutation>;
export type CreateVendorMutationResult = Apollo.MutationResult<CreateVendorMutation>;
export type CreateVendorMutationOptions = Apollo.BaseMutationOptions<CreateVendorMutation, CreateVendorMutationVariables>;
export const DeleteVendorDocument = gql`
    mutation deleteVendor($id: Int!) {
  deleteVendor(id: $id) {
    id
  }
}
    `;
export type DeleteVendorMutationFn = Apollo.MutationFunction<DeleteVendorMutation, DeleteVendorMutationVariables>;

/**
 * __useDeleteVendorMutation__
 *
 * To run a mutation, you first call `useDeleteVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVendorMutation, { data, loading, error }] = useDeleteVendorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVendorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVendorMutation, DeleteVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVendorMutation, DeleteVendorMutationVariables>(DeleteVendorDocument, options);
      }
export type DeleteVendorMutationHookResult = ReturnType<typeof useDeleteVendorMutation>;
export type DeleteVendorMutationResult = Apollo.MutationResult<DeleteVendorMutation>;
export type DeleteVendorMutationOptions = Apollo.BaseMutationOptions<DeleteVendorMutation, DeleteVendorMutationVariables>;
export const UpdateVendorDocument = gql`
    mutation updateVendor($input: UpdateVendorInput!) {
  updateVendor(input: $input) {
    attachment {
      url
      id
      name
      alt
    }
    brands
    expertCommission
    id
    isDeleted
    name
    websiteUrl
    policy
  }
}
    `;
export type UpdateVendorMutationFn = Apollo.MutationFunction<UpdateVendorMutation, UpdateVendorMutationVariables>;

/**
 * __useUpdateVendorMutation__
 *
 * To run a mutation, you first call `useUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorMutation, { data, loading, error }] = useUpdateVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVendorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorMutation, UpdateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVendorMutation, UpdateVendorMutationVariables>(UpdateVendorDocument, options);
      }
export type UpdateVendorMutationHookResult = ReturnType<typeof useUpdateVendorMutation>;
export type UpdateVendorMutationResult = Apollo.MutationResult<UpdateVendorMutation>;
export type UpdateVendorMutationOptions = Apollo.BaseMutationOptions<UpdateVendorMutation, UpdateVendorMutationVariables>;
export const AdminVendorsDocument = gql`
    query adminVendors {
  vendors {
    attachment {
      url
      id
      name
      alt
    }
    brands
    expertCommission
    id
    name
    websiteUrl
    policy
  }
}
    `;

/**
 * __useAdminVendorsQuery__
 *
 * To run a query within a React component, call `useAdminVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminVendorsQuery(baseOptions?: Apollo.QueryHookOptions<AdminVendorsQuery, AdminVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminVendorsQuery, AdminVendorsQueryVariables>(AdminVendorsDocument, options);
      }
export function useAdminVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminVendorsQuery, AdminVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminVendorsQuery, AdminVendorsQueryVariables>(AdminVendorsDocument, options);
        }
export type AdminVendorsQueryHookResult = ReturnType<typeof useAdminVendorsQuery>;
export type AdminVendorsLazyQueryHookResult = ReturnType<typeof useAdminVendorsLazyQuery>;
export type AdminVendorsQueryResult = Apollo.QueryResult<AdminVendorsQuery, AdminVendorsQueryVariables>;
export const ChangeVideoThumbnailDocument = gql`
    mutation changeVideoThumbnail($input: ChangeVideoThumbnailInput!) {
  changeVideoThumbnail(input: $input)
}
    `;
export type ChangeVideoThumbnailMutationFn = Apollo.MutationFunction<ChangeVideoThumbnailMutation, ChangeVideoThumbnailMutationVariables>;

/**
 * __useChangeVideoThumbnailMutation__
 *
 * To run a mutation, you first call `useChangeVideoThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeVideoThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeVideoThumbnailMutation, { data, loading, error }] = useChangeVideoThumbnailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeVideoThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<ChangeVideoThumbnailMutation, ChangeVideoThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeVideoThumbnailMutation, ChangeVideoThumbnailMutationVariables>(ChangeVideoThumbnailDocument, options);
      }
export type ChangeVideoThumbnailMutationHookResult = ReturnType<typeof useChangeVideoThumbnailMutation>;
export type ChangeVideoThumbnailMutationResult = Apollo.MutationResult<ChangeVideoThumbnailMutation>;
export type ChangeVideoThumbnailMutationOptions = Apollo.BaseMutationOptions<ChangeVideoThumbnailMutation, ChangeVideoThumbnailMutationVariables>;